import { h as _objectWithoutProperties, _ as _objectSpread2, j as _taggedTemplateLiteral, a as _slicedToArray, o as onCheckHandler, c as _typeof, f as _toConsumableArray, Z as ZINDEX, k as _extends$7, l as _objectDestructuringEmpty, n as OverlayPortal, I as IntersectionObserver, q as onValueHandler, d as _asyncToGenerator, e as _regeneratorRuntime, B as BodyPortal, g as _createForOfIteratorHelper, b as _defineProperty } from './common.js';
import { jsx, jsxs, Fragment as Fragment$1 } from '@emotion/react/jsx-runtime';
import { css, useTheme, keyframes } from '@emotion/react';
import { p as pxToRem, u as hexToRgba, F as FONT_STYLE, R as RESET_BUTTON, H as HOVER, h as SHADOW_STYLE, M as MEDIA_QUERY, B as BREAK_POINT, q as FOCUS, s as safeAreaInset, a as RESET_INPUT } from './foundation.js';
export { w as ReactComponent } from './foundation.js';
import * as React from 'react';
import React__default, { Fragment, useState, useEffect, useCallback, createContext, useContext, useRef, forwardRef, useMemo, useImperativeHandle, memo, useLayoutEffect, Children } from 'react';
import _styled from '@emotion/styled/base';
import { useNodeHeight, useScrollDirection, Sticky, DEFAULT_STICKY_STATE, ScrollLock, ResizeImage, useNodeSize } from '@bucketplace/ui';
export { BaseSticky, DEFAULT_STICKY_STATE, ScrollSticky, Sticky, StickyControlContext, StickyProvider, StickyValueContext, assertStickyParentPosition, getStickyChildStyle, getStickyContainerStyle, getUpdatedStickyState, hasStickyStateChanged, useBaseSticky, useGetStickyHeight, useNodeHeight, useScrollAppear, useScrollDirection, useSticky } from '@bucketplace/ui';
import { h as useMedia, m as useResponsive, j as useResize, u as useAutoComplete, e as useIsInApp, k as useWindowsOSDetector, l as useKakaoChat, g as useMatchMedia, a as useChanged } from './hooks.js';
import isPropValid from '@emotion/is-prop-valid';
import throttle from 'lodash/throttle';
import { useInView } from 'react-intersection-observer';
import { CSSTransition, SwitchTransition, Transition } from 'react-transition-group';
import 'qs';
import 'lodash/debounce';
import '@bucketplace/lib';
import { usePopper } from 'react-popper';
import classNames from 'classnames';
import { a as getCanonicalImageUrl, A as APP_BANNER_PATHNAME_BLACKLIST, n as APP_BANNER_SEARCH_BLACKLIST, k as getCookie, j as isHiddenMarketingBanner, s as setCookie, l as isMobile, g as getDeviceInfo, i as isHigherAppVersion } from './utils.js';
import { useTranslation } from 'react-i18next';
import { R as ResizeImage$1, L as Loading, m as makeIndicatorDots } from './Loading.js';
import { b1 as StarFilledIcon, X as DismissIcon, Y as DismissCircleIcon } from './icons.js';
import interact from 'interactjs';
import { quadInOut } from 'eases';
import isEqual from 'lodash/isEqual';
import findLastKey from 'lodash/findLastKey';
import omit from 'lodash/omit';
import findLast from 'lodash/findLast';
import size from 'lodash/size';
import { Virtuoso } from 'react-virtuoso';
import 'react-dom';

function cssBaseBadge(theme, props) {
  return /*#__PURE__*/css(cssBadgeVariant$1(theme, props), " display:inline-block;font-weight:700;height:", pxToRem(props.size), ";line-height:", pxToRem(props.size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseBadge;"));
}
function cssBadgeVariant$1(theme, props) {
  if (props.disabled) {
    return cssDisabledBadge(theme, props.variant);
  }
  switch (props.type) {
    case 'fill':
      return cssFillBadge(theme, props.variant);
    case 'weak':
      return cssWeakBadge(theme, props.variant);
  }
}
function cssDisabledBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/css("color:", theme.content.base2, ";background-color:", theme.dim.disabled, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;"));
    case 'base2Outline':
      return /*#__PURE__*/css("color:", theme.content.base3, ";background-color:", hexToRgba(theme.content.base5, 0.7), ";border:", pxToRem(1), " solid ", theme.outline, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;"));
    default:
      return /*#__PURE__*/css("color:", theme.content.base3, ";background-color:", theme.content.base4, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;"));
  }
}
function cssFillBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.dim.thick, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;"));
    case 'base2':
      return /*#__PURE__*/css("color:", theme.content.base6, ";background-color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;"));
    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;"));
  }
}
function cssWeakBadge(theme, variant) {
  switch (variant) {
    case 'base2Outline':
      return /*#__PURE__*/css("color:", theme.content.base2, ";background-color:", hexToRgba(theme.content.base6, 0.7), ";border:", pxToRem(1), " solid ", theme.outline, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;"));
    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/css("color:", theme.content[variant].basic, ";background-color:", theme.content[variant].thin, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;"));
    case 'primary2':
    case 'primary4':
      return /*#__PURE__*/css("color:", theme.content[variant].thick, ";background-color:", theme.content[variant].thin, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;"));
    case 'base2':
      return /*#__PURE__*/css("color:", theme.content.base2, ";background-color:", theme.content.base4, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;"));
  }
}

var _excluded$1r = ["size", "children"];
function cssSize$6(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/css(FONT_STYLE.caption2, " padding:0 ", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 20:
      return /*#__PURE__*/css(FONT_STYLE.caption2, " padding:0 ", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 24:
      return /*#__PURE__*/css(FONT_STYLE.caption1, " padding:0 ", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 28:
      return /*#__PURE__*/css(FONT_STYLE.subTitle1, " padding:0 ", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
  }
}
/**
 * @deprecated ODS의 SquareBadge를 사용해주세요.
 */
function SquareBadge(props) {
  var size = props.size,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded$1r);
  var theme = useTheme();
  return jsx("span", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [cssSize$6(size), cssBaseBadge(theme, props), /*#__PURE__*/css("border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: children
  }));
}

var _excluded$1q = ["size", "children"];
function cssSize$5(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/css(FONT_STYLE.caption2, " padding:0 ", pxToRem(6), ";border-radius:", pxToRem(9), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 20:
      return /*#__PURE__*/css(FONT_STYLE.caption1, " padding:0 ", pxToRem(6), ";border-radius:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 24:
      return /*#__PURE__*/css(FONT_STYLE.body3, " padding:0 ", pxToRem(8), ";border-radius:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
  }
}
/**
 * @deprecated ODS의 PillBadge를 사용해주세요.
 */
function PillBadge(props) {
  var size = props.size,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded$1q);
  var theme = useTheme();
  return jsx("span", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [cssSize$5(size), cssBaseBadge(theme, props)],
    children: children
  }));
}

var _excluded$1p = ["size", "children"];
function cssSize$4(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/css(FONT_STYLE.caption2, " padding:0 ", pxToRem(5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 20:
      return /*#__PURE__*/css(FONT_STYLE.caption2, " padding:0 ", pxToRem(7), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 24:
      return /*#__PURE__*/css(FONT_STYLE.caption1, " padding:0 ", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
  }
}
/**
 * @deprecated ODS의 CircleBadge 컴포넌트를 사용해 주세요.
 */
function CircleBadge(props) {
  var size = props.size,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded$1p);
  var theme = useTheme();
  return jsx("span", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [cssSize$4(size), cssBaseBadge(theme, props), /*#__PURE__*/css("border-radius:", pxToRem(size / 2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: children
  }));
}

/**
 * @author TroyTae
 * @version 1.3.8
 * @license MIT
 * @name one-spaces
 */
function n(r) {
  for (var t, e = 0, o = ""; e < r.length;) (t = r[e++]) && (t.pop && !(t = n(t)) || (o && (o += " "), o += t));
  return o;
}
function spaces () {
  return n(arguments);
}

var _excluded$1o = ["fill", "name", "size", "className"];
/**
 * @deprecated ODS의 Icon 컴포넌트를 사용해 주세요.
 */
function Icon(_ref) {
  var fill = _ref.fill,
    name = _ref.name,
    size = _ref.size,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded$1o);
  var theme = useTheme();
  return jsx("span", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [/*#__PURE__*/css("display:inline-block;font-size:", pxToRem(size), ";line-height:1;&::before{font-family:OhouseIcon;vertical-align:top;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), fill && /*#__PURE__*/css("color:", fill(theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    className: spaces(className, "_".concat(name, "_").concat(size))
  }));
}

var _excluded$1n = ["text", "isActive"];
function Crumb(_ref) {
  var text = _ref.text,
    isActive = _ref.isActive,
    rest = _objectWithoutProperties(_ref, _excluded$1n);
  var theme = useTheme();
  return jsx("button", _objectSpread2(_objectSpread2({
    type: "button"
  }, rest), {}, {
    css: /*#__PURE__*/css(RESET_BUTTON, " font:inherit;vertical-align:top;color:", isActive ? theme.content.base1 : theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: text
  }));
}

var _excluded$1m = ["activeIndex", "onChangeIndex", "crumbs"],
  _excluded2$5 = ["text"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$17() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$11 = process.env.NODE_ENV === "production" ? {
  name: "1v7jawo",
  styles: "overflow-x:auto;white-space:nowrap"
} : {
  name: "1pj4jf-css",
  styles: "overflow-x:auto;white-space:nowrap;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$17
};
function Breadcrumb(_ref2) {
  var activeIndex = _ref2.activeIndex,
    onChangeIndex = _ref2.onChangeIndex,
    crumbs = _ref2.crumbs,
    rest = _objectWithoutProperties(_ref2, _excluded$1m);
  var theme = useTheme();
  return jsx("nav", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [FONT_STYLE.subTitle2, _ref$11],
    children: crumbs.map(function (_ref3, index) {
      var text = _ref3.text,
        rest = _objectWithoutProperties(_ref3, _excluded2$5);
      return jsxs(Fragment, {
        children: [jsx(Crumb, _objectSpread2(_objectSpread2({}, rest), {}, {
          text: text,
          isActive: index === activeIndex,
          onClick: function onClick() {
            return onChangeIndex(index);
          }
        })), index + 1 < crumbs.length && jsx(Icon, {
          size: 18,
          name: "chevron_right",
          css: /*#__PURE__*/css("vertical-align:top;margin:0 ", pxToRem(4), ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        })]
      }, text);
    })
  }));
}

var _excluded$1l = ["id", "onClick", "forwardedRef", "className", "size", "full", "disabled", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$16() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function getWithIconOptions(size, iconSize) {
  return {
    gap: {
      32: 4,
      40: 6,
      44: 6,
      50: 6
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}
function cssBaseButton(size, full) {
  return /*#__PURE__*/css(RESET_BUTTON, " ", {
    32: FONT_STYLE.body2,
    40: FONT_STYLE.subTitle2,
    44: FONT_STYLE.subTitle2,
    50: FONT_STYLE.subTitle1
  }[size], " display:inline-flex;justify-content:center;align-items:center;width:", full ? '100%' : 'auto', ";height:", pxToRem(size), ";border-radius:", pxToRem(4), ";padding:0 ", pxToRem(size === 32 ? 8 : 16), ";font-weight:", size === 50 ? 700 : 400, ";box-sizing:border-box;text-align:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseButton;"));
}
var _ref$10 = process.env.NODE_ENV === "production" ? {
  name: "ebd3ti",
  styles: "position:absolute;top:0;left:0;width:0;height:0;opacity:0"
} : {
  name: "1rn162b-css",
  styles: "position:absolute;top:0;left:0;width:0;height:0;opacity:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
};
var _ref2$i = process.env.NODE_ENV === "production" ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : {
  name: "b5pnrc-css",
  styles: "vertical-align:middle;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
};
var _ref3$8 = process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "1jjbqfm-css",
  styles: "text-align:center;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
};
var _ref4$3 = process.env.NODE_ENV === "production" ? {
  name: "11408bl",
  styles: "cursor:pointer;position:relative"
} : {
  name: "15uck7x-css",
  styles: "cursor:pointer;position:relative;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
};
function FileInputLabel(_ref5) {
  var id = _ref5.id,
    _onClick = _ref5.onClick,
    forwardedRef = _ref5.forwardedRef,
    className = _ref5.className,
    size = _ref5.size,
    full = _ref5.full,
    disabled = _ref5.disabled,
    children = _ref5.children,
    rest = _objectWithoutProperties(_ref5, _excluded$1l);
  return jsxs("label", {
    className: className,
    htmlFor: id,
    css: [cssBaseButton(size, full), _ref4$3, full && _ref3$8],
    children: [jsx("span", {
      css: _ref2$i,
      children: children
    }), jsx("input", _objectSpread2(_objectSpread2({}, rest), {}, {
      id: id,
      ref: forwardedRef,
      type: "file",
      css: _ref$10,
      onClick: function onClick(e) {
        if (disabled) {
          e.preventDefault();
        }
        if (_onClick) {
          _onClick(e);
        }
      }
    }))]
  });
}

var _excluded$1k = ["forwardedRef", "full", "size", "variant", "disabled", "children"],
  _excluded2$4 = ["forwardedRef", "full", "size", "variant", "children", "disabled"],
  _excluded3$3 = ["full", "size", "variant", "disabled"];
var _templateObject$o, _templateObject2$e, _templateObject3$4;
function cssDisabled$1(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/css("color:", theme.content.base2, ";background-color:", theme.dim.disabled, ";pointer-events:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;"));
    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'base1':
      return /*#__PURE__*/css("color:", theme.content.base3, ";background-color:", theme.content.base4, ";pointer-events:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;"));
  }
}
function cssVariant$7(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";", HOVER(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive[variant].basic), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'base1':
      return /*#__PURE__*/css("color:", theme.content.base6, ";background-color:", theme.content.base1, ";", HOVER(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive.base1), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'dim':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.dim.thick, ";", HOVER(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive.dim.thick), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
  }
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function Button$2(_ref) {
  var forwardedRef = _ref.forwardedRef,
    full = _ref.full,
    size = _ref.size,
    variant = _ref.variant,
    disabled = _ref.disabled,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1k);
  var theme = useTheme();
  return jsx("button", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)],
    children: children
  }));
}
function AnchorButton(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
    full = _ref2.full,
    size = _ref2.size,
    variant = _ref2.variant,
    children = _ref2.children,
    disabled = _ref2.disabled,
    rest = _objectWithoutProperties(_ref2, _excluded2$4);
  var theme = useTheme();
  return jsx("a", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)],
    children: children
  }));
}
function FileButton(_ref3) {
  var full = _ref3.full,
    size = _ref3.size,
    variant = _ref3.variant,
    disabled = _ref3.disabled,
    rest = _objectWithoutProperties(_ref3, _excluded3$3);
  var theme = useTheme();
  return jsx(FileInputLabel, _objectSpread2(_objectSpread2({}, rest), {}, {
    size: size,
    full: full,
    disabled: disabled,
    css: (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)
  }));
}

var _excluded$1j = ["text", "icon", "isTrailing"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$15() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$$ = process.env.NODE_ENV === "production" ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : {
  name: "b5pnrc-css",
  styles: "vertical-align:middle;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$15
};
function MiddleIcon(props) {
  return jsx(Icon, _objectSpread2(_objectSpread2({}, props), {}, {
    css: _ref$$
  }));
}
function withIcon(Component, getOptions) {
  return function (_ref2) {
    var text = _ref2.text,
      icon = _ref2.icon,
      isTrailing = _ref2.isTrailing,
      rest = _objectWithoutProperties(_ref2, _excluded$1j);
    var _getOptions = getOptions(rest),
      gap = _getOptions.gap,
      iconSize = _getOptions.iconSize;
    var middleIcon = jsx(MiddleIcon, {
      name: icon,
      size: iconSize
    });
    return jsxs(Component, _objectSpread2(_objectSpread2({}, rest), {}, {
      children: [!isTrailing && middleIcon, jsx("span", {
        css: /*#__PURE__*/css("vertical-align:middle;margin-", isTrailing ? 'right' : 'left', ":", pxToRem(gap), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: text
      }), isTrailing && middleIcon]
    }));
  };
}

/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var ButtonWithIcon = withIcon(Button$2, function (_ref) {
  var size = _ref.size,
    iconSize = _ref.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var AnchorButtonWithIcon = withIcon(AnchorButton, function (_ref2) {
  var size = _ref2.size,
    iconSize = _ref2.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var FileButtonWithIcon = withIcon(FileButton, function (_ref3) {
  var size = _ref3.size,
    iconSize = _ref3.iconSize;
  return getWithIconOptions(size, iconSize);
});

var _excluded$1i = ["forwardedRef", "full", "size", "variant", "disabled", "children", "filled"],
  _excluded2$3 = ["forwardedRef", "full", "size", "variant", "children", "disabled", "filled"],
  _excluded3$2 = ["full", "size", "variant", "disabled", "filled"];
var _templateObject$n, _templateObject2$d, _templateObject3$3;
function cssVariant$6(theme, variant, filled) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/css("color:", theme.content[variant].basic, ";border:", pxToRem(1), " solid ", theme.content[variant].basic, ";", filled && /*#__PURE__*/css("background-color:", theme.content.base6, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")), " ", HOVER(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive[variant].transparent), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'base1':
      return /*#__PURE__*/css("color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";", filled && /*#__PURE__*/css("background-color:", theme.content.base6, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")), " ", HOVER(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive.transparent), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'onDark':
      return /*#__PURE__*/css("color:", theme.content.white, ";border:", pxToRem(1), " solid ", theme.content.white, ";", filled && /*#__PURE__*/css("background-color:", theme.dim.thin, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")), " ", HOVER(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive.onDark), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
  }
}
function cssDisabled(theme) {
  return /*#__PURE__*/css("color:", theme.content.base3, ";border:", pxToRem(1), " solid ", theme.content.base4, ";background-color:", theme.content.base5, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;"));
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineButton(_ref) {
  var forwardedRef = _ref.forwardedRef,
    full = _ref.full,
    size = _ref.size,
    variant = _ref.variant,
    disabled = _ref.disabled,
    children = _ref.children,
    _ref$filled = _ref.filled,
    filled = _ref$filled === void 0 ? false : _ref$filled,
    rest = _objectWithoutProperties(_ref, _excluded$1i);
  var theme = useTheme();
  return jsx("button", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)],
    children: children
  }));
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineAnchorButton(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
    full = _ref2.full,
    size = _ref2.size,
    variant = _ref2.variant,
    children = _ref2.children,
    disabled = _ref2.disabled,
    _ref2$filled = _ref2.filled,
    filled = _ref2$filled === void 0 ? false : _ref2$filled,
    rest = _objectWithoutProperties(_ref2, _excluded2$3);
  var theme = useTheme();
  return jsx("a", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)],
    children: children
  }));
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineFileButton(_ref3) {
  var full = _ref3.full,
    size = _ref3.size,
    variant = _ref3.variant,
    disabled = _ref3.disabled,
    _ref3$filled = _ref3.filled,
    filled = _ref3$filled === void 0 ? false : _ref3$filled,
    rest = _objectWithoutProperties(_ref3, _excluded3$2);
  var theme = useTheme();
  return jsx(FileInputLabel, _objectSpread2(_objectSpread2({}, rest), {}, {
    size: size,
    full: full,
    disabled: disabled,
    css: disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)
  }));
}

/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineButtonWithIcon = withIcon(OutlineButton, function (_ref) {
  var size = _ref.size,
    iconSize = _ref.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineAnchorButtonWithIcon = withIcon(OutlineAnchorButton, function (_ref2) {
  var size = _ref2.size,
    iconSize = _ref2.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineFileButtonWithIcon = withIcon(OutlineFileButton, function (_ref3) {
  var size = _ref3.size,
    iconSize = _ref3.iconSize;
  return getWithIconOptions(size, iconSize);
});

var _excluded$1h = ["forwardedRef", "error", "disabled", "grid", "size", "variant", "options", "onChange"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$14() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function cssVariant$5(theme, checked, variant) {
  if (checked) {
    switch (variant) {
      case 'primary1':
      case 'primary3':
        return /*#__PURE__*/css("color:", theme.content[variant].basic, ";border-color:", theme.content[variant].basic, ";&:hover,&:active{background-color:", theme.interactive[variant].transparent, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
      case 'primary2':
      case 'primary4':
        return /*#__PURE__*/css("color:", theme.content[variant].thick, ";border-color:", theme.content[variant].thick, ";&:hover,&:active{background-color:", theme.interactive[variant].transparent, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    }
  }
  return /*#__PURE__*/css("color:", theme.content.base2, ";border-color:", theme.border, ";&:hover,&:active{background-color:", theme.interactive.transparent, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
}
var _ref$_ = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "oj32ga-css",
  styles: "overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$14
};
function SelectButton(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
    error = _ref2.error,
    disabled = _ref2.disabled,
    grid = _ref2.grid,
    size = _ref2.size,
    variant = _ref2.variant,
    options = _ref2.options,
    onChange = _ref2.onChange,
    rest = _objectWithoutProperties(_ref2, _excluded$1h);
  var theme = useTheme();
  var getMsGridColums = function getMsGridColums(grid) {
    if (grid === 1) return '1fr';
    return new Array(grid).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };
  var getMsGridRows = function getMsGridRows(grid, buttonCount) {
    return new Array(Math.ceil(buttonCount / grid)).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };
  return jsx("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: _ref$_,
    children: jsx("div", {
      css: /*#__PURE__*/css("display:grid;grid-template-columns:repeat(", grid, ", 1fr);grid-gap:", pxToRem(6), ";display:-ms-grid;-ms-grid-columns:", getMsGridColums(grid), ";-ms-grid-columns:", getMsGridRows(grid, options.length), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: options.map(function (option) {
        return _objectSpread2(_objectSpread2({}, option), {}, {
          disabled: option.disabled || disabled
        });
      }).map(function (_ref3, index) {
        var text = _ref3.text,
          checked = _ref3.checked,
          disabled = _ref3.disabled;
        return jsx("div", {
          css: /*#__PURE__*/css("display:inline-block;vertical-align:top;-ms-grid-column:", Math.floor(index % grid) * 2 + 1, ";-ms-grid-row:", Math.floor(index / grid) * 2 + 1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: jsx("button", {
            type: "button",
            disabled: disabled,
            ref: index === 0 ? forwardedRef : null,
            css: [cssBaseButton(size), disabled ? /*#__PURE__*/css("color:", theme.content.base3, ";border-color:", theme.content.base4, ";background-color:", theme.content.base5, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : cssVariant$5(theme, checked, variant), /*#__PURE__*/css("width:100%;border-width:", pxToRem(1), ";border-style:solid;font-weight:", checked ? 700 : 400, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), error && /*#__PURE__*/css("border-color:", theme.content.primary2.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
            onClick: function onClick() {
              return onChange(index, !checked);
            },
            children: text
          })
        }, text);
      })
    })
  }));
}

var _g$2, _defs$1;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
var SvgInactiveScrap24 = function SvgInactiveScrap24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#inactiveScrap24_svg__a)",
    filter: "url(#inactiveScrap24_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3 4.05V19.5l6.63-3.482a2.3 2.3 0 0 1 2.14 0l6.63 3.481V4.05zM4 2.75h16a1 1 0 0 1 1 1v17.073a.5.5 0 0 1-.732.442l-7.803-4.096a1 1 0 0 0-.93 0l-7.803 4.096A.5.5 0 0 1 3 20.824V3.75a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "M4.3 4.05V19.5l6.63-3.482a2.3 2.3 0 0 1 2.14 0l6.63 3.481V4.05z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inactiveScrap24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "inactiveScrap24_svg__b",
    width: 28,
    height: 28.573,
    x: -2,
    y: -0.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67579",
    result: "shape"
  })))));
};

var _g$1, _defs;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var SvgInactiveScrap32 = function SvgInactiveScrap32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#inactiveScrap32_svg__a)",
    clipRule: "evenodd",
    filter: "url(#inactiveScrap32_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.3v21.55l9.536-5.007a2.3 2.3 0 0 1 2.138 0l9.535 5.006V5.3zM5 4a1 1 0 0 0-1 1v23.173a.5.5 0 0 0 .732.443l10.708-5.622a1 1 0 0 1 .93 0l10.707 5.622a.5.5 0 0 0 .732-.443V5a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "M5.3 5.3v21.55l9.536-5.007a2.3 2.3 0 0 1 2.138 0l9.535 5.006V5.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inactiveScrap32_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "inactiveScrap32_svg__b",
    width: 33.81,
    height: 34.673,
    x: -1,
    y: 1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67578",
    result: "shape"
  })))));
};

var _path$3;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgActiveScrap24 = function SvgActiveScrap24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0AA5FF",
    fillRule: "evenodd",
    d: "M20 2.75H4a1 1 0 0 0-1 1v17.073a.5.5 0 0 0 .732.442l7.803-4.096a1 1 0 0 1 .93 0l7.803 4.096a.5.5 0 0 0 .732-.442V3.75a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};

var _path$2;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgActiveScrap32 = function SvgActiveScrap32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0AA5FF",
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h21.81a1 1 0 0 1 1 1v23.173a.5.5 0 0 1-.733.443L16.37 22.994a1 1 0 0 0-.93 0L4.732 28.616A.5.5 0 0 1 4 28.173z",
    clipRule: "evenodd"
  })));
};

var SCRAP = {
  inactive: {
    24: SvgInactiveScrap24,
    32: SvgInactiveScrap32
  },
  active: {
    24: SvgActiveScrap24,
    32: SvgActiveScrap32
  }
};
var ScrapButtonSet = function ScrapButtonSet(_ref) {
  var size = _ref.size,
    isActive = _ref.isActive;
  var InactiveIcon = SCRAP['inactive'][size];
  var ActiveIcon = SCRAP['active'][size];
  return jsxs(Fragment$1, {
    children: [jsx(ActiveIcon, {
      css: /*#__PURE__*/css("opacity:", isActive ? 1 : 0, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }), jsx(InactiveIcon, {
      css: /*#__PURE__*/css("opacity:", isActive ? 0 : 1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    })]
  });
};
var ICONS_MAP = {
  scrap: ScrapButtonSet
};

var _excluded$1g = ["name", "size", "active", "onActive", "onInactive", "initialActive"];
function ToggleButton(_ref) {
  var name = _ref.name,
    size = _ref.size,
    active = _ref.active,
    onActive = _ref.onActive,
    onInactive = _ref.onInactive,
    _ref$initialActive = _ref.initialActive,
    initialActive = _ref$initialActive === void 0 ? false : _ref$initialActive,
    rest = _objectWithoutProperties(_ref, _excluded$1g);
  var theme = useTheme();
  var _useState = useState(initialActive),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setActive = _useState2[1];
  useEffect(function () {
    if (active === undefined) return;
    setActive(active);
  }, [active]);
  var Icons = ICONS_MAP[name];
  var handleClick = useCallback(function () {
    var _a;
    (_a = isActive ? onInactive : onActive) === null || _a === void 0 ? void 0 : _a();
    if (active !== undefined) return;
    setActive(!isActive);
  }, [onActive, onInactive, active, isActive]);
  return jsx("button", _objectSpread2(_objectSpread2({
    type: "button",
    onClick: handleClick,
    "aria-label": "".concat(name, " \uD1A0\uAE00 \uBC84\uD2BC"),
    css: [RESET_BUTTON, /*#__PURE__*/css("display:flex;justify-content:center;align-items:center;width:", pxToRem(size + 12), ";height:", pxToRem(size + 12), ";position:relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
  }, rest), {}, {
    children: jsx("span", {
      css: [/*#__PURE__*/css("display:inline-block;font-size:", pxToRem(size), ";line-height:1;transform:translateZ(0);&>svg{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), !isActive && name === 'scrap' && /*#__PURE__*/css("&>svg{filter:drop-shadow(0 ", pxToRem(2), " ", pxToRem(5), " ", theme.shadow.thick, ");}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: jsx(Icons, {
        size: size,
        isActive: isActive
      })
    })
  }));
}

var _excluded$1f = ["forwardedRef", "size", "variant", "disabled", "children"];
function getTextButtonWithIconOptions(size, iconSize) {
  return {
    gap: {
      30: 4,
      32: 2
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}
function cssSize$3(size) {
  switch (size) {
    case 30:
      return /*#__PURE__*/css(FONT_STYLE.subTitle1, " padding:0 ", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
    case 32:
      return /*#__PURE__*/css(FONT_STYLE.subTitle2, " padding:0 ", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
  }
}
function cssVariant$4(theme, variant) {
  switch (variant) {
    case 'primary1':
      return /*#__PURE__*/css("color:", theme.content.primary1.basic, ";font-weight:700;&:active{background-color:", theme.interactive.transparent, ";}@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.transparent, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'base1':
      return /*#__PURE__*/css("color:", theme.content.base1, ";font-weight:500;&:active{background-color:", theme.interactive.transparent, ";}@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.transparent, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'onDark':
      return /*#__PURE__*/css("color:", theme.content.white, ";font-weight:500;&:active{background-color:", theme.interactive.onDark, ";}@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.onDark, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
  }
}
/**
 * @deprecated ODS의 TextButton 컴포넌트를 사용해 주세요.
 */
function TextButton(_ref) {
  var forwardedRef = _ref.forwardedRef,
    size = _ref.size,
    variant = _ref.variant,
    disabled = _ref.disabled,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1f);
  var theme = useTheme();
  return jsx("button", _objectSpread2(_objectSpread2({
    type: "button"
  }, rest), {}, {
    ref: forwardedRef,
    disabled: disabled,
    css: [/*#__PURE__*/css(RESET_BUTTON, " height:", pxToRem(size), ";border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), cssSize$3(size), disabled ? /*#__PURE__*/css("color:", theme.content.base3, ";background-color:transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : cssVariant$4(theme, variant)],
    children: children
  }));
}

/**
 * @deprecated ODS의 TextButton 컴포넌트를 사용해 주세요.
 */
var TextButtonWithIcon = withIcon(TextButton, function (_ref) {
  var size = _ref.size,
    iconSize = _ref.iconSize;
  return getTextButtonWithIconOptions(size, iconSize);
});

function cssBaseFab(theme, size) {
  return /*#__PURE__*/css(RESET_BUTTON, " ", SHADOW_STYLE.depth30(theme), " height:", pxToRem(size), ";line-height:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseFab;"));
}
function cssFabVariant(theme, variant) {
  switch (variant) {
    case 'white':
      return /*#__PURE__*/css("color:", theme.content.base1, ";background-color:", theme.background.elevated, ";&:hover,&:active{background-color:", theme.interactive.transparent, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFabVariant;"));
    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";&:hover,&:active{background-color:", theme.interactive[variant].basic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFabVariant;"));
  }
}

var _excluded$1e = ["forwardedRef", "size", "variant", "children"];
function Fab(_ref) {
  var forwardedRef = _ref.forwardedRef,
    size = _ref.size,
    variant = _ref.variant,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1e);
  var theme = useTheme();
  return jsx("button", _objectSpread2(_objectSpread2({}, rest), {}, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/css("border-radius:50%;width:", pxToRem(size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: children
  }));
}

var _excluded$1d = ["icon"];
function IconFab(_ref) {
  var icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded$1d);
  return jsx(Fab, _objectSpread2(_objectSpread2({}, rest), {}, {
    children: jsx(Icon, {
      size: 24,
      name: icon
    })
  }));
}

var _excluded$1c = ["forwardedRef", "size", "variant", "children"];
function ExtendedFab(_ref) {
  var forwardedRef = _ref.forwardedRef,
    size = _ref.size,
    variant = _ref.variant,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1c);
  var theme = useTheme();
  return jsx("button", _objectSpread2(_objectSpread2({}, rest), {}, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/css(FONT_STYLE.subTitle1, " font-weight:700;padding:0 ", pxToRem(16), ";border-radius:", pxToRem(size / 2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: children
  }));
}

var ExtendedFabWithIcon = withIcon(ExtendedFab, function () {
  return {
    gap: 8,
    iconSize: 24
  };
});

var _excluded$1b = ["forwardedRef", "onCheck", "onChange"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$13() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$Z = process.env.NODE_ENV === "production" ? {
  name: "8um586",
  styles: "position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;margin:0;cursor:pointer"
} : {
  name: "1eso5rw-css",
  styles: "position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;margin:0;cursor:pointer;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$13
};
function HiddenInput(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
    onCheck = _ref2.onCheck,
    _onChange = _ref2.onChange,
    rest = _objectWithoutProperties(_ref2, _excluded$1b);
  return jsx("input", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: forwardedRef,
    type: "checkbox",
    onChange: function onChange(e) {
      return onCheckHandler(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    },
    css: _ref$Z
  }));
}

var _excluded$1a = ["className", "checked", "size"];
var TOGGLE_SIZE = {
  sm: function sm() {
    return {
      toggle: {
        width: 42,
        height: 24
      },
      knob: {
        width: 20,
        height: 20
      }
    };
  },
  md: function md() {
    return {
      toggle: {
        width: 50,
        height: 30
      },
      knob: {
        width: 26,
        height: 26
      }
    };
  }
};
function Toggle(_ref) {
  var className = _ref.className,
    checked = _ref.checked,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded$1a);
  var theme = useTheme();
  var _TOGGLE_SIZE$size = TOGGLE_SIZE[size](),
    toggle = _TOGGLE_SIZE$size.toggle,
    knob = _TOGGLE_SIZE$size.knob;
  var x = checked ? toggle.width - knob.width - 4 : 0;
  return jsx("div", {
    className: className,
    css: /*#__PURE__*/css("position:relative;display:inline-block;width:", toggle.width, "px;height:", toggle.height, "px;border-radius:25px;background-color:", checked ? theme.content.primary1.basic : theme.content.base3, ";&::before{", SHADOW_STYLE.depth20(theme), " content:\"\";position:absolute;top:2px;left:2px;width:", knob.width, "px;height:", knob.height, "px;border-radius:50%;background-color:", theme.content.white, ";transform:translateX(", checked ? x : 0, "px);transition:transform 0.2s ease;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: jsx(HiddenInput, _objectSpread2(_objectSpread2({}, rest), {}, {
      checked: checked
    }))
  });
}

var _templateObject$m;
var _excluded$19 = ["className", "icon", "disabled", "checked"];
function Checkbox$1(_ref) {
  var className = _ref.className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'check' : _ref$icon,
    disabled = _ref.disabled,
    checked = _ref.checked,
    rest = _objectWithoutProperties(_ref, _excluded$19);
  var theme = useTheme();
  return jsxs("div", {
    className: className,
    css: [/*#__PURE__*/css("display:inline-block;position:relative;width:", pxToRem(20), ";height:", pxToRem(20), ";border:", pxToRem(1), " solid;border-radius:", pxToRem(4), ";box-sizing:border-box;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), disabled ? /*#__PURE__*/css("border-color:", theme.content.base3, ";background-color:", theme.content.base3, ";pointer-events:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : /*#__PURE__*/css("border-color:", checked ? theme.content.primary1.basic : theme.border, ";background-color:", checked ? theme.content.primary1.basic : theme.content.white, ";transition:border-color 0.1s,background-color 0.1s;", HOVER(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n                background-color: ", ";\n                border-color: ", ";\n              "])), checked ? theme.interactive.primary1.basic : theme.interactive.transparent, checked ? theme.interactive.primary1.basic : theme.border), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: [jsx("div", {
      css: /*#__PURE__*/css("position:absolute;overflow:hidden;top:", pxToRem(3.6), ";left:", pxToRem(3), ";width:", pxToRem(checked ? 12 : 0), ";height:", pxToRem(12), ";transition:width 0.2s 0.1s;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(Icon, {
        size: 12,
        name: icon,
        css: /*#__PURE__*/css("vertical-align:top;color:", theme.content.base6, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      })
    }), jsx(HiddenInput, _objectSpread2(_objectSpread2({}, rest), {}, {
      checked: checked,
      disabled: disabled
    }))]
  });
}

var _excluded$18 = ["id", "className", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$12() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$Y = process.env.NODE_ENV === "production" ? {
  name: "ozd7xs",
  styles: "flex-shrink:0"
} : {
  name: "19pkz4e-css",
  styles: "flex-shrink:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$12
};
var _ref2$h = process.env.NODE_ENV === "production" ? {
  name: "11dqc0c",
  styles: "display:inline-flex;align-items:center;cursor:pointer"
} : {
  name: "1xiro0s-css",
  styles: "display:inline-flex;align-items:center;cursor:pointer;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$12
};
function CheckboxWithText(_ref3) {
  var id = _ref3.id,
    className = _ref3.className,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded$18);
  var theme = useTheme();
  return jsxs("label", {
    css: _ref2$h,
    className: className,
    htmlFor: id,
    children: [jsx(Checkbox$1, _objectSpread2(_objectSpread2({}, rest), {}, {
      id: id,
      css: _ref$Y
    })), jsx("span", {
      css: /*#__PURE__*/css("flex:1;", FONT_STYLE.subTitle1, " margin-left:", pxToRem(6), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: children
    })]
  });
}

var _templateObject$l;
var _excluded$17 = ["forwardedRef", "className", "disabled", "checked"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$11() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$X = process.env.NODE_ENV === "production" ? {
  name: "s6rm2m",
  styles: "cursor:pointer;position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;margin:0;&:disabled{cursor:default;}"
} : {
  name: "yoat3a-css",
  styles: "cursor:pointer;position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;margin:0;&:disabled{cursor:default;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$11
};
function Radio(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
    className = _ref2.className,
    disabled = _ref2.disabled,
    checked = _ref2.checked,
    rest = _objectWithoutProperties(_ref2, _excluded$17);
  var theme = useTheme();
  return jsx("div", {
    className: className,
    css: [/*#__PURE__*/css("display:inline-block;position:relative;width:", pxToRem(20), ";height:", pxToRem(20), ";border:", pxToRem(1), " solid;border-radius:50%;box-sizing:border-box;&::before{content:\"\";position:absolute;border-radius:50%;top:", pxToRem(5), ";left:", pxToRem(5), ";width:", pxToRem(8), ";height:", pxToRem(8), ";transform:scale(", checked ? 1 : 0, ");transition:transform 0.4s cubic-bezier(0.5, 2, 0.5, 0.5);background-color:", theme.content.base6, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), disabled ? /*#__PURE__*/css("border-color:", theme.content.base3, ";background-color:", theme.content.base3, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : /*#__PURE__*/css("border-color:", checked ? theme.content.primary1.basic : theme.content.base3, ";background-color:", checked ? theme.content.primary1.basic : theme.content.white, ";transition:border-color 0.1s,background-color 0.1s;", HOVER(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n                background-color: ", ";\n                border-color: ", ";\n              "])), checked ? theme.interactive.primary1.basic : theme.interactive.transparent, checked ? theme.interactive.primary1.basic : theme.content.base3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: jsx("input", _objectSpread2(_objectSpread2({}, rest), {}, {
      ref: forwardedRef,
      type: "radio",
      checked: checked,
      disabled: disabled,
      css: _ref$X
    }))
  });
}

var _excluded$16 = ["id", "className", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$10() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$W = process.env.NODE_ENV === "production" ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : {
  name: "b5pnrc-css",
  styles: "vertical-align:middle;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$10
};
var _ref2$g = process.env.NODE_ENV === "production" ? {
  name: "1r5gb7q",
  styles: "display:inline-block"
} : {
  name: "ml6ob0-css",
  styles: "display:inline-block;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$10
};
function RadioWithText(_ref3) {
  var id = _ref3.id,
    className = _ref3.className,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded$16);
  var theme = useTheme();
  return jsxs("label", {
    css: _ref2$g,
    className: className,
    htmlFor: id,
    children: [jsx(Radio, _objectSpread2(_objectSpread2({}, rest), {}, {
      id: id,
      css: _ref$W
    })), jsx("span", {
      css: /*#__PURE__*/css(FONT_STYLE.subTitle1, " vertical-align:middle;margin-left:", pxToRem(6), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: children
    })]
  });
}

var GRID_ITEM_CLASS_NAME = 'bucketplace-grid-item';
var COLUMN_CLASS_NAME = 'bucketplace-column';
function cssBaseGap(gap, className) {
  var _split$map = "".concat(gap).split(' ').map(Number),
    _split$map2 = _slicedToArray(_split$map, 2),
    vertical = _split$map2[0],
    horizontal = _split$map2[1];
  if (horizontal) {
    var verticalGap = pxToRem(vertical / 2);
    var horizontalGap = pxToRem(horizontal / 2);
    return "\n      margin: -".concat(verticalGap, " -").concat(horizontalGap, ";\n      > .").concat(className, " {\n        padding: ").concat(verticalGap, " ").concat(horizontalGap, ";\n      }\n    ");
  }
  var halfGap = pxToRem(vertical / 2);
  return "\n    margin: -".concat(halfGap, ";\n    > .").concat(className, " {\n      padding: ").concat(halfGap, ";\n    }\n  ");
}
function cssGap(gap, className) {
  if (_typeof(gap) === 'object') {
    var _gap$mobile = gap.mobile,
      mobile = _gap$mobile === void 0 ? 0 : _gap$mobile,
      _gap$tablet = gap.tablet,
      tablet = _gap$tablet === void 0 ? mobile : _gap$tablet,
      _gap$laptop = gap.laptop,
      laptop = _gap$laptop === void 0 ? tablet : _gap$laptop;
    return /*#__PURE__*/css(cssBaseGap(mobile, className), " ", MEDIA_QUERY.min('tablet', cssBaseGap(tablet, className)), " ", MEDIA_QUERY.min('laptop', cssBaseGap(laptop, className)), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssGap;"));
  }
  return /*#__PURE__*/css(cssBaseGap(gap, className), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssGap;"));
}

var _excluded$15 = ["gap", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$$() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var DEFAULT_GAP = {
  mobile: 12,
  tablet: 16,
  laptop: 20,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 20
};
var _ref$V = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "oj32ga-css",
  styles: "overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$$
};
function Grid(_ref2) {
  var _ref2$gap = _ref2.gap,
    gap = _ref2$gap === void 0 ? DEFAULT_GAP : _ref2$gap,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded$15);
  return jsx("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: _ref$V,
    children: jsx("div", {
      css: cssGap(gap, GRID_ITEM_CLASS_NAME),
      children: children
    })
  }));
}

var _excluded$14 = ["column", "className", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var TOTAL_COLUMN = {
  mobile: 4,
  tablet: 8,
  laptop: 12,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 12
};
var COLUMN_PRESET = {
  full: {
    mobile: 4,
    tablet: 8,
    laptop: 12,
    desktop: 12
  },
  half: {
    mobile: 2,
    tablet: 4,
    laptop: 6,
    desktop: 6
  },
  quarter: {
    mobile: 1,
    tablet: 2,
    laptop: 3,
    desktop: 3
  }
};
function cssColumn$1(breakPoint, column) {
  return /*#__PURE__*/css(MEDIA_QUERY.min(breakPoint, "\n      width: ".concat(100 / TOTAL_COLUMN[breakPoint] * (typeof column === 'number' ? column : COLUMN_PRESET[column][breakPoint]), "%;\n    ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumn;"));
}
var _ref$U = process.env.NODE_ENV === "production" ? {
  name: "1kgy64",
  styles: "display:inline-block;vertical-align:top;box-sizing:border-box"
} : {
  name: "sve5ep-css",
  styles: "display:inline-block;vertical-align:top;box-sizing:border-box;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$_
};
function GridItem(_ref2) {
  var column = _ref2.column,
    className = _ref2.className,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded$14);
  var _ref3 = _typeof(column) === 'object' ? column : COLUMN_PRESET[column],
    _ref3$mobile = _ref3.mobile,
    mobile = _ref3$mobile === void 0 ? 1 : _ref3$mobile,
    _ref3$tablet = _ref3.tablet,
    tablet = _ref3$tablet === void 0 ? mobile : _ref3$tablet,
    _ref3$laptop = _ref3.laptop,
    laptop = _ref3$laptop === void 0 ? tablet : _ref3$laptop,
    _ref3$desktop = _ref3.desktop,
    desktop = _ref3$desktop === void 0 ? laptop : _ref3$desktop;
  return jsx("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [_ref$U, cssColumn$1('mobile', mobile), cssColumn$1('tablet', tablet), cssColumn$1('laptop', laptop), cssColumn$1('desktop', desktop)],
    className: spaces(className, GRID_ITEM_CLASS_NAME),
    children: children
  }));
}

var _excluded$13 = ["gap", "columns", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$Z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function cssColumn(column) {
  var ratios = column.split(' ').map(Number);
  var total = ratios.reduce(function (v1, v2) {
    return v1 + v2;
  });
  return "\n    > .".concat(COLUMN_CLASS_NAME, " {\n      ").concat(ratios.map(function (ratio, index) {
    return "\n        &:nth-of-type(".concat(ratios.length, "n + ").concat(index + 1, ") {\n          width: ").concat(100 / total * ratio, "%;\n        }\n      ");
  }), "\n    }\n  ");
}
function cssColumns(columns) {
  if (_typeof(columns) === 'object') {
    var mobile = columns.mobile,
      _columns$tablet = columns.tablet,
      tablet = _columns$tablet === void 0 ? mobile : _columns$tablet,
      _columns$laptop = columns.laptop,
      laptop = _columns$laptop === void 0 ? tablet : _columns$laptop;
    return /*#__PURE__*/css(cssColumn(mobile), " ", MEDIA_QUERY.min('tablet', cssColumn(tablet)), " ", MEDIA_QUERY.min('laptop', cssColumn(laptop)), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumns;"));
  }
  return /*#__PURE__*/css(cssColumn(columns), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumns;"));
}
var _ref$T = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "oj32ga-css",
  styles: "overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Z
};
function Row$1(_ref2) {
  var gap = _ref2.gap,
    columns = _ref2.columns,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded$13);
  return jsx("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: _ref$T,
    children: jsx("div", {
      css: [gap && cssGap(gap, COLUMN_CLASS_NAME), cssColumns(columns)],
      children: children
    })
  }));
}

var _excluded$12 = ["children", "className"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$Y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$S = process.env.NODE_ENV === "production" ? {
  name: "x9illq",
  styles: "display:inline-block;vertical-align:top"
} : {
  name: "fjwarr-css",
  styles: "display:inline-block;vertical-align:top;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Y
};
function Column(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded$12);
  return jsx("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    className: spaces(className, COLUMN_CLASS_NAME),
    css: _ref$S,
    children: children
  }));
}

function getActiveIds(menuSchema, fallbackMenuSchema) {
  // Check for fallback menu schema first
  if (fallbackMenuSchema != null) {
    var index = fallbackMenuSchema.findIndex(function (item) {
      return item.active;
    });
    if (index !== -1) {
      return [null, index];
    }
  }
  // Try to descend down to the matching entry
  for (var i = 0; i < menuSchema.length; i += 1) {
    var child = menuSchema[i];
    var childActiveIds = getActiveIdsEntry(child);
    // If the child has 'active' entry, merge all indices
    if (childActiveIds != null) {
      return [i].concat(_toConsumableArray(childActiveIds));
    }
  }
  // Nothing matched
  return [null];
}
function getActiveIdsEntry(entry) {
  if (entry.entries != null) {
    for (var i = 0; i < entry.entries.length; i += 1) {
      var child = entry.entries[i];
      var childActiveIds = getActiveIdsEntry(child);
      // If the child has 'active' entry, merge all indices
      if (childActiveIds != null) {
        return [i].concat(_toConsumableArray(childActiveIds));
      }
    }
  }
  if (entry.active) {
    // If the entry itself is active, return itself
    return [];
  }
  // Otherwise, it didn't match
  return null;
}

var LinkContext = /*#__PURE__*/createContext('a');
var useLinkContext = function useLinkContext() {
  return useContext(LinkContext);
};
function LinkProvider(_ref) {
  var children = _ref.children,
    linkComponent = _ref.linkComponent;
  return jsx(LinkContext.Provider, {
    value: linkComponent,
    children: children
  });
}

var _excluded$11 = ["children"];
function Container$4(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$11);
  return jsx("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: /*#__PURE__*/css("width:100%;padding:0 ", pxToRem(16), ";box-sizing:border-box;", MEDIA_QUERY.min('tablet', "\n          padding: 0 ".concat(pxToRem(40), ";\n        ")), " ", MEDIA_QUERY.min('laptop', "\n          padding: 0 ".concat(pxToRem(60), ";\n        ")), " ", MEDIA_QUERY.min('desktop', "\n          max-width: ".concat(BREAK_POINT.desktop, "px;\n          margin: 0 auto;\n          padding: 0 ").concat(pxToRem(60), ";\n        ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: children
  }));
}

var LogContext = /*#__PURE__*/createContext(function () {});
var useLogContext = function useLogContext() {
  return useContext(LogContext);
};
function LogProvider(_ref) {
  var children = _ref.children,
    onLog = _ref.onLog;
  return jsx(LogContext.Provider, {
    value: onLog,
    children: children
  });
}

function useHover(onHover) {
  var onHoverRef = useRef(onHover);
  onHoverRef.current = onHover;
  var timeoutRef = useRef(null);
  var handleMouseTimeout = useCallback(function () {
    onHoverRef.current();
    timeoutRef.current = null;
  }, []);
  var handleMouseMove = useCallback(function () {
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout]);
  var handleMouseEnter = useCallback(function () {
    window.addEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout, handleMouseMove]);
  var handleMouseLeave = useCallback(function () {
    window.removeEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [handleMouseMove]);
  useEffect(function () {
    return function () {
      window.removeEventListener('mousemove', handleMouseMove);
      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [handleMouseMove]);
  return [handleMouseEnter, handleMouseLeave];
}

var _templateObject$k, _templateObject2$c;
var _excluded$10 = ["component", "index", "isActive", "isOpen", "children", "onSelect", "forwardedRef", "onClick"];
function NavigationBarPrimaryTabItem(props) {
  var _props$component = props.component,
    component = _props$component === void 0 ? 'button' : _props$component,
    index = props.index,
    isActive = props.isActive,
    isOpen = props.isOpen,
    children = props.children,
    onSelect = props.onSelect,
    forwardedRef = props.forwardedRef,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded$10);
  var theme = useTheme();
  var log = useLogContext();
  var handleClick = useCallback(function (e) {
    if (onClick) onClick(e);
    log({
      key: 'primary.item',
      category: 'click',
      params: {
        index: index
      }
    });
  }, [log, onClick, index]);
  var _useHover = useHover(onSelect),
    _useHover2 = _slicedToArray(_useHover, 2),
    handleMouseEnter = _useHover2[0],
    handleMouseLeave = _useHover2[1];
  var Component = component;
  return jsx(Component, _objectSpread2(_objectSpread2({
    css: [/*#__PURE__*/css(RESET_BUTTON, " position:relative;display:inline-block;margin:0 ", pxToRem(10), ";padding:", pxToRem(21), " ", pxToRem(5), " ", pxToRem(15), ";font-size:", pxToRem(18), ";line-height:1;font-weight:bold;color:", theme.content.base1, ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), isActive && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), isOpen && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), theme.content.primary1.basic), FOCUS(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n          color: ", ";\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), theme.content.primary1.basic, pxToRem(3), theme.interactive.primary1.thin)],
    ref: forwardedRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, rest), {}, {
    children: jsx("span", {
      css: /*#__PURE__*/css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: children
    })
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$X() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var INITIAL_NODE_HEIGHT$1 = 81;
function NavigationBarPrimary(props) {
  var leftmost = props.leftmost,
    left = props.left,
    right = props.right,
    menuEntries = props.menuEntries,
    activeId = props.activeId,
    selectedId = props.selectedId,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    _onSelect = props.onSelect;
  var LinkComponent = useLinkContext();
  var childRef = useRef(null);
  var isPc = useMedia("(min-width: ".concat(BREAK_POINT.tablet, "px)"), true);
  var nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT$1);
  var scrollDir = useScrollDirection();
  return jsx(StyledSticky$1, {
    direction: "top",
    offset: !isPc && scrollDir === 'down' ? -nodeHeight : 0,
    offsetRange: isPc ? [0, 0] : [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    zIndex: ZINDEX.appBar + 2,
    transition: 0.1,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    forwardRef: childRef,
    children: jsxs(StyledContainer$2, {
      children: [jsx(LeftMost, {
        children: leftmost
      }), jsx(Left, {
        children: left
      }), jsx(NavigationBarPrimaryTabList, {
        children: menuEntries.map(function (item, index) {
          return jsx(NavigationBarPrimaryTabItem, {
            index: index,
            component: LinkComponent,
            href: item.href,
            isActive: activeId === index,
            isOpen: selectedId === index,
            onSelect: function onSelect() {
              return _onSelect(item, index);
            },
            children: item.title
          }, index);
        })
      }), jsx(Right$1, {
        children: right
      })]
    })
  });
}
var StyledSticky$1 = /*#__PURE__*/_styled(Sticky, process.env.NODE_ENV === "production" ? {
  target: "e1qjsy915"
} : {
  target: "e1qjsy915",
  label: "StyledSticky"
})("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.background.base;
}, ";border-bottom:", pxToRem(1), " solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.divider;
}, ";");
var StyledContainer$2 = /*#__PURE__*/_styled(Container$4, process.env.NODE_ENV === "production" ? {
  target: "e1qjsy914"
} : {
  target: "e1qjsy914",
  label: "StyledContainer"
})("position:relative;display:flex;align-items:center;justify-content:space-between;height:", pxToRem(50), ";box-sizing:border-box;line-height:0;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("height:", pxToRem(80), ";padding-top:", pxToRem(10), ";padding-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledContainer;"))), ";");
var LeftMost = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy913"
} : {
  target: "e1qjsy913",
  label: "LeftMost"
})("flex:0 0 auto;display:block;margin-left:", pxToRem(-7), ";", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "jk5cn7-LeftMost",
  styles: "display:none;label:LeftMost;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$X
}), ";");
var Left = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy912"
} : {
  target: "e1qjsy912",
  label: "Left"
})("position:absolute;flex:0 0 auto;left:50%;top:50%;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.interactive.base1;
}, ";transform:translate(-50%, -50%);", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("position:static;margin-right:", pxToRem(20), ";left:none;top:none;transform:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:Left;"))), " ", MEDIA_QUERY.min('laptop', /*#__PURE__*/css("margin-right:", pxToRem(35), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Left;"))), ";");
var NavigationBarPrimaryTabList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy911"
} : {
  target: "e1qjsy911",
  label: "NavigationBarPrimaryTabList"
})("flex:1 1 0px;display:none;white-space:nowrap;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "17kma8h-NavigationBarPrimaryTabList",
  styles: "display:block;label:NavigationBarPrimaryTabList;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$X
}), ";");
var Right$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy910"
} : {
  target: "e1qjsy910",
  label: "Right"
})("flex:0 0 auto;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("flex:0 1 ", pxToRem(476), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Right;"))), " ", MEDIA_QUERY.min('desktop', /*#__PURE__*/css("flex:0 1 ", pxToRem(650), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Right;"))), " ", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("margin-right:", pxToRem(-7), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Right;"))), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$W() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$R = process.env.NODE_ENV === "production" ? {
  name: "11ase34",
  styles: "display:flex;align-items:stretch;overflow-x:auto;white-space:nowrap;&&>*{flex:1 0 0px;min-width:0;}"
} : {
  name: "l9gctv-css",
  styles: "display:flex;align-items:stretch;overflow-x:auto;white-space:nowrap;&&>*{flex:1 0 0px;min-width:0;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
};
var FixedTab = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var rest = _extends$7({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return jsx("nav", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: _ref$R
  }));
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$V() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$Q = process.env.NODE_ENV === "production" ? {
  name: "sbestf",
  styles: "display:flex;align-items:stretch;overflow-x:auto;white-space:nowrap;margin:0 -5px;&&>*{margin:0 5px;}"
} : {
  name: "aux4np-css",
  styles: "display:flex;align-items:stretch;overflow-x:auto;white-space:nowrap;margin:0 -5px;&&>*{margin:0 5px;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$V
};
var Tab = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var rest = _extends$7({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return jsx("nav", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: _ref$Q
  }));
});

var _path$1, _path2$1;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var SvgIcNew18 = function SvgIcNew18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77",
    fillRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3l-3.1-4.68h-.05v4.68z",
    clipRule: "evenodd"
  })));
};

/**
 * @deprecated ODS의 DotBadge 컴포넌트를 사용해 주세요.
 */
function DotNotification(props) {
  var theme = useTheme();
  return jsx("span", _objectSpread2(_objectSpread2({}, props), {}, {
    css: /*#__PURE__*/css("position:absolute;border-radius:50%;width:", pxToRem(4), ";height:", pxToRem(4), ";background-color:", theme.content.primary2.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
  }));
}

var _templateObject$j, _templateObject2$b;
var _excluded$$ = ["component", "isActive", "children", "subText", "bullet", "forwardedRef", "onClick", "badge", "className"];
function TabItem(_ref) {
  var _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'button' : _ref$component,
    isActive = _ref.isActive,
    children = _ref.children,
    subText = _ref.subText,
    bullet = _ref.bullet,
    forwardedRef = _ref.forwardedRef,
    _onClick = _ref.onClick,
    badge = _ref.badge,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded$$);
  var theme = useTheme();
  var Component = component;
  return jsx(Component, _objectSpread2(_objectSpread2({
    className: className,
    css: [/*#__PURE__*/css(RESET_BUTTON, " position:relative;display:inline-flex;flex-direction:column;justify-content:center;vertical-align:top;text-align:center;box-sizing:border-box;&:after{content:'';display:block;position:absolute;left:0;bottom:0;width:100%;height:", pxToRem(2), ";background-color:", theme.content.primary1.basic, ";transition:transform 0.2s;transform:scale(", isActive ? 1 : 0, ");}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n          & > div > p:first-of-type {\n            color: ", ";\n          }\n        "])), theme.content.primary1.basic), FOCUS(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n          & > div {\n            box-shadow: 0 0 0 3px ", ";\n            border-radius: 3px;\n          }\n        "])), theme.content.primary1.basic), subText ? /*#__PURE__*/css("padding:", pxToRem(11), " ", pxToRem(6), " ", pxToRem(5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : /*#__PURE__*/css("padding:", pxToRem(12), " ", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    ref: forwardedRef,
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    }
  }, rest), {}, {
    children: jsxs("div", {
      css: /*#__PURE__*/css("padding:", pxToRem(4), ";margin:-", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [jsxs("p", {
        css: [FONT_STYLE.subTitle1, /*#__PURE__*/css("position:relative;font-weight:", isActive ? 700 : 500, ";color:", isActive ? theme.content.primary1.basic : theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
        children: [children, badge && jsx(SquareBadge, {
          size: 16,
          type: badge.type,
          variant: badge.variant,
          css: /*#__PURE__*/css("vertical-align:middle;margin-left:", pxToRem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: badge.text
        }), bullet === 'dot' && jsx(DotNotification, {
          css: /*#__PURE__*/css("top:0;right:", pxToRem(-6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        }), bullet === 'new' && jsx(SvgIcNew18, {
          css: /*#__PURE__*/css("vertical-align:middle;margin:0 ", pxToRem(1.5), " ", pxToRem(1.5), " ", pxToRem(1.5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        })]
      }), subText && jsx("p", {
        css: [FONT_STYLE.caption2, /*#__PURE__*/css("color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
        children: subText
      })]
    })
  }));
}

var useNavigationLog = function useNavigationLog() {
  var log = useLogContext();
  var logTabImpression = useCallback(function (menu, index) {
    log({
      key: 'secondary.item',
      category: 'impression',
      params: {
        index: index,
        id: menu.logId,
        type: 'topic',
        section: '서브 메뉴',
        section_id: 'LNB'
      }
    });
  }, [log]);
  var logTabClick = useCallback(function (menu, index, isHncTopicTab) {
    var _a;
    var defaultParams = {
      index: index,
      section: '서브 메뉴',
      type: 'tab',
      id: (_a = menu.logId) !== null && _a !== void 0 ? _a : menu.title
    };
    var params = isHncTopicTab ? _objectSpread2(_objectSpread2({}, defaultParams), {}, {
      type: 'topic',
      section_id: 'LNB'
    }) : defaultParams;
    log({
      key: 'secondary.item',
      category: 'click',
      params: params
    });
  }, [log]);
  var logMoreButtonClick = useCallback(function () {
    log({
      key: 'secondary.more.button',
      category: 'click'
    });
  }, [log]);
  return {
    logTabClick: logTabClick,
    logTabImpression: logTabImpression,
    logMoreButtonClick: logMoreButtonClick
  };
};

var _excluded$_ = ["renderButton", "onChange", "usePortal", "isForceClosed", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$U() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function PopperContent(_ref2) {
  var referenceRef = _ref2.referenceRef,
    isOpen = _ref2.isOpen,
    onClose = _ref2.onClose,
    onExited = _ref2.onExited,
    children = _ref2.children,
    _ref2$placement = _ref2.placement,
    placement = _ref2$placement === void 0 ? 'bottom' : _ref2$placement,
    size = _ref2.size,
    className = _ref2.className,
    style = _ref2.style;
  var theme = useTheme();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    popperRef = _useState2[0],
    setPopperRef = _useState2[1];
  var _usePopper = usePopper(referenceRef, popperRef, {
      placement: placement,
      modifiers: [{
        name: 'offset',
        enabled: true,
        options: {
          offset: [0, 10]
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes,
    state = _usePopper.state;
  useEffect(function () {
    var handleClick = function handleClick(e) {
      var target = e.target;
      // Chrome regression
      if (e.target === document.body) return;
      if (e.defaultPrevented || target == null || target.parentElement == null) {
        return;
      }
      // If the user clicked somewhere else, close the popper
      while (target != null) {
        if (referenceRef === target || popperRef === target || target instanceof HTMLElement && target.hasAttribute('data-popout')) {
          return;
        }
        target = target.parentElement;
      }
      onClose();
    };
    window.addEventListener('click', handleClick);
    return function () {
      window.removeEventListener('click', handleClick);
    };
  }, [onClose, referenceRef, popperRef]);
  return jsx(CSSTransition
  // NOTE: This is a quirky workaround happening due to 'setPopperRef' -
  // which will confuse CSSTransition.
  // In order to workaround this, the timeout is set to 0 until the user
  // decides to close the popper.
  // https://github.com/reactjs/react-transition-group/issues/284
  , {
    // NOTE: This is a quirky workaround happening due to 'setPopperRef' -
    // which will confuse CSSTransition.
    // In order to workaround this, the timeout is set to 0 until the user
    // decides to close the popper.
    // https://github.com/reactjs/react-transition-group/issues/284
    in: popperRef != null && isOpen,
    timeout: isOpen ? 0 : 200,
    classNames: {
      enterActive: 'open',
      enterDone: 'open open-active',
      appearActive: 'open',
      exitActive: 'exiting',
      exit: 'exiting',
      exitDone: 'exiting'
    },
    onExited: onExited,
    children: jsx("div", _objectSpread2(_objectSpread2({
      ref: setPopperRef,
      style: _objectSpread2(_objectSpread2({}, styles.popper), style)
    }, attributes.popper), {}, {
      className: classNames("placement-".concat((state || {}).placement), className),
      css: /*#__PURE__*/css("opacity:1;visibility:visible;pointer-events:none;z-index:", ZINDEX.dropdown, ";&.placement-top .popper-item{transform:translate(0, 10px);}&.placement-bottom .popper-item{transform:translate(0, -10px);}&.open{transform:none;transition:.2s opacity;}&.open .popper-item{transform:none;transition:.2s transform;}&.open-active{pointer-events:auto;transition:.2s opacity;}&.exiting{opacity:0;visibility:hidden;transition:0s visibility .2s,.2s opacity;}&.exiting .popper-item{transition:.2s transform;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx("div", {
        className: "popper-item",
        style: styles.offset,
        css: /*#__PURE__*/css("position:relative;padding:8px;background-color:", theme.background.base, ";border:1px solid ", theme.interactive.base4, ";border-radius:6px;box-shadow:0 4px 10px 0 rgb(63, 71, 77, 0.2);width:", size ? pxToRem(size) : undefined, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: children
      })
    }))
  });
}
var _ref$P = process.env.NODE_ENV === "production" ? {
  name: "1amee4m",
  styles: "line-height:0"
} : {
  name: "1gt3o79-css",
  styles: "line-height:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$U
};
function Popper(_ref3) {
  var renderButton = _ref3.renderButton,
    onChange = _ref3.onChange,
    _ref3$usePortal = _ref3.usePortal,
    usePortal = _ref3$usePortal === void 0 ? true : _ref3$usePortal,
    _ref3$isForceClosed = _ref3.isForceClosed,
    isForceClosed = _ref3$isForceClosed === void 0 ? false : _ref3$isForceClosed,
    children = _ref3.children,
    other = _objectWithoutProperties(_ref3, _excluded$_);
  var _useState3 = useState({
      isVisible: false,
      isOpen: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var referenceRef = useRef(null);
  var handleClose = useCallback(function () {
    setState(function (v) {
      return _objectSpread2(_objectSpread2({}, v), {}, {
        isOpen: false
      });
    });
  }, []);
  var handleExited = useCallback(function () {
    setState({
      isVisible: false,
      isOpen: false
    });
  }, []);
  var handleToggle = useCallback(function () {
    setState(function (v) {
      return {
        isOpen: !v.isOpen,
        // If the node is visible, keep it visible. But if we need to reveal it,
        // make it visible
        isVisible: v.isVisible || !v.isOpen
      };
    });
  }, []);
  useEffect(function () {
    onChange === null || onChange === void 0 ? void 0 : onChange(state.isOpen);
  }, [state.isOpen, onChange]);
  useEffect(function () {
    if (isForceClosed) {
      handleClose();
    }
  }, [isForceClosed, handleClose]);
  return jsxs(Fragment$1, {
    children: [jsx("span", {
      ref: referenceRef,
      css: _ref$P,
      children: renderButton({
        onClick: handleToggle,
        isOpen: state.isOpen
      })
    }), state.isVisible && usePortal && jsx(OverlayPortal, {
      children: jsx(PopperContent, _objectSpread2(_objectSpread2({
        referenceRef: referenceRef.current,
        isOpen: state.isOpen,
        onClose: handleClose,
        onExited: handleExited
      }, other), {}, {
        children: children
      }))
    }), state.isVisible && !usePortal && jsx(PopperContent, _objectSpread2(_objectSpread2({
      referenceRef: referenceRef.current,
      isOpen: state.isOpen,
      onClose: handleClose,
      onExited: handleExited
    }, other), {}, {
      children: children
    }))]
  });
}

var _excluded$Z = ["onDark", "variant", "children"];
var Dim = /*#__PURE__*/forwardRef(function (props, ref) {
  var onDark = props.onDark,
    variant = props.variant,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded$Z);
  var theme = useTheme();
  return jsx("div", _objectSpread2(_objectSpread2({
    "data-testid": "bds-dim"
  }, rest), {}, {
    ref: ref,
    css: [/*#__PURE__*/css("position:fixed;top:0;left:0;width:100%;height:100%;text-align:center;z-index:", ZINDEX.modal, ";&::before{content:\"\";height:100%;display:inline-block;vertical-align:middle;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), variant && /*#__PURE__*/css("background-color:", (onDark ? theme.dim.onDark : theme.dim)[variant], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: children
  }));
});

var GAP$1 = 10;
var ICON_SIZE$3 = 24;
function ModalHeader(_ref) {
  var title = _ref.title,
    onBack = _ref.onBack,
    onClose = _ref.onClose;
  var theme = useTheme();
  return jsxs("div", {
    css: /*#__PURE__*/css("padding:", pxToRem(16), " ", pxToRem(16), " ", pxToRem(10), " ", pxToRem(16), ";line-height:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [onBack && jsx("button", {
      type: "button",
      onClick: onBack,
      css: /*#__PURE__*/css(RESET_BUTTON, " vertical-align:middle;width:", pxToRem(ICON_SIZE$3), ";height:", pxToRem(ICON_SIZE$3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(Icon, {
        size: ICON_SIZE$3,
        name: "arrow_left",
        css: /*#__PURE__*/css("color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      })
    }), jsx("span", {
      css: [FONT_STYLE.title2, /*#__PURE__*/css("display:inline-block;vertical-align:middle;font-weight:700;text-align:center;width:calc(100% - ", pxToRem((GAP$1 + ICON_SIZE$3) * 2), ");margin-left:", pxToRem(onBack ? GAP$1 : ICON_SIZE$3), ";margin-right:", pxToRem(onClose ? GAP$1 : ICON_SIZE$3), ";white-space:pre-line;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: title
    }), onClose && jsx("button", {
      type: "button",
      onClick: onClose,
      css: /*#__PURE__*/css(RESET_BUTTON, " vertical-align:middle;width:", pxToRem(ICON_SIZE$3), ";height:", pxToRem(ICON_SIZE$3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(Icon, {
        size: ICON_SIZE$3,
        name: "dismiss",
        css: /*#__PURE__*/css("color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$T() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$O = process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "7hnnku-css",
  styles: "width:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
};
function ModalFooter(_ref2) {
  var action = _ref2.action,
    subAction = _ref2.subAction,
    style = _ref2.style;
  var _a, _b, _c;
  return jsxs("div", {
    css: [style, /*#__PURE__*/css("padding:", pxToRem(9), " ", pxToRem(16), ";line-height:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: [action && jsxs("div", {
      css: /*#__PURE__*/css("padding-top:", pxToRem(1), ";padding-bottom:", pxToRem(subAction ? 9 : 7), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [action.secondary && (!Array.isArray(action.secondary) ? jsx(OutlineButton, {
        size: 50,
        variant: "base1",
        onClick: action.secondary.onClick,
        disabled: (_a = action.secondary.disabled) !== null && _a !== void 0 ? _a : false,
        css: /*#__PURE__*/css("width:calc(50% - ", pxToRem(5), ");margin-right:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: action.secondary.text
      }) : jsx(Fragment$1, {
        children: action.secondary.map(function (secondaryAction, index) {
          var _a;
          return jsx(OutlineButton, {
            size: 50,
            variant: "base1",
            onClick: secondaryAction.onClick,
            disabled: (_a = secondaryAction.disabled) !== null && _a !== void 0 ? _a : false,
            css: [/*#__PURE__*/css("width:calc(50% - ", pxToRem(5), ");" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), index === 0 && /*#__PURE__*/css("margin-right:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
            children: secondaryAction.text
          }, index);
        })
      })), action.primary && jsx(Button$2, {
        size: 50,
        variant: "primary1",
        onClick: action.primary.onClick,
        disabled: (_b = action.primary.disabled) !== null && _b !== void 0 ? _b : false,
        css: action.secondary ? /*#__PURE__*/css("width:calc(50% - ", pxToRem(5), ");" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : _ref$O,
        children: action.primary.text
      })]
    }), subAction && jsx(TextButton, {
      size: 32,
      variant: "base1",
      onClick: subAction.onClick,
      disabled: (_c = subAction.disabled) !== null && _c !== void 0 ? _c : false,
      children: subAction.text
    })]
  });
}

var _excluded$Y = ["width", "onBlur", "header", "footer", "isPopupInMobile", "isStretch", "stretch", "children", "hasInteraction", "height", "hasGrabber", "disableBackgroundScroll"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$S() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var LAPTOP_HEIGHT = {
  300: '48%',
  400: '78%',
  500: '84%',
  600: '90%',
  700: '96%',
  1200: '96%'
};
var MARGIN = {
  300: '0',
  400: '0',
  500: '0',
  600: '0',
  700: '0',
  1200: "0 ".concat(pxToRem(80))
};
var _ref2$f = process.env.NODE_ENV === "production" ? {
  name: "1uvus3f",
  styles: "display:flex;flex-direction:column;width:100%;height:100%;word-break:break-all;overflow-y:auto"
} : {
  name: "1c70nwk-css",
  styles: "display:flex;flex-direction:column;width:100%;height:100%;word-break:break-all;overflow-y:auto;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
var _ref3$7 = process.env.NODE_ENV === "production" ? {
  name: "1kx2ysr",
  styles: "align-items:flex-end"
} : {
  name: "1hqbzsr-css",
  styles: "align-items:flex-end;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
function Modal(_ref4) {
  var width = _ref4.width,
    onBlur = _ref4.onBlur,
    header = _ref4.header,
    footer = _ref4.footer,
    _ref4$isPopupInMobile = _ref4.isPopupInMobile,
    isPopupInMobile = _ref4$isPopupInMobile === void 0 ? false : _ref4$isPopupInMobile,
    _ref4$isStretch = _ref4.isStretch,
    isStretch = _ref4$isStretch === void 0 ? false : _ref4$isStretch,
    stretch = _ref4.stretch,
    children = _ref4.children,
    _ref4$hasInteraction = _ref4.hasInteraction,
    hasInteraction = _ref4$hasInteraction === void 0 ? false : _ref4$hasInteraction,
    _ref4$height = _ref4.height,
    height = _ref4$height === void 0 ? '' : _ref4$height,
    _ref4$hasGrabber = _ref4.hasGrabber,
    hasGrabber = _ref4$hasGrabber === void 0 ? false : _ref4$hasGrabber,
    _ref4$disableBackgrou = _ref4.disableBackgroundScroll,
    disableBackgroundScroll = _ref4$disableBackgrou === void 0 ? false : _ref4$disableBackgrou,
    rest = _objectWithoutProperties(_ref4, _excluded$Y);
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var scrollAvailableRef = useRef(null);
  var modalRef = useRef(null);
  var grabberRef = useRef(null);
  var _useState = useState(height),
    _useState2 = _slicedToArray(_useState, 2),
    customHeight = _useState2[0],
    setCustomHeight = _useState2[1];
  var isPopup = isPopupInMobile && width === 300;
  useEffect(function () {
    if (height !== 'auto') {
      setCustomHeight(height);
      return;
    }
    if (!modalRef.current || hasGrabber && !grabberRef.current) return;
    setCustomHeight("".concat(modalRef.current.getBoundingClientRect().height, "px"));
  }, [height, hasGrabber, isMobile]);
  useEffect(function () {
    if (!disableBackgroundScroll) return;
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    return function () {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    };
  }, [disableBackgroundScroll]);
  return jsx(OverlayPortal, {
    children: jsx(Dim, _objectSpread2(_objectSpread2({}, rest), {}, {
      ref: scrollAvailableRef,
      variant: "basic",
      onClick: onBlur,
      css: /*#__PURE__*/css("display:flex;align-items:center;justify-content:center;", !isPopup && MEDIA_QUERY.max('mobile', _ref3$7), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsxs("div", {
        ref: modalRef,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        css: /*#__PURE__*/css(createSizeStyle({
          width: width,
          customHeight: customHeight,
          hasInteraction: hasInteraction,
          stretch: stretch !== null && stretch !== void 0 ? stretch : isStretch,
          isPopup: isPopup
        }), " vertical-align:middle;border-radius:", pxToRem(8), ";display:inline-flex;flex-direction:column;color:", theme.content.base1, ";background-color:", theme.background.elevated, ";max-width:", pxToRem(width), ";width:100%;", !isPopup && MEDIA_QUERY.max('mobile', /*#__PURE__*/css("max-width:none;", safeAreaInset('bottom', 'padding-bottom'), " vertical-align:bottom;border-bottom-left-radius:initial;border-bottom-right-radius:initial;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: [isMobile && hasGrabber && jsx(Grabber, {
          ref: grabberRef
        }), header && jsx(ModalHeader, _objectSpread2({}, header)), jsx("div", {
          css: [FONT_STYLE.body1_1, _ref2$f, !footer && /*#__PURE__*/css("padding-bottom:", pxToRem(9), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
          children: children
        }), footer && jsx(ModalFooter, _objectSpread2({}, footer))]
      })
    }))
  });
}
/**
 * 모달 사이즈 스타일을 생성합니다.
 */
function createSizeStyle(_ref5) {
  var width = _ref5.width,
    customHeight = _ref5.customHeight,
    hasInteraction = _ref5.hasInteraction,
    stretch = _ref5.stretch,
    isPopup = _ref5.isPopup;
  var height = LAPTOP_HEIGHT[width];
  var margin = MARGIN[width];
  var interactionCSS = /*#__PURE__*/css("height:", customHeight, ";transition:height 0.3s;" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionCSS;"));
  if (stretch) {
    return createStretchStyle({
      stretch: stretch
    });
  }
  return /*#__PURE__*/css("max-height:", height, ";margin:", margin, ";", !isPopup && MEDIA_QUERY.max('mobile', /*#__PURE__*/css("max-height:90%;margin:0;", hasInteraction && interactionCSS, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createSizeStyle;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createSizeStyle;"));
}
var _ref$N = process.env.NODE_ENV === "production" ? {
  name: "tjpccj",
  styles: "height:90%"
} : {
  name: "1n0gwm3-createStretchStyle",
  styles: "height:90%;label:createStretchStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
function createStretchStyle(_ref6) {
  var stretch = _ref6.stretch;
  if (stretch === true) {
    return /*#__PURE__*/css("height:100%;", MEDIA_QUERY.max('mobile', _ref$N), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;"));
  }
  if (_typeof(stretch) === 'object') {
    var mobile = stretch.mobile,
      tablet = stretch.tablet,
      laptop = stretch.laptop,
      desktop = stretch.desktop;
    return /*#__PURE__*/css(mobile && MEDIA_QUERY.min('mobile', /*#__PURE__*/css("height:", mobile, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;"))), " ", tablet && MEDIA_QUERY.min('tablet', /*#__PURE__*/css("height:", tablet, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;"))), " ", laptop && MEDIA_QUERY.min('laptop', /*#__PURE__*/css("height:", laptop, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;"))), " ", desktop && MEDIA_QUERY.min('desktop', /*#__PURE__*/css("height:", desktop, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;"));
  }
  return /*#__PURE__*/css("height:", stretch, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;"));
}
var Grabber = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eslvxdd0"
} : {
  target: "eslvxdd0",
  label: "Grabber"
})("width:", pxToRem(32), ";min-height:", pxToRem(4), ";border-radius:", pxToRem(2), ";background-color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.content.base4;
}, ";margin:", pxToRem(6), " auto 0;");

var _templateObject$i;
function _EMOTION_STRINGIFIED_CSS_ERROR__$R() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BUTTON_WIDTH = 100;
/**
 * scraollableEntries가 false일 경우
 * 메뉴 entries UI를 다른 UI로 보여주는 로직들을 포함합니다.
 */
var useMoreMenus = function useMoreMenus(_ref2) {
  var menus = _ref2.menus,
    scrollableEntries = _ref2.scrollableEntries,
    activeId = _ref2.activeId,
    primaryId = _ref2.primaryId;
  var menusWithIndex = useMemo(function () {
    return menus.map(function (menu, index) {
      return _objectSpread2(_objectSpread2({}, menu), {}, {
        index: index
      });
    });
  }, [menus]);
  var _useState = useState(menusWithIndex),
    _useState2 = _slicedToArray(_useState, 2),
    moreMenus = _useState2[0],
    setMoreMenus = _useState2[1];
  /** moreButton + popper의 visible 여부 */
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isVisible = _useState4[0],
    setIsVisible = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isGradientVisible = _useState6[0],
    setIsGradientVisible = _useState6[1];
  /** popper를 강제로 닫을지 여부 */
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isForcePopperClosed = _useState8[0],
    setIsForcePopperClosed = _useState8[1];
  /** popper의 open 여부 */
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isPopperOpened = _useState10[0],
    setIsPopperOpened = _useState10[1];
  // TODO: bottomSheet 관련 공통 인터랙션 공통화
  var _useState11 = useState('auto'),
    _useState12 = _slicedToArray(_useState11, 2),
    bottomSheetHeight = _useState12[0],
    setBottomSheetHeight = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    hasClosingInteraction = _useState14[0],
    setHasClosingInteraction = _useState14[1];
  var containerRef = useRef(null);
  var currentClientY = useRef(0);
  var isMobile = useResponsive().breakpoint === 'mobile';
  var theme = useTheme();
  var Link = useLinkContext();
  var _useNavigationLog = useNavigationLog(),
    logTabClick = _useNavigationLog.logTabClick,
    logTabImpression = _useNavigationLog.logTabImpression,
    logMoreButtonClick = _useNavigationLog.logMoreButtonClick;
  var isHncSecondaryTabItem = primaryId === 0;
  var handleIntersect = useCallback(function (menu, index) {
    if (!isHncSecondaryTabItem || !menu.logId) return;
    logTabImpression(menu, index);
  }, [logTabImpression, isHncSecondaryTabItem]);
  var handleClick = useCallback(function (menu, index) {
    logTabClick(menu, index, !!(isHncSecondaryTabItem && menu.logId));
  }, [logTabClick, isHncSecondaryTabItem]);
  var activeIdInMoreMenus = useMemo(function () {
    if (activeId == null) return null;
    return activeId - (menus.length - moreMenus.length);
  }, [activeId, menus.length, moreMenus.length]);
  var handleOpenBottomSheet = function handleOpenBottomSheet() {
    setHasClosingInteraction(false);
    setBottomSheetHeight('auto');
    setIsForcePopperClosed(false);
  };
  var handleCloseBottomSheet = function handleCloseBottomSheet() {
    setHasClosingInteraction(true);
    setBottomSheetHeight('0%');
  };
  var handleTouchMove = useCallback(function (event) {
    var scrollDown = currentClientY.current < event.changedTouches[0].clientY;
    if (scrollDown) {
      handleCloseBottomSheet();
    }
  }, []);
  var handleChangeVisibleMenu = useCallback(function (changedMenu, changedMenuIndex, visibleRatio) {
    if (isMobile) {
      setMoreMenus(menusWithIndex);
      return;
    }
    if (visibleRatio == null) return;
    if (visibleRatio < 1) {
      setMoreMenus(function (menus) {
        return menus.map(function (menu) {
          return menu.index;
        }).includes(changedMenuIndex) ? menus : [].concat(_toConsumableArray(menus), [_objectSpread2(_objectSpread2({}, changedMenu), {}, {
          index: changedMenuIndex
        })]).sort(function (a, b) {
          return a.index - b.index;
        });
      });
    } else {
      setMoreMenus(function (menus) {
        return menus.filter(function (menu) {
          return changedMenuIndex !== menu.index;
        });
      });
    }
  }, [isMobile, menusWithIndex]);
  var handleChangeVisibleGradient = function handleChangeVisibleGradient(node) {
    var scrollRight = node.scrollWidth - Math.ceil(node.scrollLeft) - (node === null || node === void 0 ? void 0 : node.getBoundingClientRect().width);
    setIsGradientVisible(scrollRight > 5);
  };
  var handleResize = function handleResize() {
    if (!containerRef.current) return;
    var scrollWidth = containerRef.current.scrollWidth;
    var elementWidth = Math.ceil(containerRef.current.getBoundingClientRect().width);
    var overflowWidth = Math.max(scrollWidth - elementWidth, 0);
    setIsVisible(overflowWidth > 0);
  };
  useResize(containerRef, handleResize);
  useEffect(function () {
    setMoreMenus([]);
  }, [scrollableEntries]);
  useEffect(function () {
    if (isMobile) return;
    var handleScroll = function handleScroll() {
      var isScrollDown = currentClientY.current < window.scrollY;
      setIsForcePopperClosed(isScrollDown);
      currentClientY.current = window.scrollY;
    };
    var throttleScroll = throttle(handleScroll, 1000);
    window.addEventListener('scroll', throttleScroll);
    return function () {
      window.removeEventListener('scroll', throttleScroll);
    };
  }, [isMobile]);
  var MoreMenus = useMemo(function () {
    return jsx(MoreMenusContainer, {
      children: moreMenus.map(function (menu, index) {
        return jsx(StyledIntersectionObserver, {
          onIntersect: function onIntersect() {
            return handleIntersect(menu, menu.index);
          },
          children: jsx(Link, {
            href: menu.href,
            onClick: function onClick() {
              handleClick(menu, menu.index);
              setIsForcePopperClosed(true);
            },
            css: [cssLink, /*#__PURE__*/css("@media(hover: hover){&:hover{color:", theme.content.primary1.basic, ";}}", activeIdInMoreMenus === index && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), FOCUS(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n                  color: ", ";\n                "])), theme.content.primary1.basic)],
            children: menu.title
          })
        }, menu.title);
      })
    });
  }, [theme, moreMenus, Link, activeIdInMoreMenus, handleIntersect, handleClick]);
  return {
    onChangeVisibleMenu: handleChangeVisibleMenu,
    onChangeVisibleGradient: handleChangeVisibleGradient,
    containerRef: containerRef,
    isPopperOpened: isPopperOpened,
    moreMenusComponent: isVisible ? jsx(Popper, {
      isForceClosed: isForcePopperClosed,
      usePortal: false,
      style: isMobile ? {
        visibility: 'hidden'
      } : undefined,
      onChange: setIsPopperOpened,
      renderButton: function renderButton(_ref3) {
        var _onClick = _ref3.onClick,
          isOpen = _ref3.isOpen;
        return jsxs(Fragment$1, {
          children: [jsx(MoreButton, {
            isGradientVisible: isGradientVisible,
            type: "button",
            onClick: function onClick() {
              handleOpenBottomSheet();
              _onClick();
              logMoreButtonClick();
            },
            children: jsx(ChevronDownIcon, {
              size: 12,
              name: "chevron_down",
              fill: function fill(theme) {
                return theme.content.base1;
              }
            })
          }), isMobile && isOpen && jsx(StyledModal, {
            width: 400,
            hasInteraction: true,
            hasGrabber: true,
            height: bottomSheetHeight,
            hasClosingInteraction: hasClosingInteraction,
            onBlur: handleCloseBottomSheet,
            onTouchStart: function onTouchStart(event) {
              currentClientY.current = event.changedTouches[0].clientY;
            },
            onTouchMove: handleTouchMove,
            disableBackgroundScroll: true,
            header: {
              title: '탭 선택하기',
              onClose: handleCloseBottomSheet
            },
            onTransitionEnd: function onTransitionEnd() {
              if (hasClosingInteraction) {
                _onClick();
              }
            },
            children: jsx(SwitchTransition, {
              children: jsx(Transition, {
                timeout: 200,
                children: MoreMenus
              })
            })
          })]
        });
      },
      children: !isMobile && MoreMenus
    }) : null
  };
};
var cssLink = /*#__PURE__*/css(FONT_STYLE.body1_small, " display:block;padding:", pxToRem(10), " 0 ", pxToRem(10), " ", pxToRem(26), ";text-align:start;font-weight:700;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.subTitle1, ";padding:0 0 ", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;"));
var MoreButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1h7bema4"
} : {
  target: "e1h7bema4",
  label: "MoreButton"
})(RESET_BUTTON, " padding:0 ", pxToRem(6), ";height:100%;display:flex;align-items:center;position:absolute;transform:translateX(-100%);", function (_ref4) {
  var isGradientVisible = _ref4.isGradientVisible,
    theme = _ref4.theme;
  return isGradientVisible && /*#__PURE__*/css("&:after{content:'';position:absolute;right:0;width:", pxToRem(BUTTON_WIDTH), ";height:100%;background:linear-gradient(90deg, ", hexToRgba(theme.background.base, 0), " 0%, ", theme.background.base, " 50%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreButton;"));
}, ";");
var MoreMenusContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1h7bema3"
} : {
  target: "e1h7bema3",
  label: "MoreMenusContainer"
})("display:flex;flex-wrap:wrap;padding-top:", pxToRem(30), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("display:block;min-width:", pxToRem(250), ";padding:", pxToRem(20), " ", pxToRem(22), " 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenusContainer;"))), ";");
var ChevronDownIcon = /*#__PURE__*/_styled(Icon, process.env.NODE_ENV === "production" ? {
  target: "e1h7bema2"
} : {
  target: "e1h7bema2",
  label: "ChevronDownIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "1dk0v5d",
  styles: "z-index:2"
} : {
  name: "1dk0v5d",
  styles: "z-index:2",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
});
var _ref$M = process.env.NODE_ENV === "production" ? {
  name: "1yoibbp",
  styles: "opacity:0;transition:opacity 0.3s ease-in"
} : {
  name: "1pkytaj-StyledModal",
  styles: "opacity:0;transition:opacity 0.3s ease-in;label:StyledModal;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
var StyledModal = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  target: "e1h7bema1"
} : {
  target: "e1h7bema1",
  label: "StyledModal"
})(function (_ref5) {
  var hasClosingInteraction = _ref5.hasClosingInteraction;
  return hasClosingInteraction && _ref$M;
}, ";");
var StyledIntersectionObserver = /*#__PURE__*/_styled(IntersectionObserver, process.env.NODE_ENV === "production" ? {
  target: "e1h7bema0"
} : {
  target: "e1h7bema0",
  label: "StyledIntersectionObserver"
})(process.env.NODE_ENV === "production" ? {
  name: "1dlyed8",
  styles: "flex-basis:50%"
} : {
  name: "1dlyed8",
  styles: "flex-basis:50%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
});

var _templateObject$h, _templateObject2$a;
var _excluded$X = ["onSelect", "index", "item", "onChangeVisibleMenu", "containerRef", "primaryId"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$Q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$L = process.env.NODE_ENV === "production" ? {
  name: "gth0vq",
  styles: "height:inherit"
} : {
  name: "14lqk3k-css",
  styles: "height:inherit;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Q
};
function NavigationBarSecondaryTabItem(props) {
  var onSelect = props.onSelect,
    index = props.index,
    item = props.item,
    onChangeVisibleMenu = props.onChangeVisibleMenu,
    containerRef = props.containerRef,
    primaryId = props.primaryId,
    rest = _objectWithoutProperties(props, _excluded$X);
  var LinkComponent = useLinkContext();
  var _useHover = useHover(onSelect),
    _useHover2 = _slicedToArray(_useHover, 2),
    handleMouseEnter = _useHover2[0],
    handleMouseLeave = _useHover2[1];
  var _useInView = useInView({
      root: containerRef.current,
      rootMargin: "0px -".concat(BUTTON_WIDTH, "px 0px 0px"),
      initialInView: true,
      threshold: [0, 1]
    }),
    ref = _useInView.ref,
    entry = _useInView.entry;
  var _useNavigationLog = useNavigationLog(),
    logTabClick = _useNavigationLog.logTabClick,
    logTabImpression = _useNavigationLog.logTabImpression;
  var isHncSecondaryTabItem = primaryId === 0;
  var handleIntersect = useCallback(function () {
    if (!isHncSecondaryTabItem || !item.logId) return;
    logTabImpression === null || logTabImpression === void 0 ? void 0 : logTabImpression(item, index);
  }, [logTabImpression, item, index, isHncSecondaryTabItem]);
  useEffect(function () {
    onChangeVisibleMenu(item, index, entry === null || entry === void 0 ? void 0 : entry.intersectionRatio);
  }, [entry, item, index, onChangeVisibleMenu]);
  return jsx(IntersectionObserver, {
    onIntersect: handleIntersect,
    children: jsx("div", {
      ref: ref,
      css: _ref$L,
      children: jsx(StyledTabItem, _objectSpread2(_objectSpread2({}, rest), {}, {
        component: LinkComponent,
        onClick: function onClick() {
          return logTabClick === null || logTabClick === void 0 ? void 0 : logTabClick(item, index, !!(isHncSecondaryTabItem && item.logId));
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      }))
    })
  });
}
var StyledTabItem = /*#__PURE__*/_styled(TabItem, process.env.NODE_ENV === "production" ? {
  target: "e1w9mhmv0"
} : {
  target: "e1w9mhmv0",
  label: "StyledTabItem"
})("height:inherit;outline:none;&>div>p{font-weight:700;}", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("padding:", pxToRem(11), " ", pxToRem(5), ";>div>p{", FONT_STYLE.subTitle2, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;"))), " ", function (_ref2) {
  var theme = _ref2.theme;
  return /*#__PURE__*/css(HOVER(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), theme.content.primary1.basic), " ", FOCUS(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n      * {\n        color: ", ";\n      }\n      & > div {\n        box-shadow: 0 0 0 ", " ", ";\n        border-radius: ", ";\n      }\n    "])), theme.content.primary1.basic, pxToRem(3), theme.interactive.primary1.thin, pxToRem(3)), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;"));
}, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$P() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var INITIAL_NODE_HEIGHT = 51;
function NavigationBarSecondary(props) {
  var hasItems = props.hasItems,
    isForceOpened = props.isForceOpened,
    isFallback = props.isFallback,
    right = props.right,
    menuEntries = props.menuEntries,
    activeId = props.activeId,
    onMouseEnter = props.onMouseEnter,
    _onMouseLeave = props.onMouseLeave,
    _onSelect = props.onSelect,
    primaryId = props.primaryId,
    _props$scrollableEntr = props.scrollableEntries,
    scrollableEntries = _props$scrollableEntr === void 0 ? true : _props$scrollableEntr;
  var childRef = useRef(null);
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT);
  var scrollDir = useScrollDirection();
  var shouldOpen = hasItems && scrollDir !== 'down' || isForceOpened;
  var _useMoreMenus = useMoreMenus({
      menus: menuEntries,
      scrollableEntries: scrollableEntries,
      activeId: activeId,
      primaryId: primaryId
    }),
    onChangeVisibleMenu = _useMoreMenus.onChangeVisibleMenu,
    onChangeVisibleGradient = _useMoreMenus.onChangeVisibleGradient,
    containerRef = _useMoreMenus.containerRef,
    moreMenusComponent = _useMoreMenus.moreMenusComponent,
    isPopperOpened = _useMoreMenus.isPopperOpened;
  /** Hover된 Secondary 메뉴 내 Popper가 닫히면, Secondary의 Hover상태도 없애기 위해 실행합니다. */
  useEffect(function () {
    if (isPopperOpened) return;
    _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave();
  }, [isPopperOpened, _onMouseLeave]);
  if (menuEntries.length === 0) return null;
  // NOTE: Secondary의 모바일/PC 동작은 완전히 동일합니다.
  return jsx(StyledSticky, {
    className: "layout-navigation-secondary",
    css: /*#__PURE__*/css(isFallback && /*#__PURE__*/css("background:", theme.background.groupedBase, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    containerStyle: !hasItems ? {
      position: 'relative',
      top: isForceOpened ? '0' : pxToRem(-nodeHeight),
      height: '0px',
      transition: '.1s top'
    } : undefined,
    direction: "top",
    offset: shouldOpen ? 0 : -nodeHeight,
    offsetRange: [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    disableHeight: !hasItems,
    forwardRef: childRef,
    zIndex: ZINDEX.appBar + 1,
    transition: 0.1,
    initialState: !hasItems ? _objectSpread2(_objectSpread2({}, DEFAULT_STICKY_STATE), {}, {
      disabled: false,
      emulatedDisabled: false,
      offset: -nodeHeight,
      emulatedOffset: -nodeHeight
    }) : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: function onMouseLeave() {
      if (isPopperOpened) return;
      _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave();
    },
    children: jsxs(StyledContainer$1, {
      scrollable: scrollableEntries,
      children: [jsxs(TabContainer, {
        ref: containerRef,
        scrollable: scrollableEntries,
        children: [jsx(StyledTab, {
          ref: function ref(node) {
            if (!node) return;
            var throttleScroll = throttle(function () {
              return onChangeVisibleGradient(node);
            }, 100);
            node.addEventListener('scroll', throttleScroll);
          },
          scrollable: scrollableEntries,
          isMobile: isMobile,
          children: menuEntries.map(function (item, index) {
            return jsx(NavigationBarSecondaryTabItem, {
              containerRef: containerRef,
              index: index,
              onChangeVisibleMenu: onChangeVisibleMenu,
              item: item,
              href: item.href,
              bullet: item.bullet,
              badge: item.badge,
              isActive: activeId === index,
              onSelect: function onSelect() {
                return _onSelect(item, index);
              },
              primaryId: primaryId,
              children: item.title
            }, item.title);
          })
        }), !scrollableEntries && moreMenusComponent]
      }), right && jsx(Right, {
        children: right
      })]
    })
  });
}
var StyledSticky = /*#__PURE__*/_styled(Sticky, process.env.NODE_ENV === "production" ? {
  target: "e1br7gq24"
} : {
  target: "e1br7gq24",
  label: "StyledSticky"
})("background:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.background.base;
}, ";border-bottom:", pxToRem(1), " solid ", function (_ref5) {
  var theme = _ref5.theme;
  return theme.divider;
}, ";");
var _ref3$6 = process.env.NODE_ENV === "production" ? {
  name: "1ahtu5h",
  styles: "overflow:initial;padding-left:0"
} : {
  name: "167amg9-StyledContainer",
  styles: "overflow:initial;padding-left:0;label:StyledContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
var StyledContainer$1 = /*#__PURE__*/_styled(Container$4, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq23"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq23",
  label: "StyledContainer"
})("position:relative;display:flex;align-items:center;justify-content:space-between;box-sizing:border-box;overflow:auto;", function (_ref6) {
  var scrollable = _ref6.scrollable;
  return !scrollable && _ref3$6;
}, ";");
var _ref2$e = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "xx69bi-StyledTab",
  styles: "overflow:hidden;label:StyledTab;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
var StyledTab = /*#__PURE__*/_styled(Tab, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq22"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq22",
  label: "StyledTab"
})("height:", pxToRem(51), ";", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("height:", pxToRem(40), ";justify-content:center;margin:0 ", pxToRem(-2), ";&&>*{margin:0 ", pxToRem(2), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;"))), " ", function (_ref7) {
  var scrollable = _ref7.scrollable,
    isMobile = _ref7.isMobile;
  return !scrollable && /*#__PURE__*/css("&{", isMobile ? /*#__PURE__*/css("padding:0 ", pxToRem(32), " 0 ", pxToRem(16), ";justify-content:start;" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")) : _ref2$e, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;"));
}, ";");
var Right = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1br7gq21"
} : {
  target: "e1br7gq21",
  label: "Right"
})("flex:0 0 auto;display:none;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "17kpjmp",
  styles: "display:block;margin-left:10px"
} : {
  name: "a5adt4-Right",
  styles: "display:block;margin-left:10px;label:Right;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
}), ";");
var _ref$K = process.env.NODE_ENV === "production" ? {
  name: "t1y265",
  styles: "display:flex;justify-content:space-between;overflow:hidden"
} : {
  name: "1sit2m7-TabContainer",
  styles: "display:flex;justify-content:space-between;overflow:hidden;label:TabContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
var TabContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1br7gq20"
} : {
  target: "e1br7gq20",
  label: "TabContainer"
})("flex:1 0 0;", function (_ref8) {
  var scrollable = _ref8.scrollable;
  return !scrollable && _ref$K;
}, ";");

function NavigationBarTertiary(_ref) {
  var item = _ref.item,
    isOpen = _ref.isOpen,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  var _a;
  var itemRef = useRef(item);
  if (item != null) {
    itemRef.current = item;
  }
  var currentItem = itemRef.current;
  var nodeRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    top = _useState2[0],
    setTop = _useState2[1];
  useEffect(function () {
    if (!isOpen) {
      return;
    }
    if (nodeRef.current == null) {
      nodeRef.current = document.querySelector('.layout-navigation-secondary');
    }
    if (nodeRef.current) {
      setTop(nodeRef.current.getBoundingClientRect().bottom);
    }
    var timer = null;
    function handleScroll() {
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
      timer = requestAnimationFrame(function () {
        timer = null;
        if (nodeRef.current) {
          setTop(nodeRef.current.getBoundingClientRect().bottom);
        }
      });
    }
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
    };
  }, [isOpen]);
  var show = useMemo(function () {
    return Boolean(isOpen && (item === null || item === void 0 ? void 0 : item.renderBarChild));
  }, [isOpen, item]);
  if (top == null) {
    return null;
  }
  return jsx(CSSTransition, {
    timeout: 200,
    in: show,
    appear: show,
    unmountOnExit: true,
    classNames: {
      enterActive: 'open opening',
      enterDone: 'open open-active',
      appearActive: 'open opening',
      appearDone: 'open open-active',
      exit: 'exiting'
    },
    children: jsx("div", {
      css: /*#__PURE__*/css("position:fixed;top:", top, "px;left:0;right:0;background-color:#ffffff;border-bottom:1px solid #ededed;z-index:500;opacity:0;transform:translateY(-100%);&.opening{transition:.2s opacity,.2s transform;}&.exiting{transition:.2s opacity,.2s transform;}&.open{opacity:1;transform:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: (_a = currentItem === null || currentItem === void 0 ? void 0 : currentItem.renderBarChild) === null || _a === void 0 ? void 0 : _a.call(currentItem)
    })
  });
}

function isIconAction(action) {
  return 'icon' in action;
}
function cssBaseTextField(theme) {
  var onDimmed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    error = _ref.error,
    focused = _ref.focused,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly;
  return /*#__PURE__*/css("display:inline-flex;align-items:center;line-height:0;box-sizing:border-box;border:", pxToRem(1), " solid ", theme.border, ";border-radius:", pxToRem(4), ";&:hover{background-color:", theme.content.base5, ";}", disabled && "\n      border-color: ".concat(theme.content.base4, ";\n      background-color: ").concat(theme.content.base5, ";\n    "), " ", readOnly && "\n      background-color: ".concat(theme.content.base5, ";\n    "), " ", focused && "border-color: ".concat(theme.content.primary1.basic, ";"), " ", error && "border-color: ".concat(theme.content.primary2.basic, ";"), " ", onDimmed && "background-color: ".concat(theme.background.base, ";"), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseTextField;"));
}
function cssTextField(theme) {
  return /*#__PURE__*/css(RESET_INPUT, " height:100%;color:", theme.content.base1, ";outline:none;&::placeholder{color:", theme.content.base3, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextField;"));
}

var _excluded$W = ["onChange", "onValue", "onFocus", "onBlur", "forwardedRef", "className", "size", "icon", "action", "onDimmed", "error", "disabled", "readOnly"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$O() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ICON_SIZE$2 = 24;
function cssContainer(size) {
  return /*#__PURE__*/css("height:", pxToRem(size), ";padding:0 ", pxToRem({
    32: 8,
    40: 14,
    44: 16,
    50: 16
  }[size]), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssContainer;"));
}
function cssFontSize$1(size) {
  return /*#__PURE__*/css({
    32: FONT_STYLE.body2,
    40: FONT_STYLE.body1_1,
    44: FONT_STYLE.body1_1,
    50: FONT_STYLE.body1_1
  }[size], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFontSize;"));
}
function cssIconInputPadding(size) {
  return /*#__PURE__*/css(pxToRem({
    32: 4,
    40: 6,
    44: 6,
    50: 8
  }[size]), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssIconInputPadding;"));
}
/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
var _ref$J = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "jbb5ne-css",
  styles: "display:flex;align-items:center;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
function Input$1(_ref2) {
  var _onChange = _ref2.onChange,
    onValue = _ref2.onValue,
    _onFocus = _ref2.onFocus,
    _onBlur = _ref2.onBlur,
    forwardedRef = _ref2.forwardedRef,
    className = _ref2.className,
    size = _ref2.size,
    icon = _ref2.icon,
    action = _ref2.action,
    _ref2$onDimmed = _ref2.onDimmed,
    onDimmed = _ref2$onDimmed === void 0 ? false : _ref2$onDimmed,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? false : _ref2$error,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$readOnly = _ref2.readOnly,
    readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
    rest = _objectWithoutProperties(_ref2, _excluded$W);
  var theme = useTheme();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var actions = Array.isArray(action) ? action : [action];
  return jsxs("div", {
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), cssContainer(size)],
    children: [icon && jsx(Icon, {
      size: ICON_SIZE$2,
      name: _typeof(icon) === 'object' ? icon.name : icon,
      css: /*#__PURE__*/css("vertical-align:middle;padding-right:", cssIconInputPadding(size), ";color:", _typeof(icon) === 'object' ? "".concat((icon === null || icon === void 0 ? void 0 : icon.color) || theme.content.base2) : theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }), jsx(StyledInput, _objectSpread2(_objectSpread2({}, rest), {}, {
      ref: forwardedRef,
      disabled: disabled,
      readOnly: readOnly,
      onChange: function onChange(e) {
        return onValueHandler(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      onFocus: function onFocus(e) {
        if (_onFocus) {
          _onFocus(e);
        }
        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur) {
          _onBlur(e);
        }
        setFocused(false);
      },
      css: [cssTextField(theme), cssFontSize$1(size), /*#__PURE__*/css("padding-right:", cssIconInputPadding(size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
    })), jsx("div", {
      css: _ref$J,
      children: actions.map(function (action, i) {
        return !!action && (isIconAction(action) ? jsx(ActionButton, {
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          tabIndex: action.tabIndex || 0,
          css: /*#__PURE__*/css("color:", action.color || theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          },
          children: jsx(Icon, {
            size: ICON_SIZE$2,
            name: action.icon
          })
        }, i) : jsx(ActionTextButton, {
          size: 30,
          variant: "primary1",
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          tabIndex: action.tabIndex || 0,
          css: [cssFontSize$1(size)],
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          },
          children: action.text
        }, i));
      })
    })]
  });
}
var StyledInput = /*#__PURE__*/_styled("input", process.env.NODE_ENV === "production" ? {
  target: "e1rynmtb2"
} : {
  target: "e1rynmtb2",
  label: "StyledInput"
})(process.env.NODE_ENV === "production" ? {
  name: "ua3caf",
  styles: "box-sizing:border-box;flex:1 0 0%;vertical-align:middle;outline:none"
} : {
  name: "ua3caf",
  styles: "box-sizing:border-box;flex:1 0 0%;vertical-align:middle;outline:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
});
var ActionButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1rynmtb1"
} : {
  target: "e1rynmtb1",
  label: "ActionButton"
})(RESET_BUTTON, " vertical-align:middle;width:", pxToRem(ICON_SIZE$2), ";height:", pxToRem(ICON_SIZE$2), ";outline:none;margin-left:", pxToRem(8), ";&:first-of-type{margin-left:0;}");
var ActionTextButton = /*#__PURE__*/_styled(TextButton, process.env.NODE_ENV === "production" ? {
  target: "e1rynmtb0"
} : {
  target: "e1rynmtb0",
  label: "ActionTextButton"
})("flex-shrink:0;margin-left:", pxToRem(8), ";padding:0;&:first-of-type{margin-left:0;}");

var _excluded$V = ["value", "placeholder", "onChange", "onClear"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$N() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$I = process.env.NODE_ENV === "production" ? {
  name: "d02zr5",
  styles: "width:100%;input::-ms-clear{display:none;}"
} : {
  name: "1sngm61-css",
  styles: "width:100%;input::-ms-clear{display:none;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$N
};
var Input = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var value = _ref2.value,
    placeholder = _ref2.placeholder,
    onChange = _ref2.onChange,
    onClear = _ref2.onClear,
    props = _objectWithoutProperties(_ref2, _excluded$V);
  var input = useRef(null);
  var handleChange = useCallback(function (e) {
    onChange(e.target.value);
  }, [onChange]);
  var handleClear = useCallback(function () {
    onChange('');
    onClear();
  }, [onChange, onClear]);
  useImperativeHandle(ref, function () {
    return input.current;
  });
  return jsx(Input$1, _objectSpread2({
    css: _ref$I,
    forwardedRef: input,
    type: "text",
    size: 40,
    value: value,
    placeholder: placeholder,
    icon: "search",
    action: value ? {
      icon: 'dismiss_circle',
      type: 'button',
      onClick: handleClear
    } : undefined,
    onChange: handleChange
  }, props));
});

var _excluded$U = ["id", "className", "pageKey", "initialQuery", "placeholder", "isInputAutoFocused", "isListBoxAlwaysOpened", "renderInputLeft", "renderInputRight", "fetchList", "getItemQuery", "renderListBox", "onSubmit", "onSubmitItem", "onInputBlur", "onClear"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$M() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$H = process.env.NODE_ENV === "production" ? {
  name: "mvrlf6",
  styles: "min-height:0"
} : {
  name: "1u0ywus-css",
  styles: "min-height:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
};
var _ref2$d = process.env.NODE_ENV === "production" ? {
  name: "1tnn3ml",
  styles: ">input{width:100%;}"
} : {
  name: "mmix4o-css",
  styles: ">input{width:100%;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
};
var _ref3$5 = process.env.NODE_ENV === "production" ? {
  name: "7whenc",
  styles: "display:flex;width:100%"
} : {
  name: "1lwfj4l-css",
  styles: "display:flex;width:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
};
var _ref4$2 = process.env.NODE_ENV === "production" ? {
  name: "13y1wtx",
  styles: "position:relative;display:flex;flex-direction:column;height:100%"
} : {
  name: "12ba0nj-css",
  styles: "position:relative;display:flex;flex-direction:column;height:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
};
function Search(_ref5) {
  var id = _ref5.id,
    className = _ref5.className,
    pageKey = _ref5.pageKey,
    initialQuery = _ref5.initialQuery,
    placeholder = _ref5.placeholder,
    isInputAutoFocused = _ref5.isInputAutoFocused,
    isListBoxAlwaysOpened = _ref5.isListBoxAlwaysOpened,
    renderInputLeft = _ref5.renderInputLeft,
    renderInputRight = _ref5.renderInputRight,
    fetchList = _ref5.fetchList,
    getItemQuery = _ref5.getItemQuery,
    renderListBox = _ref5.renderListBox,
    onSubmit = _ref5.onSubmit,
    onSubmitItem = _ref5.onSubmitItem,
    onInputBlur = _ref5.onInputBlur,
    onClear = _ref5.onClear,
    props = _objectWithoutProperties(_ref5, _excluded$U);
  var input = useRef(null);
  var _useAutoComplete = useAutoComplete(input, {
      pageKey: pageKey,
      query: '',
      initialQuery: initialQuery,
      isAlwaysFocused: isInputAutoFocused,
      onFetch: fetchList,
      getItemQuery: getItemQuery,
      onSubmit: onSubmit,
      onSubmitItem: onSubmitItem
    }),
    items = _useAutoComplete.items,
    isOpened = _useAutoComplete.isOpened,
    shownQuery = _useAutoComplete.shownQuery,
    hoveredIndex = _useAutoComplete.hoveredIndex,
    onInputFocus = _useAutoComplete.onInputFocus,
    onInputClick = _useAutoComplete.onInputClick,
    onInputChange = _useAutoComplete.onInputChange,
    onInputKeyDown = _useAutoComplete.onInputKeyDown,
    onReset = _useAutoComplete.onReset,
    onListClick = _useAutoComplete.onListClick,
    onListMouseEnter = _useAutoComplete.onListMouseEnter;
  var handleInputFocus = useCallback(function (e) {
    onInputFocus(e);
    if (props.onInputFocus) props.onInputFocus(e);
  }, [onInputFocus, props]);
  var handleInputChange = useCallback(function (value) {
    onInputChange(value);
    if (props.onInputChange) props.onInputChange(value);
  }, [onInputChange, props]);
  var handleInputBlur = useCallback(function (e) {
    onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur(e);
  }, [onInputBlur]);
  var handleInputClear = useCallback(function () {
    onReset === null || onReset === void 0 ? void 0 : onReset();
    onClear === null || onClear === void 0 ? void 0 : onClear();
  }, [onReset, onClear]);
  return jsxs("div", {
    className: className,
    css: _ref4$2,
    children: [jsxs("div", {
      id: "".concat(id, "-combobox"),
      role: "combobox",
      "aria-expanded": isOpened,
      "aria-haspopup": "listbox",
      "aria-controls": isOpened ? "".concat(id, "-listbox") : undefined,
      css: _ref3$5,
      children: [renderInputLeft && renderInputLeft(), jsx(Input, {
        css: _ref2$d,
        ref: input,
        value: shownQuery,
        placeholder: placeholder,
        autoFocus: isInputAutoFocused,
        onFocus: handleInputFocus,
        onClick: onInputClick,
        onChange: handleInputChange,
        onKeyDown: onInputKeyDown,
        onBlur: handleInputBlur,
        onClear: handleInputClear,
        autoComplete: "off",
        "aria-autocomplete": "list"
      }), renderInputRight && renderInputRight()]
    }), (isListBoxAlwaysOpened || isOpened) && jsx("div", {
      id: "".concat(id, "-listbox"),
      role: "listbox",
      css: _ref$H,
      children: renderListBox({
        items: items,
        query: shownQuery,
        hoveredIndex: hoveredIndex,
        onItemClick: onListClick,
        onItemMouseEnter: onListMouseEnter
      })
    })]
  });
}

var _excluded$T = ["children"];
var HistoryStorageContext = /*#__PURE__*/createContext({});
var useHistoryStorage = function useHistoryStorage() {
  return useContext(HistoryStorageContext);
};
function HistoryStorageProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$T);
  return jsx(HistoryStorageContext.Provider, {
    value: props,
    children: children
  });
}

var _excluded$S = ["variant"];
function cssVariant$3(theme, variant) {
  switch (variant) {
    case 'thin':
      return /*#__PURE__*/css("margin:0;padding:0;height:", pxToRem(1), ";border:none;background-color:", theme.divider, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'thick':
      return /*#__PURE__*/css("margin:0;padding:0;height:", pxToRem(10), ";border:none;background-color:", theme.background.groupedBase, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
  }
}
function Divider$1(_ref) {
  var variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$S);
  var theme = useTheme();
  return jsx("hr", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: cssVariant$3(theme, variant)
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HighlightedText(_ref2) {
  var item = _ref2.item,
    query = _ref2.query;
  var highlightedDisplay = item.value.highlightedDisplay;
  if (!query) return jsx(Fragment$1, {
    children: item.query
  });
  var parts = highlightedDisplay ? highlightedDisplay.split(/<strong>|<\/strong>/gi) : item.query.split(new RegExp("(".concat(query, ")"), 'gi'));
  return jsx(Fragment$1, {
    children: parts.map(function (part, index) {
      return jsx(Fragment, {
        children: index % 2 === 1 ? jsx("strong", {
          children: part
        }) : part
      }, index);
    })
  });
}
var _ref$G = process.env.NODE_ENV === "production" ? {
  name: "17uk3v8",
  styles: "display:flex;align-items:center;white-space:nowrap"
} : {
  name: "1zkbwg-css",
  styles: "display:flex;align-items:center;white-space:nowrap;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
};
function KeywordItem(props) {
  return jsxs("div", {
    css: _ref$G,
    children: [jsx(Icon, {
      name: "search",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base1;
      },
      css: /*#__PURE__*/css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', "\n            width: ".concat(pxToRem(24), ";\n            height: ").concat(pxToRem(24), ";\n          ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }), jsx("div", {
      css: /*#__PURE__*/css("flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(HighlightedText, _objectSpread2({}, props))
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$F = process.env.NODE_ENV === "production" ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : {
  name: "1dhjfuy-css",
  styles: "display:flex;align-items:center;overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$K
};
var _ref2$c = process.env.NODE_ENV === "production" ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : {
  name: "1f54iy6-css",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$K
};
function CategoryItem(props) {
  var theme = useTheme();
  return jsxs("div", {
    css: _ref2$c,
    children: [jsxs("div", {
      css: _ref$F,
      children: [jsx(Icon, {
        css: /*#__PURE__*/css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n              min-width: ").concat(pxToRem(24), ";\n            ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        name: "search",
        size: 18,
        fill: function fill(theme) {
          return theme.content.base1;
        }
      }), jsx("div", {
        css: /*#__PURE__*/css("text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: jsx(HighlightedText, _objectSpread2({}, props))
      }), jsx("span", {
        css: /*#__PURE__*/css("width:", pxToRem(1), ";height:", pxToRem(10), ";background:", theme.content.base4, ";margin:0 ", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }), jsx("span", {
        css: /*#__PURE__*/css(FONT_STYLE.caption1, " margin-right:", pxToRem(14), ";color:", theme.content.base2, ";", MEDIA_QUERY.min('laptop', "\n            ".concat(FONT_STYLE.caption2, "\n          ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: "\uCE74\uD14C\uACE0\uB9AC"
      })]
    }), jsx(Icon, {
      name: "chevron_right",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base3;
      }
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var MAX_DEPTH = 2;
var _ref$E = process.env.NODE_ENV === "production" ? {
  name: "n0fp6c",
  styles: "display:flex;flex-flow:row wrap;align-items:center;width:100%"
} : {
  name: "1ji23d4-css",
  styles: "display:flex;flex-flow:row wrap;align-items:center;width:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
};
function CategoryHierarchy(_ref2) {
  var hierarchy = _ref2.hierarchy;
  var trailings = hierarchy.slice(-MAX_DEPTH);
  var theme = useTheme();
  return jsx("div", {
    css: _ref$E,
    children: trailings.map(function (depth, index) {
      return jsxs(Fragment, {
        children: [jsx("span", {
          css: /*#__PURE__*/css("display:inline-block;font-weight:bold;line-height:1.4;&:last-of-type{color:", theme.content.primary1.thick, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: depth
        }), index < trailings.length - 1 && jsx(Icon, {
          name: "chevron_right",
          size: 12,
          css: /*#__PURE__*/css("margin:0 ", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        })]
      }, index);
    })
  });
}

var _templateObject$g, _templateObject2$9;
function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$D = process.env.NODE_ENV === "production" ? {
  name: "fzu03x",
  styles: "text-overflow:ellipsis;overflow:hidden"
} : {
  name: "1shj8r0-css",
  styles: "text-overflow:ellipsis;overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$I
};
function HistoryItem(_ref2) {
  var item = _ref2.item,
    hovered = _ref2.hovered;
  var theme = useTheme();
  var query = item.query,
    value = item.value;
  var historyStorage = useHistoryStorage();
  var handleDeleteClick = function handleDeleteClick(e) {
    e.stopPropagation();
    historyStorage.remove(value);
  };
  var renderItem = function renderItem() {
    var _a;
    var elem = query;
    if (_typeof(value) === 'object' && value.type === 'category') {
      // 기존 History 데이터가 undefined 인 경우가 있어, 옵셔널 값 추가
      var orgDisplay = (_a = value.value.orgDisplay) !== null && _a !== void 0 ? _a : '';
      elem = jsx(CategoryHierarchy, {
        hierarchy: orgDisplay.split('>').map(function (value) {
          return value.trim();
        })
      });
    }
    return jsx("span", {
      css: _ref$D,
      children: elem
    });
  };
  return jsxs("div", {
    css: /*#__PURE__*/css("display:flex;align-items:center;justify-content:space-between;width:100%;padding:", pxToRem(4), " 0;box-sizing:border-box;", MEDIA_QUERY.min('laptop', /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [renderItem(), jsx("button", {
      type: "button",
      onClick: handleDeleteClick,
      css: [/*#__PURE__*/css(RESET_BUTTON, " margin-right:", pxToRem(-6), ";padding:", pxToRem(6), ";transition:.1s opacity;font-size:0;line-height:0;border-radius:", pxToRem(2), ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n            opacity: .4;\n          "]))), FOCUS(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n            box-shadow: 0 0 0 ", " ", ";\n          "])), pxToRem(3), theme.interactive.primary1.thin)],
      children: jsx(Icon, {
        name: "dismiss",
        size: 12,
        fill: function fill(theme) {
          return hovered ? theme.content.base2 : theme.content.base3;
        }
      })
    })]
  });
}

var _excluded$R = ["className", "verticalRatio", "horizontalRatio", "alt"],
  _excluded2$2 = ["className", "verticalRatio", "horizontalRatio", "alt"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HorizontalImage(_ref2) {
  var className = _ref2.className,
    verticalRatio = _ref2.verticalRatio,
    horizontalRatio = _ref2.horizontalRatio,
    alt = _ref2.alt,
    rest = _objectWithoutProperties(_ref2, _excluded$R);
  return jsx("figure", {
    className: className,
    children: jsx("img", _objectSpread2(_objectSpread2({}, rest), {}, {
      alt: alt,
      height: 0,
      css: /*#__PURE__*/css("height:0;display:block;visibility:hidden;padding-top:", 100 / verticalRatio * horizontalRatio, "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }))
  });
}
var _ref$C = process.env.NODE_ENV === "production" ? {
  name: "upuxee",
  styles: "width:0;height:0;visibility:hidden"
} : {
  name: "1w596u0-css",
  styles: "width:0;height:0;visibility:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
};
function VerticalImage(_ref3) {
  var className = _ref3.className,
    verticalRatio = _ref3.verticalRatio,
    horizontalRatio = _ref3.horizontalRatio,
    alt = _ref3.alt,
    rest = _objectWithoutProperties(_ref3, _excluded2$2);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    clientHeight = _useState2[0],
    setClientHeight = _useState2[1];
  return jsx("figure", {
    ref: function ref(el) {
      if (el) {
        setClientHeight(el.getBoundingClientRect().height);
      }
    },
    css: /*#__PURE__*/css("width:", pxToRem(clientHeight / horizontalRatio * verticalRatio), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    className: className,
    children: jsx("img", _objectSpread2(_objectSpread2({}, rest), {}, {
      alt: alt,
      width: 0,
      height: 0,
      css: _ref$C
    }))
  });
}

var _excluded$Q = ["src", "src2x", "src3x", "axis", "radius", "aspectRatio"];
function Image(_ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? '' : _ref$src,
    _ref$src2x = _ref.src2x,
    src2x = _ref$src2x === void 0 ? src : _ref$src2x,
    _ref$src3x = _ref.src3x,
    src3x = _ref$src3x === void 0 ? src2x : _ref$src3x,
    _ref$axis = _ref.axis,
    axis = _ref$axis === void 0 ? 'width' : _ref$axis,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 0 : _ref$radius,
    aspectRatio = _ref.aspectRatio,
    rest = _objectWithoutProperties(_ref, _excluded$Q);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  var imageCss = /*#__PURE__*/css("display:inline-block;background:no-repeat 50%/cover;border-radius:", pxToRem(radius), ";background-image:url(", src, ");@media only screen and (-webkit-min-device-pixel-ratio: 2),only screen and (min--moz-device-pixel-ratio: 2),only screen and (-o-min-device-pixel-ratio: 2/1),only screen and (min-device-pixel-ratio: 2),only screen and (min-resolution: 2dppx){background-image:url(", src2x, ");}@media only screen and (-webkit-min-device-pixel-ratio: 3),only screen and (min--moz-device-pixel-ratio: 3),only screen and (-o-min-device-pixel-ratio: 3/1),only screen and (min-device-pixel-ratio: 3),only screen and (min-resolution: 3dppx){background-image:url(", src3x, ");}" + (process.env.NODE_ENV === "production" ? "" : ";label:imageCss;"));
  var _aspectRatio$split$ma = aspectRatio.split(':').map(function (ratio) {
      return parseInt(ratio, 10);
    }),
    _aspectRatio$split$ma2 = _slicedToArray(_aspectRatio$split$ma, 2),
    verticalRatio = _aspectRatio$split$ma2[0],
    horizontalRatio = _aspectRatio$split$ma2[1];
  useEffect(function () {
    switch (window.devicePixelRatio) {
      case 2:
        setUrl(getCanonicalImageUrl(src2x));
        break;
      case 3:
        setUrl(getCanonicalImageUrl(src3x));
        break;
      default:
        setUrl(getCanonicalImageUrl(src));
        break;
    }
  }, [src, src2x, src3x]);
  return axis === 'width' ? jsx(HorizontalImage, _objectSpread2(_objectSpread2({}, rest), {}, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  })) : jsx(VerticalImage, _objectSpread2(_objectSpread2({}, rest), {}, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$B = process.env.NODE_ENV === "production" ? {
  name: "18wgrk7",
  styles: "border-radius:50%"
} : {
  name: "1xq8tq8-css",
  styles: "border-radius:50%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
};
function CircleImage(_ref2) {
  var rest = _extends$7({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return jsx(Image, _objectSpread2(_objectSpread2({}, rest), {}, {
    aspectRatio: "1:1",
    css: _ref$B
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$A = process.env.NODE_ENV === "production" ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : {
  name: "1dhjfuy-css",
  styles: "display:flex;align-items:center;overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
};
var _ref2$b = process.env.NODE_ENV === "production" ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : {
  name: "1f54iy6-css",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
};
function ConsultingItem(props) {
  var value = props.item.value;
  var theme = useTheme();
  var cta = " ".concat(value.info.cta);
  return jsxs("div", {
    css: _ref2$b,
    children: [jsxs("div", {
      css: _ref$A,
      children: [jsx("div", {
        css: /*#__PURE__*/css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n            ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: value.info.iconFileUrl ? jsx(CircleImage, {
          src: value.info.iconFileUrl,
          css: /*#__PURE__*/css("width:100%;border:", pxToRem(0.5), " solid ", theme.outline, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        }) : jsx(Icon, {
          name: "search",
          size: 18,
          fill: function fill(theme) {
            return theme.content.base1;
          }
        })
      }), jsxs("div", {
        css: /*#__PURE__*/css("flex:1;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: [jsx(HighlightedText, _objectSpread2({}, props)), cta]
      })]
    }), jsx(Icon, {
      name: "chevron_right",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base3;
      }
    })]
  });
}

var _templateObject$f;
var _excluded$P = ["item", "hovered", "query", "showDivider", "onHover"];
function ListBoxItem(_ref) {
  var item = _ref.item,
    hovered = _ref.hovered,
    query = _ref.query,
    _ref$showDivider = _ref.showDivider,
    showDivider = _ref$showDivider === void 0 ? false : _ref$showDivider,
    onHover = _ref.onHover,
    props = _objectWithoutProperties(_ref, _excluded$P);
  var theme = useTheme();
  var ref = useRef(null);
  var renderItem = function renderItem() {
    switch (item.type) {
      case 'query':
        return jsx(KeywordItem, {
          item: item,
          query: query
        });
      case 'category':
        return jsx(CategoryItem, {
          item: item,
          query: query
        });
      case 'consulting':
        return jsx(ConsultingItem, {
          item: item,
          query: query
        });
      case 'history':
        return jsx(HistoryItem, {
          item: item,
          hovered: hovered
        });
      default:
        return null;
    }
  };
  useEffect(function () {
    if (!hovered || !ref.current) return;
    onHover(ref.current);
  }, [hovered, onHover]);
  return jsxs(Fragment$1, {
    children: [jsx("li", _objectSpread2(_objectSpread2({
      ref: ref,
      role: "option",
      "aria-selected": undefined,
      css: [/*#__PURE__*/css(FONT_STYLE.subTitle1, " position:relative;margin:0;padding:", pxToRem(8), " ", pxToRem(16), ";color:", theme.content.base1, ";line-height:", pxToRem(21), ";cursor:pointer;border-radius:", pxToRem(2), ";outline:none;strong{color:", theme.content.primary1.thick, ";font-weight:400;}", hovered && "background: ".concat(theme.background.groupedBase, ";"), " ", MEDIA_QUERY.min('laptop', /*#__PURE__*/css(FONT_STYLE.subTitle2, " padding:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), FOCUS(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), theme.background.groupedBase)],
      tabIndex: 0
    }, props), {}, {
      children: renderItem()
    })), showDivider && jsx(Divider$1, {
      css: /*#__PURE__*/css("margin:", pxToRem(8), " 0;", MEDIA_QUERY.min('laptop', "\n              margin: ".concat(pxToRem(10), " 0;\n            ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      variant: "thin"
    })]
  });
}

var _templateObject$e, _templateObject2$8;
function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function filterOnlyHistoryKeyword(items) {
  return items.filter(function (item) {
    return item.type === 'history' && typeof item.value !== 'string' && item.value.type === 'query';
  });
}
var _ref$z = process.env.NODE_ENV === "production" ? {
  name: "1xclg2i",
  styles: "margin:0;padding:0"
} : {
  name: "1ig2mc1-css",
  styles: "margin:0;padding:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};
function ListBox(_ref2) {
  var items = _ref2.items,
    query = _ref2.query,
    hoveredIndex = _ref2.hoveredIndex,
    isHistoryList = _ref2.isHistoryList,
    onItemClick = _ref2.onItemClick,
    onItemMouseEnter = _ref2.onItemMouseEnter;
  var theme = useTheme();
  var container = useRef(null);
  var log = useLogContext();
  var handleIntersect = useCallback(function () {
    if (filterOnlyHistoryKeyword(items).length > 0) {
      log({
        key: 'primary.right.search.history',
        category: 'impression',
        params: {
          type: 'keyword'
        }
      });
    }
  }, [items, log]);
  var isShowDivider = useCallback(function (item, index) {
    return index < items.length - 1 && items[index + 1].type !== item.type;
  }, [items]);
  var handleItemHover = useCallback(function (item) {
    if (!container.current) return;
    container.current.scrollTop = item.offsetTop - (container.current.offsetHeight - item.offsetHeight) / 2;
  }, []);
  var handleItemClick = useCallback(function (item, index) {
    return function () {
      return onItemClick(item, index);
    };
  }, [onItemClick]);
  var handleItemMouseEnter = useCallback(function (item, index) {
    return function () {
      return onItemMouseEnter(item, index);
    };
  }, [onItemMouseEnter]);
  return jsx(IntersectionObserver, {
    onIntersect: handleIntersect,
    children: jsxs("div", {
      ref: container,
      css: /*#__PURE__*/css("overflow-y:auto;position:relative;width:100%;padding:", pxToRem(10), " 0;border:", pxToRem(1), " solid ", theme.divider, ";border-radius:", pxToRem(4), ";background:", theme.background.base, ";box-shadow:0 ", pxToRem(4), " ", pxToRem(6), " 0 ", theme.shadow.basic, ";box-sizing:border-box;", MEDIA_QUERY.min('laptop', "\n          position: absolute;\n          top: calc(100% + ".concat(pxToRem(4), ");\n          left: 0;\n          max-height: ").concat(pxToRem(400), ";\n        ")), " ", MEDIA_QUERY.only('tablet', "\n          top: ".concat(pxToRem(4), ";\n          height: 100%;\n        ")), " ", MEDIA_QUERY.only('mobile', "\n          height: 100%;\n          padding: ".concat(pxToRem(8), " 0;\n          border: 0;\n          box-shadow: none;\n        ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [!isHistoryList && jsx(HistoryListBoxHeader, {
        hasDeleteButton: items.length > 0
      }), items.length > 0 ? jsx("ul", {
        css: _ref$z,
        children: items.map(function (item, index) {
          return jsx(ListBoxItem, {
            item: item,
            query: query,
            hovered: hoveredIndex === index,
            showDivider: isShowDivider(item, index),
            onHover: handleItemHover,
            onClick: handleItemClick(item, index),
            onMouseEnter: handleItemMouseEnter(item, index)
          }, "".concat(item.query).concat(index));
        })
      }) : jsx("p", {
        css: /*#__PURE__*/css("margin:0;padding:", pxToRem(10), " ", pxToRem(16), ";color:", theme.content.base3, ";font-size:", pxToRem(15), ";line-height:1.4;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: "\uCD5C\uADFC \uAC80\uC0C9\uD55C \uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
      })]
    })
  });
}
function HistoryListBoxHeader(_ref3) {
  var hasDeleteButton = _ref3.hasDeleteButton;
  var theme = useTheme();
  var historyStorage = useHistoryStorage();
  return jsxs("div", {
    css: /*#__PURE__*/css("display:flex;align-items:center;justify-content:space-between;padding:", pxToRem(7), " ", pxToRem(8), " ", pxToRem(10), ";font-size:", pxToRem(15), ";line-height:", pxToRem(21), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [jsx("span", {
      css: /*#__PURE__*/css("font-size:", pxToRem(13), ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: "\uCD5C\uADFC \uAC80\uC0C9\uC5B4"
    }), hasDeleteButton && jsx("button", {
      type: "button",
      onClick: historyStorage.removeAll,
      css: [/*#__PURE__*/css(RESET_BUTTON, " margin:", pxToRem(-2), ";padding:", pxToRem(2), ";font-size:", pxToRem(12), ";color:", theme.content.base2, ";border-radius:", pxToRem(2), ";outline:none;transition:.1s opacity;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n              opacity: .4;\n            "]))), FOCUS(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)],
      children: "\uC804\uCCB4 \uC0AD\uC81C"
    })]
  });
}

function getSearchPlaceholder(searchType) {
  return searchType === 'store' && '쇼핑 검색' || searchType === 'expert_user' && '시공업체 검색' || '통합검색';
}

var _excluded$O = ["searchType", "initialQuery", "onFetch", "onSubmit", "onSubmitItem", "onInputFocus", "historyStorage", "placeholder"];
function NavigationSearch(_ref) {
  var searchType = _ref.searchType,
    initialQuery = _ref.initialQuery,
    onFetch = _ref.onFetch,
    onSubmit = _ref.onSubmit,
    onSubmitItem = _ref.onSubmitItem,
    onInputFocus = _ref.onInputFocus,
    historyStorage = _ref.historyStorage,
    placeholder = _ref.placeholder,
    props = _objectWithoutProperties(_ref, _excluded$O);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pageKey = _useState2[0],
    setPageKey = _useState2[1];
  var _useState3 = useState(initialQuery),
    _useState4 = _slicedToArray(_useState3, 2),
    manuallyTypedInputValue = _useState4[0],
    setManuallyTypedInputValue = _useState4[1];
  var fetchListFromSearchHistory = useCallback(function () {
    var history = historyStorage.get();
    return history.map(function (value) {
      return {
        type: 'history',
        value: value,
        query: typeof value === 'string' ? value : value.query
      };
    });
  }, [historyStorage]);
  var fetchList = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(query) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (manuallyTypedInputValue) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", fetchListFromSearchHistory());
          case 2:
            return _context.abrupt("return", onFetch(query));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [manuallyTypedInputValue, fetchListFromSearchHistory, onFetch]);
  var handleHistoryUpdate = useCallback(function () {
    setPageKey(_objectSpread2(_objectSpread2({}, window.location), {}, {
      timestamp: new Date().getTime()
    }));
  }, []);
  var handleSubmit = useCallback(function (value) {
    historyStorage.append(value);
    if (onSubmit) onSubmit(value);
  }, [historyStorage, onSubmit]);
  var log = useLogContext();
  var logAutocompleteKeyword = useCallback(function (item, index) {
    var params = {
      type: item.type,
      index: index,
      id: item.query
    };
    if (item.type === 'history' && typeof item.value !== 'string') {
      log({
        key: 'primary.right.search.history',
        category: 'click',
        params: _objectSpread2(_objectSpread2({}, params), {}, {
          type: item.value.type
        })
      });
    }
    if (item.type === 'category' || item.type === 'query') {
      log({
        key: "primary.right.search.autocomplete.".concat(item.type),
        category: 'click',
        params: params
      });
    }
  }, [log]);
  var handleSubmitItem = useCallback(function (item, index) {
    var value = item.type === 'history' ? item.value : item;
    historyStorage.append(value);
    if (onSubmitItem) onSubmitItem(item);
    logAutocompleteKeyword(item, index);
  }, [historyStorage, onSubmitItem, logAutocompleteKeyword]);
  var handleInputFocus = useCallback(function (e) {
    if (onInputFocus) onInputFocus(e);
    log({
      key: 'primary.right.search.input',
      category: 'click',
      params: {
        search_type: searchType
      }
    });
  }, [onInputFocus, log, searchType]);
  return jsx(HistoryStorageProvider, {
    get: historyStorage.get,
    set: function set(histories) {
      historyStorage.set(histories);
      handleHistoryUpdate();
    },
    append: function append(history) {
      historyStorage.append(history);
      handleHistoryUpdate();
    },
    remove: function remove(history) {
      historyStorage.remove(history);
      handleHistoryUpdate();
    },
    removeAll: function removeAll() {
      historyStorage.removeAll();
      handleHistoryUpdate();
    },
    children: jsx(Search, _objectSpread2({
      id: "global-search",
      pageKey: pageKey,
      initialQuery: initialQuery,
      placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getSearchPlaceholder(searchType),
      fetchList: fetchList,
      getItemQuery: function getItemQuery(item) {
        return item.query;
      },
      renderListBox: function renderListBox(props) {
        return jsx(ListBox, _objectSpread2(_objectSpread2({}, props), {}, {
          isHistoryList: !!manuallyTypedInputValue
        }));
      },
      onSubmit: handleSubmit,
      onSubmitItem: handleSubmitItem,
      onInputFocus: handleInputFocus,
      onInputChange: setManuallyTypedInputValue
    }, props))
  });
}

var _templateObject$d, _templateObject2$7;
var KEYFRAMES = {
  overlay: keyframes(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "]))),
  drawer: keyframes(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  "])))
};
var Animation = {
  open: 'open',
  close: 'close'
};
function Drawer(_ref) {
  var open = _ref.open,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    width = _ref.width,
    padding = _ref.padding,
    animationKeyframes = _ref.animationKeyframes,
    containerCss = _ref.containerCss,
    children = _ref.children,
    onClose = _ref.onClose,
    onClosed = _ref.onClosed;
  var theme = useTheme();
  var scrollAvailableRef = useRef(null);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    animation = _useState2[0],
    setAnimation = _useState2[1];
  var _useState3 = useState(open),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  useEffect(function () {
    setAnimation(open ? Animation.open : Animation.close);
  }, [open]);
  useEffect(function () {
    if (open) {
      setVisible(true);
    }
  }, [open]);
  var overlayAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.overlay) || KEYFRAMES.overlay;
  var drawerAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.drawer) || KEYFRAMES.drawer;
  var handleNavigationClose = useCallback(function () {
    onClose();
  }, [onClose]);
  var handleAnimationEnd = useCallback(function () {
    if (animation === Animation.open) {
      setAnimation(undefined);
    }
    if (animation === Animation.close) {
      setVisible(false);
      onClosed === null || onClosed === void 0 ? void 0 : onClosed();
    }
  }, [animation, onClosed]);
  if (!visible) {
    return null;
  }
  return jsxs(OverlayPortal, {
    children: [jsx(ScrollLock, {
      enabled: open,
      getElement: function getElement() {
        return scrollAvailableRef.current;
      }
    }), jsx(Dim, {
      ref: scrollAvailableRef,
      variant: "basic",
      onClick: handleNavigationClose,
      css: /*#__PURE__*/css(animation === Animation.open && /*#__PURE__*/css("animation:", overlayAnimation, " .2s forwards;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), " ", animation === Animation.close && /*#__PURE__*/css("pointer-events:none;animation:", overlayAnimation, " .2s reverse forwards;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx("div", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onAnimationEnd: handleAnimationEnd,
        css: [/*#__PURE__*/css("position:absolute;overflow-y:auto;top:0;bottom:0;", align === 'left' ? 'left: 0' : 'right: 0', ";width:", width != null ? "".concat(width, "px") : '100%', ";height:100%;padding:", padding != null ? "".concat(padding[0], " ").concat(padding[1]) : "".concat(pxToRem(26), " ").concat(pxToRem(16)), ";box-sizing:border-box;background:", theme.background.base, ";text-align:left;", animation === Animation.open && /*#__PURE__*/css("animation:", drawerAnimation, " .3s forwards;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), " ", animation === Animation.close && /*#__PURE__*/css("animation:", drawerAnimation, " .3s reverse forwards;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), containerCss],
        children: children
      })
    })]
  });
}

var _excluded$N = ["className", "onSubmit", "onSubmitItem"];
var _templateObject$c, _templateObject2$6, _templateObject3$2, _templateObject4$1;
var slideIn = keyframes(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(50px);\n  }\n  to {\n    transform: translateX(0);\n  }\n"])));
function SearchDrawer(_ref) {
  var className = _ref.className,
    onSubmit = _ref.onSubmit,
    onSubmitItem = _ref.onSubmitItem,
    searchProps = _objectWithoutProperties(_ref, _excluded$N);
  var theme = useTheme();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var drawerAnimation = {
    drawer: slideIn
  };
  var handleDrawerOpen = useCallback(function () {
    setOpen(true);
  }, []);
  var handleDrawerClose = useCallback(function () {
    setOpen(false);
  }, []);
  var handleSubmit = useCallback(function (value) {
    setOpen(false);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
  }, [onSubmit]);
  var handleSubmitItem = useCallback(function (item) {
    setOpen(false);
    onSubmitItem === null || onSubmitItem === void 0 ? void 0 : onSubmitItem(item);
  }, [onSubmitItem]);
  return jsxs("div", {
    css: className,
    children: [jsx("button", {
      type: "button",
      css: [/*#__PURE__*/css(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", theme.content.base1, ";line-height:0;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n            color: ", ";\n          "])), theme.content.primary1.basic), FOCUS(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n            color: ", ";\n          "])), theme.content.primary1.basic)],
      onClick: handleDrawerOpen,
      children: jsx(Icon, {
        name: "search",
        size: 24
      })
    }), jsx(Drawer, {
      open: open,
      align: "right",
      onClose: handleDrawerClose,
      animationKeyframes: drawerAnimation,
      containerCss: /*#__PURE__*/css(safeAreaInset('bottom', 'padding-bottom'), " ", MEDIA_QUERY.min('tablet', "\n            min-width: ".concat(pxToRem(256), ";\n            max-width: ").concat(pxToRem(326), ";\n            padding: ").concat(pxToRem(30), ";\n          ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:containerCss;")),
      children: jsx(NavigationSearch, _objectSpread2(_objectSpread2({}, searchProps), {}, {
        onSubmit: handleSubmit,
        onSubmitItem: handleSubmitItem,
        isInputAutoFocused: true,
        renderInputRight: function renderInputRight() {
          return jsx("button", {
            type: "button",
            onClick: handleDrawerClose,
            css: [/*#__PURE__*/css(RESET_BUTTON, " flex-shrink:0;margin-left:", pxToRem(15), ";padding:", pxToRem(9), " ", pxToRem(5), " ", pxToRem(10), ";color:", theme.content.base1, ";font-size:", pxToRem(15), ";line-height:1;font-weight:700;outline:none;", MEDIA_QUERY.min('tablet', "\n                    display: none;\n                  "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), FOCUS(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n                  & > span {\n                    box-shadow: 0 0 0 ", " ", ";\n                  }\n                "])), pxToRem(3), theme.interactive.primary1.thin)],
            children: jsx("span", {
              css: /*#__PURE__*/css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
              children: "\uCDE8\uC18C"
            })
          });
        }
      }))
    })]
  });
}

var _templateObject$b, _templateObject2$5;
function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$y = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1uvyp5k-css",
  styles: "position:relative;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
};
function UploadDropdownContentItem(_ref2) {
  var href = _ref2.href,
    icon = _ref2.icon,
    title = _ref2.title,
    subtitle = _ref2.subtitle,
    logId = _ref2.logId;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return jsxs(LinkComponent, {
    href: href,
    css: [/*#__PURE__*/css("display:flex;align-items:center;padding:", pxToRem(15), ";background-color:", theme.background.base, ";border-radius:", pxToRem(2), ";transition:.1s background-color;word-break:keep-all;white-space:nowrap;font-size:", pxToRem(15), ";line-height:0;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.background.groupedBase), FOCUS(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logId) {
        log({
          key: logId,
          category: 'click'
        });
      }
    },
    children: [jsx("div", {
      css: _ref$y,
      children: icon
    }), jsxs("div", {
      css: /*#__PURE__*/css("margin-left:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [jsx("div", {
        css: /*#__PURE__*/css("font-size:", pxToRem(15), ";font-weight:bold;line-height:", pxToRem(21), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: title
      }), jsx("div", {
        css: /*#__PURE__*/css("margin:", pxToRem(4), " 0 0;font-size:", pxToRem(12), ";line-height:", pxToRem(16), ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: subtitle
      })]
    })]
  });
}

var _templateObject$a;
function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BUTTON_SIZE = 40;
var _ref$x = process.env.NODE_ENV === "production" ? {
  name: "12whrtl",
  styles: "outline:none;overflow:hidden"
} : {
  name: "16iio9p-css",
  styles: "outline:none;overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
};
function UploadDropdownContentButton(_ref2) {
  var uploadMenuLinks = _ref2.uploadMenuLinks;
  var theme = useTheme();
  var log = useLogContext();
  var _getWithIconOptions = getWithIconOptions(BUTTON_SIZE),
    gap = _getWithIconOptions.gap,
    iconSize = _getWithIconOptions.iconSize;
  return jsx(Popper, {
    usePortal: false,
    renderButton: function renderButton(_ref3) {
      var _onClick = _ref3.onClick;
      return jsxs(Button$2, {
        variant: "primary1",
        size: BUTTON_SIZE,
        type: "button",
        css: [_ref$x, FOCUS(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)],
        onClick: function onClick() {
          _onClick();
          log({
            key: 'primary.right.upload',
            category: 'click'
          });
        },
        children: [jsx("span", {
          css: /*#__PURE__*/css("vertical-align:middle;white-space:nowrap;", MEDIA_QUERY.min('laptop', "\n                margin-right: ".concat(pxToRem(gap), ";\n              ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: "\uAE00\uC4F0\uAE30"
        }), jsx(Icon, {
          css: /*#__PURE__*/css("vertical-align:middle;display:none;", MEDIA_QUERY.min('laptop', "\n                display: inline-block;\n              "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          name: "chevron_down",
          size: iconSize
        })]
      });
    },
    children: uploadMenuLinks && uploadMenuLinks.map(function (item) {
      return jsx(UploadDropdownContentItem, _objectSpread2({}, item), item.title);
    })
  });
}

var _templateObject$9, _templateObject2$4;
function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$w = process.env.NODE_ENV === "production" ? {
  name: "1dnrp50",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0"
} : {
  name: "11mxadn-css",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
function UserDropdownContentItem(_ref2) {
  var bullet = _ref2.bullet,
    title = _ref2.title,
    href = _ref2.href,
    _onClick = _ref2.onClick,
    logKey = _ref2.logKey;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  var Component = href ? LinkComponent : 'button';
  return jsxs(Component, _objectSpread2(_objectSpread2({}, Component === LinkComponent ? {
    href: href
  } : {
    type: 'button'
  }), {}, {
    css: [/*#__PURE__*/css("display:block;position:relative;width:100%;margin:0;padding:", pxToRem(10), " ", pxToRem(14), " ", pxToRem(11), ";box-sizing:border-box;border:none;background:", theme.background.base, ";color:", theme.content.base1, ";font-family:inherit;font-weight:normal;font-size:", pxToRem(15), ";line-height:", pxToRem(21), ";text-decoration:none;text-align:left;cursor:pointer;border-radius:", pxToRem(2), ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), theme.background.groupedBase), FOCUS(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logKey) {
        log({
          key: logKey,
          category: 'click'
        });
      }
      if (_onClick) {
        _onClick();
      }
    },
    children: [title, bullet === 'new' && jsx(SvgIcNew18, {
      css: _ref$w
    })]
  }));
}

var _templateObject$8, _templateObject2$3;
function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var DEFAULT_PROFILE_URL = 'https://image.ohousecdn.com/i/bucketplace-v2-development/uploads/users/profile_images1542987307_LkcmI.jpeg';
var _ref$v = process.env.NODE_ENV === "production" ? {
  name: "xnm8en",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover"
} : {
  name: "wgv9yk-css",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
};
function UserDropdownContentButton(_ref2) {
  var profileUrl = _ref2.profileUrl,
    userMenu = _ref2.userMenu;
  var theme = useTheme();
  var items = useMemo(function () {
    return userMenu.filter(function (menu) {
      var _a;
      return (_a = menu.showOn) === null || _a === void 0 ? void 0 : _a.includes('bar');
    });
  }, [userMenu]);
  return jsx(Popper, {
    usePortal: false,
    renderButton: function renderButton(_ref3) {
      var onClick = _ref3.onClick;
      return jsx("button", {
        css: [/*#__PURE__*/css(RESET_BUTTON, " position:relative;overflow:hidden;width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:100%;outline:none;&:after{content:'';display:none;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:100%;border:", pxToRem(2), " solid ", theme.content.primary1.basic, ";box-sizing:border-box;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n              &:after {\n                display: block;\n              }\n            "]))), FOCUS(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n              &:after {\n                display: block;\n              }\n            "])))],
        type: "button",
        onClick: onClick,
        "aria-label": "\uD504\uB85C\uD544 \uBA54\uB274",
        children: jsx(ResizeImage, {
          width: 40,
          aspect: 1,
          src: profileUrl || DEFAULT_PROFILE_URL,
          alt: "\uD504\uB85C\uD544 \uC0AC\uC9C4",
          css: _ref$v
        })
      });
    },
    children: jsx("div", {
      css: /*#__PURE__*/css("width:", pxToRem(184), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: items.map(function (item, index) {
        return jsx(UserDropdownContentItem, _objectSpread2({}, item), index);
      })
    })
  });
}

var _excluded$M = ["count", "maxCount"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * @deprecated ODS의 CircleBadge 컴포넌트를 사용해 주세요.
 */
var _ref$u = process.env.NODE_ENV === "production" ? {
  name: "a4hmbt",
  styles: "position:absolute"
} : {
  name: "exuen1-css",
  styles: "position:absolute;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
};
function NumberNotification(_ref2) {
  var count = _ref2.count,
    maxCount = _ref2.maxCount,
    rest = _objectWithoutProperties(_ref2, _excluded$M);
  return jsx(CircleBadge, _objectSpread2(_objectSpread2({}, rest), {}, {
    size: 16,
    type: "fill",
    variant: "primary2",
    css: _ref$u,
    children: maxCount < count ? "+".concat(maxCount) : count
  }));
}

var _templateObject$7, _templateObject2$2;
var _excluded$L = ["component", "iconName", "type", "count"];
var NotificationType = {
  Dot: 'DOT',
  Number: 'NUMBER',
  None: 'NONE'
};
function IconNotification(_ref) {
  var _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'div' : _ref$component,
    iconName = _ref.iconName,
    type = _ref.type,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    restProps = _objectWithoutProperties(_ref, _excluded$L);
  var theme = useTheme();
  var Component = component;
  return jsxs(Component
  // FIXME: 이거 IconNotification에서 높이를 임의로 지정하면 안될 것 같아요
  // NOTE: 디자인에서는 아이콘마다 14px의 거리를 규정하고 있습니다. 즉, 각 아이콘이
  //       한 방향에서 가질 수 있는 가로 padding+margin은 7px까지입니다.
  , _objectSpread2(_objectSpread2({
    // FIXME: 이거 IconNotification에서 높이를 임의로 지정하면 안될 것 같아요
    // NOTE: 디자인에서는 아이콘마다 14px의 거리를 규정하고 있습니다. 즉, 각 아이콘이
    //       한 방향에서 가질 수 있는 가로 padding+margin은 7px까지입니다.
    css: [/*#__PURE__*/css("position:relative;display:inline-block;padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", theme.content.base1, ";line-height:0;outline:none;", MEDIA_QUERY.min('tablet', "\n            margin: ".concat(pxToRem(9), " ").concat(pxToRem(1), ";\n          ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), theme.content.primary1.basic), FOCUS(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), theme.content.primary1.basic)]
  }, restProps), {}, {
    children: [jsx(Icon, {
      css: /*#__PURE__*/css("font-size:", pxToRem(24), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      name: iconName,
      size: 24
    }), type === NotificationType.Dot && jsx(DotNotification, {}), type === NotificationType.Number && count > 0 && jsx("span", {
      css: /*#__PURE__*/css("position:absolute;top:0;right:", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(NumberNotification, {
        count: count,
        maxCount: 99
      })
    })]
  }));
}

var _excluded$K = ["component", "label", "href", "logKey"];
function NoLoginMenuItem(_ref) {
  var _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    label = _ref.label,
    href = _ref.href,
    logKey = _ref.logKey,
    rest = _objectWithoutProperties(_ref, _excluded$K);
  var theme = useTheme();
  var Component = component;
  var log = useLogContext();
  return jsx(Component, _objectSpread2(_objectSpread2({}, rest), {}, {
    href: href,
    css: /*#__PURE__*/css(FONT_STYLE.subTitle2, ";color:", theme.content.base1, ";padding:0 10px;border-left:1px solid ", theme.content.base4, ";&:first-of-type{border-left:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    onClick: function onClick() {
      return log({
        key: logKey,
        category: 'click'
      });
    },
    children: label
  }));
}

var _excluded$J = ["userableType"];
var SELLER_USERABLE_TYPE = 'SalesUser';
var SellerButton = /*#__PURE__*/memo(function (_ref) {
  var userableType = _ref.userableType,
    rest = _objectWithoutProperties(_ref, _excluded$J);
  if (userableType !== SELLER_USERABLE_TYPE) {
    return null;
  }
  return jsx(OutlineAnchorButton, _objectSpread2(_objectSpread2({
    css: /*#__PURE__*/css("display:none;margin-left:8px;", MEDIA_QUERY.min('laptop', "\n          display: flex;\n          align-items: center;\n        "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    variant: "base1",
    size: 40
  }, rest), {}, {
    children: "\uD310\uB9E4\uC790 \uC804\uC6A9\uC11C\uBE44\uC2A4"
  }));
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$t = process.env.NODE_ENV === "production" ? {
  name: "1kpxvh4",
  styles: "display:flex;margin:0 10px 0 8px"
} : {
  name: "8i8pe6-css",
  styles: "display:flex;margin:0 10px 0 8px;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
};
var _ref2$a = process.env.NODE_ENV === "production" ? {
  name: "10vibjk",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0"
} : {
  name: "m9y27m-css",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
};
function PrimaryRight(_ref3) {
  var searchProps = _ref3.searchProps,
    userProfile = _ref3.userProfile,
    userMenu = _ref3.userMenu,
    scrap = _ref3.scrap,
    cart = _ref3.cart,
    notification = _ref3.notification,
    signin = _ref3.signin,
    signup = _ref3.signup,
    cs = _ref3.cs,
    seller = _ref3.seller,
    uploadMenuLinks = _ref3.uploadMenuLinks;
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  var _ref4 = userProfile || {},
    userId = _ref4.userId,
    imageUrl = _ref4.imageUrl;
  var loggedIn = userId != null;
  return jsxs("div", {
    css: _ref2$a,
    children: [searchProps && jsxs(Fragment$1, {
      children: [jsx(NavigationSearch, _objectSpread2({
        css: /*#__PURE__*/css("flex:1 1 0px;min-width:0;margin-right:", pxToRem(9), ";", MEDIA_QUERY.min('desktop', "\n                margin-right: ".concat(pxToRem(14), ";\n              ")), " ", MEDIA_QUERY.max('tablet', "\n                display: none;\n              "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }, searchProps)), jsx(SearchDrawer, _objectSpread2({
        css: /*#__PURE__*/css(MEDIA_QUERY.min('laptop', "\n                display: none;\n              "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }, searchProps))]
    }), scrap && jsx("div", {
      css: /*#__PURE__*/css(MEDIA_QUERY.max('mobile', "\n            display: none;\n          "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(IconNotification, {
        iconName: "scrap_outline",
        type: NotificationType.None,
        component: LinkComponent,
        "aria-label": "\uC2A4\uD06C\uB7A9\uBD81 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        href: scrap.href,
        onClick: function onClick() {
          return log({
            key: 'primary.right.scrap',
            category: 'click'
          });
        }
      })
    }), notification && jsx("div", {
      css: /*#__PURE__*/css(MEDIA_QUERY.max('mobile', "\n              display: none;\n            "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(IconNotification, {
        iconName: "notification_outline",
        type: NotificationType.Number,
        count: notification.count,
        component: LinkComponent,
        href: notification.href,
        "aria-label": "\uB0B4\uC18C\uC2DD \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        onClick: function onClick() {
          return log({
            key: 'primary.right.notification',
            category: 'click'
          });
        }
      })
    }), cart && jsx(IconNotification, {
      iconName: "cart",
      type: NotificationType.Number,
      count: cart.count,
      component: LinkComponent,
      href: cart.href,
      "aria-label": "\uC7A5\uBC14\uAD6C\uB2C8 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
      onClick: function onClick() {
        return log({
          key: 'primary.right.cart',
          category: 'click'
        });
      }
    }), jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;", MEDIA_QUERY.max('mobile', "\n            display: none;\n          "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [loggedIn && jsx("div", {
        css: /*#__PURE__*/css("margin:0 ", pxToRem(12), " 0 ", pxToRem(5), ";", MEDIA_QUERY.min('laptop', "\n                margin: 0 ".concat(pxToRem(16), " 0 ").concat(pxToRem(9), ";\n              ")), " ", MEDIA_QUERY.min('desktop', "\n                margin: 0 ".concat(pxToRem(20), " 0 ").concat(pxToRem(13), ";\n              ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: jsx(UserDropdownContentButton, {
          profileUrl: imageUrl,
          userMenu: userMenu
        })
      }), jsxs("div", {
        css: _ref$t,
        children: [signin && jsx(NoLoginMenuItem, {
          label: "\uB85C\uADF8\uC778",
          href: signin.href,
          component: LinkComponent,
          logKey: "primary.right.login"
        }), signup && jsx(NoLoginMenuItem, {
          label: "\uD68C\uC6D0\uAC00\uC785",
          href: signup.href,
          component: LinkComponent,
          logKey: "primary.right.signup"
        }), cs && jsx(NoLoginMenuItem, {
          label: "\uACE0\uAC1D\uC13C\uD130",
          href: cs.href,
          component: LinkComponent,
          logKey: "primary.right.cs",
          css: /*#__PURE__*/css(MEDIA_QUERY.max('laptop', "\n                  display: none;\n                "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        })]
      }), uploadMenuLinks && uploadMenuLinks.length > 0 && jsx(UploadDropdownContentButton, {
        uploadMenuLinks: uploadMenuLinks
      }), seller && jsx(SellerButton, {
        href: seller.href
      })]
    })]
  });
}

var _path, _rect, _path2, _path3;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgLogo$1 = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.2 25.17H9.28V20.7a1.45 1.45 0 0 0-2.9 0v4.47H1.44a1.45 1.45 0 1 0 0 2.9H14.2a1.45 1.45 0 0 0 0-2.9M4.5 9.15c0-4.6 2.08-5.28 3.33-5.28 1.24 0 3.33.69 3.33 5.28v.36c0 4.6-2.09 5.28-3.33 5.28-1.25 0-3.34-.69-3.34-5.28v-.36zm3.33 8.54c3.84 0 6.23-3.13 6.23-8.18v-.36c0-5.05-2.39-8.18-6.23-8.18-3.85 0-6.24 3.13-6.24 8.18v.36c0 5.05 2.39 8.18 6.24 8.18m25.54-7.34H17.81a1.45 1.45 0 0 0 0 2.9h15.56a1.45 1.45 0 1 0 0-2.9m-1.55 15.49c-7.08 1.84-9.45.8-10.14.26-.45-.35-.65-.8-.65-1.48v-.87h10.25c.8 0 1.46-.65 1.46-1.45v-5.08c0-.8-.65-1.45-1.46-1.45h-11.7a1.45 1.45 0 1 0 0 2.9h10.25v2.18H19.57c-.8 0-1.45.65-1.45 1.45v2.32a4.6 4.6 0 0 0 1.78 3.78c1.2.92 2.94 1.39 5.21 1.39 2.05 0 4.54-.38 7.44-1.13a1.45 1.45 0 1 0-.73-2.82M20.3 7.83h10.82a1.45 1.45 0 1 0 0-2.9h-9.36V1.44a1.45 1.45 0 1 0-2.9 0v4.93c0 .8.65 1.45 1.45 1.45z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 15,
    x: 70,
    fill: "currentColor",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M64.5 13.28a1.45 1.45 0 0 0 2.73-1c-.05-.13-1-2.68-3.38-4.5l3.7-4.1a1.45 1.45 0 0 0-1.09-2.42h-9.05a1.45 1.45 0 1 0 0 2.9h5.8l-6.88 7.64a1.45 1.45 0 1 0 2.16 1.95l3.41-3.8a8 8 0 0 1 2.6 3.33m5.06 13.24h-7.01a.82.82 0 0 1-.82-.82v-1.95h8.65v1.95c0 .45-.37.82-.82.82m2.27-9.37c-.8 0-1.45.65-1.45 1.45v2.25h-8.65V18.6a1.45 1.45 0 1 0-2.9 0v7.1a3.72 3.72 0 0 0 3.72 3.72h7.01a3.72 3.72 0 0 0 3.72-3.72v-7.1c0-.8-.65-1.45-1.45-1.45M42.46 3.87c2.22 0 2.33 4.24 2.33 5.08 0 .85-.11 5.09-2.33 5.09-2.21 0-2.32-4.24-2.32-5.09 0-.84.11-5.08 2.32-5.08m0 13.07c1.76 0 3.23-.93 4.14-2.62.71-1.34 1.1-3.2 1.1-5.37 0-2.16-.39-4.02-1.1-5.36A4.59 4.59 0 0 0 42.46.97c-1.75 0-3.22.93-4.13 2.62-.72 1.34-1.1 3.2-1.1 5.36 0 2.17.38 4.03 1.1 5.37a4.59 4.59 0 0 0 4.13 2.62",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51.4.49c-.8 0-1.45.65-1.45 1.45v17.78c-1.93.6-5.75 1.12-10.38 1.12h-2.2a1.45 1.45 0 0 0 0 2.91h2.2c2.64 0 7.21-.23 10.38-1.02v4.84a1.45 1.45 0 0 0 2.9 0V1.94c0-.8-.65-1.45-1.45-1.45",
    clipRule: "evenodd"
  })));
};

var _templateObject$6;
var _excluded$I = ["logo", "children"];
function Logo(_ref) {
  var logo = _ref.logo,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$I);
  var theme = useTheme();
  var Link = useLinkContext();
  return jsx(Link, _objectSpread2(_objectSpread2({}, rest), {}, {
    href: (logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se',
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uB85C\uACE0",
    css: [/*#__PURE__*/css(RESET_BUTTON, " display:inline-flex;align-items:center;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";font-size:0;line-height:0;color:", theme.interactive.base1, ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), FOCUS(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n          box-shadow: 0 0 0 ", " ", ";\n          border-radius: ", ";\n        "])), pxToRem(3), theme.interactive.primary1.thin, pxToRem(3))],
    children: children || (logo === null || logo === void 0 ? void 0 : logo.item) || jsx(SvgLogo$1, {
      css: /*#__PURE__*/css("vertical-align:top;height:", pxToRem(26), ";", MEDIA_QUERY.min('tablet', "\n            height: ".concat(pxToRem(30), ";\n          ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    })
  }));
}

function useFocusedLatch(onChange) {
  var focusRef = useRef(null);
  var handleFocusIn = useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    onChange(true);
  }, [onChange]);
  var handleFocusOut = useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    focusRef.current = requestAnimationFrame(function () {
      return onChange(false);
    });
  }, [onChange]);
  return [handleFocusIn, handleFocusOut];
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function NavigationBar(props) {
  var _a;
  var log = useLogContext();
  var logo = props.logo,
    primaryLeftmost = props.primaryLeftmost,
    menuSchema = props.menuSchema,
    fallbackMenuSchema = props.fallbackMenuSchema,
    searchOptions = props.searchOptions,
    supplementary = props.supplementary;
  var _useState = useState({
      isHovered: false,
      selectedIds: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    isHovered = _useState2$.isHovered,
    selectedIds = _useState2$.selectedIds,
    setState = _useState2[1];
  var setHovered = useCallback(function (value) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        isHovered: value,
        selectedIds: !value ? null : prevState.selectedIds
      });
    });
  }, []);
  var _useFocusedLatch = useFocusedLatch(setHovered),
    _useFocusedLatch2 = _slicedToArray(_useFocusedLatch, 2),
    onMouseEnter = _useFocusedLatch2[0],
    onMouseLeave = _useFocusedLatch2[1];
  var activeIds = useMemo(function () {
    return getActiveIds(menuSchema, fallbackMenuSchema);
  }, [menuSchema, fallbackMenuSchema]);
  var currentSelectedIds = selectedIds == null ? activeIds : selectedIds;
  var primaryEntries = menuSchema;
  var activePrimaryItem = activeIds[0] != null ? primaryEntries[activeIds[0]] : null;
  var primaryItem = currentSelectedIds[0] != null ? primaryEntries[currentSelectedIds[0]] : null;
  var secondaryEntries = getSecondaryEntries({
    primary: primaryItem,
    activeIds: activeIds,
    fallbackMenuSchema: fallbackMenuSchema
  });
  var secondaryItem = currentSelectedIds[1] != null ? secondaryEntries[currentSelectedIds[1]] : null;
  var hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  var handlePrimarySelect = useCallback(function (_, index) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        selectedIds: [index]
      });
    });
  }, []);
  var handleSecondarySelect = useCallback(function (_, index) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        selectedIds: [currentSelectedIds[0], index]
      });
    });
  }, [currentSelectedIds]);
  var CustomPrimaryRight = (_a = supplementary.primaryRight) !== null && _a !== void 0 ? _a : null;
  var showTertiary = selectedIds != null && selectedIds[1] != null && secondaryItem != null && secondaryItem.renderBarChild != null;
  var secondaryRightElement = supplementary.secondaryRight != null ? /*#__PURE__*/React__default.createElement(supplementary.secondaryRight) : null;
  var hasItemInActivedPrimaryItem = activePrimaryItem != null && activePrimaryItem.entries != null ? activePrimaryItem.entries.length > 0 : false;
  var hasItemInHoveredPrimaryItem = primaryItem != null && primaryItem.entries != null ? primaryItem.entries.length > 0 : false;
  return jsxs("header", {
    children: [jsx(NavigationBarPrimary, {
      leftmost: primaryLeftmost,
      left: jsx(StyledLogo, {
        logo: logo,
        onClick: function onClick() {
          log({
            key: 'logo',
            category: 'click'
          });
        }
      }),
      right: CustomPrimaryRight ? jsx(CustomPrimaryRightContainer, {
        children: jsx(CustomPrimaryRight, {})
      }) : jsx(PrimaryRight, _objectSpread2({
        searchProps: searchOptions
      }, supplementary)),
      menuEntries: primaryEntries,
      activeId: activeIds[0],
      selectedId: currentSelectedIds[0],
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handlePrimarySelect
    }), jsx(NavigationBarSecondary, {
      right: secondaryRightElement,
      menuEntries: secondaryEntries,
      hasItems: hasItemInActivedPrimaryItem || hasItemInHoveredPrimaryItem || hasFallbackMenuSchema,
      activeId: currentSelectedIds[0] === activeIds[0] ? activeIds[1] : null,
      primaryId: currentSelectedIds[0],
      isForceOpened: isHovered && secondaryEntries.length > 0,
      isFallback: currentSelectedIds[0] == null && hasFallbackMenuSchema,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handleSecondarySelect,
      scrollableEntries: primaryItem === null || primaryItem === void 0 ? void 0 : primaryItem.scrollableEntries
    }), showTertiary && jsx(NavigationBarTertiary, {
      item: showTertiary ? secondaryItem : null,
      isOpen: showTertiary,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
}
var StyledLogo = /*#__PURE__*/_styled(Logo, process.env.NODE_ENV === "production" ? {
  target: "e4qy2et1"
} : {
  target: "e4qy2et1",
  label: "StyledLogo"
})("height:", pxToRem(26), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("height:", pxToRem(30), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledLogo;"))), ";");
var CustomPrimaryRightContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e4qy2et0"
} : {
  target: "e4qy2et0",
  label: "CustomPrimaryRightContainer"
})(MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "ffpekn-CustomPrimaryRightContainer",
  styles: "display:none;label:CustomPrimaryRightContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
}), ";");
/** Secondary 메뉴 스키마를 리턴합니다 */
function getSecondaryEntries(_ref) {
  var primary = _ref.primary,
    activeIds = _ref.activeIds,
    fallbackMenuSchema = _ref.fallbackMenuSchema;
  var _a;
  if (primary != null) {
    return (_a = primary.entries) !== null && _a !== void 0 ? _a : [];
  }
  if (activeIds[1] != null) {
    return fallbackMenuSchema !== null && fallbackMenuSchema !== void 0 ? fallbackMenuSchema : [];
  }
  return [];
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$s = process.env.NODE_ENV === "production" ? {
  name: "10qs83r",
  styles: "display:block;margin:20px -10px 0;line-height:1"
} : {
  name: "9o50xr-css",
  styles: "display:block;margin:20px -10px 0;line-height:1;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
var _ref2$9 = process.env.NODE_ENV === "production" ? {
  name: "d0zu4q",
  styles: "position:relative;display:block;width:80px;height:80px;&>img{position:absolute;top:0;left:0;width:100%;border:0;}"
} : {
  name: "17o3szl-css",
  styles: "position:relative;display:block;width:80px;height:80px;&>img{position:absolute;top:0;left:0;width:100%;border:0;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
var _ref3$4 = process.env.NODE_ENV === "production" ? {
  name: "dg5hsf",
  styles: "display:block;padding:10px 0;font-size:14px;font-weight:bold;text-align:center"
} : {
  name: "1euwkiu-css",
  styles: "display:block;padding:10px 0;font-size:14px;font-weight:bold;text-align:center;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
var _ref4$1 = process.env.NODE_ENV === "production" ? {
  name: "laomuu",
  styles: "padding-right:60px"
} : {
  name: "1ma20jq-css",
  styles: "padding-right:60px;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
var _ref5$1 = process.env.NODE_ENV === "production" ? {
  name: "v61o11",
  styles: "max-width:1276px;padding:10px 0 10px 60px"
} : {
  name: "rqatd3-css",
  styles: "max-width:1276px;padding:10px 0 10px 60px;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
var _ref6 = process.env.NODE_ENV === "production" ? {
  name: "1qmr6ab",
  styles: "overflow:auto"
} : {
  name: "d293do-css",
  styles: "overflow:auto;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
function StoreCategory(_ref7) {
  var categories = _ref7.categories;
  var Link = useLinkContext();
  var log = useLogContext();
  var theme = useTheme();
  return jsx("div", {
    css: _ref6,
    children: jsx("ul", {
      css: /*#__PURE__*/css("display:flex;justify-content:space-between;margin:0 auto;padding:10px 0 10px 40px;box-sizing:border-box;", MEDIA_QUERY.min('laptop', _ref5$1), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: categories.map(function (category, index) {
        return jsx("li", {
          css: /*#__PURE__*/css("flex:0 0 auto;margin:0;padding:0 0 0 10px;color:", category.active ? theme.content.primary1.basic : theme.content.base1, ";&:last-of-type{padding-right:40px;", MEDIA_QUERY.min('laptop', _ref4$1), ";}&:hover{color:", theme.content.primary1.basic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: jsxs(Link, {
            href: category.href,
            onClick: function onClick() {
              log({
                key: 'tertiary.store.category.item',
                category: 'click',
                params: {
                  id: category.logId,
                  index: index
                }
              });
            },
            css: _ref3$4,
            children: [jsx("span", {
              css: _ref2$9,
              children: category.icon
            }), jsx("span", {
              css: _ref$s,
              children: category.title
            })]
          })
        }, category.title);
      })
    })
  });
}

function NavigationDrawerDivider() {
  return jsx(Divider$1, {
    variant: "thin",
    css: /*#__PURE__*/css("margin:", pxToRem(20), " 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$r = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "oj32ga-css",
  styles: "overflow:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};
function NavigationDrawerMenuAccordion(_ref2) {
  var children = _ref2.children,
    isExpanded = _ref2.isExpanded,
    onTransitionStart = _ref2.onTransitionStart,
    onTransitionEnd = _ref2.onTransitionEnd;
  var container = useRef(null);
  var content = useRef(null);
  var isExpanding = useRef(false);
  var isCollapsing = useRef(false);
  var expand = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isExpanding.current = true;
    container.current.style.display = 'block';
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    onTransitionStart();
  }, [onTransitionStart]);
  var collapse = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isCollapsing.current = true;
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.height = '0px';
      onTransitionStart();
    }, 50);
  }, [onTransitionStart]);
  var handleTransitionEnd = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) {
      container.current.style.height = 'auto';
      isExpanding.current = false;
    } else if (isCollapsing.current) {
      container.current.style.display = 'none';
      isCollapsing.current = false;
    }
    onTransitionEnd();
  }, [onTransitionEnd]);
  useEffect(function () {
    if (!container.current) return;
    if (!container.current.style.transition) return;
    (isExpanded ? expand : collapse)();
  }, [isExpanded, expand, collapse]);
  useEffect(function () {
    if (!container.current) return;
    container.current.style.height = isExpanded ? 'auto' : '0px';
    container.current.style.display = isExpanded ? 'block' : 'none';
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.transition = 'height .3s';
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx("div", {
    ref: container,
    css: _ref$r,
    onTransitionEnd: handleTransitionEnd,
    children: jsx("div", {
      ref: content,
      children: children
    })
  });
}

var _templateObject$5, _templateObject2$1, _templateObject3$1, _templateObject4;
function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref3$3 = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "1mfgb2o-css",
  styles: "padding:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
};
function NavigationDrawerMenu(_ref4) {
  var items = _ref4.items,
    indents = _ref4.indents,
    fontStyles = _ref4.fontStyles,
    onClose = _ref4.onClose;
  var _useState = useState(function () {
      return items.findIndex(function (item) {
        return item.active;
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    expandedIndex = _useState2[0],
    setExpandedIndex = _useState2[1];
  return jsx("ul", {
    css: _ref3$3,
    children: items.map(function (item, index) {
      return jsx(NavigationDrawerMenuItem, {
        title: item.title,
        icon: item.icon,
        bullet: item.bullet,
        href: item.href,
        isActive: item.active,
        items: item.entries,
        renderChild: item.renderDrawerChild,
        indents: indents,
        fontStyles: fontStyles,
        isExpanded: index === expandedIndex,
        onExpand: function onExpand() {
          return setExpandedIndex(index);
        },
        onCollapse: function onCollapse() {
          return setExpandedIndex(-1);
        },
        onClick: function onClick() {
          var _a;
          (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item, {
            item: item,
            index: index
          });
          !item.entries && (onClose === null || onClose === void 0 ? void 0 : onClose());
        },
        onClose: onClose
      }, index);
    })
  });
}
var _ref$q = process.env.NODE_ENV === "production" ? {
  name: "1r7xtnv",
  styles: "margin-left:1.5px"
} : {
  name: "to2q6j-css",
  styles: "margin-left:1.5px;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
};
var _ref2$8 = process.env.NODE_ENV === "production" ? {
  name: "6103ef",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1"
} : {
  name: "jhsr6x-css",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
};
function NavigationDrawerMenuItem(_ref5) {
  var title = _ref5.title,
    icon = _ref5.icon,
    href = _ref5.href,
    bullet = _ref5.bullet,
    items = _ref5.items,
    _ref5$indents = _ref5.indents,
    indents = _ref5$indents === void 0 ? [] : _ref5$indents,
    _ref5$fontStyles = _ref5.fontStyles,
    fontStyles = _ref5$fontStyles === void 0 ? [] : _ref5$fontStyles,
    isActive = _ref5.isActive,
    isExpanded = _ref5.isExpanded,
    onExpand = _ref5.onExpand,
    onCollapse = _ref5.onCollapse,
    renderChild = _ref5.renderChild,
    _onClick = _ref5.onClick,
    onClose = _ref5.onClose;
  var theme = useTheme();
  var Link = useLinkContext();
  var isAccordionTransitioning = useRef(false);
  var handleAccordionTransitionStart = useCallback(function () {
    isAccordionTransitioning.current = true;
  }, []);
  var handleAccordionTransitionEnd = useCallback(function () {
    isAccordionTransitioning.current = false;
  }, []);
  var handleAccordionToggle = useCallback(function () {
    if (isAccordionTransitioning.current) return;
    (isExpanded ? onCollapse : onExpand)();
  }, [isExpanded, onCollapse, onExpand]);
  var renderTitle = function renderTitle() {
    return jsxs("div", {
      css: _ref2$8,
      children: [icon && jsx("span", {
        css: /*#__PURE__*/css("display:inline-block;margin-right:", pxToRem(8), ";border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: icon
      }), title, bullet === 'new' && jsx(SvgIcNew18, {
        css: _ref$q
      })]
    });
  };
  var _indents = _slicedToArray(indents, 1),
    indent = _indents[0];
  var _fontStyles = _slicedToArray(fontStyles, 1),
    _fontStyles$ = _fontStyles[0],
    fontStyle = _fontStyles$ === void 0 ? {} : _fontStyles$;
  return jsx("li", {
    css: /*#__PURE__*/css("margin:", pxToRem(4), " 0 0;padding:0;font-size:", pxToRem(fontStyle.size || 14), ";font-weight:", isActive ? 'bold' : fontStyle.weight || 'normal', ";color:", fontStyle.color || theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: items && items.length || renderChild ? jsxs(Fragment$1, {
      children: [jsxs("button", {
        type: "button",
        onClick: function onClick() {
          handleAccordionToggle();
          _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        },
        css: /*#__PURE__*/css(RESET_BUTTON, " overflow:hidden;position:relative;display:block;width:100%;height:", pxToRem(40), ";margin:0;padding:0 ", pxToRem(40), " 0 ", pxToRem(indent || 14), ";color:inherit;text-align:left;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/css("background-color:", theme.interactive.transparent, ";", HOVER(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n                      background-color: ", ";\n                    "])), theme.content.base5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : HOVER(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n                    background-color: ", ";\n                  "])), theme.content.base5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: [renderTitle(), jsx(Icon, {
          size: 12,
          name: isExpanded ? 'chevron_thick_up' : 'chevron_thick_down',
          css: /*#__PURE__*/css("position:absolute;top:", pxToRem(14), ";right:", pxToRem(14), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        })]
      }), jsx(NavigationDrawerMenuAccordion, {
        isExpanded: isExpanded,
        onTransitionStart: handleAccordionTransitionStart,
        onTransitionEnd: handleAccordionTransitionEnd,
        children: items && jsx(NavigationDrawerMenu, {
          items: items,
          fontStyles: fontStyles.slice(1),
          indents: indents.length > 1 ? indents.slice(1) : indents.slice(-1),
          onClose: onClose
        }) || renderChild && renderChild()
      })]
    }) : jsx(Link, {
      href: href,
      onClick: _onClick,
      css: /*#__PURE__*/css("overflow:hidden;display:block;width:100%;height:", pxToRem(40), ";padding:0 ", pxToRem(14), " 0 ", pxToRem(indent || 14), ";color:inherit;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/css("background-color:", theme.interactive.transparent, ";", HOVER(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n                  background-color: ", ";\n                "])), theme.content.base5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : HOVER(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                background-color: ", ";\n              "])), theme.content.base5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: renderTitle()
    })
  });
}

var _excluded$H = ["size", "src"];
/**
 * @deprecated ODS의 Avatar 컴포넌트를 사용해 주세요.
 */
function Avatar(_ref) {
  var size = _ref.size,
    src = _ref.src,
    rest = _objectWithoutProperties(_ref, _excluded$H);
  if (!src) return null;
  return jsx(ResizeImage$1, _objectSpread2(_objectSpread2({}, rest), {}, {
    src: src,
    intrinsicAspect: 1,
    objectFit: "cover",
    css: /*#__PURE__*/css("width:", pxToRem(size), ";height:", pxToRem(size), ";border-radius:50%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
  }));
}

var _excluded$G = ["text"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$p = process.env.NODE_ENV === "production" ? {
  name: "1200b05",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none"
} : {
  name: "ux88qh-css",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
};
function NavigationDrawerHeader(_ref2) {
  var logo = _ref2.logo,
    action = _ref2.action,
    supplementary = _ref2.supplementary;
  var log = useLogContext();
  var userProfile = supplementary.userProfile,
    signup = supplementary.signup,
    signin = supplementary.signin;
  return jsxs(Fragment$1, {
    children: [jsxs("div", {
      css: /*#__PURE__*/css("position:relative;font-size:", pxToRem(14), ";line-height:", pxToRem(18), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [jsx(Logo, _objectSpread2(_objectSpread2({}, logo), {}, {
        onClick: function onClick() {
          return log({
            key: 'drawer.logo',
            category: 'click'
          });
        }
      })), action && function (_ref3) {
        var text = _ref3.text,
          rest = _objectWithoutProperties(_ref3, _excluded$G);
        return jsxs(TextButton, _objectSpread2(_objectSpread2({}, rest), {}, {
          size: 32,
          variant: "primary1",
          css: _ref$p,
          children: [text, jsx(Icon, {
            name: "chevron_right",
            size: 12,
            fill: function fill(theme) {
              return theme.content.primary1.basic;
            },
            css: /*#__PURE__*/css("margin-left:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
          })]
        }));
      }(action)]
    }), userProfile == null ? jsxs("div", {
      css: /*#__PURE__*/css("display:flex;justify-content:space-between;width:100%;margin:", pxToRem(20), " 0 ", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [signin && jsx(OutlineAnchorButton, {
        href: signin.href,
        size: 44,
        variant: "primary1",
        onClick: function onClick() {
          // to signIn page
        },
        css: /*#__PURE__*/css("font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;height:", pxToRem(42), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: "\uB85C\uADF8\uC778"
      }), signup && jsx(AnchorButton, {
        href: signup.href,
        size: 44,
        variant: "primary1",
        onClick: function onClick() {
          // to signUp page
        },
        css: /*#__PURE__*/css("margin-left:", pxToRem(8), ";font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: "\uD68C\uC6D0\uAC00\uC785"
      })]
    }) : jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;margin:", pxToRem(24), " 0 ", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [jsx(Avatar, {
        size: 20,
        src: userProfile.imageUrl
      }), jsx("p", {
        css: /*#__PURE__*/css("font-size:", pxToRem(14), ";line-height:", pxToRem(20), ";margin-left:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: userProfile.nickname
      })]
    })]
  });
}

var _templateObject$4;
function NavigationDrawerFooterListItem(_ref) {
  var title = _ref.title,
    href = _ref.href,
    onClick = _ref.onClick,
    onClose = _ref.onClose;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  return jsx("li", {
    css: [/*#__PURE__*/css("display:inline-block;padding:", pxToRem(6), ";border-radius:", pxToRem(4), ";margin:0 0 0 ", pxToRem(7), ";line-height:", pxToRem(18), ";&:first-of-type{margin:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), HOVER(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.background.groupedBase)],
    children: href != null ? jsx(LinkComponent, {
      href: href,
      css: /*#__PURE__*/css(FONT_STYLE.subTitle2, " outline:none;vertical-align:middle;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      onClick: onClose,
      children: title
    }) : jsx("button", {
      css: /*#__PURE__*/css(RESET_BUTTON, " ", FONT_STYLE.subTitle2, " color:", theme.content.base1, ";outline:none;cursor:pointer;vertical-align:middle;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      onClick: onClick,
      type: "button",
      children: title
    })
  });
}
function NavigationDrawerFooter(_ref2) {
  var items = _ref2.items,
    onClose = _ref2.onClose;
  return jsx("ul", {
    css: /*#__PURE__*/css("padding:0;margin-top:", pxToRem(14), ";display:flex;align-items:center;>button{font-size:", pxToRem(14), ";font-weight:normal;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: items.map(function (item, index) {
      return jsx(NavigationDrawerFooterListItem, _objectSpread2({
        onClose: onClose
      }, item), index);
    })
  });
}

var _excluded$F = ["open", "logo", "menuSchema", "supplementary", "onClose", "onAppDownload"];
function NavigationDrawer(_ref) {
  var open = _ref.open,
    logo = _ref.logo,
    menuSchema = _ref.menuSchema,
    supplementary = _ref.supplementary,
    onClose = _ref.onClose,
    onAppDownload = _ref.onAppDownload,
    rest = _objectWithoutProperties(_ref, _excluded$F);
  var userMenu = supplementary.userMenu,
    _supplementary$showAp = supplementary.showAppDownloadButton,
    showAppDownloadButton = _supplementary$showAp === void 0 ? true : _supplementary$showAp;
  var log = useLogContext();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var drawerMenu = useMemo(function () {
    return menuSchema.map(function (mainMenu) {
      var _a;
      return _objectSpread2(_objectSpread2({}, mainMenu), {}, {
        onClick: function onClick(_ref2) {
          var index = _ref2.index;
          log({
            key: 'drawer.main.item',
            category: 'click',
            params: {
              index: index
            }
          });
        },
        entries: (_a = mainMenu.entries) === null || _a === void 0 ? void 0 : _a.map(function (subMenu) {
          return _objectSpread2(_objectSpread2({}, subMenu), {}, {
            onClick: function onClick(_ref3) {
              var href = _ref3.item.href,
                index = _ref3.index;
              log({
                key: 'drawer.sub.item',
                category: 'click',
                params: {
                  index: index,
                  href: href
                }
              });
            }
          });
        })
      });
    });
  }, [menuSchema, log]);
  var drawerUserMenu = useMemo(function () {
    return userMenu.filter(function (menu) {
      var _a;
      return (_a = menu.showOn) === null || _a === void 0 ? void 0 : _a.includes('drawer');
    }).map(function (_ref4) {
      var title = _ref4.title,
        href = _ref4.href,
        bullet = _ref4.bullet;
      return {
        title: title,
        href: href,
        bullet: bullet,
        onClick: function onClick(_ref5) {
          var index = _ref5.index;
          log({
            key: 'drawer.user.item',
            category: 'click',
            params: {
              index: index
            }
          });
        }
      };
    });
  }, [userMenu, log]);
  var drawerFooterMenu = useMemo(function () {
    return userMenu.filter(function (menu) {
      return menu.type === 'bottom';
    });
  }, [userMenu]);
  return jsxs(Drawer, _objectSpread2(_objectSpread2({
    open: open,
    width: 270,
    onClose: onClose
  }, rest), {}, {
    children: [jsx(NavigationDrawerHeader, {
      logo: {
        logo: logo,
        onClick: function onClick() {
          return window.open((logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se');
        }
      },
      action: showAppDownloadButton ? {
        text: t('COMMON__DOWNLOADAPP', '앱다운로드'),
        onClick: function onClick() {
          log({
            key: 'drawer.user.profile',
            category: 'click'
          });
          onAppDownload === null || onAppDownload === void 0 ? void 0 : onAppDownload();
        }
      } : undefined,
      supplementary: supplementary
    }), jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerMenu, {
      items: drawerMenu,
      fontStyles: [{
        size: 16,
        weight: 'bold'
      }],
      indents: [14, 42, 50],
      onClose: onClose
    }), drawerUserMenu.length > 0 && jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerMenu, {
      items: drawerUserMenu,
      onClose: onClose
    }), jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerFooter, {
      items: drawerFooterMenu,
      onClose: onClose
    })]
  }));
}

function Navigation(props) {
  var logo = props.logo,
    menuSchema = props.menuSchema,
    searchOptions = props.searchOptions,
    supplementary = props.supplementary,
    fallbackMenuSchema = props.fallbackMenuSchema,
    linkComponent = props.linkComponent,
    onLog = props.onLog,
    onAppDownload = props.onAppDownload,
    location = props.location;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDrawerOpen = _useState2[0],
    setDrawerOpen = _useState2[1];
  var handleDrawerToggle = useCallback(function () {
    setDrawerOpen(function (v) {
      return !v;
    });
  }, []);
  var handleDrawerClose = useCallback(function () {
    setDrawerOpen(false);
  }, []);
  var isInApp = useIsInApp(location);
  if (isInApp) {
    return null;
  }
  return jsx(LinkProvider, {
    linkComponent: linkComponent,
    children: jsx(LogProvider, {
      onLog: onLog,
      children: jsxs(Fragment$1, {
        children: [jsx(NavigationBar, {
          logo: logo,
          menuSchema: menuSchema,
          primaryLeftmost: jsx(Button$1, {
            type: "button",
            onClick: function onClick() {
              onLog({
                key: 'drawer.button',
                category: 'click'
              });
              handleDrawerToggle();
            },
            children: jsx(Icon, {
              size: 24,
              name: "menu"
            })
          }),
          searchOptions: searchOptions,
          supplementary: supplementary,
          fallbackMenuSchema: fallbackMenuSchema
        }), jsx(NavigationDrawer, {
          open: isDrawerOpen,
          logo: logo,
          menuSchema: menuSchema,
          supplementary: supplementary,
          onOpen: handleDrawerToggle,
          onClose: handleDrawerClose,
          onAppDownload: onAppDownload
        })]
      })
    })
  });
}
var Button$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ebs7dy10"
} : {
  target: "ebs7dy10",
  label: "Button"
})(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", function (_ref) {
  var theme = _ref.theme;
  return theme.content.base1;
}, ";outline:none;");

var _templateObject$3;
function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$o = process.env.NODE_ENV === "production" ? {
  name: "mzbvs0",
  styles: "margin-left:8px;line-height:0"
} : {
  name: "12yyv6c-css",
  styles: "margin-left:8px;line-height:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
};
var NavigationRightButton = /*#__PURE__*/memo(function (_ref2) {
  var title = _ref2.title,
    href = _ref2.href;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return jsx(LinkComponent, {
    href: href,
    css: [/*#__PURE__*/css("display:flex;align-items:center;", FONT_STYLE.subTitle1, ";color:", theme.content.primary1.basic, ";font-weight:700;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), FOCUS(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), pxToRem(3), theme.content.primary1.thin)],
    onClick: function onClick() {
      return log({
        key: 'secondary.interior',
        category: 'click'
      });
    },
    children: jsxs("span", {
      css: /*#__PURE__*/css("display:inline-block;padding:", pxToRem(4), ";margin:", pxToRem(-4), ";border-radius:", pxToRem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [title, jsx(Icon, {
        css: _ref$o,
        name: "chevron_thick_right",
        size: 18
      })]
    })
  });
});

var _excluded$E = ["index", "href"];
var TYPE_MAP = {
  'logo': function logo() {
    return {
      click: {
        bucket: {
          section: '로고'
        }
      }
    };
  },
  // primary
  'primary.item': function primaryItem(_ref) {
    var index = _ref.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'primary.right.search.input': function primaryRightSearchInput(_ref2) {
    var search_type = _ref2.search_type;
    return {
      click: {
        bucket: {
          section: '검색'
        },
        amplitude: {
          type: '검색 필드 Clicked',
          search_type: search_type
        }
      }
    };
  },
  'primary.right.search.autocomplete.query': function primaryRightSearchAutocompleteQuery(_ref3) {
    var id = _ref3.id,
      type = _ref3.type,
      index = _ref3.index;
    return {
      click: {
        bucket: {
          section: '자동완성',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.autocomplete.category': function primaryRightSearchAutocompleteCategory(_ref4) {
    var id = _ref4.id,
      type = _ref4.type,
      index = _ref4.index;
    return {
      click: {
        bucket: {
          section: '추천 카테고리',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.history': function primaryRightSearchHistory(_ref5) {
    var id = _ref5.id,
      type = _ref5.type,
      index = _ref5.index;
    return {
      click: {
        bucket: {
          section: '최근 검색어',
          id: id,
          type: type,
          index: index
        }
      },
      impression: {
        bucket: {
          section: '최근 검색어',
          type: type
        }
      }
    };
  },
  'primary.right.scrap': function primaryRightScrap() {
    return {
      click: {
        bucket: {
          section: '스크랩북'
        },
        amplitude: {
          type: '스크랩북 Viewed',
          data: {
            source: {
              page: {
                tab: {
                  main: '스크랩북'
                }
              },
              referrer: {
                type: '바로가기'
              }
            }
          }
        }
      }
    };
  },
  'primary.right.cart': function primaryRightCart() {
    return {
      click: {
        bucket: {
          section: '장바구니'
        }
      }
    };
  },
  'primary.right.notification': function primaryRightNotification() {
    return {
      click: {
        bucket: {
          section: '알림'
        },
        amplitude: {
          type: '알림 리스트 Viewed'
        }
      }
    };
  },
  'primary.right.login': function primaryRightLogin() {
    return {
      click: {
        bucket: {
          section: '로그인'
        }
      }
    };
  },
  'primary.right.signup': function primaryRightSignup() {
    return {
      click: {
        bucket: {
          section: '회원가입'
        }
      }
    };
  },
  'primary.right.cs': function primaryRightCs() {
    return {
      click: {
        bucket: {
          section: '고객센터'
        }
      }
    };
  },
  'primary.right.mypage': function primaryRightMypage() {
    return {
      click: {
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  },
  'primary.right.logout': function primaryRightLogout() {
    return {
      click: {
        amplitude: {
          type: '계정 Logout'
        }
      }
    };
  },
  'primary.right.upload': function primaryRightUpload() {
    return {
      click: {
        bucket: {
          section: '글쓰기'
        }
      }
    };
  },
  'primary.right.upload.photo': function primaryRightUploadPhoto() {
    return {
      click: {
        bucket: {
          section: '사진 올리기'
        }
      }
    };
  },
  // secondary
  'secondary.item': function secondaryItem(_ref6) {
    var index = _ref6.index,
      href = _ref6.href,
      rest = _objectWithoutProperties(_ref6, _excluded$E);
    return {
      click: {
        bucket: _objectSpread2({
          index: index,
          url: typeof href === 'string' ? href : '/'
        }, rest)
      },
      impression: {
        bucket: _objectSpread2({
          index: index
        }, rest)
      }
    };
  },
  'secondary.interior': function secondaryInterior() {
    return {
      click: {
        bucket: {
          section: '3D인테리어'
        }
      }
    };
  },
  'secondary.more.button': function secondaryMoreButton() {
    return {
      click: {
        bucket: {
          section: '토픽',
          section_id: 'TOPIC',
          type: 'button',
          id: 'more_button'
        }
      }
    };
  },
  // tertiary
  'tertiary.store.category.item': function tertiaryStoreCategoryItem(_ref7) {
    var id = _ref7.id,
      index = _ref7.index;
    return {
      click: {
        bucket: {
          section: '카테고리 메뉴',
          type: 'category',
          id: id,
          index: index
        }
      }
    };
  },
  // drawer
  'drawer.logo': function drawerLogo() {
    return {
      click: {
        bucket: {
          section: 'drawer 로고'
        }
      }
    };
  },
  'drawer.button': function drawerButton() {
    return {
      click: {
        bucket: {
          section: '햄버거 메뉴'
        }
      }
    };
  },
  'drawer.main.item': function drawerMainItem(_ref8) {
    var index = _ref8.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.sub.item': function drawerSubItem(_ref9) {
    var index = _ref9.index,
      href = _ref9.href;
    return {
      click: {
        bucket: {
          section: '서브 메뉴',
          index: index,
          url: typeof href === 'string' ? href : '/'
        }
      }
    };
  },
  'drawer.user.item': function drawerUserItem(_ref10) {
    var index = _ref10.index;
    return {
      click: {
        bucket: {
          section: '유저 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.user.profile': function drawerUserProfile() {
    return {
      click: {
        bucket: {
          section: '유저 프로필'
        },
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  },
  'popup.app.download': function popupAppDownload(_ref11) {
    var id = _ref11.id;
    return {
      click: {
        bucket: {
          section: '웹투앱 유도 모달',
          type: 'BUTTON',
          id: id,
          section_id: 'WEBTOAPP_MODAL'
        }
      },
      impression: {
        bucket: {
          section: '웹투앱 유도 모달',
          type: 'MODAL',
          id: id,
          section_id: 'WEBTOAPP_MODAL'
        }
      }
    };
  },
  'banner.top.pc.click': function bannerTopPcClick(_ref12) {
    var index = _ref12.index;
    return {
      click: {
        bucket: {
          section: '네비 배너',
          index: index
        }
      }
    };
  },
  'banner.top.mobile.click': function bannerTopMobileClick() {
    return {
      click: {
        bucket: {
          section: '네비 배너'
        }
      }
    };
  },
  'banner.top.pc.close': function bannerTopPcClose() {
    return {
      click: {
        bucket: {
          section: '네비 배너 닫기'
        }
      }
    };
  },
  'banner.top.mobile.close': function bannerTopMobileClose() {
    return {
      click: {
        bucket: {
          section: '네비 배너 닫기'
        }
      }
    };
  }
};

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo_svg__icon",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#35C5F0",
    d: "M16.41 0H3.59A3.59 3.59 0 0 0 0 3.59v12.82A3.59 3.59 0 0 0 3.59 20h12.82A3.59 3.59 0 0 0 20 16.41V3.59A3.59 3.59 0 0 0 16.41 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.75 10.34c-.74 0-1.33-.6-1.33-1.34s.6-1.34 1.33-1.34 1.32.6 1.32 1.34-.59 1.34-1.32 1.34m-1 3.53H6.12V8.75l3.82-2.7 2.2 1.55a3 3 0 0 0-.35 1.4 3 3 0 0 0 1.98 2.83v2.04zm1-7.87c-.34 0-.66.06-.97.17l-3.17-2.24a1.18 1.18 0 0 0-1.35 0L4.5 7.28a1.2 1.2 0 0 0-.51.98v6.54c0 .66.53 1.2 1.19 1.2h9.5a1.2 1.2 0 0 0 1.18-1.2v-3.02A3 3 0 0 0 17.7 9c0-1.65-1.32-3-2.96-3z"
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$n = process.env.NODE_ENV === "production" ? {
  name: "3lg2zs",
  styles: "flex:0 1 auto;min-width:0;display:flex;flex-direction:column;justify-content:center"
} : {
  name: "96e0lz-css",
  styles: "flex:0 1 auto;min-width:0;display:flex;flex-direction:column;justify-content:center;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
};
function AppDownloadPopup(_ref2) {
  var isOpen = _ref2.isOpen,
    onClose = _ref2.onClose,
    _ref2$onAppOpen = _ref2.onAppOpen,
    onAppOpen = _ref2$onAppOpen === void 0 ? function () {
      //
    } : _ref2$onAppOpen,
    localeData = _ref2.localeData;
  var _a, _b, _c, _d;
  var theme = useTheme();
  var log = useLogContext();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasBottomPadding = _useState2[0],
    setHasBottomPadding = _useState2[1];
  var isDescriptionShown = useMemo(function () {
    return localeData == null || (localeData === null || localeData === void 0 ? void 0 : localeData.description) != null;
  }, [localeData]);
  var handleIntersect = useCallback(function () {
    log({
      key: 'popup.app.download',
      category: 'impression',
      params: {
        id: 'webtoapp_modal'
      }
    });
  }, [log]);
  var handleAppOpen = useCallback(function () {
    log({
      key: 'popup.app.download',
      category: 'click',
      params: {
        id: 'view_app'
      }
    });
    onAppOpen();
  }, [log, onAppOpen]);
  var handleClose = useCallback(function () {
    log({
      key: 'popup.app.download',
      category: 'click',
      params: {
        id: 'view_web'
      }
    });
    onClose();
  }, [log, onClose]);
  useEffect(function () {
    if (/(?:iPad|iPhone|iPod).*Instagram/gi.test(navigator.userAgent)) {
      setHasBottomPadding(true);
    }
  }, []);
  if (!isOpen) return null;
  return jsx(Modal, {
    width: 400,
    children: jsx(IntersectionObserver, {
      onIntersect: handleIntersect,
      children: jsxs("div", {
        css: /*#__PURE__*/css("box-sizing:content-box;max-width:", pxToRem(325), ";margin:0 auto;padding:", pxToRem(30), " ", pxToRem(36), ";text-align:left;", hasBottomPadding && /*#__PURE__*/css("padding-bottom:", pxToRem(100), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: [jsxs("div", {
          css: /*#__PURE__*/css("display:flex;justify-content:center;margin-bottom:", pxToRem(28), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: [jsx(SvgLogo, {
            css: /*#__PURE__*/css("flex:0 0 auto;width:", pxToRem(70), ";height:", pxToRem(70), ";margin-right:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
          }), jsxs("div", {
            css: _ref$n,
            children: [jsx("div", {
              "data-testid": "popup-title",
              css: /*#__PURE__*/css(FONT_STYLE.title3, " font-weight:700;color:", theme.content.base1, ";white-space:pre-line;word-break:break-word;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
              children: (_a = localeData === null || localeData === void 0 ? void 0 : localeData.title) !== null && _a !== void 0 ? _a : '앱에서는 1초만에!\n간편하게 로그인하기'
            }), isDescriptionShown && jsxs("div", {
              css: /*#__PURE__*/css("display:flex;align-items:center;font-size:", pxToRem(11), ";line-height:1;gap:", pxToRem(2), ";margin-top:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
              children: [jsx("div", {
                css: /*#__PURE__*/css("display:flex;gap:", pxToRem(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
                children: new Array(5).fill(0).map(function (_, index) {
                  return jsx(StarFilledIcon, {
                    size: 12,
                    fill: function fill(theme) {
                      return theme.content.primary1.basic;
                    }
                  }, index);
                })
              }), jsx("div", {
                "data-testid": "popup-description",
                css: /*#__PURE__*/css(FONT_STYLE.caption2, " display:inline-block;color:", theme.content.base2, ";font-weight:400;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
                children: (_b = localeData === null || localeData === void 0 ? void 0 : localeData.description) !== null && _b !== void 0 ? _b : '특가, 쿠폰 등 앱 전용 혜택까지'
              })]
            })]
          })]
        }), jsx(Button$2, {
          type: "button",
          size: 44,
          variant: "primary1",
          full: true,
          onClick: handleAppOpen,
          "aria-label": "\uC624\uB298\uC758\uC9D1 \uC571\uC73C\uB85C \uBCF4\uAE30",
          children: (_c = localeData === null || localeData === void 0 ? void 0 : localeData.appDownloadButtonText) !== null && _c !== void 0 ? _c : '편리한 앱으로 보기'
        }), jsx("button", {
          css: /*#__PURE__*/css(RESET_BUTTON, " ", FONT_STYLE.body14L18, " color:", theme.content.base2, ";text-align:center;width:100%;margin-top:", pxToRem(12), ";font-weight:500;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          type: "button",
          onClick: handleClose,
          "aria-label": "\uB2EB\uAE30",
          children: (_d = localeData === null || localeData === void 0 ? void 0 : localeData.remainWebButtonText) !== null && _d !== void 0 ? _d : '모바일 웹으로 볼래요'
        })]
      })
    })
  });
}

function AppDownloadPopupContainer(props) {
  var onCheck = props.onCheck,
    onAppOpen = props.onAppOpen,
    onClose = props.onClose,
    localeData = props.localeData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var checked = onCheck();
  useEffect(function () {
    setOpen(checked);
  }, [checked]);
  var handleClose = useCallback(function () {
    onClose();
    setOpen(false);
  }, [onClose]);
  return jsx(AppDownloadPopup, {
    isOpen: isOpen,
    onClose: handleClose,
    onAppOpen: onAppOpen,
    localeData: localeData
  });
}

/** FIXME: imageSrc 제거 */
function MobileTopBanner(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$onAppOpen = _ref.onAppOpen,
    onAppOpen = _ref$onAppOpen === void 0 ? function () {
      //
    } : _ref$onAppOpen;
    _ref.imageSrc;
    var className = _ref.className,
    localeData = _ref.localeData;
  var _a, _b;
  var theme = useTheme();
  if (!isOpen) return null;
  return jsxs("div", {
    "data-testId": "mobileTopBanner",
    className: className,
    css: /*#__PURE__*/css(RESET_BUTTON, " position:relative;width:100%;box-sizing:border-box;z-index:", ZINDEX.banner, ";background-color:", theme.background.groupedBase, ";display:none;overflow:hidden;padding:", pxToRem(18), " ", pxToRem(16), " ", pxToRem(18), " 0;", MEDIA_QUERY.max('mobile', "\n          display: flex;\n        "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [jsx("button", {
      type: "button",
      css: /*#__PURE__*/css(RESET_BUTTON, " position:absolute;width:100%;height:100%;top:0;left:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      "aria-label": "\uC624\uB298\uC758\uC9D1 \uC571\uC73C\uB85C \uBCF4\uAE30",
      onClick: onAppOpen
    }), jsx("button", {
      type: "button",
      css: /*#__PURE__*/css(RESET_BUTTON, " display:flex;color:", theme.content.base2, ";width:44px;align-items:center;flex-shrink:0;z-index:1;padding:0 16px;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      "aria-label": "\uB2EB\uAE30",
      onClick: function onClick(e) {
        onClose();
        e.stopPropagation();
      },
      children: jsx(DismissIcon, {
        size: 12,
        fill: function fill(theme) {
          return theme.content.base2;
        }
      })
    }), jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;width:calc(100% - ", pxToRem(44), ");" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [jsx(SvgLogo, {
        css: /*#__PURE__*/css("width:", pxToRem(40), ";height:", pxToRem(40), ";margin-right:", pxToRem(8), ";flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }), jsx("div", {
        "data-testid": "banner-title",
        css: /*#__PURE__*/css(FONT_STYLE.body2_small, " color:", theme.content.base1, ";font-weight:600;white-space:pre-line;word-break:break-word;text-align:left;flex-grow:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: (_a = localeData === null || localeData === void 0 ? void 0 : localeData.title) !== null && _a !== void 0 ? _a : '앱에서 1초만에!\n간편하게 로그인하기'
      }), jsx(Button$2, {
        "data-testid": "banner-button",
        size: 32,
        variant: "primary1",
        css: /*#__PURE__*/css("font-weight:700;flex-shrink:0;margin-left:", pxToRem(16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        onClick: onAppOpen,
        children: (_b = localeData === null || localeData === void 0 ? void 0 : localeData.appDownloadButtonText) !== null && _b !== void 0 ? _b : '앱으로 보기'
      })]
    })]
  });
}

var getContentsUrl = function getContentsUrl(_ref) {
  var contentId = _ref.contentId,
    contentType = _ref.contentType,
    contentUrl = _ref.contentUrl,
    isUserLoggedIn = _ref.isUserLoggedIn,
    origin = _ref.origin;
  switch (contentType === null || contentType === void 0 ? void 0 : contentType.split(/(?=[A-Z])/).join('_').toLowerCase()) {
    case 'competition':
      return "".concat(origin, "/competitions/").concat(contentId);
    case 'production':
      return "".concat(origin, "/productions/").concat(contentId, "/selling");
    case 'exhibition':
      return "".concat(origin, "/exhibitions/").concat(contentId);
    case 'advice':
      return "".concat(origin, "/advices/").concat(contentId);
    case 'project':
      return "".concat(origin, "/projects/").concat(contentId, "/detail");
    case 'card_collection':
      return "".concat(origin, "/contents/card_collections/").concat(contentId);
    case 'invite_friend':
      if (!isUserLoggedIn) {
        return "".concat(origin, "/users/sign_in?redirect_to=/invite_codes/recommend_code");
      }
      return "".concat(origin, "/invite_codes/recommend_code");
    default:
      return contentUrl || '';
  }
};
function PCTopBanner(_ref2) {
  var className = _ref2.className,
    isOpen = _ref2.isOpen,
    onClose = _ref2.onClose,
    _onClick = _ref2.onClick,
    contentList = _ref2.contentList,
    linkComponent = _ref2.linkComponent,
    isUserLoggedIn = _ref2.isUserLoggedIn,
    origin = _ref2.origin;
  var LinkComponent = linkComponent;
  var backgroundContent = [contentList[0], contentList[contentList.length - 1]];
  if (!isOpen) return null;
  return jsxs("div", {
    className: className,
    css: /*#__PURE__*/css("position:relative;display:none;z-index:", ZINDEX.banner, ";", MEDIA_QUERY.min('tablet', "\n          display: block;\n        "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [backgroundContent.map(function (content, index) {
      /* 왼쪽, 오른쪽 배너의 끝 부분을 채워주기 위해 필요합니다. */
      var pcGradientColor = content.pcGradientColor;
      var url = getContentsUrl(_objectSpread2(_objectSpread2({}, content), {}, {
        isUserLoggedIn: isUserLoggedIn,
        origin: origin
      }));
      var isFirst = index === 0;
      return jsx(LinkComponent, {
        href: url,
        "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
        onClick: function onClick() {
          return _onClick && _onClick(content, index >= 1 ? contentList.length - 1 : 0);
        },
        css: /*#__PURE__*/css("position:absolute;top:0;bottom:0;width:50%;background-color:", pcGradientColor, ";", isFirst ? 'left: 0;' : 'right: 0;', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }, index);
    }), jsx("div", {
      css: /*#__PURE__*/css("display:flex;max-width:", pxToRem(1156), ";margin:0 auto;padding:0 ", pxToRem(40), ";", MEDIA_QUERY.min('laptop', "\n            padding: 0 ".concat(pxToRem(60), ";\n          ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: contentList.map(function (content, index) {
        var coverImageUrl = content.coverImageUrl,
          pcGradientColor = content.pcGradientColor;
        var url = getContentsUrl(_objectSpread2(_objectSpread2({}, content), {}, {
          isUserLoggedIn: isUserLoggedIn,
          origin: origin
        }));
        return jsx(LinkComponent, {
          href: url,
          onClick: function onClick() {
            return _onClick && _onClick(content, index);
          },
          "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
          css: /*#__PURE__*/css("flex:1 0 0;background-image:url(", coverImageUrl, ");background-color:", pcGradientColor, ";position:relative;height:", pxToRem(50), ";background-size:auto 100%;background-repeat:no-repeat;background-position:center;z-index:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        }, index);
      })
    }), jsx("button", {
      css: /*#__PURE__*/css(RESET_BUTTON, " position:absolute;top:50%;right:", pxToRem(8), ";display:block;margin:-", pxToRem(25), " 0 0;padding:", pxToRem(12), ";color:white;width:", pxToRem(48), ";height:", pxToRem(48), ";box-sizing:border-box;font-size:0;line-height:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      type: "button",
      "aria-label": "\uB2EB\uAE30",
      onClick: function onClick() {
        onClose();
      },
      children: jsx(Icon, {
        size: 24,
        name: "dismiss_thick",
        fill: function fill(theme) {
          return theme.background.base;
        }
      })
    })]
  });
}

function TopBannerContainer(props) {
  var pathname = props.pathname,
    isVisible = props.isVisible,
    onCheck = props.onCheck,
    onClose = props.onClose,
    ssrCheckLiteral = props.ssrCheckLiteral,
    ssrClassName = props.ssrClassName,
    children = props.children;
  /**
   * isOpen과 isUnsure은 무엇인가요? ...
   * React에서 자체적으로 배너 상태를 관리하고 있긴 하지만, 유저가 오늘의집에 들어와서 로딩하는
   * 시점에는 아직 React가 로딩되지 않은 상황이기 때문에, 이 때 layout shift를 최소화하기
   * 위해 배너의 동작을 <script> 태그를 통해서 제어하고 있습니다.
   *
   * script 태그 안에서는 유저가 앱 다운로드 팝업을 봤는지, 배너를 닫았는지 등 여러가지를
   * 판단해서 배너가 보여져야 하는지, 아니면 숨겨져야 하는지 결정해서, 만약 숨겨져야 한다면
   * style 태그를 추가해서 노드를 숨겨버립니다.
   *
   * 문제는 이 style 태그는 지워지지 않기 때문에, React에서 다시 배너를 표출하려고 할 때
   * 이슈가 생기게 됩니다.
   * PC 배너와 달리, 모바일 배너는 앱 다운로드 팝업을 닫고, 유저가 다른 페이지로 이동했을 때
   * 다시 보여지는데요, 다른 페이지로 이동하는 것의 인식을 'pathname'을 통해서 하고 있습니다.
   *
   * 즉, 실제 reload가 아닌, SPA 안에서 페이지가 바뀌어도 배너가 보여져야 합니다. 하지만
   * 이 때 페이지 진입 시 배너를 강제로 숨겨버렸기 때문에, React에서 다시 배너를 보여줄 수
   * 없는 상황이 되어버립니다.
   *
   * 이를 해결하기 위해, SSR 시점의 배너 로직은 순전히 SSR 과정중 layout shift를 막는
   * 용도로만 쓰고, React가 로딩되고 나면 이 스타일에 영향받지 않도록 구성하면 됩니다.
   *
   * 이를 위해 "isUnsure" 플래그가 추가되었습니다. 아직 리액트가 렌더링되지 않은 상황에서는
   * isUnsure가 true라서 클래스 네임이 입력되겠지만, 리액트가 초기화된 뒤에는 리액트가
   * 자유롭게 제어할 수 있도록 클래스 네임을 해제합니다.
   */
  var _useState = useState({
      isOpen: false,
      isUnsure: true
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    isOpen = _useState2$.isOpen,
    isUnsure = _useState2$.isUnsure,
    setState = _useState2[1];
  useEffect(function () {
    setState({
      isOpen: onCheck(),
      isUnsure: false
    });
  }, [pathname, onCheck]);
  var handleClose = useCallback(function () {
    setState({
      isOpen: false,
      isUnsure: false
    });
    onClose();
  }, [onClose]);
  return jsxs(Fragment$1, {
    children: [ssrCheckLiteral && jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "(function() {\n  if (!(".concat(ssrCheckLiteral, ")) {\n    var style = document.createElement('style');\n    style.append('.").concat(ssrClassName, " { display: none !important; }');\n    document.head.appendChild(style);\n  }\n})();")
      }
    }), children({
      className: isUnsure ? ssrClassName : '',
      isOpen: isVisible && (isOpen || isUnsure),
      onClose: handleClose
    })]
  });
}

function NavigationTopBanner(props) {
  var location = props.location,
    _onAppOpen = props.onAppOpen,
    mobileImageSrc = props.mobileImageSrc,
    _props$pcContentList = props.pcContentList,
    pcContentList = _props$pcContentList === void 0 ? [] : _props$pcContentList,
    linkComponent = props.linkComponent,
    onLog = props.onLog,
    isUserLoggedIn = props.isUserLoggedIn,
    onClosePCTopBanner = props.onClosePCTopBanner,
    onCloseMobileTopBanner = props.onCloseMobileTopBanner,
    onCloseAppDownloadPopup = props.onCloseAppDownloadPopup,
    localeData = props.localeData;
  var cookieDomain = location.origin ? ".".concat(location.origin.split(/\.|\/\//).slice(-2).join('.')) : '.ohou.se';
  var isInApp = useIsInApp(location);
  var hiddenAppBanner = isInApp || APP_BANNER_PATHNAME_BLACKLIST.test(location.pathname) || APP_BANNER_SEARCH_BLACKLIST.test(location.search);
  return jsxs(LogProvider, {
    onLog: onLog,
    children: [jsx(TopBannerContainer, {
      pathname: location.pathname,
      isVisible: !isInApp && pcContentList.length > 0,
      onCheck: function onCheck() {
        return getCookie('ohsTopBannerClosed') !== 'yes' && !isHiddenMarketingBanner(location.search);
      },
      onClose: function onClose() {
        onLog({
          key: 'banner.top.pc.close',
          category: 'click'
        });
        setCookie('ohsTopBannerClosed', 'yes', 24 * 3600 * 1000, cookieDomain);
        onClosePCTopBanner === null || onClosePCTopBanner === void 0 ? void 0 : onClosePCTopBanner();
      },
      ssrClassName: "gnb-pc-top-banner--unsure",
      // eslint-disable-next-line max-len
      ssrCheckLiteral: "!/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)",
      children: function children(props) {
        return jsx(PCTopBanner, _objectSpread2(_objectSpread2({}, props), {}, {
          contentList: pcContentList,
          linkComponent: linkComponent,
          onClick: function onClick(content, index) {
            onLog({
              key: 'banner.top.pc.click',
              category: 'click',
              params: {
                index: index
              }
            });
          },
          isUserLoggedIn: isUserLoggedIn,
          origin: location.origin || 'https://ohou.se'
        }));
      }
    }), jsx(TopBannerContainer, {
      pathname: location.pathname,
      isVisible: !hiddenAppBanner,
      onCheck: function onCheck() {
        return getCookie('ohsAppDownloadPopupClosed') === 'yes' && getCookie('ohsTopBannerClosed') !== 'yes' && !isHiddenMarketingBanner(location.search);
      },
      onClose: function onClose() {
        onLog({
          key: 'banner.top.mobile.close',
          category: 'click'
        });
        setCookie('ohsTopBannerClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
        onCloseMobileTopBanner === null || onCloseMobileTopBanner === void 0 ? void 0 : onCloseMobileTopBanner();
      },
      ssrClassName: "gnb-mobile-top-banner--unsure",
      ssrCheckLiteral: '/(^|;)ohsAppDownloadPopupClosed=yes($|;)/.test(document.cookie) ' + '&& !/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)',
      children: function children(props) {
        return jsx(MobileTopBanner, _objectSpread2(_objectSpread2({}, props), {}, {
          imageSrc: mobileImageSrc,
          onAppOpen: function onAppOpen() {
            onLog({
              key: 'banner.top.mobile.click',
              category: 'click'
            });
            _onAppOpen('banner.top.mobile.click');
          },
          localeData: localeData === null || localeData === void 0 ? void 0 : localeData.mobileBanner
        }));
      }
    }), jsx(AppDownloadPopupContainer, {
      onCheck: function onCheck() {
        return isMobile() && !hiddenAppBanner && getCookie('ohsAppDownloadPopupClosed') !== 'yes' && !isHiddenMarketingBanner(location.search);
      },
      onClose: function onClose() {
        setCookie('ohsAppDownloadPopupClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
        onCloseAppDownloadPopup === null || onCloseAppDownloadPopup === void 0 ? void 0 : onCloseAppDownloadPopup();
      },
      onAppOpen: function onAppOpen() {
        _onAppOpen('banner.bottom.mobile.click');
      },
      localeData: localeData === null || localeData === void 0 ? void 0 : localeData.mobilePopup
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$m = process.env.NODE_ENV === "production" ? {
  name: "1089mxj",
  styles: "white-space:pre-wrap"
} : {
  name: "mj7czm-css",
  styles: "white-space:pre-wrap;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
};
function NotSupportedBrowserBanner(_ref2) {
  var buttons = _ref2.buttons;
  var theme = useTheme();
  return jsx(Sticky, {
    direction: "top",
    offset: 0,
    zIndex: ZINDEX.appBar + 3,
    disableNativeSticky: true,
    disableBottom: true,
    children: jsxs("div", {
      css: /*#__PURE__*/css("display:flex;flex-wrap:wrap;align-items:center;justify-content:center;width:100%;padding:", pxToRem(18), ";box-sizing:border-box;background:", theme.content.base4, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [jsx("p", {
        css: [FONT_STYLE.body1_1, /*#__PURE__*/css("margin:", pxToRem(6), " ", pxToRem(12), ";color:", theme.content.base1, ";font-weight:500;text-align:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), MEDIA_QUERY.max('mobile', _ref$m)],
        children: '이 브라우저는 지원이 종료되었습니다.\n다른 브라우저를 이용해 주세요.'
      }), jsx("div", {
        css: /*#__PURE__*/css("margin:", pxToRem(2), " ", pxToRem(12), ";text-align:center;line-height:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: buttons.map(function (button) {
          return jsx(Button$2, {
            variant: "base1",
            size: 32,
            onClick: button.onClick,
            css: /*#__PURE__*/css("margin:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
            children: button.text
          }, button.id);
        })
      })]
    })
  });
}

function NotSupportedBrowserPopup(_ref) {
  var buttons = _ref.buttons,
    onClose = _ref.onClose;
  var isMobile = useResponsive().breakpoint === 'mobile';
  var modalWidthProps = useMemo(function () {
    return isMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 400
    };
  }, [isMobile]);
  return jsx(Modal, _objectSpread2(_objectSpread2({}, modalWidthProps), {}, {
    header: {
      title: '브라우저 지원 종료 안내',
      onClose: onClose
    },
    footer: {
      // IE flex 버그 때문에 height 고정
      style: /*#__PURE__*/css("height:", pxToRem(76), ";box-sizing:border-box;" + (process.env.NODE_ENV === "production" ? "" : ";label:style;")),
      action: {
        secondary: [buttons[0], buttons[1]]
      }
    },
    children: jsx("p", {
      css: /*#__PURE__*/css("padding:", pxToRem(10), " ", pxToRem(16), ";word-break:keep-all;white-space:pre-wrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: '이 브라우저(인터넷 익스플로러)는\n서비스 지원이 종료되었습니다.\n다른 브라우저로 오늘의집을 이용해 주세요.'
    })
  }));
}

var POPUP_CLOSED_FLAG_SESSION_KEY = 'ohsNotSupportedBrowserPopupClosed';
function NotSupportedBrowser() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPopupOpened = _useState2[0],
    setPopupOpened = _useState2[1];
  var isWindowsOS = useWindowsOSDetector();
  useEffect(function () {
    setPopupOpened(window.sessionStorage.getItem(POPUP_CLOSED_FLAG_SESSION_KEY) !== 'true');
  }, []);
  var buttons = useMemo(function () {
    return [{
      id: 'chrome',
      text: '크롬 설치하기',
      onClick: function onClick() {
        window.location.href = 'https://www.google.co.kr/chrome';
      }
    }, {
      id: 'edge',
      text: isWindowsOS ? '엣지로 열기' : '엣지 설치하기',
      onClick: isWindowsOS ? function () {
        window.location.href = 'microsoft-edge:https://ohou.se';
      } : function () {
        window.location.href = 'https://www.microsoft.com/edge';
      }
    }];
  }, [isWindowsOS]);
  var handlePopupClose = useCallback(function () {
    window.sessionStorage.setItem(POPUP_CLOSED_FLAG_SESSION_KEY, 'true');
    setPopupOpened(false);
  }, []);
  return jsxs(Fragment$1, {
    children: [jsx(NotSupportedBrowserBanner, {
      buttons: buttons
    }), isPopupOpened && jsx(NotSupportedBrowserPopup, {
      buttons: buttons,
      onClose: handlePopupClose
    })]
  });
}

var _excluded$D = ["children", "error"];
function Hint(_ref) {
  var children = _ref.children,
    error = _ref.error,
    rest = _objectWithoutProperties(_ref, _excluded$D);
  var theme = useTheme();
  return jsxs("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: /*#__PURE__*/css(FONT_STYLE.caption1, " color:", error ? theme.content.primary2.thick : theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [error && jsx(Icon, {
      name: "alert",
      size: 18,
      css: /*#__PURE__*/css("vertical-align:middle;margin-right:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }), children]
  }));
}

var _excluded$C = ["children", "count", "maxCount"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$l = process.env.NODE_ENV === "production" ? {
  name: "rvw9kk",
  styles: "flex:1;overflow:hidden;text-overflow:ellipsis"
} : {
  name: "1yldn38-css",
  styles: "flex:1;overflow:hidden;text-overflow:ellipsis;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
};
var _ref2$7 = process.env.NODE_ENV === "production" ? {
  name: "uoloz",
  styles: "display:flex;white-space:nowrap"
} : {
  name: "vx4hoq-css",
  styles: "display:flex;white-space:nowrap;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
};
function CounterHint(_ref3) {
  var children = _ref3.children,
    count = _ref3.count,
    maxCount = _ref3.maxCount,
    rest = _objectWithoutProperties(_ref3, _excluded$C);
  return jsxs(Hint, _objectSpread2(_objectSpread2({}, rest), {}, {
    css: _ref2$7,
    children: [jsx("span", {
      css: _ref$l,
      children: children
    }), jsxs("span", {
      css: /*#__PURE__*/css("text-align:right;padding-left:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [count, "/", maxCount]
    })]
  }));
}

var _excluded$B = ["className"];
function DimLoading(_ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded$B);
  var theme = useTheme();
  return jsx(BodyPortal, {
    children: jsx(Dim, {
      children: jsx("div", {
        className: className,
        css: /*#__PURE__*/css("position:relative;display:inline-block;vertical-align:middle;width:", pxToRem(80), ";height:", pxToRem(80), ";border-radius:", pxToRem(8), ";background-color:", theme.dim.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: jsx(Loading, _objectSpread2(_objectSpread2({}, rest), {}, {
          css: /*#__PURE__*/css("position:absolute;top:", pxToRem(28), ";left:", pxToRem(28), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        }))
      })
    })
  });
}

var _excluded$A = ["className", "error", "size", "value", "options", "valueEquals", "placeholder", "forwardedRef", "onChange", "onValue"];
var ICON_SIZE$1 = 24;
var SELECT_PADDING = {
  32: 13,
  40: 13,
  44: 15,
  50: 15
};
function Select(_ref) {
  var className = _ref.className,
    error = _ref.error,
    size = _ref.size,
    value = _ref.value,
    options = _ref.options,
    valueEquals = _ref.valueEquals,
    placeholder = _ref.placeholder,
    forwardedRef = _ref.forwardedRef,
    onChange = _ref.onChange,
    onValue = _ref.onValue,
    rest = _objectWithoutProperties(_ref, _excluded$A);
  var theme = useTheme();
  // As we don't want to update the entire component when the predicate function
  // changes.
  var valueEqualsFnRef = useRef();
  valueEqualsFnRef.current = valueEquals !== null && valueEquals !== void 0 ? valueEquals : defaultValueEqual;
  // This augments the value with the index to feed into the select element.
  // Since the native `select` HTML element only accepts strings as values, we
  // need to convert the index to a string.
  var augmentedValue = useMemo(function () {
    if (value === undefined) {
      return undefined;
    }
    // We use `findIndex()` which is O(n) operation to find the element position
    // in the options array.
    //
    // This is okay for the small number of options, but as the number grows, it
    // may degrade performance as it's O(n) to find the index for **every**
    // render.
    //
    // But in general, the number of options is small, so it should be fine for
    // our use cases.
    //
    // We may want to consider using a `Map` to store the inverted index for
    // lookups. But it also comes with a cost of creating the map upfront.
    var valueEqualsFn = valueEqualsFnRef.current;
    var found = options.findIndex(function (opt) {
      if (isSelectOption(opt)) {
        return valueEqualsFn(opt.value, value);
      }
      return valueEqualsFn(opt, value);
    });
    // If no value is found, return an empty string. This will show placeholder
    // if it's provided.
    if (found === -1) {
      return '';
    }
    return String(found);
  }, [options, value]);
  var handleChange = useCallback(function (e) {
    onValueHandler(e, {
      onChange: onChange,
      onValue: onValue
    }, function (val) {
      var current = options[Number(val)];
      if (isSelectOption(current)) {
        return current.value;
      }
      return current;
    });
  }, [onChange, onValue, options]);
  return jsxs("div", {
    className: className,
    css: /*#__PURE__*/css("position:relative;display:inline-block;line-height:0;&:hover{background-color:", theme.interactive.transparent, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [jsx(Icon, {
      size: ICON_SIZE$1,
      name: "dropdown",
      css: /*#__PURE__*/css("position:absolute;top:", pxToRem(size / 2 - ICON_SIZE$1 / 2), ";right:", pxToRem(SELECT_PADDING[size]), ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }), jsxs("select", _objectSpread2(_objectSpread2({}, rest), {}, {
      value: augmentedValue,
      ref: forwardedRef,
      onChange: handleChange,
      css: [/*#__PURE__*/css(RESET_INPUT, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), size === 32 ? FONT_STYLE.body2 : FONT_STYLE.subTitle1, /*#__PURE__*/css("position:relative;appearance:none;width:100%;height:", pxToRem(size), ";border-radius:", pxToRem(4), ";border:", pxToRem(1), " solid ", theme.border, ";color:", value !== '' ? theme.content.base1 : theme.content.base3, ";padding-left:", pxToRem(SELECT_PADDING[size]), ";padding-right:", pxToRem(ICON_SIZE$1 + SELECT_PADDING[size]), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), error ? /*#__PURE__*/css("border-color:", theme.content.primary2.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : /*#__PURE__*/css("&:disabled{background-color:", theme.interactive.transparent, ";}&:focus{border-color:", theme.content.primary1.basic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: [placeholder && jsx("option", {
        value: "",
        hidden: true,
        disabled: true,
        children: placeholder
      }), options.map(function (option, index) {
        // This is the simple case where the option is just a string or a number.
        if (typeof option === 'string' || typeof option === 'number') {
          return (
            // eslint-disable-next-line react/no-array-index-key
            jsx("option", {
              value: index,
              children: option
            }, index)
          );
        }
        if (isSelectOption(option)) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            jsx("option", {
              value: index,
              disabled: option.disabled,
              children: option.text
            }, index)
          );
        }
        // If none of the above, it's an invalid option; ignore it.
        return null;
      })]
    }))]
  });
}
function isSelectOption(input) {
  return _typeof(input) === 'object' && input !== null && 'value' in input;
}
function defaultValueEqual(a, b) {
  return a === b;
}

function cssBaseIconButton(size) {
  return /*#__PURE__*/css("width:", pxToRem(size), ";padding:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseIconButton;"));
}

var _excluded$z = ["size", "icon"];
/**
 * @deprecated ODS의 IconButton을 사용해주세요. 만약 디자인상 ODS의 IconButton을 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function OutlineIconButton(_ref) {
  var size = _ref.size,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded$z);
  return jsx(OutlineButton, _objectSpread2(_objectSpread2({}, rest), {}, {
    size: size,
    css: cssBaseIconButton(size),
    children: jsx(Icon, {
      size: 18,
      name: icon
    })
  }));
}

var SIZE = 32;
var GAP = 10;

function PageButton(_ref) {
  var page = _ref.page,
    selected = _ref.selected,
    onClick = _ref.onClick;
  var pageButtonCss = /*#__PURE__*/css("width:", pxToRem(SIZE), ";padding:0;vertical-align:middle;margin-right:", pxToRem(GAP), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:pageButtonCss;"));
  return selected ? jsx(Button$2, {
    size: SIZE,
    variant: "primary1",
    onClick: onClick,
    css: pageButtonCss,
    children: page
  }) : jsx(TextButton, {
    size: SIZE,
    variant: "base1",
    onClick: onClick,
    css: pageButtonCss,
    children: page
  });
}

var _excluded$y = ["page", "total", "pageCount", "onPageChange", "row", "rowOptions", "onRowChange"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function firstPage(page, lastPage, pageCount) {
  var halfPage = Math.floor(pageCount / 2);
  if (page <= halfPage) {
    return 1;
  }
  if (lastPage < page + halfPage) {
    return lastPage - pageCount + 1;
  }
  return page - halfPage;
}
var _ref$k = process.env.NODE_ENV === "production" ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : {
  name: "b5pnrc-css",
  styles: "vertical-align:middle;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
};
function Pagination$1(_ref2) {
  var page = _ref2.page,
    total = _ref2.total,
    _ref2$pageCount = _ref2.pageCount,
    pageCount = _ref2$pageCount === void 0 ? 10 : _ref2$pageCount,
    onPageChange = _ref2.onPageChange,
    _ref2$row = _ref2.row,
    row = _ref2$row === void 0 ? 10 : _ref2$row,
    rowOptions = _ref2.rowOptions,
    onRowChange = _ref2.onRowChange,
    rest = _objectWithoutProperties(_ref2, _excluded$y);
  var lastPage = Math.ceil(total / row);
  var actualPageCount = Math.min(lastPage, pageCount);
  useEffect(function () {
    if (lastPage < page) {
      onPageChange(Math.max(lastPage, 1));
    }
  }, [page, lastPage, onPageChange]);
  return jsxs("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    children: [rowOptions && onRowChange && jsx(Select, {
      size: SIZE,
      value: row,
      options: rowOptions,
      onValue: function onValue(value) {
        return onRowChange(value);
      },
      css: /*#__PURE__*/css("vertical-align:middle;margin-right:", pxToRem(16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }), jsx(OutlineIconButton, {
      disabled: page === 1,
      size: SIZE,
      variant: "base1",
      icon: "chevron_left",
      css: /*#__PURE__*/css("vertical-align:middle;margin-right:", pxToRem(GAP), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      onClick: function onClick() {
        return onPageChange(page - 1);
      }
    }), Array(actualPageCount).fill(firstPage(page, lastPage, actualPageCount)).map(function (v, i) {
      return v + i;
    }).map(function (pageNumber) {
      return jsx(PageButton, {
        page: pageNumber,
        selected: page === pageNumber,
        onClick: function onClick() {
          return onPageChange(pageNumber);
        }
      }, pageNumber);
    }), jsx(OutlineIconButton, {
      disabled: page === lastPage,
      size: SIZE,
      variant: "base1",
      icon: "chevron_right",
      css: _ref$k,
      onClick: function onClick() {
        return onPageChange(page + 1);
      }
    })]
  }));
}

var _excluded$x = ["className", "hint", "error"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$j = process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "7hnnku-css",
  styles: "width:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
};
function withHint(Component) {
  return function (_ref2) {
    var className = _ref2.className,
      hint = _ref2.hint,
      error = _ref2.error,
      rest = _objectWithoutProperties(_ref2, _excluded$x);
    return jsxs("div", {
      className: className,
      children: [jsx(Component, _objectSpread2(_objectSpread2({}, rest), {}, {
        error: error,
        css: _ref$j
      })), hint && jsx(Hint, {
        error: error,
        css: /*#__PURE__*/css("margin-top:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: hint
      })]
    });
  };
}

var SelectWithHint = withHint(Select);

/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
var InputWithHint = withHint(Input$1);

var _excluded$w = ["className", "value", "hint", "error", "maxCount"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$i = process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "7hnnku-css",
  styles: "width:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
};
function withCountHint(Component) {
  return function (_ref2) {
    var className = _ref2.className,
      value = _ref2.value,
      hint = _ref2.hint,
      error = _ref2.error,
      maxCount = _ref2.maxCount,
      rest = _objectWithoutProperties(_ref2, _excluded$w);
    var data = typeof value === 'string' ? value.substring(0, maxCount) : value;
    return jsxs("div", {
      className: className,
      children: [jsx(Component, _objectSpread2(_objectSpread2({}, rest), {}, {
        error: error,
        value: data,
        css: _ref$i
      })), jsx(CounterHint, {
        error: error,
        count: data ? "".concat(data).length : 0,
        maxCount: maxCount,
        css: /*#__PURE__*/css("margin-top:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: hint
      })]
    });
  };
}

/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
var InputWithCountHint = withCountHint(Input$1);

var _excluded$v = ["className", "error", "disabled", "readOnly", "onDimmed", "thumbnail", "onThumbnailDelete"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$h = process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "mvej1x-css",
  styles: "width:100%;height:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
};
var _ref2$6 = process.env.NODE_ENV === "production" ? {
  name: "1heawd3",
  styles: "width:100%;padding:0;border:0"
} : {
  name: "jyx0nw-css",
  styles: "width:100%;padding:0;border:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
};
function withThumbnail(Component) {
  return function (_ref3) {
    var className = _ref3.className,
      _ref3$error = _ref3.error,
      error = _ref3$error === void 0 ? false : _ref3$error,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$readOnly = _ref3.readOnly,
      readOnly = _ref3$readOnly === void 0 ? false : _ref3$readOnly,
      _ref3$onDimmed = _ref3.onDimmed,
      onDimmed = _ref3$onDimmed === void 0 ? false : _ref3$onDimmed,
      thumbnail = _ref3.thumbnail,
      onThumbnailDelete = _ref3.onThumbnailDelete,
      props = _objectWithoutProperties(_ref3, _excluded$v);
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];
    var theme = useTheme();
    return jsxs("div", {
      className: className,
      css: [cssBaseTextField(theme, onDimmed, {
        error: error,
        disabled: disabled,
        readOnly: readOnly,
        focused: focused
      }), /*#__PURE__*/css("display:block;padding:", pxToRem(0), " ", pxToRem(16), ";cursor:text;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: [jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
        size: 44,
        error: error,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          var _a;
          setFocused(true);
          (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onBlur: function onBlur(e) {
          var _a;
          setFocused(false);
          (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        css: _ref2$6
      })), thumbnail && jsx("div", {
        css: /*#__PURE__*/css("margin-bottom:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: jsxs("span", {
          css: /*#__PURE__*/css("overflow:hidden;position:relative;display:inline-block;width:", pxToRem(100), ";height:", pxToRem(100), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: [jsx(Image, {
            aspectRatio: "1:1",
            src: thumbnail,
            radius: 4,
            css: _ref$h
          }), jsx("button", {
            type: "button",
            title: "\uC0AD\uC81C",
            css: /*#__PURE__*/css("position:absolute;top:0;right:0;width:", pxToRem(32), ";height:", pxToRem(32), ";margin:0;padding:0;border:0;background:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
            onClick: function onClick(e) {
              e.stopPropagation();
              onThumbnailDelete === null || onThumbnailDelete === void 0 ? void 0 : onThumbnailDelete();
            },
            children: jsx(Icon, {
              name: "dismiss_circle",
              size: 18,
              fill: function fill(theme) {
                return theme.content.base1;
              }
            })
          })]
        })
      })]
    });
  };
}

var InputWithThumbnail = withThumbnail(Input$1);

var _excluded$u = ["className", "value", "disabled", "readOnly", "placeholder", "onCut", "onPaste", "onInput", "onValue", "onFocus", "onBlur"];
var ContentEditable = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    placeholder = _ref.placeholder,
    _onCut = _ref.onCut,
    _onPaste = _ref.onPaste,
    _onInput = _ref.onInput,
    onValue = _ref.onValue,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    props = _objectWithoutProperties(_ref, _excluded$u);
  var theme = useTheme();
  var node = useRef(null);
  useImperativeHandle(ref, function () {
    return node.current;
  });
  var innerValue = useRef('');
  var handleUpdate = useCallback(function () {
    var _a;
    var newValue = ((_a = node.current) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
    innerValue.current = newValue;
    onValue === null || onValue === void 0 ? void 0 : onValue(newValue);
  }, [onValue]);
  useEffect(function () {
    if (!node.current) return;
    if (innerValue.current !== value) {
      node.current.innerHTML = value;
      handleUpdate();
    }
  }, [value, handleUpdate]);
  useEffect(function () {
    if (!node.current) return;
    var observer = new MutationObserver(function (mutations) {
      var _iterator = _createForOfIteratorHelper(mutations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'childList') {
            handleUpdate();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(node.current, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [handleUpdate]);
  return jsx("div", _objectSpread2({
    ref: node,
    contentEditable: !readOnly && !disabled,
    onCut: function onCut(e) {
      handleUpdate();
      _onCut === null || _onCut === void 0 ? void 0 : _onCut(e);
    },
    onPaste: function onPaste(e) {
      handleUpdate();
      _onPaste === null || _onPaste === void 0 ? void 0 : _onPaste(e);
    },
    onInput: function onInput(e) {
      handleUpdate();
      _onInput === null || _onInput === void 0 ? void 0 : _onInput(e);
    },
    onFocus: onFocus,
    onBlur: onBlur,
    "data-placeholder": placeholder,
    className: className,
    css: /*#__PURE__*/css("word-break:break-word;cursor:", disabled ? 'default' : 'text', ";&&:empty:before{content:attr(data-placeholder);color:", theme.content.base3, ";pointer-events:none;display:-webkit-box;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
  }, props));
});

var _excluded$t = ["className", "autoHeight", "maxRows", "disabled", "readOnly", "error", "value", "action", "onValue", "useContentEditable", "onDimmed"],
  _excluded2$1 = ["forwardedRef", "onFocus", "onBlur", "onChange"],
  _excluded3$1 = ["forwardedRef", "onFocus", "onBlur"];
function cssTextareaField(theme, _ref) {
  var autoHeight = _ref.autoHeight,
    height = _ref.height;
  return /*#__PURE__*/css(cssTextField(theme), " ", FONT_STYLE.body1_1, " overflow-y:auto;flex:1 0 0%;height:", pxToRem(78), ";min-height:", pxToRem(24), ";margin:", pxToRem(9), " 0;box-sizing:border-box;resize:none;vertical-align:top;", autoHeight && /*#__PURE__*/css("height:", pxToRem(height), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextareaField;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextareaField;"));
}
function Textarea(_ref2) {
  var className = _ref2.className,
    _ref2$autoHeight = _ref2.autoHeight,
    autoHeight = _ref2$autoHeight === void 0 ? false : _ref2$autoHeight,
    maxRows = _ref2.maxRows,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$readOnly = _ref2.readOnly,
    readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? false : _ref2$error,
    value = _ref2.value,
    action = _ref2.action,
    onValue = _ref2.onValue,
    useContentEditable = _ref2.useContentEditable,
    _ref2$onDimmed = _ref2.onDimmed,
    onDimmed = _ref2$onDimmed === void 0 ? false : _ref2$onDimmed,
    rest = _objectWithoutProperties(_ref2, _excluded$t);
  var _a;
  var theme = useTheme();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    focused = _useState6[0],
    setFocused = _useState6[1];
  var actions = Array.isArray(action) ? action : [action];
  var updateHeight = useCallback(function (element) {
    var _a, _b;
    element.style.height = '0';
    if (maxRows) {
      var _window$getComputedSt = window.getComputedStyle(element),
        lineHeight = _window$getComputedSt.lineHeight;
      var maxHeight = maxRows * parseInt(lineHeight, 10);
      setHeight(Math.min(element.scrollHeight, maxHeight));
    } else {
      setHeight(element.scrollHeight);
    }
    element.style.height = (_b = (_a = rest.style) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : null;
  }, [maxRows, (_a = rest.style) === null || _a === void 0 ? void 0 : _a.height]);
  var handleValue = useCallback(function (value) {
    if (autoHeight && element) {
      updateHeight(element);
    }
    onValue === null || onValue === void 0 ? void 0 : onValue(value);
  }, [autoHeight, element, updateHeight, onValue]);
  useEffect(function () {
    if (!value) return;
    handleValue(value);
  }, [value, handleValue]);
  return jsxs("div", {
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), /*#__PURE__*/css("align-items:flex-start;padding:", pxToRem(6), " ", pxToRem(15), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: [!useContentEditable ? function () {
      var forwardedRef = rest.forwardedRef,
        _onFocus = rest.onFocus,
        _onBlur = rest.onBlur,
        _onChange = rest.onChange,
        assertedRest = _objectWithoutProperties(rest, _excluded2$1);
      return jsx("textarea", _objectSpread2(_objectSpread2({}, assertedRest), {}, {
        ref: function ref(el) {
          setElement(el);
          if (forwardedRef) {
            if (typeof forwardedRef === 'function') {
              forwardedRef(el);
            } else {
              forwardedRef.current = el;
            }
          }
        },
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          if (_onFocus) {
            _onFocus(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur) {
            _onBlur(e);
          }
          setFocused(false);
        },
        onChange: function onChange(e) {
          return onValueHandler(e, {
            onChange: _onChange,
            onValue: handleValue
          });
        },
        css: cssTextareaField(theme, {
          autoHeight: autoHeight,
          height: height
        })
      }));
    }() : function () {
      var forwardedRef = rest.forwardedRef,
        _onFocus2 = rest.onFocus,
        _onBlur2 = rest.onBlur,
        assertedRest = _objectWithoutProperties(rest, _excluded3$1);
      return jsx(ContentEditable, _objectSpread2(_objectSpread2({}, assertedRest), {}, {
        ref: function ref(el) {
          setElement(el);
          if (forwardedRef) {
            if (typeof forwardedRef === 'function') {
              forwardedRef(el);
            } else {
              forwardedRef.current = el;
            }
          }
        },
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          if (_onFocus2) {
            _onFocus2(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur2) {
            _onBlur2(e);
          }
          setFocused(false);
        },
        onValue: handleValue,
        css: [cssTextareaField(theme, {
          autoHeight: autoHeight,
          height: height
        }), /*#__PURE__*/css("min-width:", pxToRem(100), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
      }));
    }(), jsx("div", {
      css: /*#__PURE__*/css("box-sizing:border-box;display:flex;align-items:center;height:", pxToRem(42), ";padding:", pxToRem(9), " 0;&:not(:empty){margin-left:", pxToRem(8), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: actions.map(function (action, i) {
        return !!action && (isIconAction(action) ? jsx("button", {
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          css: /*#__PURE__*/css(RESET_BUTTON, ";vertical-align:top;width:", pxToRem(24), ";height:", pxToRem(24), ";margin-left:", pxToRem(12), ";&:first-of-type{margin-left:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          },
          children: jsx(Icon, {
            size: 24,
            name: action.icon,
            css: /*#__PURE__*/css("color:", action.color || theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
          })
        }, i) : jsx(TextButton, {
          size: 30,
          variant: "primary1",
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          css: /*#__PURE__*/css("flex-shrink:0;margin-left:", pxToRem(12), ";padding:0;&:first-of-type{margin-left:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          },
          children: action.text
        }, i));
      })
    })]
  });
}

var TextareaWithHint = withHint(Textarea);

var TextareaWithCountHint = withCountHint(Textarea);

var TextareaWithThumbnail = withThumbnail(Textarea);

var _excluded$s = ["header", "body", "footer"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$g = process.env.NODE_ENV === "production" ? {
  name: "1uixtsi",
  styles: "width:100%;border-collapse:collapse"
} : {
  name: "14063a5-css",
  styles: "width:100%;border-collapse:collapse;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
};
function Table(_ref2) {
  var header = _ref2.header,
    body = _ref2.body,
    footer = _ref2.footer,
    rest = _objectWithoutProperties(_ref2, _excluded$s);
  return jsxs("table", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [FONT_STYLE.subTitle1, _ref$g],
    children: [header && jsx("thead", {
      children: header
    }), body && jsx("tbody", {
      children: body
    }), footer && jsx("tfoot", {
      children: footer
    })]
  }));
}

var TABLE_HEADER_CLASS_NAME = 'bucketplace-table-header';
var TABLE_DATA_CLASS_NAME = 'bucketplace-table-data';

var _excluded$r = ["emphasized", "children", "highlight"];
/**
 * 테이블 강조 표시 방법에 따른 스타일
 */
var TABLE_HIGHLIGHT_STYLE = {
  none: function none(theme) {
    return /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:none;");
  },
  default: function _default(theme) {
    return /*#__PURE__*/css("background-color:", theme.colors.backgroundWeak, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:default;"));
  },
  emphasis: function emphasis(theme) {
    return /*#__PURE__*/css("background-color:", theme.colors.backgroundEmphasisWeak, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:emphasis;"));
  },
  critical: function critical(theme) {
    return /*#__PURE__*/css("background-color:", theme.colors.backgroundCriticalWeak, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:critical;"));
  },
  attention: function attention(theme) {
    return /*#__PURE__*/css("background-color:", theme.colors.backgroundAttentionWeak, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:attention;"));
  }
};
function TableRowImpl(_ref, ref) {
  var emphasized = _ref.emphasized,
    children = _ref.children,
    _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? emphasized ? 'default' : 'none' : _ref$highlight,
    rest = _objectWithoutProperties(_ref, _excluded$r);
  var theme = useTheme();
  return jsx("tr", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: [/*#__PURE__*/css(">.", TABLE_HEADER_CLASS_NAME, ",>.", TABLE_DATA_CLASS_NAME, "{color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.content.base4, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), TABLE_HIGHLIGHT_STYLE[highlight](theme)],
    children: children
  }));
}
var TableRow = /*#__PURE__*/forwardRef(TableRowImpl);

var _excluded$q = ["className", "children"];
function TableHeader(_ref) {
  var className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$q);
  var theme = useTheme();
  return jsx("th", _objectSpread2(_objectSpread2({}, rest), {}, {
    className: spaces(className, TABLE_HEADER_CLASS_NAME),
    css: /*#__PURE__*/css("text-align:left;font-weight:700;height:", pxToRem(56), ";padding:0 ", pxToRem(16), ";background-color:", theme.content.base5, ";&:hover{background-color:", theme.interactive.base5, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: children
  }));
}

var _excluded$p = ["text", "action"];
var ACTION_BUTTON_SIZE = 18;
function TableHeaderWithAction(_ref) {
  var text = _ref.text,
    action = _ref.action,
    rest = _objectWithoutProperties(_ref, _excluded$p);
  var theme = useTheme();
  return jsxs(TableHeader, _objectSpread2(_objectSpread2({}, rest), {}, {
    children: [jsx("span", {
      css: /*#__PURE__*/css("margin-right:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: text
    }), jsx("button", {
      type: "button",
      css: /*#__PURE__*/css(RESET_BUTTON, ";width:", pxToRem(ACTION_BUTTON_SIZE), ";height:", pxToRem(ACTION_BUTTON_SIZE), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      onClick: action.onClick,
      children: jsx(Icon, {
        size: ACTION_BUTTON_SIZE,
        name: action.icon,
        css: /*#__PURE__*/css("color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      })
    })]
  }));
}

var _excluded$o = ["className", "children"];
function TableDataImpl(_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$o);
  var theme = useTheme();
  return jsx("td", _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    className: spaces(className, TABLE_DATA_CLASS_NAME),
    css: /*#__PURE__*/css("height:", pxToRem(52), ";padding:0 ", pxToRem(16), ";@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.colors.backgroundOverlay, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: children
  }));
}
var TableData = /*#__PURE__*/forwardRef(TableDataImpl);

var _excluded$n = ["size", "children"],
  _excluded2 = ["checked", "onChange", "onCheck"],
  _excluded3 = ["size"],
  _excluded4 = ["fill", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var THUMBNAIL_LEFT_MARGIN = 4;
var calcSidePadding = function calcSidePadding(size) {
  switch (size) {
    case 32:
      return 12;
    case 38:
      return 14;
    case 48:
      return 16;
    default:
      return 0;
  }
};
var calcThumbnailRightMargin = function calcThumbnailRightMargin(size) {
  switch (size) {
    case 32:
      return 4;
    case 38:
      return 6;
    case 48:
      return 8;
    default:
      return 0;
  }
};
var getFontStyle = function getFontStyle(size) {
  if (size === 48) {
    return FONT_STYLE.subTitle1;
  }
  return FONT_STYLE.subTitle2;
};
var getChipSpacing = function getChipSpacing(size) {
  return /*#__PURE__*/css("margin-left:-", pxToRem(calcSidePadding(size) - THUMBNAIL_LEFT_MARGIN), ";margin-right:", pxToRem(calcThumbnailRightMargin(size)), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:getChipSpacing;"));
};
function cssBaseChip(size) {
  return /*#__PURE__*/css("display:inline-block;position:relative;height:", pxToRem(size), ";border-radius:", pxToRem(size / 2), ";padding-left:", pxToRem(calcSidePadding(size)), ";padding-right:", pxToRem(calcSidePadding(size)), ";line-height:0;&::before{content:\"\";height:100%;display:inline-block;vertical-align:middle;}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseChip;"));
}
var _ref2$5 = process.env.NODE_ENV === "production" ? {
  name: "1aeh6hi",
  styles: "vertical-align:middle;white-space:nowrap;cursor:inherit"
} : {
  name: "3h5xx7-css",
  styles: "vertical-align:middle;white-space:nowrap;cursor:inherit;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
function Text(_ref3) {
  var size = _ref3.size,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded$n);
  return jsx("span", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [getFontStyle(size), _ref2$5],
    children: children
  }));
}
var _ref$f = process.env.NODE_ENV === "production" ? {
  name: "ebd3ti",
  styles: "position:absolute;top:0;left:0;width:0;height:0;opacity:0"
} : {
  name: "1rn162b-css",
  styles: "position:absolute;top:0;left:0;width:0;height:0;opacity:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
function Checkbox(_ref4) {
  var checked = _ref4.checked,
    _onChange = _ref4.onChange,
    onCheck = _ref4.onCheck,
    rest = _objectWithoutProperties(_ref4, _excluded2);
  return jsx("input", _objectSpread2(_objectSpread2({}, rest), {}, {
    type: "checkbox",
    css: _ref$f,
    checked: checked,
    onChange: function onChange(e) {
      return onCheckHandler(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    }
  }));
}
function Thumbnail(_ref5) {
  var size = _ref5.size,
    rest = _objectWithoutProperties(_ref5, _excluded3);
  return jsx(CircleImage, _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [getChipSpacing(size), /*#__PURE__*/css("width:", pxToRem(size - 8), ";vertical-align:middle;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
  }));
}
function RemoveButton(_ref6) {
  var fill = _ref6.fill;
    _ref6.size;
    var rest = _objectWithoutProperties(_ref6, _excluded4);
  var theme = useTheme();
  return jsx("button", _objectSpread2(_objectSpread2({}, rest), {}, {
    type: "button",
    css: /*#__PURE__*/css(RESET_BUTTON, " width:", pxToRem(12), ";height:", pxToRem(12), ";margin-left:", pxToRem(4), ";margin-right:", pxToRem(-4), ";vertical-align:middle;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: jsx(Icon, {
      size: 12,
      name: "dismiss",
      css: /*#__PURE__*/css("vertical-align:top;color:", theme.content[fill], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    })
  }));
}

var _excluded$m = ["children", "size", "variant", "thumbnail", "onRemove", "onClick"];
function cssVariant$2(_ref) {
  var theme = _ref.theme,
    variant = _ref.variant,
    hasInteraction = _ref.hasInteraction;
  switch (variant) {
    case 'default':
      return /*#__PURE__*/css("color:", theme.content.base1, ";background-color:", theme.content.base5, ";", hasInteraction && /*#__PURE__*/css("&:hover{background-color:", theme.interactive.base5, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'outline':
      return /*#__PURE__*/css("color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";", hasInteraction && /*#__PURE__*/css("&:hover{background-color:", theme.interactive.transparent, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";", hasInteraction && /*#__PURE__*/css("&:hover{background-color:", theme.interactive[variant].basic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
  }
}
/**
 * @deprecated ODS의 Chip 컴포넌트를 사용해 주세요. 만약 디자인상 ODS의 Chip 컴포넌트를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function Chip(_ref2) {
  var children = _ref2.children,
    size = _ref2.size,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
    thumbnail = _ref2.thumbnail,
    onRemove = _ref2.onRemove,
    onClick = _ref2.onClick,
    rest = _objectWithoutProperties(_ref2, _excluded$m);
  var theme = useTheme();
  return jsxs("div", _objectSpread2(_objectSpread2({
    css: [cssBaseChip(size), cssVariant$2({
      theme: theme,
      variant: variant,
      hasInteraction: !!onClick
    }), /*#__PURE__*/css("cursor:", onClick ? 'pointer' : 'default', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    onClick: onClick
  }, rest), {}, {
    children: [thumbnail && jsx(Thumbnail, {
      src: thumbnail,
      size: size
    }), jsx(Text, {
      size: size,
      children: children
    }), onRemove && jsx(RemoveButton, {
      size: size,
      fill: {
        default: 'base2',
        outline: 'base2',
        primary1: 'white',
        primary3: 'white',
        primary4: 'white'
      }[variant],
      onClick: onRemove
    })]
  }));
}

var _excluded$l = ["className", "prefix", "value", "placeholder", "onChange", "onValue", "onFocus", "onBlur", "onRemove"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
var _ref$e = process.env.NODE_ENV === "production" ? {
  name: "1ro929w",
  styles: "position:absolute;display:inline-block;white-space:pre;visibility:hidden;top:0;left:0"
} : {
  name: "1vq8mid-css",
  styles: "position:absolute;display:inline-block;white-space:pre;visibility:hidden;top:0;left:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
};
function InputChip(_ref2) {
  var className = _ref2.className,
    prefix = _ref2.prefix,
    value = _ref2.value,
    placeholder = _ref2.placeholder,
    _onChange = _ref2.onChange,
    onValue = _ref2.onValue,
    _onFocus = _ref2.onFocus,
    _onBlur = _ref2.onBlur,
    onRemove = _ref2.onRemove,
    rest = _objectWithoutProperties(_ref2, _excluded$l);
  var theme = useTheme();
  var ref = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  useEffect(function () {
    if (ref.current) {
      ref.current.style.width = '0';
      setWidth(ref.current.scrollWidth);
      ref.current.removeAttribute('style');
    }
  }, [value, placeholder]);
  return jsxs("div", {
    className: className,
    css: [FONT_STYLE.subTitle2, cssBaseChip(32), /*#__PURE__*/css("position:relative;white-space:nowrap;color:", theme.content.base1, ";border:", pxToRem(1), " solid ", focused ? theme.content.primary1.basic : theme.content.base5, ";background-color:", theme.content.base5, ";&:hover{border-color:", focused ? theme.content.primary1.basic : theme.interactive.base5, ";background-color:", theme.interactive.base5, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: [jsx("span", {
      ref: ref,
      css: _ref$e,
      children: value || placeholder
    }), prefix && jsx(Text, {
      size: 32,
      css: /*#__PURE__*/css("margin-right:", pxToRem(1), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: prefix
    }), jsx("input", _objectSpread2(_objectSpread2({}, rest), {}, {
      value: value,
      placeholder: placeholder,
      onFocus: function onFocus(e) {
        if (_onFocus) {
          _onFocus(e);
        }
        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur) {
          _onBlur(e);
        }
        setFocused(false);
      },
      onChange: function onChange(e) {
        return onValueHandler(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      css: /*#__PURE__*/css(RESET_INPUT, " width:", pxToRem(width), ";font:inherit;color:inherit;vertical-align:middle;&::placeholder{color:", theme.content.base3, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    })), onRemove && jsx(RemoveButton, {
      fill: "base2",
      onClick: onRemove
    })]
  });
}

var _excluded$k = ["id", "children", "className", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function cssVariant$1(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive[variant].basic, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'primary4':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content.primary4.thick, ";@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.primary4.thick, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'base1':
      return /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content[variant], ";@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive[variant], ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
  }
}
/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
var _ref$d = process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "1diuouz-css",
  styles: "cursor:pointer;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
};
function SelectChip(_ref2) {
  var id = _ref2.id,
    children = _ref2.children,
    className = _ref2.className,
    size = _ref2.size,
    variant = _ref2.variant,
    thumbnail = _ref2.thumbnail,
    extraText = _ref2.extraText,
    checked = _ref2.checked,
    onChange = _ref2.onChange,
    onCheck = _ref2.onCheck,
    rest = _objectWithoutProperties(_ref2, _excluded$k);
  var theme = useTheme();
  return jsxs("label", {
    className: className,
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant$1(theme, variant) : /*#__PURE__*/css("color:", theme.content.base1, ";background-color:", theme.content.base5, ";&:hover{background-color:", theme.interactive.base5, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), _ref$d],
    children: [jsx(Checkbox, _objectSpread2(_objectSpread2({}, rest), {}, {
      id: id,
      checked: checked,
      onCheck: onCheck,
      onChange: onChange
    })), thumbnail && jsx(Thumbnail, {
      src: thumbnail,
      size: size
    }), jsx(Text, {
      size: size,
      children: children
    }), extraText && jsx(Text, {
      size: size,
      css: [checked ? /*#__PURE__*/css("color:", theme.content.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")) : /*#__PURE__*/css("color:", variant === 'base1' ? theme.content.base1 : theme.content[variant].thick, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), /*#__PURE__*/css("margin-left:", pxToRem(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: extraText
    })]
  });
}

var _excluded$j = ["id", "children", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck", "className"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function cssVariant(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary4':
      return /*#__PURE__*/css("color:", theme.content[variant].thick, ";background-color:", theme.content[variant].thin, ";border:", pxToRem(1), " solid ", theme.content[variant].thick, ";@media(hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive[variant].thin, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'primary3':
      return /*#__PURE__*/css("color:", theme.content[variant].basic, ";background-color:", theme.content[variant].thin, ";border:", pxToRem(1), " solid ", theme.content[variant].basic, ";@media(hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive[variant].thin, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
    case 'base1':
      return /*#__PURE__*/css("color:", theme.content.base1, ";background-color:", theme.content.base5, ";border:", pxToRem(1), " solid ", theme.content.base1, ";@media(hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.base5, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;"));
  }
}
/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
var _ref$c = process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "1diuouz-css",
  styles: "cursor:pointer;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
};
function OutlineSelectChip(_ref2) {
  var id = _ref2.id,
    children = _ref2.children,
    size = _ref2.size,
    variant = _ref2.variant,
    thumbnail = _ref2.thumbnail,
    extraText = _ref2.extraText,
    _ref2$checked = _ref2.checked,
    checked = _ref2$checked === void 0 ? false : _ref2$checked,
    onChange = _ref2.onChange,
    onCheck = _ref2.onCheck,
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded$j);
  var theme = useTheme();
  return jsxs("label", {
    className: className,
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant(theme, variant) : /*#__PURE__*/css("color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";@media(hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.base5, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), _ref$c],
    children: [jsx(Checkbox, _objectSpread2(_objectSpread2({}, rest), {}, {
      id: id,
      checked: checked,
      onCheck: onCheck,
      onChange: onChange
    })), thumbnail && jsx(Thumbnail, {
      src: thumbnail,
      size: size
    }), jsx(Text, {
      size: size,
      children: children
    }), extraText && jsx(Text, {
      size: size,
      css: [/*#__PURE__*/css("color:", variant === 'primary3' ? theme.content[variant].basic : variant !== 'base1' ? theme.content[variant].thick : theme.content[variant], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), /*#__PURE__*/css("margin-left:", pxToRem(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: extraText
    })]
  });
}

/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function FillOutlineSelectChip(props) {
  var checked = props.checked;
  return checked ? jsx(SelectChip, _objectSpread2({}, props)) : jsx(OutlineSelectChip, _objectSpread2({}, props));
}

var cat1x1 = "https://assets.ohou.se/design-system/4115b98dcf15cece.png";

var cat1x2 = "https://assets.ohou.se/design-system/0d544e95b1db25b2.png";

var cat1x3 = "https://assets.ohou.se/design-system/266288958944af51.png";

var man1x1 = "https://assets.ohou.se/design-system/23babe1bcb31c86f.png";

var man1x2 = "https://assets.ohou.se/design-system/b3ed77dde9be5229.png";

var man1x3 = "https://assets.ohou.se/design-system/5a7ef2ef9bba815e.png";

function EmptyImage(_ref) {
  var image = _ref.image;
  return jsx(Image, {
    aspectRatio: "1:1",
    css: /*#__PURE__*/css("width:", pxToRem(100), ";vertical-align:top;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    src: {
      cat1: cat1x1,
      man1: man1x1
    }[image],
    src2x: {
      cat1: cat1x2,
      man1: man1x2
    }[image],
    src3x: {
      cat1: cat1x3,
      man1: man1x3
    }[image]
  });
}

var _excluded$i = ["image", "title", "description", "action", "subAction"];
/**
 * @deprecated ODS의 Empty 컴포넌트를 사용해 주세요. 만약 디자인상 ODS의 Empty 컴포넌트를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function EmptyPage(_ref) {
  var image = _ref.image,
    title = _ref.title,
    description = _ref.description,
    action = _ref.action,
    subAction = _ref.subAction,
    rest = _objectWithoutProperties(_ref, _excluded$i);
  var theme = useTheme();
  return jsxs("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: /*#__PURE__*/css("width:", pxToRem(343), ";margin:0 auto;text-align:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [image && jsx("div", {
      css: /*#__PURE__*/css("margin-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(EmptyImage, {
        image: image
      })
    }), title && jsx("p", {
      css: [FONT_STYLE.title1, /*#__PURE__*/css("color:", theme.content.base1, ";white-space:pre-wrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: title
    }), description && jsx("p", {
      css: [FONT_STYLE.body1_1, /*#__PURE__*/css("margin-top:", pxToRem(10), ";color:", theme.content.base2, ";white-space:pre-wrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: description
    }), action && jsx("div", {
      css: /*#__PURE__*/css("margin-top:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(Button$2, {
        size: 44,
        variant: "primary1",
        onClick: action.onClick,
        children: action.text
      })
    }), subAction && jsx("div", {
      css: /*#__PURE__*/css("margin-top:", pxToRem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(TextButton, {
        size: 32,
        variant: "primary1",
        onClick: subAction.onClick,
        children: subAction.text
      })
    })]
  }));
}

function SocialLink(_ref) {
  var type = _ref.type,
    href = _ref.href,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    onClick = _ref.onClick;
  var theme = useTheme();
  return jsx("a", {
    href: href,
    target: "_blank",
    css: /*#__PURE__*/css("display:inline-block;margin-right:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    rel: "noreferrer",
    "data-testid": "SocialLink-".concat(type),
    onClick: onClick,
    children: jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      css: /*#__PURE__*/css("vertical-align:top;color:", theme.content.base2, ";&:hover{color:", theme.interactive.base2, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [type === 'KakaoStory' && jsx(KakaoStorySvg, {}), type === 'Facebook' && jsx(FacebookSvg, {}), type === 'Instagram' && jsx(InstagramSvg, {}), type === 'NaverPost' && jsx(NaverPostSvg, {}), type === 'Youtube' && jsx(YoutubeSvg, {}), type === 'Pinterest' && jsx(PinterestSvg, {}), type === 'TikTok' && jsx(TikTokSvg, {})]
    })
  });
}
function KakaoStorySvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M14.6548 6.5H9.34617C8.98953 6.5 8.70036 6.77492 8.70036 7.11427V12.4991C8.70036 12.8382 8.98953 13.1132 9.34617 13.1132H11.7936C11.7768 13.7122 11.5225 14.3691 11.1359 14.9432C10.7632 15.4965 10.1507 16.0415 9.81838 16.3021C9.80983 16.3089 9.80136 16.3154 9.79337 16.3217C9.72167 16.3871 9.66939 16.4632 9.66826 16.5686C9.66714 16.6486 9.71075 16.7105 9.75928 16.7761L9.77173 16.7896L11.4662 18.6074C11.4662 18.6074 11.549 18.6908 11.6175 18.7066C11.6948 18.7243 11.7823 18.7265 11.8429 18.6818C14.7987 16.5067 15.2256 13.7794 15.2999 12.3034C15.3001 12.295 15.3004 7.11427 15.3004 7.11427C15.3004 6.77492 15.0114 6.5 14.6548 6.5Z",
      fill: "white"
    })]
  });
}
function FacebookSvg() {
  return jsxs(Fragment$1, {
    children: [jsxs("g", {
      clipPath: "url(#clip0_21132_87052)",
      children: [jsx("path", {
        d: "M23 12C23 5.92486 18.0751 1 12 1C5.92486 1 1 5.92486 1 12C1 17.4903 5.02252 22.0412 10.2812 22.8664V15.1797H7.48828V12H10.2812V9.57656C10.2812 6.81969 11.9235 5.29688 14.4361 5.29688C15.6397 5.29688 16.8984 5.51172 16.8984 5.51172V8.21875H15.5114C14.145 8.21875 13.7188 9.06674 13.7188 9.93664V12H16.7695L16.2818 15.1797H13.7188V22.8664C18.9775 22.0412 23 17.4905 23 12Z",
        fill: "currentColor"
      }), jsx("path", {
        d: "M16.2818 15.1797L16.7695 12H13.7188V9.93664C13.7188 9.06674 14.145 8.21875 15.5114 8.21875H16.8984V5.51172C16.8984 5.51172 15.6397 5.29688 14.4361 5.29688C11.9235 5.29688 10.2812 6.81969 10.2812 9.57656V12H7.48828V15.1797H10.2812V22.8664C10.8413 22.9542 11.4152 23 12 23C12.5848 23 13.1587 22.9542 13.7188 22.8664V15.1797H16.2818Z",
        fill: "white"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_21132_87052",
        children: jsx("rect", {
          width: "22",
          height: "22",
          fill: "white",
          transform: "translate(1 1)"
        })
      })
    })]
  });
}
function InstagramSvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M9.10061 5.04896C8.3558 5.0841 7.84718 5.20296 7.40253 5.37768C6.94235 5.55702 6.5523 5.79768 6.16422 6.18717C5.77614 6.57665 5.53715 6.96698 5.35907 7.42786C5.18673 7.87349 5.06997 8.38253 5.03707 9.12776C5.00417 9.87299 4.99689 10.1125 5.00053 12.0135C5.00417 13.9144 5.01257 14.1527 5.04869 14.8995C5.08425 15.6441 5.20269 16.1526 5.37741 16.5974C5.55703 17.0576 5.79742 17.4475 6.18704 17.8357C6.57666 18.2239 6.96671 18.4624 7.42871 18.6407C7.87392 18.8128 8.3831 18.9301 9.12819 18.9627C9.87328 18.9953 10.1131 19.0029 12.0135 18.9993C13.9139 18.9956 14.1531 18.9872 14.8997 18.9518C15.6464 18.9164 16.1522 18.7971 16.5971 18.6232C17.0573 18.4432 17.4475 18.2032 17.8354 17.8134C18.2234 17.4237 18.4622 17.0331 18.6402 16.5719C18.8126 16.1267 18.9298 15.6175 18.9622 14.873C18.9948 14.1258 19.0025 13.8872 18.9988 11.9866C18.9952 10.0859 18.9867 9.84765 18.9513 9.10116C18.9158 8.35467 18.7972 7.84773 18.6227 7.40266C18.4428 6.94248 18.2027 6.55285 17.8132 6.16435C17.4237 5.77584 17.0328 5.53714 16.5718 5.35962C16.1263 5.18728 15.6174 5.06982 14.8723 5.03762C14.1272 5.00542 13.8874 4.99716 11.9863 5.0008C10.0852 5.00444 9.84724 5.01256 9.10061 5.04896ZM9.18237 17.7034C8.49986 17.6737 8.12928 17.5603 7.88232 17.4654C7.55527 17.3394 7.32231 17.1871 7.07619 16.9433C6.83007 16.6996 6.67886 16.4658 6.55118 16.1394C6.45528 15.8925 6.33978 15.5223 6.30786 14.8398C6.27314 14.1021 6.26586 13.8807 6.2618 12.0118C6.25774 10.1429 6.26488 9.92171 6.29722 9.18376C6.32634 8.50181 6.44044 8.13081 6.53522 7.88399C6.66122 7.55652 6.81299 7.32398 7.05729 7.078C7.30159 6.83201 7.53469 6.68053 7.86132 6.55285C8.108 6.45653 8.47816 6.34201 9.16039 6.30953C9.89862 6.27453 10.1198 6.26753 11.9884 6.26347C13.857 6.25941 14.0788 6.26641 14.8173 6.29889C15.4992 6.32857 15.8704 6.44155 16.1169 6.53689C16.4441 6.66289 16.6769 6.81423 16.9229 7.05896C17.1689 7.30368 17.3205 7.53594 17.4482 7.86327C17.5447 8.10925 17.6592 8.47927 17.6914 9.16192C17.7265 9.90015 17.7345 10.1215 17.7379 11.9899C17.7412 13.8584 17.7346 14.0803 17.7023 14.818C17.6725 15.5005 17.5594 15.8712 17.4643 16.1184C17.3383 16.4454 17.1864 16.6785 16.9419 16.9243C16.6975 17.1701 16.4647 17.3216 16.1379 17.4493C15.8915 17.5455 15.5209 17.6603 14.8393 17.6928C14.101 17.7275 13.8798 17.7348 12.0105 17.7388C10.1412 17.7429 9.92074 17.7353 9.18251 17.7034M14.889 8.25877C14.8898 8.72273 15.2664 9.09822 15.7304 9.09738C16.1943 9.09654 16.5698 8.71993 16.569 8.25597C16.5681 7.792 16.1915 7.41652 15.7276 7.41736C15.7276 7.41736 15.7274 7.41736 15.7273 7.41736C15.2635 7.41834 14.8881 7.79494 14.889 8.25877ZM8.4055 12.007C8.40942 13.9922 10.0217 15.5979 12.0065 15.5941C13.9913 15.5904 15.5981 13.9782 15.5943 11.993C15.5905 10.0078 13.9778 8.40171 11.9928 8.40563C10.0077 8.40955 8.40172 10.0221 8.4055 12.007ZM9.66635 12.0045C9.66383 10.7158 10.7064 9.669 11.9951 9.66648C13.2839 9.66396 14.3306 10.7066 14.3332 11.9953C14.3357 13.284 13.2931 14.3308 12.0044 14.3333C10.7158 14.336 9.66901 13.2936 9.66635 12.0051V12.0045Z",
      fill: "white"
    })]
  });
}
function NaverPostSvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M7.96631 5.76685H16.033V13.8335H7.96631V5.76685ZM12.5913 8.24889V9.81433L11.4126 8.24889H10.1381V11.3515H11.4082V9.78601L12.5872 11.3515H13.8612V8.24889H12.5913Z",
      fill: "white"
    }), jsx("path", {
      d: "M7.96631 14.454H16.033L14.5204 16.3156H9.47869L7.96631 14.454Z",
      fill: "white"
    }), jsx("path", {
      d: "M9.98281 16.9361H14.0161L11.9993 19.4181L9.98281 16.9361Z",
      fill: "white"
    })]
  });
}
function YoutubeSvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M18.7086 8.63031C18.5472 8.02758 18.0736 7.55392 17.4709 7.39258C16.3783 7.09985 12.0002 7.09985 12.0002 7.09985C12.0002 7.09985 7.62199 7.09985 6.53062 7.39258C5.92789 7.55392 5.45423 8.02758 5.29289 8.63031C5.00016 9.72168 5.00016 12.0001 5.00016 12.0001C5.00016 12.0001 5.00016 14.2785 5.29289 15.3699C5.45423 15.9726 5.92789 16.4462 6.53062 16.6076C7.62199 16.9003 12.0002 16.9003 12.0002 16.9003C12.0002 16.9003 16.3783 16.9003 17.4697 16.6076C18.0724 16.4462 18.5461 15.9726 18.7074 15.3699C19.0002 14.2785 19.0002 12.0001 19.0002 12.0001C19.0002 12.0001 19.0002 9.72168 18.7074 8.63031H18.7086Z",
      fill: "white"
    }), jsx("path", {
      d: "M10.6013 14.0994L14.2396 11.9997L10.6013 9.8999V14.0994Z",
      fill: "currentColor"
    })]
  });
}
function PinterestSvg() {
  return jsx("g", {
    id: "mdi:pinterest",
    children: jsx("path", {
      id: "Vector",
      d: "M8.744 22.494C9.8 22.813 10.867 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 10.5555 22.7155 9.12506 22.1627 7.79048C21.6099 6.4559 20.7996 5.24327 19.7782 4.22183C18.7567 3.20038 17.5441 2.39013 16.2095 1.83733C14.8749 1.28452 13.4445 1 12 1C10.5555 1 9.12506 1.28452 7.79048 1.83733C6.4559 2.39013 5.24327 3.20038 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 16.675 3.937 20.69 8.084 22.274C7.985 21.416 7.886 19.997 8.084 19.018L9.349 13.584C9.349 13.584 9.03 12.946 9.03 11.934C9.03 10.416 9.976 9.283 11.054 9.283C12 9.283 12.44 9.976 12.44 10.867C12.44 11.813 11.813 13.166 11.494 14.464C11.307 15.542 12.066 16.488 13.166 16.488C15.124 16.488 16.642 14.398 16.642 11.45C16.642 8.81 14.75 7.006 12.033 7.006C8.931 7.006 7.105 9.316 7.105 11.747C7.105 12.693 7.413 13.65 7.919 14.277C8.018 14.343 8.018 14.431 7.985 14.596L7.666 15.795C7.666 15.982 7.545 16.048 7.358 15.916C5.95 15.3 5.136 13.298 5.136 11.681C5.136 8.205 7.6 5.048 12.352 5.048C16.136 5.048 19.084 7.765 19.084 11.373C19.084 15.157 16.741 18.193 13.386 18.193C12.319 18.193 11.274 17.621 10.9 16.95L10.163 19.557C9.91 20.503 9.217 21.768 8.744 22.527V22.494Z",
      fill: "currentColor"
    })
  });
}
function TikTokSvg() {
  return jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM14.9105 4.41289V4.40002H12.3471V14.4163C12.3471 14.8779 12.2999 15.2892 12.2051 15.6499C11.3685 17.4927 8.97015 17.2094 8.38751 15.9032C7.74726 14.4685 8.5531 12.4646 10.9619 12.8189C10.9619 11.4282 10.9615 11.4283 10.9611 11.4284C10.9607 11.4285 10.9603 11.4286 10.9603 10.0384C5.12937 9.11658 3.19974 17.7295 9.00693 19.4666C10.015 19.6869 10.6155 19.6726 11.2824 19.5463C13.6628 19.095 14.9342 16.855 14.9027 14.571L14.9067 9.52692C16.1836 10.6659 18.2357 10.8143 18.5 10.7985C18.5 9.5631 18.4996 9.62598 18.4992 9.69178C18.4988 9.76398 18.4984 9.83969 18.4984 8.20747C14.9792 7.99822 14.9112 4.64478 14.9105 4.41289Z",
    fill: "currentColor"
  });
}

var CUSTOMER_CENTER_EMAIL = 'cs@bucketplace.net';
function ServiceCenter(_ref) {
  var phone = _ref.phone,
    openingHour = _ref.openingHour,
    ohouseFooterLinks = _ref.ohouseFooterLinks;
  var _useKakaoChat = useKakaoChat(),
    openKakaoChat = _useKakaoChat.openKakaoChat;
  var _getDeviceInfo = getDeviceInfo(),
    isApp = _getDeviceInfo.isApp;
  return jsxs(ServiceCenterContainer, {
    children: [jsxs(ServiceCenterAnchorContainer, {
      children: [jsx(ServiceCenterAnchor, {
        href: ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.serviceCenter,
        children: "\uACE0\uAC1D\uC13C\uD130"
      }), jsx(Icon, {
        name: "chevron_thick_right",
        size: 12
      })]
    }), jsxs(ServiceCenterInfo, {
      children: [jsx(ServiceCenterNumberAnchor, {
        href: "tel:".concat(phone),
        children: phone
      }), jsx(ServiceCenterTime, {
        dateTime: openingHour.start,
        children: openingHour.start
      }), "~", jsx(ServiceCenterTime, {
        dateTime: openingHour.end,
        children: openingHour.end
      })]
    }), jsxs(ServiceCenterDescription, {
      children: [jsx(WorkingDay, {
        children: "\uD3C9\uC77C: \uC804\uCCB4 \uBB38\uC758 \uC0C1\uB2F4"
      }), jsx(WorkingDay, {
        children: "\uD1A0\uC694\uC77C, \uACF5\uD734\uC77C: \uC624\uB298\uC758\uC9D1 \uC9C1\uC811\uBC30\uC1A1 \uC8FC\uBB38\uAC74 \uC0C1\uB2F4"
      }), jsx(WorkingDay, {
        children: "\uC77C\uC694\uC77C: \uD734\uBB34"
      })]
    }), jsxs(AnchorContainer, {
      children: [jsx(OutlineButton, {
        variant: "base1",
        size: 32,
        onClick: openKakaoChat,
        css: cssServiceButton,
        children: "\uCE74\uD1A1 \uC0C1\uB2F4(\uD3C9\uC77C 09:00~18:00)"
      }), jsx(OutlineAnchorButton, {
        href: !isApp || isHigherAppVersion({
          AOS: '0',
          iOS: '8.8'
        }) ? ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.voiceOfCustomer : "mailto:".concat(CUSTOMER_CENTER_EMAIL),
        variant: "base1",
        size: 32,
        css: cssServiceButton,
        children: "\uC774\uBA54\uC77C \uBB38\uC758"
      })]
    })]
  });
}
var ServiceCenterContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p8"
} : {
  target: "e18sae9p8",
  label: "ServiceCenterContainer"
})("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.content.base1;
}, ";");
var ServiceCenterAnchor = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p7"
} : {
  target: "e18sae9p7",
  label: "ServiceCenterAnchor"
})(FONT_STYLE.title3, " font-weight:700;display:flex;align-items:center;");
var ServiceCenterNumberAnchor = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p6"
} : {
  target: "e18sae9p6",
  label: "ServiceCenterNumberAnchor"
})(FONT_STYLE.subTitle1, " font-weight:700;white-space:nowrap;margin-right:", pxToRem(6), ";");
var ServiceCenterInfo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p5"
} : {
  target: "e18sae9p5",
  label: "ServiceCenterInfo"
})("display:flex;align-items:center;margin:", pxToRem(20), " 0 ", pxToRem(8), ";");
var ServiceCenterTime = /*#__PURE__*/_styled("time", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p4"
} : {
  target: "e18sae9p4",
  label: "ServiceCenterTime"
})(FONT_STYLE.body2, ";");
var ServiceCenterDescription = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p3"
} : {
  target: "e18sae9p3",
  label: "ServiceCenterDescription"
})(FONT_STYLE.body3, " white-space:pre-wrap;margin-bottom:", pxToRem(12), ";", MEDIA_QUERY.min('desktop', "\n    padding-right: ".concat(pxToRem(10), ";\n  ")), ";");
var AnchorContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p2"
} : {
  target: "e18sae9p2",
  label: "AnchorContainer"
})("display:flex;flex-direction:column;gap:", pxToRem(12), ";margin-top:", pxToRem(12), ";", MEDIA_QUERY.max('mobile', "\n    flex-direction: row;\n  "), ";");
var cssServiceButton = /*#__PURE__*/css("width:fit-content;white-space:nowrap;", MEDIA_QUERY.max('mobile', "\n    white-space: normal;\n  "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssServiceButton;"));
var ServiceCenterAnchorContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p1"
} : {
  target: "e18sae9p1",
  label: "ServiceCenterAnchorContainer"
})("display:flex;align-items:center;gap:", pxToRem(2), ";");
var WorkingDay = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p0"
} : {
  target: "e18sae9p0",
  label: "WorkingDay"
})("position:relative;padding-left:", pxToRem(20), ";&:before{content:'\u2022';position:absolute;font-size:", pxToRem(10), ";left:", pxToRem(7), ";}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Certification(_ref) {
  var certification = _ref.certification;
  var img = certification.imgSrc && jsx(Img, {
    src: certification.imgSrc,
    width: 32,
    height: 32,
    alt: "".concat(certification.id, " \uC778\uC99D \uB9C8\uD06C")
  });
  return jsxs(Container$3, {
    children: [certification.imgLink && img ? jsx("a", {
      href: certification.imgLink,
      target: "_blank",
      rel: "noreferrer",
      children: img
    }) : img, (certification.title || certification.date) && jsxs(Description, {
      children: [certification.title, jsx("br", {}), certification.date]
    })]
  });
}
var Container$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqedtio2"
} : {
  target: "eqedtio2",
  label: "Container"
})("display:flex;height:", pxToRem(40), ";padding:0 ", pxToRem(6), ";gap:", pxToRem(6), ";align-items:center;justify-content:center;border:", pxToRem(1), " solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.outline;
}, ";");
var Img = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "eqedtio1"
} : {
  target: "eqedtio1",
  label: "Img"
})(process.env.NODE_ENV === "production" ? {
  name: "1e1ncky",
  styles: "border:none"
} : {
  name: "1e1ncky",
  styles: "border:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
var Description = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqedtio0"
} : {
  target: "eqedtio0",
  label: "Description"
})(FONT_STYLE.caption2, " color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.content.base2;
}, ";");

function Responsive(_ref) {
  var mobile = _ref.mobile,
    _ref$tablet = _ref.tablet,
    tablet = _ref$tablet === void 0 ? mobile : _ref$tablet,
    _ref$laptop = _ref.laptop,
    laptop = _ref$laptop === void 0 ? tablet : _ref$laptop,
    _ref$desktop = _ref.desktop,
    desktop = _ref$desktop === void 0 ? laptop : _ref$desktop,
    defaultBreakpoint = _ref.defaultBreakpoint,
    preventSyncOnInitialRender = _ref.preventSyncOnInitialRender;
  var _useResponsive = useResponsive({
      fallbackBreakpoint: defaultBreakpoint !== null && defaultBreakpoint !== void 0 ? defaultBreakpoint : 'mobile',
      preventSyncOnInitialRender: preventSyncOnInitialRender
    }),
    breakpoint = _useResponsive.breakpoint;
  return jsxs(Fragment$1, {
    children: [breakpoint === 'mobile' && mobile, breakpoint === 'tablet' && tablet, breakpoint === 'laptop' && laptop, breakpoint === 'desktop' && desktop]
  });
}

function CompanyInfo(_ref) {
  var companyInfo = _ref.companyInfo;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenCompanyInfo = _useState2[0],
    setOpenCompanyInfo = _useState2[1];
  return jsx(Responsive, {
    mobile: jsxs(Fragment$1, {
      children: [jsxs(Button, {
        type: "button",
        onClick: function onClick() {
          return setOpenCompanyInfo(function (isOpenCompanyInfo) {
            return !isOpenCompanyInfo;
          });
        },
        children: [companyInfo['상호명'], jsx(Icon, {
          name: isOpenCompanyInfo ? 'chevron_thick_up' : 'chevron_thick_down',
          size: 12
        })]
      }), isOpenCompanyInfo && jsx("div", {
        css: /*#__PURE__*/css("margin-top:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        children: Object.keys(companyInfo).map(function (key) {
          return key !== '상호명' && jsx(CompanyInfoItem, {
            children: companyInfo[key]
          }, key);
        })
      })]
    }),
    tablet: jsx("div", {
      css: /*#__PURE__*/css("margin-left:", pxToRem(-9), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: Object.keys(companyInfo).map(function (key) {
        return jsxs(CompanyInfoItem, {
          children: [jsx("span", {
            css: /*#__PURE__*/css("margin:0 ", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
            children: "|"
          }), companyInfo[key]]
        }, key);
      })
    })
  });
}
var CompanyInfoItem = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1jtu31t1"
} : {
  target: "e1jtu31t1",
  label: "CompanyInfoItem"
})(FONT_STYLE.body3, " display:inline-block;white-space:nowrap;", MEDIA_QUERY.max('mobile', "\n    display: block;\n  "), ";");
var Button = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1jtu31t0"
} : {
  target: "e1jtu31t0",
  label: "Button"
})(RESET_BUTTON, " ", FONT_STYLE.caption1, " color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.content.base1;
}, ";font-weight:700;display:flex;gap:", pxToRem(2), ";align-items:center;");

var _excluded$h = ["copyright", "serviceCenter", "socialLinks", "companyLinks", "companyInfo", "responsibilityInfo", "paymentGuarantee", "certifications"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$b = process.env.NODE_ENV === "production" ? {
  name: "15bx5k",
  styles: "overflow-x:hidden"
} : {
  name: "1lck7ow-css",
  styles: "overflow-x:hidden;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
};
function Footer(_ref2) {
  var copyright = _ref2.copyright,
    serviceCenter = _ref2.serviceCenter,
    socialLinks = _ref2.socialLinks,
    companyLinks = _ref2.companyLinks,
    companyInfo = _ref2.companyInfo,
    responsibilityInfo = _ref2.responsibilityInfo,
    paymentGuarantee = _ref2.paymentGuarantee,
    certifications = _ref2.certifications,
    rest = _objectWithoutProperties(_ref2, _excluded$h);
  return jsx(FooterComponenet, _objectSpread2(_objectSpread2({}, rest), {}, {
    children: jsxs(StyledContainer, {
      children: [serviceCenter && jsx(ServiceCenter, _objectSpread2({}, serviceCenter)), jsx(Divider, {
        css: /*#__PURE__*/css(MEDIA_QUERY.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n            width: 100%;\n            height: ".concat(pxToRem(1), ";\n          ")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }), companyLinks && jsx(CompanyLinksContainer, {
        children: companyLinks.map(function (_ref3) {
          var text = _ref3.text,
            href = _ref3.href,
            target = _ref3.target,
            isBold = _ref3.isBold;
          return jsx(CompanyLink, {
            href: href,
            target: target || '_self',
            isBold: !!isBold,
            children: text
          }, text);
        })
      }), jsx(Divider, {
        css: /*#__PURE__*/css(MEDIA_QUERY.max('tablet', "\n            grid-column-start: 1;\n            grid-column-end: 4;\n            width: 100%;\n            height: ".concat(pxToRem(1), ";\n          ")), " ", MEDIA_QUERY.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n          "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }), jsxs(InfoContainer, {
        children: [companyInfo && jsx("div", {
          css: _ref$b,
          children: jsx(CompanyInfo, {
            companyInfo: companyInfo
          })
        }), paymentGuarantee && jsx("div", {
          children: paymentGuarantee
        }), certifications && jsx(CertificationContainer, {
          children: certifications.map(function (certification) {
            return jsx(Certification, {
              certification: certification
            }, certification.id);
          })
        }), responsibilityInfo && jsx("div", {
          children: responsibilityInfo
        }), socialLinks && jsx("div", {
          children: socialLinks.map(function (socialLink) {
            return jsx(SocialLink, _objectSpread2({}, socialLink), socialLink.href);
          })
        }), copyright && jsx("p", {
          children: copyright
        })]
      })]
    })
  }));
}
var FooterComponenet = /*#__PURE__*/_styled("footer", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd6"
} : {
  target: "e1nsvcrd6",
  label: "FooterComponenet"
})("padding:", pxToRem(40), " 0;background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.content.base5;
}, ";", MEDIA_QUERY.max('mobile', "\n    padding: ".concat(pxToRem(30), " 0;\n  ")), " & a:hover{text-decoration:underline;}");
var StyledContainer = /*#__PURE__*/_styled(Container$4, process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd5"
} : {
  target: "e1nsvcrd5",
  label: "StyledContainer"
})(FONT_STYLE.caption1, ";display:grid;grid-template-columns:", pxToRem(256), " 1px ", pxToRem(256), " 1px 2fr;grid-column-gap:", pxToRem(24), ";", MEDIA_QUERY.max('tablet', "\n    grid-template-columns: 1fr 1px 1fr;\n    grid-row-gap: ".concat(pxToRem(24), ";\n  ")), " ", MEDIA_QUERY.max('mobile', "\n    padding: 0 ".concat(pxToRem(16), ";\n    grid-template-columns: 1fr;\n    grid-row-gap: ").concat(pxToRem(20), ";\n  ")), ";");
var InfoContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd4"
} : {
  target: "e1nsvcrd4",
  label: "InfoContainer"
})(FONT_STYLE.caption2, " display:flex;flex-direction:column;gap:", pxToRem(12), ";color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.content.base2;
}, ";", MEDIA_QUERY.max('tablet', "\n    grid-column-start: 1;\n    grid-column-end: 4;\n  "), " ", MEDIA_QUERY.max('mobile', "\n    grid-column-start: 1;\n    grid-column-end: 2;\n  "), ";");
var CompanyLinksContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd3"
} : {
  target: "e1nsvcrd3",
  label: "CompanyLinksContainer"
})("display:grid;grid-template-columns:repeat(2, 1fr);grid-template-rows:repeat(6, min-content);grid-auto-flow:column;grid-column-gap:", pxToRem(8), ";grid-row-gap:", pxToRem(20), ";", MEDIA_QUERY.max('mobile', "\n    display: block;\n    grid-column-gap: ".concat(pxToRem(10), ";\n  ")), ";");
var CompanyLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd2"
} : {
  target: "e1nsvcrd2",
  label: "CompanyLink"
})(FONT_STYLE.caption1, " display:inline-block;color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.content.base1;
}, ";white-space:nowrap;font-weight:", function (_ref7) {
  var isBold = _ref7.isBold;
  return isBold && '700';
}, ";", MEDIA_QUERY.max('mobile', "\n    margin: ".concat(pxToRem(8), " ").concat(pxToRem(12), " ").concat(pxToRem(8), " 0;\n  ")), ";");
var CertificationContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd1"
} : {
  target: "e1nsvcrd1",
  label: "CertificationContainer"
})("display:grid;grid-column-gap:", pxToRem(6), ";grid-template-columns:max-content minmax(min-content, ", pxToRem(116), ") minmax(min-content, ", pxToRem(116), ");", MEDIA_QUERY.max('mobile', "\n    grid-template-columns: 1fr;\n  "), ";");
var Divider = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd0"
} : {
  target: "e1nsvcrd0",
  label: "Divider"
})("width:", pxToRem(1), ";background-color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.divider;
}, ";");

var markIsmsSrc = "https://assets.ohou.se/design-system/8f5b2c2e98ea1196.png";

var markIso27001Src = "https://assets.ohou.se/design-system/d5fb816a58bb6a06.png";

var markPcrSrc = "https://assets.ohou.se/design-system/ad1cf869a6c58058.png";

var _excluded$g = ["ohouseFooterLinks"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var PHONE_NUMBER = '1670-0876';
var ADDRESS = '서울 서초구 서초대로74길 4 삼성생명서초타워 25층, 27층';
var COPYRIGHT_TEXT = 'Copyright 2014. bucketplace, Co., Ltd. All rights reserved.';
var BUCKETPLACE_HOMEPAGE_URL = 'https://www.bucketplace.com';
var OPENING_HOUR = {
  START: '09:00',
  END: '18:00'
};
var EMAIL = {
  CS: 'cs@bucketplace.net',
  CONTACT: 'contact@bucketplace.net'
};
/**
 * ohouse 서비스 도메인과 연결된 link schema를 create합니다.
 * @param ohs prod, stage 등 환경에 따른 `ohou.se` url
 * @param pro prod, stage 등 환경에 따른 `o2o-partner.ohou.se` url (pro.ohou.se deprecated)
 * @returns 서비스 도메인과 연결된 link schema
 */
function createOhouseFooterLinkSchema(_ref2) {
  var ohs = _ref2.ohs,
    pro = _ref2.pro;
  return {
    serviceCenter: "".concat(ohs, "/customer_center"),
    usepolicy: "".concat(ohs, "/usepolicy"),
    privacy: "".concat(ohs, "/privacy"),
    partnerPrivacy: "".concat(ohs, "/partner_privacy"),
    notice: "".concat(ohs, "/customer_notices"),
    inquiry: "".concat(ohs, "/contacts/new?type=request"),
    voiceOfCustomer: "".concat(ohs, "/contacts/new"),
    pro: "".concat(pro, "/intro?utm_source=ohouse&utm_medium=web&utm_campaign=prosignup&utm_content=footer")
  };
}
var _ref$a = process.env.NODE_ENV === "production" ? {
  name: "ya1ij",
  styles: "display:inline-block;font-style:normal"
} : {
  name: "7131b2-css",
  styles: "display:inline-block;font-style:normal;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};
function OhouseFooter(props) {
  var ohouseFooterLinks = props.ohouseFooterLinks,
    restProps = _objectWithoutProperties(props, _excluded$g);
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var paymentGuarantee = jsxs(Fragment$1, {
    children: [jsx("span", {
      children: "\uACE0\uAC1D\uB2D8\uC774 \uD604\uAE08\uACB0\uC81C\uD55C \uAE08\uC561\uC5D0 \uB300\uD574 \uC6B0\uB9AC\uC740\uD589\uACFC \uCC44\uBB34\uC9C0\uAE09\uBCF4\uC99D \uACC4\uC57D\uC744 \uCCB4\uACB0\uD558\uC5EC \uC548\uC804\uAC70\uB798\uB97C \uBCF4\uC7A5\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
    }), ' ', jsx("a", {
      target: "_blank",
      href: "https://ohouse.notion.site/da111ffbfc7c45a0a1327e23a7bd5dde",
      css: /*#__PURE__*/css("font-weight:700;color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      rel: "noreferrer",
      children: "\uC11C\uBE44\uC2A4\uAC00\uC785\uC0AC\uC2E4\uD655\uC778"
    })]
  });
  var iso27001 = {
    id: 'iso27001',
    imgSrc: markIso27001Src
  };
  var isms = {
    id: 'isms',
    imgSrc: markIsmsSrc,
    title: jsx("span", {
      children: "\uC624\uB298\uC758\uC9D1 \uC11C\uBE44\uC2A4 \uC6B4\uC601"
    }),
    date: '2024. 09. 08 ~ 2027. 09. 07'
  };
  var pcr = {
    id: 'pcr',
    imgSrc: markPcrSrc,
    imgLink: 'https://www.pipc.go.kr/np/cop/bbs/selectBoardArticle.do?bbsId=BS213&mCode=C040050000&nttId=8926'
  };
  return jsx(Footer, _objectSpread2(_objectSpread2({}, restProps), {}, {
    copyright: COPYRIGHT_TEXT,
    serviceCenter: {
      phone: PHONE_NUMBER,
      openingHour: {
        start: OPENING_HOUR.START,
        end: OPENING_HOUR.END
      },
      ohouseFooterLinks: ohouseFooterLinks
    },
    socialLinks: [{
      type: 'Youtube',
      href: 'https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA'
    }, {
      type: 'Instagram',
      href: 'https://www.instagram.com/todayhouse'
    }, {
      type: 'Facebook',
      href: 'https://www.facebook.com/interiortoday'
    }, {
      type: 'KakaoStory',
      href: 'https://story.kakao.com/ch/bucketplace'
    }, {
      type: 'NaverPost',
      href: 'https://naver.me/51ckkDZh'
    }],
    companyLinks: [{
      text: '회사소개',
      href: BUCKETPLACE_HOMEPAGE_URL
    }, {
      text: '채용정보',
      href: "".concat(BUCKETPLACE_HOMEPAGE_URL, "/careers")
    }, {
      text: '이용약관',
      href: ohouseFooterLinks.usepolicy
    }, {
      text: '개인정보 처리방침',
      href: ohouseFooterLinks.privacy,
      isBold: true
    }, {
      text: '공지사항',
      href: ohouseFooterLinks.notice
    }, {
      text: '권리보호센터',
      href: 'https://safetybucketplace.zendesk.com/hc/ko',
      target: 'blank'
    }, {
      text: '입점신청',
      href: 'https://partnerbucketplace.zendesk.com/hc/ko/articles/19259629646361-오늘의집-입점안내'
    }, {
      text: '제휴/광고 문의',
      href: ohouseFooterLinks.inquiry
    }, {
      text: '시공파트너 안내',
      href: ohouseFooterLinks.pro
    }, {
      text: '파트너 개인정보 처리방침',
      href: ohouseFooterLinks.partnerPrivacy,
      isBold: true
    }, {
      text: '상품광고 소개',
      href: 'https://ohouse-ad.oopy.io'
    }, {
      text: '고객의 소리',
      href: ohouseFooterLinks.voiceOfCustomer
    }],
    companyInfo: {
      상호명: '(주)버킷플레이스',
      대표이사: '대표이사 이승재',
      주소: jsx("address", {
        css: _ref$a,
        children: ADDRESS
      }),
      이메일: jsx("a", {
        href: "mailto:contact@bucketplace.net",
        children: EMAIL.CONTACT
      }),
      사업자등록번호: jsxs(Fragment$1, {
        children: [jsx("span", {
          children: "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638 119-86-91245"
        }), jsxs("a", {
          target: "_blank",
          href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1198691245",
          css: /*#__PURE__*/css("font-weight:700;color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          rel: "noreferrer",
          children: [' ', "\uC0AC\uC5C5\uC790\uC815\uBCF4\uD655\uC778"]
        })]
      }),
      통신판매업신고번호: jsx("span", {
        children: "\uD1B5\uC2E0\uD310\uB9E4\uC5C5\uC2E0\uACE0\uBC88\uD638 \uC81C2018-\uC11C\uC6B8\uC11C\uCD08-0580\uD638"
      })
    },
    responsibilityInfo: "(\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uB294 \uD1B5\uC2E0\uD310\uB9E4\uC911\uAC1C\uC790\uB85C \uAC70\uB798 \uB2F9\uC0AC\uC790\uAC00 \uC544\uB2C8\uBBC0\uB85C, \uD310\uB9E4\uC790\uAC00 \uB4F1\uB85D\uD55C \uC0C1\uD488\uC815\uBCF4 \uBC0F \uAC70\uB798 \uB4F1\uC5D0 \uB300\uD574 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB2E8, (\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uAC00 \uD310\uB9E4\uC790\uB85C \uB4F1\uB85D \uD310\uB9E4\uD55C \uC0C1\uD488\uC740 \uD310\uB9E4\uC790\uB85C\uC11C \uCC45\uC784\uC744 \uBD80\uB2F4\uD569\uB2C8\uB2E4.",
    paymentGuarantee: paymentGuarantee,
    certifications: !isMobile ? [isms, iso27001, pcr] : undefined
  }));
}

var _excluded$f = ["size", "selected", "disabled", "forwardedRef", "children"];
function ListItem(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'basic' : _ref$size,
    selected = _ref.selected,
    disabled = _ref.disabled,
    forwardedRef = _ref.forwardedRef,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$f);
  var theme = useTheme();
  return jsx("div", _objectSpread2(_objectSpread2({
    ref: forwardedRef,
    css: /*#__PURE__*/css("padding:", pxToRem({
      basic: 16,
      compact: 11
    }[size]), " ", pxToRem(16), ";color:", theme.content.base1, ";", FONT_STYLE.subTitle1, " transition:background-color .2s ease-in-out;", disabled && "\n          color: ".concat(theme.content.base3, ";\n        "), " &:hover,&:focus{background-color:", theme.content.base5, ";}", selected && "\n          background-color: ".concat(theme.content.base5, ";\n        "), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
  }, props), {}, {
    children: children
  }));
}

var _excluded$e = ["variant"];
function DividerListItem(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'thin' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded$e);
  return jsxs(Fragment$1, {
    children: [jsx(ListItem, _objectSpread2({}, props)), jsx(Divider$1, {
      variant: variant
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Dropdown = function Dropdown(_ref) {
  var dropdownRef = _ref.dropdownRef,
    title = _ref.title,
    items = _ref.items,
    _onClick = _ref.onClick,
    onCloseDropdown = _ref.onCloseDropdown,
    onClose = _ref.onClose,
    _ref$selectedItemId = _ref.selectedItemId,
    selectedItemId = _ref$selectedItemId === void 0 ? -1 : _ref$selectedItemId,
    _ref$isPopupInMobile = _ref.isPopupInMobile,
    isPopupInMobile = _ref$isPopupInMobile === void 0 ? false : _ref$isPopupInMobile;
  var isMobile = useResponsive().breakpoint === 'mobile';
  var listItemRef = useRef(null);
  var listItemHeight = useNodeHeight(listItemRef);
  // PC의 경우 최대 10.5개의 아이템 노출
  var maxDropdownHeight = useMemo(function () {
    return listItemHeight * 10.5;
  }, [listItemHeight]);
  var modalWidthProps = useMemo(function () {
    return isMobile && isPopupInMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 600
    };
  }, [isMobile, isPopupInMobile]);
  return jsx("div", {
    ref: dropdownRef,
    onClick: function onClick(e) {
      return onCloseDropdown(e);
    },
    children: isMobile ? jsx(Modal, _objectSpread2(_objectSpread2({}, modalWidthProps), {}, {
      onBlur: onClose,
      header: {
        title: title,
        onClose: onClose
      },
      children: jsx(ListItemWrapper, {
        children: items.map(function (item) {
          return jsx(Item, {
            size: "basic",
            onClick: function onClick() {
              return _onClick(item.id);
            },
            selected: item.id === selectedItemId,
            children: item.value
          }, item.id);
        })
      })
    })) : jsx(Container$2, {
      maxDropdownHeight: maxDropdownHeight,
      children: items.map(function (item) {
        return (
          // TODO: disabled 기능 추가
          jsx(Item, {
            size: "basic",
            onClick: function onClick() {
              return _onClick(item.id);
            },
            forwardedRef: listItemRef,
            selected: item.id === selectedItemId,
            children: item.value
          }, item.id)
        );
      })
    })
  });
};
var Container$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uoa6tb2"
} : {
  target: "e1uoa6tb2",
  label: "Container"
})("border-radius:", pxToRem(4), ";max-height:", function (_ref2) {
  var maxDropdownHeight = _ref2.maxDropdownHeight;
  return pxToRem(maxDropdownHeight);
}, ";overflow-y:auto;z-index:1;", function (_ref3) {
  var theme = _ref3.theme;
  return /*#__PURE__*/css("border:", pxToRem(1), " solid ", theme.content.base4, ";background-color:", theme.background.elevated, ";box-shadow:", theme.shadow.thin, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"));
}, ";");
var ListItemWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uoa6tb1"
} : {
  target: "e1uoa6tb1",
  label: "ListItemWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "umwchj",
  styles: "overflow-y:auto"
} : {
  name: "umwchj",
  styles: "overflow-y:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});
var Item = /*#__PURE__*/_styled(ListItem, process.env.NODE_ENV === "production" ? {
  target: "e1uoa6tb0"
} : {
  target: "e1uoa6tb0",
  label: "Item"
})(process.env.NODE_ENV === "production" ? {
  name: "1ud33u0",
  styles: "cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;&:active{font-weight:700;}"
} : {
  name: "1ud33u0",
  styles: "cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;&:active{font-weight:700;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ICON_SIZE = 24;
function SimpleFooter(_ref) {
  var companyLinks = _ref.companyLinks,
    socialLinks = _ref.socialLinks,
    localeSelection = _ref.localeSelection;
  var dropdownRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownOpen = _useState2[0],
    setIsDropdownOpen = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItemId = _useState4[0],
    setSelectedItemId = _useState4[1];
  var dropdownItems = React__default.useMemo(function () {
    return localeSelection ? localeSelection.locales.map(function (item, index) {
      return {
        id: index,
        value: item.text
      };
    }) : [];
  }, [localeSelection]);
  var currentLocaleText = React__default.useMemo(function () {
    var _a;
    return (_a = localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.locales[selectedItemId]) === null || _a === void 0 ? void 0 : _a.text;
  }, [localeSelection, selectedItemId]);
  var getLocaleByDropdownItemId = function getLocaleByDropdownItemId(id) {
    return localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.locales[id].locale;
  };
  var handleLocaleButtonClick = function handleLocaleButtonClick() {
    setIsDropdownOpen(!isDropdownOpen);
  };
  var handleCloseDropdown = function handleCloseDropdown() {
    setIsDropdownOpen(false);
  };
  var handleClick = function handleClick(id) {
    setIsDropdownOpen(false);
    if (selectedItemId === id) return;
    setSelectedItemId(id);
    var locale = getLocaleByDropdownItemId(id);
    if (locale) localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.onLocaleChange(locale);
  };
  useEffect(function () {
    if (localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.initialLocale) {
      setSelectedItemId(localeSelection.locales.findIndex(function (item) {
        return item.locale === localeSelection.initialLocale;
      }));
    }
  }, [localeSelection]);
  return jsxs(FooterContainer, {
    children: [jsxs(CompanyLinksAndLocaleContainer, {
      children: [localeSelection && jsx(LocaleContainer, {
        children: jsxs(LocaleButton, {
          onClick: handleLocaleButtonClick,
          children: [currentLocaleText, jsx(ArrowIcon, {
            size: ICON_SIZE,
            name: "dropdown"
          }), isDropdownOpen && jsx(DropdownWrapper, {
            children: jsx(Dropdown, {
              title: "",
              dropdownRef: dropdownRef,
              items: dropdownItems,
              onCloseDropdown: handleCloseDropdown,
              onClose: function onClose() {
                return setIsDropdownOpen(false);
              },
              onClick: handleClick,
              selectedItemId: selectedItemId
            })
          })]
        })
      }), companyLinks === null || companyLinks === void 0 ? void 0 : companyLinks.map(function (_ref2) {
        var text = _ref2.text,
          href = _ref2.href,
          target = _ref2.target,
          isBold = _ref2.isBold;
        return jsx(GlobalCompanyLink, {
          href: href,
          target: target || '_self',
          isBold: !!isBold,
          children: text
        }, text);
      })]
    }), socialLinks && jsx(SocialLinkContainer, {
      children: socialLinks.map(function (socialLink) {
        return jsx(SocialLink, _objectSpread2({}, socialLink), socialLink.href);
      })
    })]
  });
}
var FooterContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm897"
} : {
  target: "e1blcm897",
  label: "FooterContainer"
})("display:flex;align-items:center;justify-content:space-between;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.background.groupedBase;
}, ";", MEDIA_QUERY.only('mobile', process.env.NODE_ENV === "production" ? {
  name: "hvmejc",
  styles: "flex-direction:column;align-items:flex-start;padding:28px 16px"
} : {
  name: "11e3d5f-FooterContainer",
  styles: "flex-direction:column;align-items:flex-start;padding:28px 16px;label:FooterContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), " ", MEDIA_QUERY.only('tablet', /*#__PURE__*/css("flex-direction:row;gap:", pxToRem(10), ";padding:40px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;"))), " ", MEDIA_QUERY.min('laptop', /*#__PURE__*/css("flex-direction:row;gap:", pxToRem(10), ";padding:40px 60px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;"))), ";");
var SocialLinkContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm896"
} : {
  target: "e1blcm896",
  label: "SocialLinkContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "zuryxo",
  styles: "display:flex;flex-wrap:wrap;margin-right:-12px"
} : {
  name: "zuryxo",
  styles: "display:flex;flex-wrap:wrap;margin-right:-12px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var CompanyLinksAndLocaleContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm895"
} : {
  target: "e1blcm895",
  label: "CompanyLinksAndLocaleContainer"
})(FONT_STYLE.caption1, " display:flex;flex-wrap:wrap;align-items:center;padding:4px 0px;color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.content.base1;
}, ";gap:", pxToRem(10), " ", pxToRem(20), ";", MEDIA_QUERY.only('mobile', process.env.NODE_ENV === "production" ? {
  name: "18uqayh",
  styles: "margin-bottom:16px"
} : {
  name: "1x5h36d-CompanyLinksAndLocaleContainer",
  styles: "margin-bottom:16px;label:CompanyLinksAndLocaleContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), ";");
var LocaleContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm894"
} : {
  target: "e1blcm894",
  label: "LocaleContainer"
})(FONT_STYLE.caption1, " display:flex;flex-wrap:wrap;align-items:center;color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.content.base1;
}, ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("gap:", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:LocaleContainer;"))), ";");
var LocaleButton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm893"
} : {
  target: "e1blcm893",
  label: "LocaleButton"
})("display:flex;position:relative;align-items:center;justify-content:space-between;cursor:pointer;&:hover{background-color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.interactive.transparent;
}, ";}");
var ArrowIcon = /*#__PURE__*/_styled(Icon, process.env.NODE_ENV === "production" ? {
  target: "e1blcm892"
} : {
  target: "e1blcm892",
  label: "ArrowIcon"
})("color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.content.base2;
}, ";");
var DropdownWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm891"
} : {
  target: "e1blcm891",
  label: "DropdownWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "h98bmf",
  styles: "position:absolute;bottom:calc(100%);left:0px"
} : {
  name: "h98bmf",
  styles: "position:absolute;bottom:calc(100%);left:0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var GlobalCompanyLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e1blcm890"
} : {
  target: "e1blcm890",
  label: "GlobalCompanyLink"
})(FONT_STYLE.caption1, " display:inline-block;color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.content.base1;
}, ";white-space:nowrap;font-weight:", function (_ref9) {
  var isBold = _ref9.isBold;
  return isBold && '700';
}, ";");

var _excluded$d = ["title", "type", "icon", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * @deprecated ODS의 CautionBox 컴포넌트를 사용해 주세요.
 */
var _ref$9 = process.env.NODE_ENV === "production" ? {
  name: "15ne7tr",
  styles: "font-weight:700;vertical-align:middle"
} : {
  name: "yci5s1-css",
  styles: "font-weight:700;vertical-align:middle;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
};
function Callout(_ref2) {
  var title = _ref2.title,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'notice' : _ref2$type,
    icon = _ref2.icon,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded$d);
  var theme = useTheme();
  return jsxs("div", _objectSpread2(_objectSpread2({}, rest), {}, {
    css: /*#__PURE__*/css("color:", theme.content.base1, ";padding:", pxToRem(16), ";border-radius:", pxToRem(4), ";background-color:", {
      notice: theme.content.base5,
      confirm: theme.content.base5,
      alert: theme.content.primary2.thin
    }[type], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [jsxs("div", {
      css: FONT_STYLE.subTitle1,
      children: [icon && jsx(Icon, {
        size: 18,
        name: icon,
        css: /*#__PURE__*/css("vertical-align:middle;margin-right:", pxToRem(6), ";color:", {
          notice: theme.content.base1,
          confirm: theme.content.primary1.basic,
          alert: theme.content.primary2.thick
        }[type], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      }), jsx("span", {
        css: _ref$9,
        children: title
      })]
    }), children && jsx("div", {
      css: [FONT_STYLE.body1_1, /*#__PURE__*/css("margin-top:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: children
    })]
  }));
}

var _excluded$c = ["currentPage", "maxPage", "size", "dimmed", "fontWeight", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function cssSize$2(size) {
  return /*#__PURE__*/css({
    small: /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(8), ";font-size:", pxToRem(12), ";height:", pxToRem(24), ";border-radius:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;")),
    medium: /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(10), ";font-size:", pxToRem(14), ";height:", pxToRem(26), ";border-radius:", pxToRem(13), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")),
    large: /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(12), ";font-size:", pxToRem(16), ";height:", pxToRem(28), ";border-radius:", pxToRem(14), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:large;"))
  }[size], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
}
function cssDimmed(dimmed, theme) {
  return /*#__PURE__*/css({
    basic: /*#__PURE__*/css("background-color:", theme.dim.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:basic;")),
    thick: /*#__PURE__*/css("background-color:", theme.dim.thick, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:thick;"))
  }[dimmed], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssDimmed;"));
}
var _ref$8 = process.env.NODE_ENV === "production" ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : {
  name: "1jxftah-bold",
  styles: "font-weight:700;label:bold;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
};
var _ref2$4 = process.env.NODE_ENV === "production" ? {
  name: "mmvz9h",
  styles: "font-weight:400"
} : {
  name: "13ofrm9-regular",
  styles: "font-weight:400;label:regular;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
};
function cssFontWeight(fontWeight) {
  return /*#__PURE__*/css({
    regular: _ref2$4,
    bold: _ref$8
  }[fontWeight], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFontWeight;"));
}
function IndicatorNumber(_ref3) {
  var _ref3$currentPage = _ref3.currentPage,
    currentPage = _ref3$currentPage === void 0 ? 1 : _ref3$currentPage,
    _ref3$maxPage = _ref3.maxPage,
    maxPage = _ref3$maxPage === void 0 ? 1 : _ref3$maxPage,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'small' : _ref3$size,
    _ref3$dimmed = _ref3.dimmed,
    dimmed = _ref3$dimmed === void 0 ? 'basic' : _ref3$dimmed,
    _ref3$fontWeight = _ref3.fontWeight,
    fontWeight = _ref3$fontWeight === void 0 ? 'regular' : _ref3$fontWeight,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded$c);
  var theme = useTheme();
  return jsx("span", _objectSpread2(_objectSpread2({
    css: [cssSize$2(size), cssDimmed(dimmed, theme), cssFontWeight(fontWeight), /*#__PURE__*/css("display:inline-flex;align-items:center;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;line-height:0;overflow:hidden;max-width:100%;color:", theme.content.white, ";box-sizing:border-box;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
  }, rest), {}, {
    children: children || "".concat(currentPage, "/").concat(maxPage)
  }));
}

var _excluded$b = ["currentPage", "maxPage", "size", "fontWeight"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function getGap(size) {
  return {
    small: 2,
    medium: 2,
    large: 4
  }[size];
}
function getIconSize(size) {
  return {
    small: 12,
    medium: 12,
    large: 18
  }[size];
}
function getIconName(fontWeight) {
  return {
    regular: 'add',
    bold: 'add_thick'
  }[fontWeight];
}
function cssSize$1(size) {
  return /*#__PURE__*/css({
    small: /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(6), " ", pxToRem(4), " ", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;")),
    medium: /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(8), " ", pxToRem(4), " ", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")),
    large: /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(8), " ", pxToRem(4), " ", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:large;"))
  }[size], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
}
var _ref2$3 = process.env.NODE_ENV === "production" ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : {
  name: "1jb04g5-medium",
  styles: "vertical-align:middle;label:medium;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
};
var _ref3$2 = process.env.NODE_ENV === "production" ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : {
  name: "1al83xd-small",
  styles: "vertical-align:middle;label:small;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
};
function cssIcon(size) {
  return /*#__PURE__*/css({
    small: _ref3$2,
    medium: _ref2$3,
    large: /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:large;")
  }[size], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssIcon;"));
}
var _ref$7 = process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "1diuouz-css",
  styles: "cursor:pointer;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
};
function IndicatorNumberWithIcon(_ref4) {
  var currentPage = _ref4.currentPage,
    maxPage = _ref4.maxPage,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'small' : _ref4$size,
    _ref4$fontWeight = _ref4.fontWeight,
    fontWeight = _ref4$fontWeight === void 0 ? 'regular' : _ref4$fontWeight,
    rest = _objectWithoutProperties(_ref4, _excluded$b);
  return jsxs(IndicatorNumber, _objectSpread2(_objectSpread2({
    size: size,
    currentPage: currentPage,
    maxPage: maxPage,
    fontWeight: fontWeight,
    css: [cssSize$1(size), _ref$7]
  }, rest), {}, {
    children: [jsxs("span", {
      css: /*#__PURE__*/css("vertical-align:middle;margin-right:", pxToRem(getGap(size)), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [currentPage, "/", maxPage]
    }), jsx(Icon, {
      name: getIconName(fontWeight),
      size: getIconSize(size),
      css: cssIcon(size)
    })]
  }));
}

var _excluded$a = ["variant"];
var visibleCount = 6;
function dotSize(index, maxPage, activeIndex) {
  var isLeftEnd = activeIndex < visibleCount / 2;
  var isRightEnd = activeIndex > maxPage - visibleCount / 2;
  var getVisibleCount = isLeftEnd || isRightEnd ? visibleCount : visibleCount + 1 ;
  var visibleStartIndex = function () {
    if (isLeftEnd) {
      return 0;
    } else if (isRightEnd) {
      return maxPage - getVisibleCount;
    } else {
      return activeIndex - Math.floor(getVisibleCount / 2);
    }
  }();
  var visibleLastIndex = visibleStartIndex + getVisibleCount - 1;
  var isCurrentDot = index === activeIndex;
  if (isCurrentDot) {
    return 8;
  }
  var isHiddenDot = index < visibleStartIndex || visibleLastIndex < index;
  if (isHiddenDot) {
    return 0;
  }
  var isMoreDot = isLeftEnd ? index === visibleLastIndex : isRightEnd ? index === visibleStartIndex : index === visibleStartIndex || index === visibleLastIndex;
  if (isMoreDot) {
    return 4;
  }
  return 6;
}
/**
 * ODS의 IndicatorDots 컴포넌트를 사용해 주세요.
 */
function IndicatorDots(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'basic' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$a);
  var theme = useTheme();
  return makeIndicatorDots({
    dotSize: dotSize,
    dotBackgroundColor: variant === 'basic' ? theme.content.base3 : theme.dim.onDark.thick,
    activeDotBackgroundColor: variant === 'basic' ? theme.content.base1 : theme.content.white,
    boxShadow: variant === 'onDimmed' ? "".concat(pxToRem(0), " ").concat(pxToRem(1), " ").concat(pxToRem(6), " ").concat(theme.shadow.basic) : ''
  })(rest);
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$6 = process.env.NODE_ENV === "production" ? {
  name: "1aslf6p",
  styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
} : {
  name: "nghld0-css",
  styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
function MoreAnchor(_ref2) {
  var rest = _extends$7({}, (_objectDestructuringEmpty(_ref2), _ref2));
  var theme = useTheme();
  return jsxs("a", _objectSpread2(_objectSpread2({
    css: [/*#__PURE__*/css("color:", theme.content.base1, ";display:inline-block;font-weight:500;padding:", pxToRem(6), " ", pxToRem(16), ";&:hover{&>div:first-of-type{background-color:", theme.interactive.base4, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
  }, rest), {}, {
    children: [jsx("div", {
      css: /*#__PURE__*/css("width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:", pxToRem(20), ";background-color:", theme.content.base4, ";margin-bottom:", pxToRem(6), ";position:relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: jsx(Icon, {
        name: "arrow_right",
        size: 18,
        css: _ref$6
      })
    }), jsx("div", {
      css: FONT_STYLE.body2,
      children: "\uB354\uBCF4\uAE30"
    })]
  }));
}

var _templateObject$2;
var _excluded$9 = ["thumbnail", "size", "label", "hasHoverEffect", "hasBorder", "active", "children"];
function cssSize(size) {
  return /*#__PURE__*/css({
    72: /*#__PURE__*/css("border-radius:", pxToRem(24), ";"),
    100: /*#__PURE__*/css("border-radius:", pxToRem(32), ";")
  }[size], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;"));
}
function cssLabel(size) {
  return /*#__PURE__*/css({
    72: FONT_STYLE.subTitle2,
    100: FONT_STYLE.subTitle1
  }[size], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLabel;"));
}
function ThumbnailAnchor(_ref) {
  var thumbnail = _ref.thumbnail,
    size = _ref.size,
    label = _ref.label,
    _ref$hasHoverEffect = _ref.hasHoverEffect,
    hasHoverEffect = _ref$hasHoverEffect === void 0 ? true : _ref$hasHoverEffect,
    _ref$hasBorder = _ref.hasBorder,
    hasBorder = _ref$hasBorder === void 0 ? true : _ref$hasBorder,
    active = _ref.active,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  var theme = useTheme();
  return jsxs("a", _objectSpread2(_objectSpread2({
    css: [/*#__PURE__*/css("display:flex;flex-direction:column;margin-top:", pxToRem(12), ";max-width:", pxToRem(size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), hasHoverEffect && HOVER(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n          & > div:first-of-type > figure {\n            transition: transform ease-in-out 0.2s;\n            transform: scale(1.05);\n          }\n        "])), pxToRem(2), theme.content.primary1.basic), active && /*#__PURE__*/css("&>div:first-of-type:after{border:", pxToRem(2), " solid ", theme.content.primary1.basic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
  }, rest), {}, {
    children: [jsx("div", {
      css: [/*#__PURE__*/css("overflow:hidden;position:relative;box-sizing:border-box;width:", pxToRem(size), ";height:", pxToRem(size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), hasBorder && /*#__PURE__*/css("&:after{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;border-radius:inherit;border:", pxToRem(1), " solid ", theme.outline, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), cssSize(size)],
      children: jsx(Image, {
        src: thumbnail,
        aspectRatio: "1:1",
        css: /*#__PURE__*/css("box-sizing:border-box;border-radius:inherit;width:", pxToRem(size), ";height:", pxToRem(size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
      })
    }), label && jsx("div", {
      css: [cssLabel(size), /*#__PURE__*/css("text-align:center;margin-top:", pxToRem(10), ";color:", theme.content.base1, ";overflow:hidden;word-break:break-all;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
      children: label
    }), children]
  }));
}

var _excluded$8 = ["badge"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "t8gs49",
  styles: "top:0;right:0;position:absolute;display:flex;min-width:fit-content"
} : {
  name: "z2yh1s-right",
  styles: "top:0;right:0;position:absolute;display:flex;min-width:fit-content;label:right;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
};
function cssBadgePosition() {
  var badgePosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
  return /*#__PURE__*/css({
    center: /*#__PURE__*/css("top:", pxToRem(-12), ";left:50%;transform:translateX(-50%);position:absolute;display:flex;min-width:fit-content;" + (process.env.NODE_ENV === "production" ? "" : ";label:center;")),
    right: _ref2$2
  }[badgePosition], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBadgePosition;"));
}
var _ref$5 = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1uvyp5k-css",
  styles: "position:relative;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
};
function withBadge(Component, cssBadgeVariant) {
  return function (_ref3) {
    var rest = _extends$7({}, (_objectDestructuringEmpty(_ref3), _ref3));
    var badge = rest.badge,
      props = _objectWithoutProperties(rest, _excluded$8);
    return jsxs(Component, _objectSpread2(_objectSpread2({}, props), {}, {
      css: _ref$5,
      children: [badge.component === 'SquareBadge' && jsx(SquareBadge, _objectSpread2(_objectSpread2({
        size: 24
      }, badge), {}, {
        css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)],
        children: badge.label
      })), badge.component === 'PillBadge' && jsx(PillBadge, _objectSpread2(_objectSpread2({
        size: 24
      }, badge), {}, {
        css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)],
        children: badge.label
      }))]
    }));
  };
}

function cssBadgeVariant(size) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
  return /*#__PURE__*/css({
    center: /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:center;"),
    right: /*#__PURE__*/css({
      72: /*#__PURE__*/css("top:", pxToRem(-8), ";right:", pxToRem(-8), ";"),
      100: /*#__PURE__*/css("top:", pxToRem(-6), ";right:", pxToRem(-6), ";")
    }[size], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:right;"))
  }[position], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBadgeVariant;"));
}
var ThumbnailAnchorWithBadge = withBadge(ThumbnailAnchor, function (_ref) {
  var size = _ref.size,
    badge = _ref.badge;
  return cssBadgeVariant(size, badge.position);
});

var DEFAULT_AUTO_PLAY_INTERVAL = 3000;

/**
 * 현재 캐러셀에서 가능한 currentOffset의 범위를 계산합니다.
 * @return [가능한 currentOffset의 최솟값, 가능한 currentOffset의 최댓값]
 */
var getCurrentOffsetBounds = function getCurrentOffsetBounds(_ref) {
  var align = _ref.align,
    _ref$itemRatio = _ref.itemRatio,
    itemRatio = _ref$itemRatio === void 0 ? 1 : _ref$itemRatio,
    _ref$edgeSpaceRatio = _ref.edgeSpaceRatio,
    edgeSpaceRatio = _ref$edgeSpaceRatio === void 0 ? 0 : _ref$edgeSpaceRatio,
    childrenLength = _ref.childrenLength;
  var visibleChildrenCount = 1 / itemRatio;
  switch (align) {
    case 'centerConstrained':
      {
        var left = (visibleChildrenCount - 1) / 2;
        return [left - edgeSpaceRatio, Math.max(0, childrenLength - visibleChildrenCount) + left + edgeSpaceRatio];
      }
    case 'left':
      return [0, Math.max(0, childrenLength - visibleChildrenCount)];
    case 'center':
      return [0, Math.max(0, childrenLength - 1)];
    default:
      return [0, 0];
  }
};

function useOffset(_ref) {
  var loop = _ref.loop,
    childrenLength = _ref.childrenLength,
    align = _ref.align,
    _ref$itemRatio = _ref.itemRatio,
    itemRatio = _ref$itemRatio === void 0 ? 1 : _ref$itemRatio,
    _ref$edgeSpaceRatio = _ref.edgeSpaceRatio,
    edgeSpaceRatio = _ref$edgeSpaceRatio === void 0 ? 0 : _ref$edgeSpaceRatio;
  var _useMemo = useMemo(function () {
      return getCurrentOffsetBounds({
        align: align,
        itemRatio: itemRatio,
        edgeSpaceRatio: edgeSpaceRatio,
        childrenLength: childrenLength
      });
    }, [align, edgeSpaceRatio, itemRatio, childrenLength]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    minCurrentOffset = _useMemo2[0],
    maxCurrentOffset = _useMemo2[1];
  var getLimitOffset = useCallback(function (offset) {
    if (!loop) {
      return Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));
    }
    return offset;
  }, [loop, minCurrentOffset, maxCurrentOffset]);
  var getLimitOffsetData = useCallback(function (prevOffset, newOffset) {
    var fromOffset = getLimitOffset(prevOffset);
    var toOffset = typeof newOffset === 'number' ? getLimitOffset(newOffset) : null;
    return {
      currentOffset: fromOffset,
      fromOffset: fromOffset,
      toOffset: toOffset
    };
  }, [getLimitOffset]);
  var getMinMaxOffset = function getMinMaxOffset(offsetData) {
    var currentOffset = offsetData.currentOffset,
      fromOffset = offsetData.fromOffset,
      toOffset = offsetData.toOffset;
    var offset = currentOffset;
    var newToOffset = toOffset;
    if (!loop) {
      offset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));
      if (newToOffset !== null) {
        newToOffset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, newToOffset));
      }
    }
    var minOffset = offset;
    var maxOffset = offset;
    if (newToOffset !== null && fromOffset !== null) {
      minOffset = Math.min(offset, fromOffset, newToOffset);
      maxOffset = Math.max(offset, fromOffset, newToOffset);
    }
    return [minOffset, maxOffset];
  };
  var offsetMargin = useMemo(function () {
    if (['center', 'centerConstrained'].includes(align)) {
      return (1 - itemRatio) / (2 * itemRatio);
    }
    return 0;
  }, [align, itemRatio]);
  return {
    getLimitOffset: getLimitOffset,
    getLimitOffsetData: getLimitOffsetData,
    getMinMaxOffset: getMinMaxOffset,
    offsetMargin: offsetMargin
  };
}

function useInteract(_ref) {
  var align = _ref.align,
    _ref$itemRatio = _ref.itemRatio,
    itemRatio = _ref$itemRatio === void 0 ? 1 : _ref$itemRatio,
    _ref$edgeSpaceRatio = _ref.edgeSpaceRatio,
    edgeSpaceRatio = _ref$edgeSpaceRatio === void 0 ? 0 : _ref$edgeSpaceRatio,
    loop = _ref.loop,
    disableSwipe = _ref.disableSwipe,
    childrenLength = _ref.childrenLength,
    setOffsetData = _ref.setOffsetData,
    onDrag = _ref.onDrag,
    onEnd = _ref.onEnd;
  var interactRef = useRef(null);
  var lastVelocityX = useRef(0);
  var deltaXRef = useRef(0);
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };
  var _getCurrentOffsetBoun = getCurrentOffsetBounds(baseProps),
    _getCurrentOffsetBoun2 = _slicedToArray(_getCurrentOffsetBoun, 2),
    minCurrentOffset = _getCurrentOffsetBoun2[0],
    maxCurrentOffset = _getCurrentOffsetBoun2[1];
  var _useOffset = useOffset(baseProps),
    getLimitOffsetData = _useOffset.getLimitOffsetData;
  var handlePan = useCallback(function (event) {
    onDrag === null || onDrag === void 0 ? void 0 : onDrag(event);
    // NOTE: interact dx는 현재 이벤트와 직전 이벤트의 거리만 반환하기 때문에 누적해서 저장
    deltaXRef.current = deltaXRef.current + event.dx;
    setOffsetData(function (_ref2) {
      var fromOffset = _ref2.fromOffset,
        currentOffset = _ref2.currentOffset;
      var _a, _b;
      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }
      var _ref3 = (_b = (_a = interactRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : {},
        _ref3$width = _ref3.width,
        width = _ref3$width === void 0 ? 0 : _ref3$width;
      var velocityX = event.velocityX;
      var newOffset = fromOffset - deltaXRef.current / width / itemRatio;
      lastVelocityX.current = velocityX;
      return {
        currentOffset: newOffset,
        fromOffset: fromOffset,
        toOffset: null
      };
    });
  }, [itemRatio, onDrag, setOffsetData]);
  var handlePanEnd = useCallback(function (event) {
    onEnd === null || onEnd === void 0 ? void 0 : onEnd(event);
    setOffsetData(function (_ref4) {
      var fromOffset = _ref4.fromOffset,
        currentOffset = _ref4.currentOffset;
      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }
      var velocity = event.velocity;
      var newOffset = Math.round(currentOffset);
      var direction = velocity.x < 0 ? 'right' : 'left';
      if (Math.abs(lastVelocityX.current) > 0.5 || Math.abs(event.velocityX) > 0.5) {
        newOffset = direction === 'left' ? Math.floor(currentOffset) : Math.ceil(currentOffset);
      }
      var offsetDelta;
      if (!loop) {
        if (currentOffset < minCurrentOffset) {
          offsetDelta = -Math.log(-currentOffset + minCurrentOffset + 1) / Math.log(8);
        } else if (currentOffset > maxCurrentOffset) {
          offsetDelta = Math.log(currentOffset - maxCurrentOffset + 1) / Math.log(8);
        }
      }
      lastVelocityX.current = 0;
      return getLimitOffsetData(currentOffset, newOffset, offsetDelta);
    });
  }, [getLimitOffsetData, loop, maxCurrentOffset, minCurrentOffset, onEnd, setOffsetData]);
  var handleInteract = useCallback(function (event) {
    switch (event.type) {
      case 'dragstart':
        deltaXRef.current = 0;
        setOffsetData(function (_ref5) {
          var currentOffset = _ref5.currentOffset;
          return getLimitOffsetData(currentOffset, null);
        });
        break;
      case 'dragmove':
        handlePan(event);
        break;
      case 'dragend':
        handlePanEnd(event);
        break;
    }
  }, [getLimitOffsetData, handlePan, handlePanEnd, setOffsetData]);
  useEffect(function () {
    if (disableSwipe) return;
    var node = interactRef.current;
    if (node) {
      interact(node).draggable({
        onstart: function onstart(event) {
          return handleInteract(event);
        },
        onmove: function onmove(event) {
          return handleInteract(event);
        },
        onend: function onend(event) {
          return handleInteract(event);
        },
        startAxis: 'x'
      });
    }
    return function () {
      if (node) {
        interact(node).unset();
      }
      lastVelocityX.current = 0;
    };
  }, [disableSwipe, handleInteract]);
  return {
    interactRef: interactRef
  };
}

function useAutoPlay(_ref) {
  var autoPlay = _ref.autoPlay,
    autoPlayInterval = _ref.autoPlayInterval,
    move = _ref.move;
  var autoPlayRef = useRef(null);
  var cleanupAutoPlay = useCallback(function () {
    if (autoPlayRef.current) {
      window.clearInterval(autoPlayRef.current);
      autoPlayRef.current = null;
    }
  }, []);
  var setupAutoPlay = useCallback(function () {
    if (!autoPlayRef.current) {
      autoPlayRef.current = window.setInterval(function () {
        return move('right');
      }, autoPlayInterval);
    }
  }, [autoPlayInterval, move]);
  useEffect(function () {
    if (autoPlay) {
      setupAutoPlay();
    }
    return function () {
      return cleanupAutoPlay();
    };
  }, [autoPlay, cleanupAutoPlay, setupAutoPlay]);
  return {
    cleanupAutoPlay: cleanupAutoPlay,
    setupAutoPlay: setupAutoPlay
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Carousel = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$itemRatio = props.itemRatio,
    initialItemRatio = _props$itemRatio === void 0 ? 1 : _props$itemRatio,
    _props$edgeSpaceRatio = props.edgeSpaceRatio,
    edgeSpaceRatio = _props$edgeSpaceRatio === void 0 ? 0 : _props$edgeSpaceRatio,
    _props$duration = props.duration,
    initialDuration = _props$duration === void 0 ? 350 : _props$duration,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? false : _props$loop,
    _props$autoPlay = props.autoPlay,
    autoPlay = _props$autoPlay === void 0 ? false : _props$autoPlay,
    _props$autoPlayInterv = props.autoPlayInterval,
    autoPlayInterval = _props$autoPlayInterv === void 0 ? DEFAULT_AUTO_PLAY_INTERVAL : _props$autoPlayInterv,
    _props$align = props.align,
    align = _props$align === void 0 ? 'center' : _props$align,
    children = props.children,
    renderControl = props.renderControl,
    renderPagination = props.renderPagination,
    className = props.className,
    initialOffset = props.initialOffset,
    onOffsetChange = props.onOffsetChange,
    _props$disableSwipe = props.disableSwipe,
    disableSwipe = _props$disableSwipe === void 0 ? false : _props$disableSwipe,
    renderEdgeDecoration = props.renderEdgeDecoration,
    nodeRef = props.nodeRef,
    length = props.length,
    _props$preloadCount = props.preloadCount,
    preloadCount = _props$preloadCount === void 0 ? 0 : _props$preloadCount,
    onRowsRendered = props.onRowsRendered;
  var _useState = useState({
      // 현재 offset
      currentOffset: initialOffset !== null && initialOffset !== void 0 ? initialOffset : 0,
      // duration 시작 전 offset
      fromOffset: null,
      // duration 끝나고 최종적으로 변경될 offset
      toOffset: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    offsetData = _useState2[0],
    setOffsetData = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    progressOffset = _useState4[0],
    setProgressOffset = _useState4[1];
  var _useState5 = useState(initialDuration),
    _useState6 = _slicedToArray(_useState5, 2),
    duration = _useState6[0],
    setDuration = _useState6[1];
  var currentOffset = offsetData.currentOffset,
    fromOffset = offsetData.fromOffset,
    toOffset = offsetData.toOffset;
  var childrenList = React__default.Children.toArray(children);
  if (!loop && renderEdgeDecoration) {
    childrenList = [renderEdgeDecoration(0)].concat(_toConsumableArray(childrenList), [renderEdgeDecoration(childrenList.length + 1)]);
  }
  var childrenLength = length !== null && length !== void 0 ? length : childrenList.length;
  var itemRatio = initialItemRatio === 0 ? 1 : Math.min(initialItemRatio, 1);
  var visibleChildrenCount = 1 / itemRatio;
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };
  var _getCurrentOffsetBoun = getCurrentOffsetBounds(baseProps),
    _getCurrentOffsetBoun2 = _slicedToArray(_getCurrentOffsetBoun, 2),
    minCurrentOffset = _getCurrentOffsetBoun2[0],
    maxCurrentOffset = _getCurrentOffsetBoun2[1];
  var _useOffset = useOffset(baseProps),
    getLimitOffset = _useOffset.getLimitOffset,
    getLimitOffsetData = _useOffset.getLimitOffsetData,
    getMinMaxOffset = _useOffset.getMinMaxOffset,
    offsetMargin = _useOffset.offsetMargin;
  var centerOffset = loop ? (Math.round(currentOffset) % childrenLength + childrenLength) % childrenLength : Math.round(currentOffset);
  var move = useCallback(function (direction) {
    var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    setDuration(null);
    setOffsetData(function (_ref) {
      var currentOffset = _ref.currentOffset;
      var deltaOffset = Math.abs(delta) * (direction === 'right' ? 1 : -1);
      var newOffset = Math.round(currentOffset + deltaOffset);
      return getLimitOffsetData(currentOffset, newOffset);
    });
  }, [getLimitOffsetData]);
  var _useAutoPlay = useAutoPlay({
      autoPlay: autoPlay,
      autoPlayInterval: autoPlayInterval,
      move: move
    }),
    cleanupAutoPlay = _useAutoPlay.cleanupAutoPlay,
    setupAutoPlay = _useAutoPlay.setupAutoPlay;
  var isDragging = useRef(false);
  var handleDrag = useCallback(function () {
    isDragging.current = true;
    setDuration(null);
    if (autoPlay) {
      cleanupAutoPlay();
    }
  }, [autoPlay, cleanupAutoPlay]);
  var handleDragEnd = useCallback(function () {
    if (autoPlay) {
      setupAutoPlay();
    }
    setTimeout(function () {
      isDragging.current = false;
    });
  }, [autoPlay, setupAutoPlay]);
  var _useInteract = useInteract(_objectSpread2(_objectSpread2({}, baseProps), {}, {
      disableSwipe: disableSwipe,
      setOffsetData: setOffsetData,
      onDrag: handleDrag,
      onEnd: handleDragEnd
    })),
    interactRef = _useInteract.interactRef;
  var _getMinMaxOffset = getMinMaxOffset(offsetData),
    _getMinMaxOffset2 = _slicedToArray(_getMinMaxOffset, 2),
    minOffset = _getMinMaxOffset2[0],
    maxOffset = _getMinMaxOffset2[1];
  var baseOffset = minOffset - offsetMargin - preloadCount;
  var startIndex = Math.floor(baseOffset);
  var renderedItemCount = useMemo(function () {
    return Math.ceil(baseOffset + visibleChildrenCount + (maxOffset - minOffset) + 2 * preloadCount) - startIndex;
  }, [baseOffset, maxOffset, minOffset, startIndex, preloadCount, visibleChildrenCount]);
  var isOverflow = useCallback(function (offset) {
    return !loop && (offset < 0 || offset > childrenLength - 1);
  }, [childrenLength, loop]);
  var virtualChildren = useMemo(function () {
    if (onRowsRendered) {
      onRowsRendered(startIndex, startIndex + renderedItemCount - 1);
    }
    return Array.from({
      length: Math.ceil(renderedItemCount)
    }).map(function (_, renderedIndex) {
      /** 전체 캐러셀 아이템 중 기준 아이템(baseOffset이 0) 위치 기준으로 측정된 index
       * @example
       * 전체 캐러셀 아이템이 10개 이고, 화면에 노출 중인 아이템 2개, preload count가 2이라면
       * |--preload 아이템--|--preload 아이템--|--노출 중인 아이템--|--노출 중인 아이템--|--preload 아이템--|--preload 아이템--|
       *  actualIndex: -2   actualIndex: -1   actualIndex: 0   actualIndex: 1   actualIndex: 2   actualIndex: 3
       *  index: 8          index: 9         index: 0          index: 1          index: 2         index: 3
       */
      var actualIndex = startIndex + renderedIndex;
      /** 전체 캐러셀 아이템 리스트에서 몇 번째 인지 */
      var index = (startIndex % childrenLength + childrenLength + renderedIndex) % childrenLength;
      return jsx(CarouselListItem, {
        css: /*#__PURE__*/css("width:", itemRatio * 100, "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        role: "group",
        "aria-roledescription": "slide",
        "aria-label": "".concat(index, " of ").concat(childrenLength),
        onClickCapture: function onClickCapture(e) {
          if (isDragging.current) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        children: !isOverflow(actualIndex) && childrenList[index]
      }, actualIndex);
    });
  }, [renderedItemCount, startIndex, childrenLength, childrenList, itemRatio, isOverflow, onRowsRendered]);
  var set = function set(targetOffset) {
    var deltaOffset = currentOffset - targetOffset;
    var direction = deltaOffset <= 0 ? 'right' : 'left';
    move(direction, deltaOffset);
  };
  var getProgress = useCallback(function () {
    var offset = loop ? currentOffset : Math.min(maxCurrentOffset, Math.max(minCurrentOffset, currentOffset));
    var baseOffset = minOffset - offsetMargin;
    var progressOffset = (baseOffset - startIndex + (offset - minOffset)) * itemRatio;
    return progressOffset;
  }, [itemRatio, currentOffset, loop, minOffset, minCurrentOffset, maxCurrentOffset, offsetMargin, startIndex]);
  var handleTransitionEnd = function handleTransitionEnd() {
    if (onOffsetChange) {
      onOffsetChange(currentOffset);
    }
    setOffsetData(function (_ref2) {
      var currentOffset = _ref2.currentOffset;
      return {
        currentOffset: currentOffset,
        fromOffset: null,
        toOffset: null
      };
    });
    setDuration(null);
  };
  useEffect(function () {
    if (loop) {
      return;
    }
    setOffsetData(function (_ref3) {
      var currentOffset = _ref3.currentOffset,
        toOffset = _ref3.toOffset;
      return getLimitOffsetData(currentOffset, toOffset);
    });
  }, [align, getLimitOffsetData, loop]);
  useEffect(function () {
    var animationId = requestAnimationFrame(function () {
      if (toOffset === null) {
        return;
      }
      setDuration(initialDuration);
      setOffsetData(function (_ref4) {
        var toOffset = _ref4.toOffset,
          currentOffset = _ref4.currentOffset;
        return {
          currentOffset: toOffset !== null && toOffset !== void 0 ? toOffset : currentOffset,
          fromOffset: fromOffset,
          toOffset: toOffset
        };
      });
    });
    return function () {
      return cancelAnimationFrame(animationId);
    };
  }, [toOffset, currentOffset, fromOffset, initialDuration]);
  useLayoutEffect(function () {
    var progress = getProgress();
    setProgressOffset(progress);
  }, [currentOffset, toOffset, getProgress]);
  useImperativeHandle(ref, function () {
    return {
      set: set
    };
  });
  var controlProps = {
    prev: function prev(countOfSlides) {
      return move('left', countOfSlides);
    },
    next: function next(countOfSlides) {
      return move('right', countOfSlides);
    },
    set: set,
    offset: getLimitOffset(centerOffset),
    length: childrenLength,
    isLeftEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === minCurrentOffset,
    isRightEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === maxCurrentOffset
  };
  var paginationProps = {
    currentPage: Math.floor(currentOffset) % childrenLength + 1,
    maxPage: childrenLength,
    onClick: function onClick(index) {
      return set(index);
    }
  };
  return jsxs(Container$1, {
    role: "region",
    "aria-roledescription": "carousel",
    className: className,
    ref: function ref(node) {
      if (nodeRef) {
        nodeRef(node);
      }
    },
    children: [jsx(CarouselListWrapper, {
      ref: interactRef,
      children: jsx(CarouselList, {
        style: {
          transform: "translateX(".concat(progressOffset * -100, "%)"),
          transition: "".concat(duration ? "transform ".concat(duration, "ms") : '')
        },
        onTransitionEnd: handleTransitionEnd,
        "aria-live": autoPlay ? 'off' : 'polite',
        children: virtualChildren
      })
    }), renderControl && renderControl(controlProps), renderPagination && jsx(Pagination, {
      css: renderPagination(paginationProps).props.variant === 'onDimmed' ? {
        top: "".concat(pxToRem(-18))
      } : undefined,
      children: renderPagination(paginationProps)
    })]
  });
});
var Container$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i4"
} : {
  target: "ec0uc7i4",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var CarouselListWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i3"
} : {
  target: "ec0uc7i3",
  label: "CarouselListWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "d3v9zr",
  styles: "overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var CarouselList = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i2"
} : {
  target: "ec0uc7i2",
  label: "CarouselList"
})(process.env.NODE_ENV === "production" ? {
  name: "154jlx0",
  styles: "display:flex;flex-wrap:nowrap;align-items:stretch;min-height:100%;padding:0;margin:0"
} : {
  name: "154jlx0",
  styles: "display:flex;flex-wrap:nowrap;align-items:stretch;min-height:100%;padding:0;margin:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var CarouselListItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i1"
} : {
  target: "ec0uc7i1",
  label: "CarouselListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "1dadcqx",
  styles: "flex:0 0 auto;-moz-user-select:-moz-none;-webkit-user-select:none;-ms-user-select:none;user-select:none;box-sizing:border-box;padding:0;margin:0;*{-webkit-user-drag:none;-khtml-user-drag:none;-moz-user-drag:none;-o-user-drag:none;user-drag:none;}"
} : {
  name: "1dadcqx",
  styles: "flex:0 0 auto;-moz-user-select:-moz-none;-webkit-user-select:none;-ms-user-select:none;user-select:none;box-sizing:border-box;padding:0;margin:0;*{-webkit-user-drag:none;-khtml-user-drag:none;-moz-user-drag:none;-o-user-drag:none;user-drag:none;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var Pagination = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i0"
} : {
  target: "ec0uc7i0",
  label: "Pagination"
})("position:relative;top:", pxToRem(18), ";");

var _excluded$7 = ["size", "icon"];
/**
 * @deprecated ODS의 IconButton을 사용해주세요. 만약 디자인상 ODS의 IconButton을 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function IconButton(_ref) {
  var size = _ref.size,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  var _a;
  return jsx(Button$2, _objectSpread2(_objectSpread2({}, rest), {}, {
    size: size,
    css: cssBaseIconButton(size),
    children: jsx(Icon, {
      size: (_a = icon.size) !== null && _a !== void 0 ? _a : 18,
      name: icon.name,
      fill: icon === null || icon === void 0 ? void 0 : icon.fill
    })
  }));
}

var _excluded$6 = ["iconName", "position", "hidden", "variant", "className"];
var _templateObject$1, _templateObject2, _templateObject3;
function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function cssButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return /*#__PURE__*/css("border-radius:", pxToRem(24), ";background-color:", theme.content.base6, ";box-shadow:0 ", pxToRem(2), " ", pxToRem(5), " ", theme.shadow.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;"));
    case 'onContents':
      return /*#__PURE__*/css("border-radius:", pxToRem(24), ";background-color:", theme.dim.thin, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;"));
    case 'list':
      return /*#__PURE__*/css("background-color:", theme.content.base6, ";border:", pxToRem(1), " solid ", theme.content.base4, ";border-radius:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;"));
  }
}
function cssHoverButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return HOVER(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n          background-color: ", ";\n      "])), theme.interactive.transparent);
    case 'onContents':
      return HOVER(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.dim.basic);
    case 'list':
      return HOVER(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.interactive.transparent);
  }
}
function cssFont(theme, variant) {
  switch (variant) {
    case 'basic':
      return theme.content.base1;
    case 'onContents':
      return theme.content.white;
    case 'list':
      return theme.content.base1;
  }
}
var _ref$4 = process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "o7wsxo-css",
  styles: "display:none;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};
function CarouselControlButton(_ref2) {
  var iconName = _ref2.iconName,
    position = _ref2.position,
    _ref2$hidden = _ref2.hidden,
    hidden = _ref2$hidden === void 0 ? false : _ref2$hidden,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'basic' : _ref2$variant,
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded$6);
  var theme = useTheme();
  return jsx("div", {
    css: [/*#__PURE__*/css("position:absolute;top:50%;transform:translate(-50%, -50%);left:", position === 'left' ? '0' : '100', "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), hidden && _ref$4],
    className: className,
    children: jsx(IconButton, _objectSpread2({
      type: "button",
      size: 50,
      variant: "primary1",
      icon: {
        name: iconName,
        size: 24,
        fill: function fill(theme) {
          return cssFont(theme, variant);
        }
      },
      css: [/*#__PURE__*/css("width:", pxToRem(48), ";height:", pxToRem(48), ";display:flex;align-items:center;justify-content:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), cssButton(theme, variant), cssHoverButton(theme, variant)]
    }, rest))
  });
}

function CarouselControl(_ref) {
  var prev = _ref.prev,
    next = _ref.next,
    variant = _ref.variant,
    _ref$isLeftEnd = _ref.isLeftEnd,
    isLeftEnd = _ref$isLeftEnd === void 0 ? false : _ref$isLeftEnd,
    _ref$isRightEnd = _ref.isRightEnd,
    isRightEnd = _ref$isRightEnd === void 0 ? false : _ref$isRightEnd,
    className = _ref.className;
  return jsxs(Fragment$1, {
    children: [jsx(CarouselControlButton, {
      iconName: "chevron_left",
      position: "left",
      onClick: function onClick() {
        return prev();
      },
      "aria-label": "\uC774\uC804",
      variant: variant,
      hidden: isLeftEnd,
      className: className
    }), jsx(CarouselControlButton, {
      iconName: "chevron_right",
      position: "right",
      onClick: function onClick() {
        return next();
      },
      "aria-label": "\uB2E4\uC74C",
      variant: variant,
      hidden: isRightEnd,
      className: className
    })]
  });
}

var _excluded$5 = ["contentRef", "children", "gradation", "gap", "fixed", "variant", "hiddenBreakpoints", "className", "contentClassName", "itemClassName", "buttonClassName"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$3 = process.env.NODE_ENV === "production" ? {
  name: "1doeymb",
  styles: "@media(hover: hover){&:hover{z-index:1;}}"
} : {
  name: "12r4i78-css",
  styles: "@media(hover: hover){&:hover{z-index:1;}};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "w8k1h1",
  styles: "scroll-snap-type:x mandatory;overflow:auto;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"
} : {
  name: "1ljqlap-css",
  styles: "scroll-snap-type:x mandatory;overflow:auto;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var _ref3$1 = process.env.NODE_ENV === "production" ? {
  name: "1442dl5",
  styles: "display:flex;margin:0;padding:0;overflow:hidden;&>li:last-of-type{margin-right:0;}"
} : {
  name: "6127sm-css",
  styles: "display:flex;margin:0;padding:0;overflow:hidden;&>li:last-of-type{margin-right:0;};label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "3q4ecs",
  styles: "position:relative;z-index:0"
} : {
  name: "1fd8nxm-css",
  styles: "position:relative;z-index:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var _ref5 = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1uvyp5k-css",
  styles: "position:relative;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var CarouselScrollControl = /*#__PURE__*/React__default.forwardRef(function (_ref6, ref) {
  var contentRef = _ref6.contentRef,
    children = _ref6.children,
    _ref6$gradation = _ref6.gradation,
    gradation = _ref6$gradation === void 0 ? true : _ref6$gradation,
    _ref6$gap = _ref6.gap,
    gap = _ref6$gap === void 0 ? 8 : _ref6$gap,
    _ref6$fixed = _ref6.fixed,
    fixed = _ref6$fixed === void 0 ? false : _ref6$fixed,
    _ref6$variant = _ref6.variant,
    variant = _ref6$variant === void 0 ? 'basic' : _ref6$variant,
    _ref6$hiddenBreakpoin = _ref6.hiddenBreakpoints,
    hiddenBreakpoints = _ref6$hiddenBreakpoin === void 0 ? ['mobile', 'tablet'] : _ref6$hiddenBreakpoin,
    className = _ref6.className,
    contentClassName = _ref6.contentClassName,
    itemClassName = _ref6.itemClassName,
    buttonClassName = _ref6.buttonClassName,
    rest = _objectWithoutProperties(_ref6, _excluded$5);
  var _useState = useState({
      startIdx: 0,
      endIdx: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    fullVisibleItem = _useState2[0],
    setFullVisibleItem = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hovered = _useState4[0],
    setHovered = _useState4[1];
  var animateRef = useRef(null);
  var carouselRef = useRef(null);
  var carouselItemRefs = useRef([]);
  var breakpoint = useResponsive().breakpoint;
  var _useMatchMedia = useMatchMedia('(pointer: coarse)'),
    matches = _useMatchMedia.matches;
  var isHidden = matches || hiddenBreakpoints.some(function (hiddenBreakpoint) {
    return hiddenBreakpoint === breakpoint;
  });
  var theme = useTheme();
  var childrenCount = React__default.Children.count(children);
  var updatePosition = useCallback(function () {
    var carousel = carouselRef.current;
    if (!carousel) return;
    var carouselRect = carousel.getBoundingClientRect();
    var carouselStartX = carouselRect.left;
    var carouselEndX = carouselStartX + carouselRect.width;
    var startItemIdx;
    var endItemIdx;
    for (var i = 0; i < childrenCount; i += 1) {
      var item = carouselItemRefs.current[i];
      var itemRect = (item === null || item === void 0 ? void 0 : item.getBoundingClientRect()) || {
        left: 0,
        width: 0
      };
      var itemStartX = itemRect.left;
      var itemEndX = itemStartX + itemRect.width;
      var isFullVisibleItem = item && Math.floor(carouselStartX) <= Math.floor(itemStartX) && Math.floor(itemEndX) <= Math.floor(carouselEndX);
      if (isFullVisibleItem) {
        if (startItemIdx === undefined) {
          startItemIdx = i;
        }
        endItemIdx = i;
      }
    }
    setFullVisibleItem({
      startIdx: startItemIdx !== null && startItemIdx !== void 0 ? startItemIdx : 0,
      endIdx: endItemIdx !== null && endItemIdx !== void 0 ? endItemIdx : 0
    });
  }, [setFullVisibleItem, childrenCount]);
  var scrollToOffset = useCallback(function (targetOffset) {
    if (animateRef.current) {
      cancelAnimationFrame(animateRef.current);
    }
    var startTime = Date.now();
    var carousel = carouselRef.current;
    if (!carousel) return;
    var currentCarouselStartX = carousel.scrollLeft;
    var lastCarouselStartX = carousel.scrollWidth - carousel.offsetWidth;
    var nextCarouselStartX = Math.max(0, Math.min(lastCarouselStartX, targetOffset));
    var handleScroll = function handleScroll() {
      var elapsed = Date.now() - startTime;
      var progress = Math.min(elapsed / 350, 1);
      var carousel = carouselRef.current;
      if (carousel) {
        carousel.scrollLeft = currentCarouselStartX + (nextCarouselStartX - currentCarouselStartX) * quadInOut(progress);
      }
      if (progress < 1) {
        animateRef.current = requestAnimationFrame(handleScroll);
      }
    };
    animateRef.current = requestAnimationFrame(handleScroll);
  }, []);
  var moveRight = useCallback(function (basis) {
    var _a, _b;
    var startItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.endIdx + 1;
    if (startItemIdx >= childrenCount) return;
    if (!carouselRef.current) return;
    var startItem = carouselItemRefs.current[startItemIdx];
    if (!startItem) return;
    var carouselWidth = carouselRef.current.offsetWidth;
    var endItemIdx = startItemIdx;
    var endItemOffsetRight = 0;
    while (endItemIdx < childrenCount) {
      var item = carouselItemRefs.current[endItemIdx];
      var itemOffsetRight = ((_a = item === null || item === void 0 ? void 0 : item.offsetLeft) !== null && _a !== void 0 ? _a : 0) + ((_b = item === null || item === void 0 ? void 0 : item.offsetWidth) !== null && _b !== void 0 ? _b : 0);
      var carouselOffsetRight = startItem.offsetLeft + carouselWidth;
      var isNotFullVisibleItem = !item || carouselOffsetRight < itemOffsetRight;
      if (isNotFullVisibleItem || !item) break;
      endItemOffsetRight = (item === null || item === void 0 ? void 0 : item.offsetLeft) + (item === null || item === void 0 ? void 0 : item.offsetWidth);
      endItemIdx += 1;
    }
    endItemIdx -= 1;
    var carouselOffsetLeft = (startItem.offsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, childrenCount, scrollToOffset]);
  var moveLeft = useCallback(function (basis) {
    var endItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.startIdx - 1;
    if (endItemIdx < 0) return;
    if (!carouselRef.current) return;
    var endItem = carouselItemRefs.current[endItemIdx];
    if (!endItem) return;
    var endItemOffsetRight = endItem.offsetLeft + endItem.offsetWidth;
    var carouselWidth = carouselRef.current.offsetWidth;
    var startItemIdx = endItemIdx;
    var startItemOffsetLeft = 0;
    while (startItemIdx >= 0) {
      var item = carouselItemRefs.current[startItemIdx];
      var _carouselOffsetLeft = endItemOffsetRight - carouselWidth;
      var isNotFullVisibleItem = !item || item.offsetLeft < _carouselOffsetLeft;
      if (isNotFullVisibleItem || !item) break;
      startItemOffsetLeft = item.offsetLeft;
      startItemIdx -= 1;
    }
    startItemIdx += 1;
    var carouselOffsetLeft = (startItemOffsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, scrollToOffset]);
  var scrollTo = useCallback(function (index) {
    if (index < fullVisibleItem.startIdx) {
      moveRight(index);
    } else if (index > fullVisibleItem.endIdx) {
      moveLeft(index);
    } else ;
  }, [fullVisibleItem, moveLeft, moveRight]);
  var getFullVisibleItem = useCallback(function () {
    return fullVisibleItem;
  }, [fullVisibleItem]);
  useImperativeHandle(ref, function () {
    return {
      getFullVisibleItem: getFullVisibleItem,
      scrollTo: scrollTo,
      moveLeft: moveLeft,
      moveRight: moveRight
    };
  });
  useEffect(function () {
    updatePosition();
    var resizeAnimationId = null;
    var handleResize = function handleResize() {
      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }
      resizeAnimationId = requestAnimationFrame(function () {
        resizeAnimationId = null;
        updatePosition();
      });
    };
    var resizeObserver = null;
    var carousel = carouselRef.current;
    if (window.ResizeObserver && carousel) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(carousel);
    } else {
      window.addEventListener('resize', handleResize);
    }
    return function () {
      if (animateRef.current) {
        cancelAnimationFrame(animateRef.current);
      }
      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [updatePosition]);
  var isLeftEnd = fullVisibleItem.startIdx === 0;
  var isRightEnd = fullVisibleItem.endIdx === childrenCount - 1;
  return jsxs("div", _objectSpread2(_objectSpread2({
    css: _ref5,
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    className: className
  }, rest), {}, {
    children: [jsx("div", {
      css: _ref4,
      children: jsx("ul", {
        onScroll: updatePosition,
        className: contentClassName,
        ref: function ref(node) {
          carouselRef.current = node;
          if (contentRef) {
            contentRef(node);
          }
        },
        css: [_ref3$1, isHidden && _ref2$1, !isRightEnd && gradation && /*#__PURE__*/css("&:after{content:'';position:absolute;top:0;right:-1px;width:100px;height:100%;background:", "linear-gradient(90deg, ".concat(hexToRgba(theme.background.base, 0), " 0%, ").concat(theme.background.base, " 100%)"), ";pointer-events:none;padding:0;margin:0;z-index:1;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
        children: Children.map(children, function (child, index) {
          return jsx("li", {
            className: itemClassName,
            css: /*#__PURE__*/css("margin:0 ", pxToRem(gap), " 0 0;padding:0;flex-shrink:0;scroll-snap-align:start;", MEDIA_QUERY.min('tablet', _ref$3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
            ref: function ref(node) {
              carouselItemRefs.current[index] = node;
            },
            children: child
          }, _typeof(child) === 'object' && child != null && 'key' in child ? child.key : undefined);
        })
      })
    }), (fixed || hovered) && jsxs(Fragment$1, {
      children: [jsx(CarouselControlButton, {
        iconName: "chevron_left",
        position: "left",
        onClick: function onClick() {
          return moveLeft();
        },
        "aria-label": "\uC774\uC804",
        hidden: isHidden || isLeftEnd,
        variant: variant,
        className: buttonClassName
      }), jsx(CarouselControlButton, {
        iconName: "chevron_right",
        position: "right",
        onClick: function onClick() {
          return moveRight();
        },
        "aria-label": "\uB2E4\uC74C",
        hidden: isHidden || isRightEnd,
        variant: variant,
        className: buttonClassName
      })]
    })]
  }));
});

var _excluded$4 = ["number", "variant"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$2 = process.env.NODE_ENV === "production" ? {
  name: "tmxs11",
  styles: "position:relative;display:inline-block;font-size:0;line-height:1"
} : {
  name: "x8b7wt-css",
  styles: "position:relative;display:inline-block;font-size:0;line-height:1;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
function Ranking(_ref2) {
  var number = _ref2.number,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded$4);
  var theme = useTheme();
  return jsxs("div", _objectSpread2(_objectSpread2({}, props), {}, {
    css: _ref$2,
    children: [jsx("svg", {
      width: 26,
      height: 30,
      fill: "none",
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13 24.25-13 5V0h26v29.25l-13-5Z",
        fill: function () {
          switch (variant) {
            case 'primary1':
              return hexToRgba(theme.content.primary1.basic, 0.86);
            case 'dim':
              return theme.dim.basic;
            default:
              return;
          }
        }()
      })
    }), jsx("span", {
      css: /*#__PURE__*/css("position:absolute;top:", pxToRem(4), ";left:0;right:0;", FONT_STYLE.body3, ";font-weight:700;color:", theme.content.white, ";text-align:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: number
    })]
  }));
}

var _excluded$3 = ["component"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "1diuouz-css",
  styles: "cursor:pointer;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "ilqpfg",
  styles: "display:inline-flex;align-items:center;max-width:100%"
} : {
  name: "1lrem0l-css",
  styles: "display:inline-flex;align-items:center;max-width:100%;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "dlv2hg",
  styles: "flex:1;display:flex;align-items:flex-start;flex-direction:column;min-width:0"
} : {
  name: "ntae1h-css",
  styles: "flex:1;display:flex;align-items:flex-start;flex-direction:column;min-width:0;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function SectionTitle(_ref4) {
  var className = _ref4.className,
    size = _ref4.size,
    title = _ref4.title,
    caption = _ref4.caption,
    badge = _ref4.badge,
    count = _ref4.count,
    moreButton = _ref4.moreButton,
    customButton = _ref4.customButton,
    hasArrow = _ref4.hasArrow,
    _onClick = _ref4.onClick;
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var handleClickChild = function handleClickChild(e) {
    if (!_onClick) return;
    e.stopPropagation();
    _onClick(e);
  };
  return jsxs("div", {
    className: className,
    onClick: function onClick() {
      if (!isMobile) return;
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    css: [/*#__PURE__*/css("display:flex;align-items:center;justify-content:space-between;width:100%;padding:", pxToRem(20), " 0;font-size:0;line-height:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))],
    children: [!!badge && jsx(CircleBadge, {
      type: "fill",
      variant: "primary2",
      size: 24,
      css: /*#__PURE__*/css("margin-right:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: badge
    }), jsxs("div", {
      css: _ref3,
      children: [jsxs("div", {
        onClick: handleClickChild,
        css: [_ref2, _onClick && cssClickable],
        children: [jsx("strong", {
          css: [/*#__PURE__*/css("overflow:hidden;display:inline-block;font-weight:700;color:", theme.content.base1, ";letter-spacing:", pxToRem(-0.3), ";white-space:nowrap;text-overflow:ellipsis;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), cssFontSize(size)],
          children: title
        }), !!count && jsx("span", {
          css: [/*#__PURE__*/css("display:inline-block;margin-left:", pxToRem(6), ";", size === 'large' && FONT_STYLE.title2, ";", size === 'small' && FONT_STYLE.title3, ";font-weight:700;color:", theme.content.primary1.basic, ";letter-spacing:", pxToRem(-0.3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), cssFontSize(size)],
          children: count
        })]
      }), caption && jsxs("div", {
        onClick: function onClick(e) {
          if (!caption.onClick) return;
          e.stopPropagation();
          caption.onClick(e);
        },
        css: [/*#__PURE__*/css("display:inline-flex;align-items:center;max-width:100%;margin-top:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), caption.onClick && cssClickable],
        children: [jsx("span", {
          css: /*#__PURE__*/css("overflow:hidden;display:inline-block;", FONT_STYLE.subTitle2, ";font-weight:400;color:", theme.content.base1, ";letter-spacing:", pxToRem(-0.3), ";white-space:nowrap;text-overflow:ellipsis;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
          children: caption.text
        }), caption.icon && jsx(Icon, {
          name: caption.icon,
          size: 18,
          css: /*#__PURE__*/css("margin-left:", pxToRem(2), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
        })]
      })]
    }), jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;height:0;margin-left:", pxToRem(10), ";&:empty{margin-left:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      children: [moreButton && jsx("button", {
        type: "button",
        onClick: handleClickChild,
        css: [/*#__PURE__*/css(RESET_BUTTON, " ", FONT_STYLE.subTitle1, " font-weight:700;color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")), cssClickable],
        children: _typeof(moreButton) === 'object' && moreButton.text || '더보기'
      }), customButton && function () {
        var component = customButton.component,
          props = _objectWithoutProperties(customButton, _excluded$3);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var CustomButton = component;
        return jsx(CustomButton, _objectSpread2(_objectSpread2({}, props), {}, {
          size: 32,
          onClick: handleClickChild
        }));
      }(), hasArrow && jsx(Icon, {
        size: 24,
        name: "chevron_thick_right",
        fill: function fill(theme) {
          return theme.content.base1;
        },
        onClick: handleClickChild,
        css: _ref$1
      })]
    })]
  });
}
var cssFontSize = function cssFontSize(size) {
  switch (size) {
    case 'large':
      return FONT_STYLE.title2;
    case 'small':
      return FONT_STYLE.title3;
    default:
      return;
  }
};
var cssClickable = process.env.NODE_ENV === "production" ? {
  name: "1oqvtbd",
  styles: "cursor:pointer;@media(hover: hover){&:hover{opacity:.5;}}"
} : {
  name: "11bn8kc-cssClickable",
  styles: "cursor:pointer;@media(hover: hover){&:hover{opacity:.5;}};label:cssClickable;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var _templateObject;
var _excluded$2 = ["multiple", "type", "accept", "onFileSelected", "onClick"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "13qwn8x-css",
  styles: "display:block;label:css;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function ImageUploadButtonImpl(_ref2, ref) {
  var multiple = _ref2.multiple,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'button' : _ref2$type,
    _ref2$accept = _ref2.accept,
    accept = _ref2$accept === void 0 ? 'image/*' : _ref2$accept,
    onFileSelected = _ref2.onFileSelected,
    onButtonClick = _ref2.onClick,
    buttonProps = _objectWithoutProperties(_ref2, _excluded$2);
  var inputRef = useRef(null);
  var theme = useTheme();
  var handleClickButton = function handleClickButton(ev) {
    var _a;
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(ev);
  };
  return jsxs("button", _objectSpread2(_objectSpread2({
    ref: ref,
    onClick: handleClickButton,
    css: /*#__PURE__*/css(RESET_BUTTON, ";", FONT_STYLE.body3, ";width:", pxToRem(72), ";height:", pxToRem(72), ";font-weight:700;text-align:center;border-radius:", pxToRem(4), ";color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";cursor:pointer;", HOVER(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive.transparent), ";&:disabled{color:", theme.content.base3, ";pointer-events:none;background-color:", theme.content.base4, ";border:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    type: type
  }, buttonProps), {}, {
    children: [jsx("input", {
      hidden: true,
      ref: inputRef,
      type: "file",
      multiple: multiple,
      accept: accept,
      onChange: onFileSelected
    }), jsx(Icon, {
      size: 24,
      css: /*#__PURE__*/css("margin-bottom:", pxToRem(6.5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      name: "camera"
    }), jsx("span", {
      css: _ref,
      children: "\uC0AC\uC9C4 \uC62C\uB9AC\uAE30"
    })]
  }));
}
var ImageUploadButton = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(ImageUploadButtonImpl));

function ImageAttachedItem(_ref) {
  var imageUrl = _ref.imageUrl,
    onDelete = _ref.onDelete,
    _ref$deletable = _ref.deletable,
    deletable = _ref$deletable === void 0 ? true : _ref$deletable,
    className = _ref.className,
    alt = _ref.alt;
  var theme = useTheme();
  return jsxs("figure", {
    className: className,
    css: /*#__PURE__*/css("width:", pxToRem(72), ";height:", pxToRem(72), ";display:inline-block;vertical-align:bottom;position:relative;overflow:hidden;&:after{position:absolute;content:\"\";top:0;left:0;right:0;bottom:0;border-radius:", pxToRem(4), ";border:", pxToRem(1), " solid ", theme.outline, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: [jsx(ResizeImage$1, {
      src: imageUrl,
      intrinsicAspect: 1,
      intrinsicInitialHeight: 72,
      quality: 70,
      objectFit: "cover",
      alt: alt,
      css: /*#__PURE__*/css("box-sizing:border-box;width:", pxToRem(72), ";height:", pxToRem(72), ";border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))
    }), deletable && jsx("button", {
      css: /*#__PURE__*/css(RESET_BUTTON, ";display:flex;z-index:3;align-items:center;justify-content:center;position:absolute;top:", pxToRem(6), ";right:", pxToRem(6), ";cursor:pointer;&:hover{opacity:0.6;}&:before{content:'';position:absolute;background-color:", theme.content.white, ";border-radius:50%;width:", pxToRem(15), ";height:", pxToRem(15), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
      onClick: onDelete,
      children: jsx(DismissCircleIcon, {
        css: /*#__PURE__*/css("color:", theme.content.base1, ";border-radius:50%;position:relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
        size: 24
      })
    })]
  });
}

function LinearProgressBar(_ref) {
  var total = _ref.total,
    variant = _ref.variant,
    currentStep = _ref.currentStep,
    width = _ref.width,
    className = _ref.className;
  var theme = useTheme();
  var progress = Math.max(Math.min(currentStep / total * 100, 100), 0);
  return jsx("div", {
    className: className,
    css: /*#__PURE__*/css("background-color:", theme.content.base5, ";width:", typeof width === 'number' ? pxToRem(width) : '100%', ";height:", pxToRem(6), ";margin-top:auto;margin-bottom:auto;overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")),
    children: jsx(StyledDiv, {
      progress: progress,
      variant: variant
    })
  });
}
var StyledDiv = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e80j02f0"
} : {
  target: "e80j02f0",
  label: "StyledDiv"
})("transform:translateX(", function (_ref2) {
  var progress = _ref2.progress;
  return -100 + progress;
}, "%);transform-origin:center left;transition:transform 1.5s ease;background-color:", function (_ref3) {
  var theme = _ref3.theme,
    variant = _ref3.variant;
  return theme.content[variant].basic;
}, ";border-top-right-radius:", pxToRem(10), ";border-bottom-right-radius:", pxToRem(10), ";height:100%;transition-duration:0.2s;transition-timing-function:ease-in-out;");

var FETCH_STATUS = {
  LOADED: 'loaded',
  NON_LOAD: 'non-load'
};

var createScrollStorage = function createScrollStorage(tabId) {
  var sessionKey = "scroll-".concat(tabId);
  return {
    get: function get() {
      var scrollInfo = sessionStorage.getItem(sessionKey);
      return scrollInfo ? JSON.parse(scrollInfo) : undefined;
    },
    set: function set(value) {
      sessionStorage.setItem(sessionKey, value);
    },
    reset: function reset() {
      sessionStorage.removeItem(sessionKey);
    }
  };
};
/**
 * @param length
 * @returns length개의 null을 채운 배열
 */
var createNullArray = function createNullArray(length) {
  return Array.from({
    length: length
  }).map(function (_) {
    return null;
  });
};
/**
 * findPageByIndex
 * index보다 작으면서 가장 가까운 배열 요소의 index(page)를 찾아서 반환합니다.
 * @param {number[]} array 각 page의 offset이 담긴 배열
 * @param {number} index 찾고자 하는 아이템 index
 */
var findPageByIndex = function findPageByIndex(array, index) {
  var start = 0;
  var end = array.length - 1;
  while (start <= end) {
    var mid = Math.floor((start + end) / 2);
    var isLastItem = array.length - 1 === mid;
    var currValue = array[mid];
    var nextValue = isLastItem ? Number.MAX_SAFE_INTEGER : array[mid + 1];
    if (index < currValue) {
      end = mid - 1;
    } else if (currValue <= index && index < nextValue) {
      return mid;
    } else {
      start = mid + 1;
    }
  }
  return 0;
};

var _excluded$1 = ["page"];
var MIN_PAGE$1 = 1;
/**
 * info의 개수가 per보다 큰 경우, info를 per개씩 나누어 저장한 pageInfo를 리턴합니다.
 */
var formatPageInfo = function formatPageInfo(_ref) {
  var page = _ref.page,
    info = _ref.info,
    per = _ref.per;
  var itemStatus = info.itemStatus,
    items = info.items,
    hasNext = info.hasNext;
  var pageCount = items.length !== 0 ? Math.ceil(items.length / per) : 0;
  var formattedPageInfo = {};
  Array.from({
    length: pageCount
  }).forEach(function (_, index) {
    var isLastPage = index === pageCount - 1;
    formattedPageInfo = _objectSpread2(_objectSpread2({}, formattedPageInfo), {}, _defineProperty({}, page + index, {
      itemStatus: itemStatus,
      items: items.slice(index * per, (index + 1) * per),
      hasNext: isLastPage ? hasNext : true
    }));
  });
  return formattedPageInfo;
};
var getInitialDataInfo = function getInitialDataInfo(initialData, per) {
  if (!initialData) return {};
  var page = initialData.page,
    pageInfo = _objectWithoutProperties(initialData, _excluded$1);
  return formatPageInfo({
    page: page,
    info: _objectSpread2({
      itemStatus: FETCH_STATUS.LOADED
    }, pageInfo),
    per: per
  });
};
function usePageInfo(_ref2) {
  var per = _ref2.per,
    tabId = _ref2.tabId,
    originalInitialData = _ref2.initialData;
  var _useState = useState(getInitialDataInfo(originalInitialData, per)),
    _useState2 = _slicedToArray(_useState, 2),
    pageInfo = _useState2[0],
    setPageInfo = _useState2[1];
  var maxPage = useRef(null);
  useEffect(function () {
    var actualMaxPage = maxPage.current;
    if (actualMaxPage == null) return;
    var isPageInfoAlreadyFiltered = Number(findLastKey(pageInfo)) <= actualMaxPage;
    if (isPageInfoAlreadyFiltered) return;
    setPageInfo(function (pageInfo) {
      var pageList = Object.keys(pageInfo);
      var omittedPageList = pageList.filter(function (page) {
        return Number(page) > actualMaxPage;
      }).map(function (page) {
        return Number(page);
      });
      return omit(pageInfo, omittedPageList);
    });
  }, [pageInfo]);
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  var count = useMemo(function () {
    return Object.values(pageInfo).reduce(function (prev, _ref3) {
      var items = _ref3.items;
      return prev + items.length;
    }, 0);
  }, [pageInfo]);
  var getPageInfo = useCallback(function (page) {
    return pageInfo[page];
  }, [pageInfo]);
  var resetPageInfo = useCallback(function () {
    setPageInfo({});
  }, []);
  var addPageInfo = useCallback(function (_ref4) {
    var page = _ref4.page,
      info = _ref4.info;
    setPageInfo(function (pageInfo) {
      return _objectSpread2(_objectSpread2({}, pageInfo), {}, _defineProperty({}, page, info));
    });
  }, []);
  var getPageFromIndex = useCallback(function (index) {
    var page = 1;
    for (var i = 0; i < Object.values(pageInfo).length; i++) {
      var items = Object.values(pageInfo)[i].items;
      if (index + 1 <= items.length) break;
      index -= items.length;
      page++;
    }
    return {
      page: page,
      pageIndex: index
    };
  }, [pageInfo]);
  var getInitialPageInfo = useCallback(function () {
    if (originalInitialData === null) return {};
    return getInitialDataInfo(originalInitialData, per);
  }, [originalInitialData, per]);
  var createNonLoadPageInfo = useCallback(function (itemCount) {
    return formatPageInfo({
      page: MIN_PAGE$1,
      info: {
        itemStatus: FETCH_STATUS.NON_LOAD,
        items: createNullArray(itemCount),
        hasNext: true
      },
      per: per
    });
  }, [per]);
  /**
   * 스크롤 복귀할 page index와 initialData의 마지막 page index를 비교한 후
   * 더 큰 page까지 non-load로 데이터를 채워 반환합니다.
   */
  var getInitialNonLoadPageInfo = useCallback(function () {
    var _a;
    var initialLastPage = (_a = originalInitialData === null || originalInitialData === void 0 ? void 0 : originalInitialData.page) !== null && _a !== void 0 ? _a : 1;
    var scrollInfo = sessionScrollStorage.get();
    if (!(scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollEndItemIndex)) {
      return createNonLoadPageInfo(initialLastPage * per);
    }
    var scrollItemIndex = Number(scrollInfo.scrollEndItemIndex);
    var scrollPage = Math.floor(scrollItemIndex / per) + 1;
    return createNonLoadPageInfo(Math.max(scrollPage, initialLastPage) * per);
  }, [originalInitialData, sessionScrollStorage, createNonLoadPageInfo, per]);
  var initPageInfo = useCallback(function () {
    var initialPageInfo = getInitialPageInfo();
    var initialNonLoadPageInfo = getInitialNonLoadPageInfo();
    maxPage.current = null;
    setPageInfo(_objectSpread2(_objectSpread2({}, initialNonLoadPageInfo), initialPageInfo));
  }, [getInitialNonLoadPageInfo, getInitialPageInfo]);
  return {
    maxPage: maxPage,
    count: count,
    getPageInfo: getPageInfo,
    addPageInfo: addPageInfo,
    resetPageInfo: resetPageInfo,
    initPageInfo: initPageInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function useLoadingPageList() {
  var loadingPageList = useRef(new Set());
  var addLoadingPage = useCallback(function (newPage) {
    loadingPageList.current.add(newPage);
  }, []);
  var removeLoadingPage = useCallback(function (targetPage) {
    loadingPageList.current.delete(targetPage);
  }, []);
  var isLoadingPage = useCallback(function (page) {
    return loadingPageList.current.has(page);
  }, []);
  return {
    addLoadingPage: addLoadingPage,
    removeLoadingPage: removeLoadingPage,
    isLoadingPage: isLoadingPage
  };
}

function usePagedInfiniteList(_ref) {
  var initialData = _ref.initialData,
    initialDataPending = _ref.initialDataPending,
    per = _ref.per,
    tabId = _ref.tabId,
    getItemList = _ref.getItemList;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var shouldInit = useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual);
  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }
  var _usePageInfo = usePageInfo({
      per: per,
      tabId: tabId,
      initialData: initialData
    }),
    maxPage = _usePageInfo.maxPage,
    count = _usePageInfo.count,
    getPageInfo = _usePageInfo.getPageInfo,
    addPageInfo = _usePageInfo.addPageInfo,
    initPageInfo = _usePageInfo.initPageInfo,
    getPageFromIndex = _usePageInfo.getPageFromIndex;
  var _useLoadingPageList = useLoadingPageList(),
    addLoadingPage = _useLoadingPageList.addLoadingPage,
    removeLoadingPage = _useLoadingPageList.removeLoadingPage,
    isLoadingPage = _useLoadingPageList.isLoadingPage;
  /**
   * @param page fetch 할 페이지
   * @param fetchStatus fetch하는 status(non-load/loaded)
   */
  var fetchPageItemList = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var page, _ref2$fetchStatus, fetchStatus, _a, _yield$getItemList, _yield$getItemList$it, items, hasNext;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            page = _ref2.page, _ref2$fetchStatus = _ref2.fetchStatus, fetchStatus = _ref2$fetchStatus === void 0 ? FETCH_STATUS.LOADED : _ref2$fetchStatus;
            if (error == null) {
              addPageInfo({
                page: page,
                info: {
                  itemStatus: FETCH_STATUS.NON_LOAD,
                  items: createNullArray(per),
                  hasNext: true
                }
              });
            }
            if (!(fetchStatus === FETCH_STATUS.NON_LOAD)) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            addLoadingPage(page);
            _context.prev = 5;
            _context.next = 8;
            return getItemList(page, per);
          case 8:
            _yield$getItemList = _context.sent;
            _yield$getItemList$it = _yield$getItemList.items;
            items = _yield$getItemList$it === void 0 ? [] : _yield$getItemList$it;
            hasNext = _yield$getItemList.hasNext;
            addPageInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.LOADED,
                items: items,
                hasNext: hasNext
              }
            });
            if (hasNext === false) {
              maxPage.current = Math.min((_a = maxPage.current) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER, page);
            }
            if (page === (error === null || error === void 0 ? void 0 : error.errorPage)) {
              setError(undefined);
            }
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](5);
            setError({
              error: _context.t0,
              errorPage: page
            });
          case 20:
            _context.prev = 20;
            removeLoadingPage(page);
            return _context.finish(20);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 17, 20, 23]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [addLoadingPage, addPageInfo, error, getItemList, maxPage, per, removeLoadingPage]);
  var handleLoadItemList = useCallback(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref4) {
      var startItemIndex, _ref4$endItemIndex, endItemIndex, _ref4$fetchStatus, fetchStatus, _getPageFromIndex, startItemPage, _getPageFromIndex2, endItemPage, pageCount;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            startItemIndex = _ref4.startItemIndex, _ref4$endItemIndex = _ref4.endItemIndex, endItemIndex = _ref4$endItemIndex === void 0 ? startItemIndex : _ref4$endItemIndex, _ref4$fetchStatus = _ref4.fetchStatus, fetchStatus = _ref4$fetchStatus === void 0 ? FETCH_STATUS.LOADED : _ref4$fetchStatus;
            if (!(startItemIndex > endItemIndex)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _getPageFromIndex = getPageFromIndex(startItemIndex), startItemPage = _getPageFromIndex.page;
            _getPageFromIndex2 = getPageFromIndex(endItemIndex), endItemPage = _getPageFromIndex2.page;
            pageCount = endItemPage - startItemPage + 1;
            Array.from({
              length: pageCount
            }).forEach(function (_, index) {
              var _a;
              var page = index + startItemPage;
              var isPageAlreadyFetched = ((_a = getPageInfo(page)) === null || _a === void 0 ? void 0 : _a.itemStatus) === FETCH_STATUS.LOADED;
              var isPageLoading = isLoadingPage(page);
              var isPageNotInRange = page < MIN_PAGE$1 || maxPage.current != null && page > maxPage.current;
              if (isPageAlreadyFetched || isPageLoading || isPageNotInRange || error) return;
              fetchPageItemList({
                page: page,
                fetchStatus: fetchStatus
              });
            });
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }(), [error, fetchPageItemList, getPageFromIndex, getPageInfo, isLoadingPage, maxPage]);
  var handleReloadErrorPage = useCallback(function () {
    if (!error) return;
    fetchPageItemList({
      page: error.errorPage
    });
  }, [error, fetchPageItemList]);
  var handleGetItem = useCallback(function (index) {
    var _a;
    var _getPageFromIndex3 = getPageFromIndex(index),
      page = _getPageFromIndex3.page,
      pageIndex = _getPageFromIndex3.pageIndex;
    return (_a = getPageInfo(page)) === null || _a === void 0 ? void 0 : _a.items[pageIndex];
  }, [getPageFromIndex, getPageInfo]);
  /**
   * 기존 데이터를 reset하고, initial 데이터와 현재 스크롤 위치에서의 데이터를 reFetching합니다.
   * 중간 데이터들은 전부 non-load로 처리합니다.
   */
  var handleReloadItemList = useCallback(function () {
    initPageInfo();
  }, [initPageInfo]);
  useEffect(function () {
    if (initialDataPending || !initialData || !shouldInit.current) return;
    initPageInfo();
    shouldInit.current = false;
  }, [initPageInfo, initialData, initialDataPending]);
  return {
    count: count,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var MIN_PAGE = 0;
var getInitialCursorInfo = function getInitialCursorInfo(initialData) {
  if (initialData === null) return {};
  return _defineProperty({}, MIN_PAGE, _objectSpread2({
    itemStatus: FETCH_STATUS.LOADED,
    offset: 0,
    cursor: null
  }, initialData));
};
function useCursorInfo(_ref2) {
  var initialData = _ref2.initialData;
  var _useState = useState(getInitialCursorInfo(initialData)),
    _useState2 = _slicedToArray(_useState, 2),
    cursorInfo = _useState2[0],
    setCursorInfo = _useState2[1];
  var _useMemo = useMemo(function () {
      var _a;
      var lastCursorInfo = (_a = findLast(cursorInfo)) !== null && _a !== void 0 ? _a : {
        offset: 0,
        items: [],
        nextCursor: null,
        itemStatus: FETCH_STATUS.NON_LOAD
      };
      var count = lastCursorInfo.offset + lastCursorInfo.items.length;
      var nextCursor = lastCursorInfo.nextCursor || null;
      var hasNext = !(lastCursorInfo.itemStatus === 'loaded' && nextCursor === null);
      return {
        count: count,
        nextCursor: nextCursor,
        hasNext: hasNext
      };
    }, [cursorInfo]),
    count = _useMemo.count,
    nextCursor = _useMemo.nextCursor,
    hasNext = _useMemo.hasNext;
  var lastPage = useMemo(function () {
    var _a;
    return Number((_a = findLastKey(cursorInfo)) !== null && _a !== void 0 ? _a : 0);
  }, [cursorInfo]);
  var getCursorInfo = useCallback(function (page) {
    return cursorInfo[page];
  }, [cursorInfo]);
  var resetCursorInfo = useCallback(function () {
    setCursorInfo({});
  }, []);
  var addCursorInfo = useCallback(function (_ref3) {
    var page = _ref3.page,
      info = _ref3.info;
    var prevCursorInfo = cursorInfo[page - 1];
    var offset = prevCursorInfo ? prevCursorInfo.offset + prevCursorInfo.items.length : 0;
    setCursorInfo(function (cursorInfo) {
      return _objectSpread2(_objectSpread2({}, cursorInfo), {}, _defineProperty({}, page, _objectSpread2(_objectSpread2({}, info), {}, {
        offset: offset
      })));
    });
  }, [cursorInfo]);
  var getPageFromIndex = useCallback(function (index) {
    var offsetArray = [].concat(_toConsumableArray(Object.values(cursorInfo).map(function (_ref4) {
      var offset = _ref4.offset;
      return offset;
    })), [count]);
    var page = findPageByIndex(offsetArray, index);
    var isOverCount = page === size(cursorInfo);
    if (isOverCount) return null;
    return page;
  }, [cursorInfo, count]);
  var removeCursorInfo = useCallback(function (page) {
    setCursorInfo(function (cursorInfo) {
      return omit(cursorInfo, page);
    });
  }, []);
  var initCursorInfo = useCallback(function () {
    if (!initialData) return;
    var initialCursorInfo = getInitialCursorInfo(initialData);
    setCursorInfo(initialCursorInfo);
  }, [initialData]);
  return {
    nextCursor: nextCursor,
    count: count,
    lastPage: lastPage,
    hasNext: hasNext,
    getCursorInfo: getCursorInfo,
    addCursorInfo: addCursorInfo,
    removeCursorInfo: removeCursorInfo,
    resetCursorInfo: resetCursorInfo,
    initCursorInfo: initCursorInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function usePagedCursorInfiniteList(_ref) {
  var initialData = _ref.initialData,
    initialDataPending = _ref.initialDataPending,
    per = _ref.per,
    tabId = _ref.tabId,
    getItemList = _ref.getItemList;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollTargetIndex = _useState4[0],
    setScrollTargetIndex = _useState4[1];
  var shouldInit = useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual);
  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  var _useCursorInfo = useCursorInfo({
      initialData: initialData
    }),
    targetCursor = _useCursorInfo.nextCursor,
    count = _useCursorInfo.count,
    lastPage = _useCursorInfo.lastPage,
    hasNext = _useCursorInfo.hasNext,
    getCursorInfo = _useCursorInfo.getCursorInfo,
    addCursorInfo = _useCursorInfo.addCursorInfo,
    removeCursorInfo = _useCursorInfo.removeCursorInfo,
    initCursorInfo = _useCursorInfo.initCursorInfo,
    getPageFromIndex = _useCursorInfo.getPageFromIndex;
  var _useLoadingPageList = useLoadingPageList(),
    addLoadingPage = _useLoadingPageList.addLoadingPage,
    removeLoadingPage = _useLoadingPageList.removeLoadingPage,
    isLoadingPage = _useLoadingPageList.isLoadingPage;
  var visibleCount = useMemo(function () {
    if (hasNext && scrollTargetIndex !== null) {
      return Math.max(count, scrollTargetIndex + 1);
    }
    return count;
  }, [count, hasNext, scrollTargetIndex]);
  var fetchCursorItemList = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var page, cursor, _yield$getItemList, _yield$getItemList$it, items, _hasNext, nextCursor;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            page = _ref2.page, cursor = _ref2.cursor;
            if (!(!cursor || !initialData)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            addCursorInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.NON_LOAD,
                items: createNullArray(per !== null && per !== void 0 ? per : initialData.items.length),
                hasNext: true,
                nextCursor: null,
                cursor: cursor
              }
            });
            addLoadingPage(page);
            _context.prev = 5;
            _context.next = 8;
            return getItemList(cursor, per);
          case 8:
            _yield$getItemList = _context.sent;
            _yield$getItemList$it = _yield$getItemList.items;
            items = _yield$getItemList$it === void 0 ? [] : _yield$getItemList$it;
            _hasNext = _yield$getItemList.hasNext;
            nextCursor = _yield$getItemList.nextCursor;
            addCursorInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.LOADED,
                items: items,
                hasNext: _hasNext,
                nextCursor: nextCursor,
                cursor: cursor
              }
            });
            if ((error === null || error === void 0 ? void 0 : error.errorPage) === page) {
              setError(undefined);
            }
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](5);
            setError({
              error: _context.t0,
              errorPage: page
            });
          case 20:
            _context.prev = 20;
            removeLoadingPage(page);
            return _context.finish(20);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 17, 20, 23]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [initialData, addCursorInfo, per, addLoadingPage, getItemList, error === null || error === void 0 ? void 0 : error.errorPage, removeLoadingPage]);
  var handleLoadItemList = useCallback(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref4) {
      var endItemIndex, targetPage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            endItemIndex = _ref4.endItemIndex;
            targetPage = lastPage + 1;
            if (!(!targetCursor || isLoadingPage(targetPage) || endItemIndex < count)) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            fetchCursorItemList({
              page: targetPage,
              cursor: targetCursor
            });
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }(), [count, fetchCursorItemList, isLoadingPage, lastPage, targetCursor]);
  var handleReloadErrorPage = useCallback(function () {
    var _a;
    if (!error) return;
    setError(undefined);
    removeCursorInfo(error.errorPage);
    var cursorData = getCursorInfo(error.errorPage);
    var errorCursor = (_a = cursorData === null || cursorData === void 0 ? void 0 : cursorData.cursor) !== null && _a !== void 0 ? _a : null;
    fetchCursorItemList({
      page: error.errorPage,
      cursor: errorCursor
    });
  }, [error, fetchCursorItemList, getCursorInfo, removeCursorInfo]);
  var handleGetItem = useCallback(function (index) {
    var page = getPageFromIndex(index);
    if (page === null) return null;
    var cursorInfo = getCursorInfo(page);
    if (!cursorInfo) return null;
    var itemIndexInPage = index - cursorInfo.offset;
    return cursorInfo.items[itemIndexInPage];
  }, [getCursorInfo, getPageFromIndex]);
  var initScrollTarget = useCallback(function () {
    var scrollInfo = sessionScrollStorage.get();
    if (!(scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollEndItemIndex)) {
      setScrollTargetIndex(0);
      return;
    }
    var scrollEndItemIndex = Number(scrollInfo.scrollEndItemIndex);
    setScrollTargetIndex(scrollEndItemIndex);
  }, [sessionScrollStorage]);
  var handleReloadItemList = useCallback(function () {
    initCursorInfo();
    initScrollTarget();
  }, [initCursorInfo, initScrollTarget]);
  useEffect(function () {
    if (!shouldInit.current || initialDataPending || !initialData) return;
    initCursorInfo();
    initScrollTarget();
    shouldInit.current = false;
  }, [initCursorInfo, initScrollTarget, initialData, initialDataPending]);
  return {
    count: visibleCount,
    // 이슈 대응을 위해 임시로 필드를 추가 반환합니다. (DESYSWEB-428 참조)
    itemCount: count,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var SCROLL_THROTTLE_MILLISECONDS = 500;
/**
 * useVirtualizedScroll
 * 페이지를 벗어날 때 스크롤 위치를 저장하고, 페이지 재접근 시 스크롤 위치를 복귀시키는 역할을 수행합니다.
 */
var useVirtualizedScroll = function useVirtualizedScroll(_ref) {
  var tabId = _ref.tabId,
    columnCount = _ref.columnCount,
    containerRef = _ref.containerRef,
    renderedRowList = _ref.renderedRowList,
    disableSaveScroll = _ref.disableSaveScroll;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    targetScrollTop = _useState2[0],
    setTargetScrollTop = _useState2[1];
  var scrollIntervalId = useRef(null);
  var scrollDone = useRef(false);
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  /**
   * 현재 scroll 위치 정보를 sessionStorage에 저장합니다.
   */
  var saveScrollInfo = useCallback(function () {
    var _a, _b, _c;
    if (!scrollDone.current || !containerRef.current || !renderedRowList.current || renderedRowList.current.length === 0 || disableSaveScroll) return;
    var offsetTop = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) !== null && _b !== void 0 ? _b : 0;
    /** 화면 최상단에서부터 scrollTop */
    var scrollTop = document.documentElement.scrollTop;
    /** 현재 보이는 화면 "상단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */
    var scrollTopFromStart = scrollTop - offsetTop;
    /** 현재 보이는 화면 "하단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */
    var scrollBottomFromStart = scrollTopFromStart + window.innerHeight;
    var lastRenderedRow = renderedRowList.current[renderedRowList.current.length - 1];
    var _ref2 = (_c = renderedRowList.current.find(function (_ref3) {
        var offset = _ref3.offset,
          size = _ref3.size;
        return offset <= scrollBottomFromStart && scrollBottomFromStart < offset + size;
      })) !== null && _c !== void 0 ? _c : lastRenderedRow,
      visibleEndRowIndex = _ref2.index;
    /** 화면에 보이는 마지막 아이템 item */
    var endItemIndex = (visibleEndRowIndex + 1) * columnCount - 1;
    var scrollInfo = {
      scrollTop: scrollTop,
      scrollEndItemIndex: endItemIndex
    };
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      bottom = _containerRef$current.bottom;
    var isScrollAfterList = bottom < 0;
    if (isScrollAfterList) {
      var prevScrollInfo = sessionScrollStorage.get();
      var prevEndItemIndex = prevScrollInfo === null || prevScrollInfo === void 0 ? void 0 : prevScrollInfo.scrollEndItemIndex;
      if (prevEndItemIndex) {
        scrollInfo.scrollEndItemIndex = Math.max(prevEndItemIndex, endItemIndex);
      }
    }
    sessionScrollStorage.set(JSON.stringify(scrollInfo));
  }, [columnCount, containerRef, disableSaveScroll, renderedRowList, sessionScrollStorage]);
  useEffect(function () {
    var scrollInfo = sessionScrollStorage.get();
    if ((scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollTop) == null) {
      scrollDone.current = true;
      return;
    }
    scrollDone.current = false;
    setTargetScrollTop(scrollInfo.scrollTop);
  }, [sessionScrollStorage]);
  useEffect(function () {
    if (scrollIntervalId.current) {
      clearInterval(scrollIntervalId.current);
    }
    if (scrollDone.current) return;
    var intervalId = setInterval(function () {
      if (targetScrollTop == null) return;
      var scrollTop = document.documentElement.scrollTop;
      var isClearInterval = scrollTop !== 0 && scrollTop <= targetScrollTop || scrollTop === targetScrollTop;
      if (isClearInterval) {
        scrollDone.current = true;
        clearInterval(intervalId);
        return;
      }
      window.scrollTo({
        top: targetScrollTop
      });
    }, 10);
    scrollIntervalId.current = intervalId;
    return function () {
      clearInterval(intervalId);
    };
  }, [targetScrollTop]);
  useEffect(function () {
    var throttleSaveScrollInfo = throttle(saveScrollInfo, SCROLL_THROTTLE_MILLISECONDS);
    window.addEventListener('scroll', throttleSaveScrollInfo);
    if (disableSaveScroll) {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    }
    return function () {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    };
  }, [saveScrollInfo, disableSaveScroll, sessionScrollStorage]);
};

var _excluded = ["initialBreakpoint", "grid", "tabId", "count", "loadItemList", "disableSaveScroll", "disableUseWindowScroll", "overscanHeight", "insertedItemList", "renderItem", "fastScrollingVelocity"];
var DEFAULT_FAST_SCROLLING_VELOCITY = 4000; // (px/s)
var DEFAULT_OVERSCAN_HEIGHT = 500;
/**
 * Grid 컴포넌트는 autoHeight와 연동되지 않으므로,
 * List의 한 row당 grid만큼의 아이템을 가질 수 있도록 그리드 형태를 구현
 */
function VirtualizedList(_ref) {
  var _ref$initialBreakpoin = _ref.initialBreakpoint,
    initialBreakpoint = _ref$initialBreakpoin === void 0 ? 'desktop' : _ref$initialBreakpoin,
    grid = _ref.grid,
    tabId = _ref.tabId,
    count = _ref.count,
    loadItemList = _ref.loadItemList,
    _ref$disableSaveScrol = _ref.disableSaveScroll,
    disableSaveScroll = _ref$disableSaveScrol === void 0 ? false : _ref$disableSaveScrol,
    _ref$disableUseWindow = _ref.disableUseWindowScroll,
    disableUseWindowScroll = _ref$disableUseWindow === void 0 ? false : _ref$disableUseWindow,
    _ref$overscanHeight = _ref.overscanHeight,
    overscanHeight = _ref$overscanHeight === void 0 ? DEFAULT_OVERSCAN_HEIGHT : _ref$overscanHeight,
    _ref$insertedItemList = _ref.insertedItemList,
    insertedItemList = _ref$insertedItemList === void 0 ? [] : _ref$insertedItemList,
    renderItem = _ref.renderItem,
    _ref$fastScrollingVel = _ref.fastScrollingVelocity,
    fastScrollingVelocity = _ref$fastScrollingVel === void 0 ? DEFAULT_FAST_SCROLLING_VELOCITY : _ref$fastScrollingVel,
    props = _objectWithoutProperties(_ref, _excluded);
  var containerRef = useRef(null);
  var renderedRowList = useRef([]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFastScrolling = _useState2[0],
    setIsFastScrolling = _useState2[1];
  var breakpoint = useResponsive().breakpoint;
  var columnCount = useMemo(function () {
    return grid[breakpoint !== null && breakpoint !== void 0 ? breakpoint : initialBreakpoint];
  }, [breakpoint, grid, initialBreakpoint]);
  var itemRowCount = useMemo(function () {
    return Math.ceil(count / columnCount);
  }, [columnCount, count]);
  var insertedItemObject = useMemo(function () {
    return insertedItemList.reduce(function (prev, curr) {
      return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, curr.rowIndex, curr));
    }, {});
  }, [insertedItemList]);
  var insertedItemRowCount = useMemo(function () {
    var _a;
    return (_a = Object.keys(insertedItemObject).length) !== null && _a !== void 0 ? _a : 0;
  }, [insertedItemObject]);
  useVirtualizedScroll({
    tabId: tabId,
    columnCount: columnCount,
    containerRef: containerRef,
    renderedRowList: renderedRowList,
    disableSaveScroll: disableSaveScroll
  });
  /**
   * grid개의 아이템을 포함한 index번째 row를 생성합니다.
   */
  var createRowContent = useCallback(function (rowIndex) {
    var hasInsertedItem = Object.keys(insertedItemObject).includes("".concat(rowIndex));
    if (hasInsertedItem) {
      return jsx(Row, {
        children: insertedItemObject[rowIndex].component
      });
    }
    // 현재 rowIndex 보다 위에 존재하는 insertedItem의 개수
    var nowInsertedItemCount = Object.keys(insertedItemObject).filter(function (embedIndex) {
      return Number(embedIndex) < rowIndex;
    }).length;
    return jsx(Row, {
      columnCount: columnCount,
      children: Array.from({
        length: columnCount
      }).map(function (_, columnIndex) {
        var index = columnCount * (rowIndex - nowInsertedItemCount) + columnIndex;
        var lastItemIndex = count - 1;
        if (index > lastItemIndex) return null;
        return jsx(Fragment, {
          children: renderItem(index, rowIndex, isFastScrolling)
        }, "item".concat(index));
      })
    });
  }, [insertedItemObject, columnCount, count, isFastScrolling, renderItem]);
  var fetchItemList = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(renderedRowList, isFastScrolling) {
      var startRow, endRow, startItemIndex, endItemIndex;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(renderedRowList.length < 1 || !loadItemList)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            startRow = renderedRowList[0].index;
            endRow = renderedRowList[renderedRowList.length - 1].index;
            startItemIndex = startRow * columnCount;
            endItemIndex = (endRow + 1) * columnCount;
            loadItemList({
              startItemIndex: startItemIndex,
              endItemIndex: endItemIndex,
              fetchStatus: isFastScrolling ? FETCH_STATUS.NON_LOAD : FETCH_STATUS.LOADED
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [columnCount, loadItemList]);
  var handleItemsRendered = useCallback(function (items) {
    if (items.length < 1) return;
    renderedRowList.current = items;
    fetchItemList(items, isFastScrolling);
  }, [fetchItemList, isFastScrolling]);
  return jsx("div", {
    ref: containerRef,
    style: disableUseWindowScroll ? {
      height: '100%',
      overflow: 'hidden'
    } : {},
    children: jsx(Virtuoso, _objectSpread2(_objectSpread2({}, props), {}, {
      itemContent: createRowContent,
      totalCount: itemRowCount + insertedItemRowCount,
      useWindowScroll: !disableUseWindowScroll,
      itemsRendered: handleItemsRendered,
      initialItemCount: itemRowCount,
      scrollSeekConfiguration: {
        enter: function enter(velocity) {
          setIsFastScrolling(Math.abs(velocity) > fastScrollingVelocity);
          return false;
        },
        exit: function exit(velocity) {
          setIsFastScrolling(Math.abs(velocity) > fastScrollingVelocity);
          return false;
        }
      },
      isScrolling: function isScrolling(_isScrolling) {
        if (_isScrolling) return;
        setIsFastScrolling(false);
        fetchItemList(renderedRowList.current, false);
      },
      increaseViewportBy: {
        top: overscanHeight,
        bottom: overscanHeight
      },
      style: disableUseWindowScroll ? {
        height: '100%'
      } : {
        height: 'fit-content'
      }
    }))
  });
}
var Row = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qabbed0"
} : {
  target: "e1qabbed0",
  label: "Row"
})("width:100%;display:flex;&>*{width:", function (_ref3) {
  var _ref3$columnCount = _ref3.columnCount,
    columnCount = _ref3$columnCount === void 0 ? 1 : _ref3$columnCount;
  return 100 / columnCount;
}, "%;}");

var TOOLTIP_MIN_WIDTH = 92;
var TOOLTIP_MIN_HEIGHT = 36;
var TOOLTIP_MARGIN = 8;
var ARROW_SIZE = {
  width: 14,
  height: 10
};
var Tooltip = function Tooltip(_ref) {
  var arrow = _ref.arrow,
    variant = _ref.variant,
    _ref$hasRoundBorder = _ref.hasRoundBorder,
    hasRoundBorder = _ref$hasRoundBorder === void 0 ? false : _ref$hasRoundBorder,
    _ref$isTwoLine = _ref.isTwoLine,
    isTwoLine = _ref$isTwoLine === void 0 ? false : _ref$isTwoLine,
    children = _ref.children,
    onClose = _ref.onClose;
  var _a;
  var options = {
    arrow: arrow,
    variant: variant
  };
  var placement = arrow.placement;
  var tooltipRef = useRef(null);
  var tooltipWidth = ((_a = useNodeSize(tooltipRef, [TOOLTIP_MIN_WIDTH, TOOLTIP_MIN_HEIGHT])) === null || _a === void 0 ? void 0 : _a[0]) || 0;
  var tooltipHeight = useNodeHeight(tooltipRef) || 0;
  // arrow 방향에 따라 width || height 값을 넘겨줌
  var tooltipSize = placement === 'bottom' || placement === 'top' ? tooltipWidth : tooltipHeight;
  return jsxs(Container, {
    children: [jsxs(Content, {
      variant: variant,
      hasRoundBorder: hasRoundBorder,
      isTwoLine: isTwoLine,
      ref: tooltipRef,
      children: [children, onClose && jsx(CloseButton, {
        type: "button",
        size: 32,
        icon: {
          name: 'dismiss',
          size: 16
        },
        onClick: onClose,
        isTwoLine: isTwoLine,
        variant: "base1"
      })]
    }), jsx(ArrowContainer, {
      options: options,
      tooltipSize: tooltipSize
    })]
  });
};
var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1rflc093"
} : {
  target: "e1rflc093",
  label: "Container"
})(FONT_STYLE.body2, ";letter-spacing:", pxToRem(-0.3), ";position:relative;gap:", pxToRem(10), ";display:inline-block;");
var cssBackgroundColor = function cssBackgroundColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.layer.dark;
    case 'light':
      return theme.layer.light;
  }
};
var cssFontColor = function cssFontColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.content.white;
    case 'light':
      return theme.content.base1;
  }
};
var Content = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1rflc092"
} : {
  target: "e1rflc092",
  label: "Content"
})("padding:", pxToRem(8), " ", pxToRem(12), ";border-radius:", function (_ref2) {
  var hasRoundBorder = _ref2.hasRoundBorder;
  return hasRoundBorder ? pxToRem(20) : pxToRem(4);
}, ";color:", function (_ref3) {
  var theme = _ref3.theme,
    variant = _ref3.variant;
  return cssFontColor(theme, variant);
}, ";background-color:", function (_ref4) {
  var theme = _ref4.theme,
    variant = _ref4.variant;
  return cssBackgroundColor(theme, variant);
}, ";align-items:", function (_ref5) {
  var isTwoLine = _ref5.isTwoLine;
  return isTwoLine ? 'flex-start' : 'center';
}, ";margin:auto;white-space:pre-line;display:flex;flex-direction:row;");
var CloseButton = /*#__PURE__*/_styled(IconButton, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isTwoLine';
  },
  target: "e1rflc091"
} : {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isTwoLine';
  },
  target: "e1rflc091",
  label: "CloseButton"
})("margin-top:", function (_ref6) {
  var isTwoLine = _ref6.isTwoLine;
  return isTwoLine && "".concat(pxToRem(-6));
}, ";margin-right:", pxToRem(-8), ";cursor:pointer;");
var createArrowShape = function createArrowShape(theme, options) {
  var arrow = options.arrow,
    variant = options.variant;
  switch (arrow.placement) {
    case 'top':
      return /*#__PURE__*/css("border-bottom:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-left:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-right:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;"));
    case 'left':
      return /*#__PURE__*/css("border-right:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-bottom:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-top:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;"));
    case 'right':
      return /*#__PURE__*/css("border-left:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-bottom:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-top:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;"));
    case 'bottom':
      return /*#__PURE__*/css("border-top:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-left:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-right:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;"));
  }
};
var createArrowPlacement = function createArrowPlacement(tooltipSize, options) {
  var arrow = options.arrow;
  var placement = arrow.placement,
    align = arrow.align,
    alignLocation = arrow.alignLocation;
  var bottomHeight = placement === 'bottom' ? ARROW_SIZE.height : 0;
  var arrowLocation = align === 'center' ? 'left' : align;
  var arrowAlign = align !== 'center' && alignLocation ? Math.min(alignLocation, tooltipSize) : tooltipSize / 2 - TOOLTIP_MARGIN;
  switch (placement) {
    case 'top':
    case 'bottom':
      return /*#__PURE__*/css(placement, ":", pxToRem(-10 + bottomHeight), ";", arrowLocation, ":", pxToRem(arrowAlign), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowPlacement;"));
    case 'right':
    case 'left':
      return /*#__PURE__*/css("top:", pxToRem(arrowAlign), ";", placement, ":", pxToRem(-10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowPlacement;"));
  }
};
var ArrowContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1rflc090"
} : {
  target: "e1rflc090",
  label: "ArrowContainer"
})("width:", pxToRem(ARROW_SIZE.width), ";height:", pxToRem(ARROW_SIZE.height), ";&::after{content:'';position:absolute;", function (_ref7) {
  var theme = _ref7.theme,
    options = _ref7.options;
  return createArrowShape(theme, options);
}, " ", function (_ref8) {
  var tooltipSize = _ref8.tooltipSize,
    options = _ref8.options;
  return createArrowPlacement(tooltipSize, options);
}, ";}");

var SEARCH_TYPE = {
  TOTAL: 'total',
  STORE: 'store',
  EXPERT: 'expert_user'
};

export { ADDRESS, AnchorButton, AnchorButtonWithIcon, Animation, AppDownloadPopup, AppDownloadPopupContainer, Avatar, BUCKETPLACE_HOMEPAGE_URL, Breadcrumb, Button$2 as Button, ButtonWithIcon, COLUMN_PRESET, COPYRIGHT_TEXT, Callout, Carousel, CarouselControl, CarouselControlButton, CarouselScrollControl, Checkbox$1 as Checkbox, CheckboxWithText, Chip, CircleBadge, CircleImage, Column, CompanyLink, Container$4 as Container, CounterHint, DEFAULT_GAP, Dim, DimLoading, Divider$1 as Divider, DividerListItem, DotNotification, Drawer, Dropdown, EMAIL, EmptyPage, ExtendedFab, ExtendedFabWithIcon, FETCH_STATUS, Fab, FileButton, FileButtonWithIcon, FileInputLabel, FillOutlineSelectChip, FixedTab, Footer, FooterComponenet, Grid, GridItem, Hint, Icon, IconFab, IconNotification, Image, ImageAttachedItem, ImageUploadButton, IndicatorDots, IndicatorNumber, IndicatorNumberWithIcon, Input$1 as Input, InputChip, InputWithCountHint, InputWithHint, InputWithThumbnail, LinearProgressBar, LinkContext, LinkProvider, ListItem, Loading, MobileTopBanner, Modal, MoreAnchor, NaverPostSvg, Navigation, NavigationBar, NavigationDrawer, NavigationRightButton, NavigationSearch, NavigationTopBanner, NotSupportedBrowser, NotificationType, NumberNotification, OPENING_HOUR, OhouseFooter, OutlineAnchorButton, OutlineAnchorButtonWithIcon, OutlineButton, OutlineButtonWithIcon, OutlineFileButton, OutlineFileButtonWithIcon, OutlineSelectChip, PCTopBanner, PHONE_NUMBER, Pagination$1 as Pagination, PillBadge, PinterestSvg, Popper, PrimaryRight, Radio, RadioWithText, Ranking, Responsive, Row$1 as Row, SEARCH_TYPE, Search, SectionTitle, Select, SelectButton, SelectChip, SelectWithHint, SimpleFooter, SocialLink, SquareBadge, StoreCategory, TABLE_HIGHLIGHT_STYLE, TOGGLE_SIZE, TOTAL_COLUMN, TYPE_MAP, Tab, TabItem, Table, TableData, TableDataImpl, TableHeader, TableHeaderWithAction, TableRow, TextButton, TextButtonWithIcon, Textarea, TextareaWithCountHint, TextareaWithHint, TextareaWithThumbnail, ThumbnailAnchor, ThumbnailAnchorWithBadge, TikTokSvg, Toggle, ToggleButton, Tooltip, TopBannerContainer, UploadDropdownContentButton, UploadDropdownContentItem, UserDropdownContentButton, UserDropdownContentItem, VirtualizedList, YoutubeSvg, createOhouseFooterLinkSchema, createScrollStorage, cssBaseButton, cssDimmed, cssFontWeight, cssSize$2 as cssSize, dotSize, getTextButtonWithIconOptions, getWithIconOptions, useLinkContext, usePagedCursorInfiniteList, usePagedInfiniteList };
//# sourceMappingURL=bds.js.map
